import Z, { useState as O, useSyncExternalStore as Zr, useEffect as U, useCallback as ce, useRef as oe, memo as eo, useMemo as Ke, createContext as zt, useContext as to, forwardRef as Xn, useLayoutEffect as io } from "react";
import { jsx as s, jsxs as p, Fragment as se } from "react/jsx-runtime";
import { getAsset as nn, formatPaise as Bt, getShiphouseSDK as pt, getDynamicAsset as we, getAssetImageUrl as ht, GlobalSDKManager as no, initializeShiphouseSDK as ro } from "@team-shiphouse/shiphouse-sdk";
import { ImageOff as oo, Package as _t, X as rn, Loader2 as Ft, Save as so, Plus as pn, AlertCircle as Hi, ChevronRight as ao, MessageSquare as mn, Clock as hn, CheckCircle as ji, ChevronDown as Qn, Search as lo, Send as co, Pencil as uo, ShoppingBag as Vi, HelpCircle as po, Heart as Jn, Truck as mo, MapPin as ho, Trash2 as Zn } from "lucide-react";
import { useRouteContext as ft, getShiphouseSDK as Ve, getCartItemImage as er, getCartItemTitle as tr, getCartItemVariantTitle as ir, getCartItemPrice as nr, formatPaise as He, useAppDispatch as tt, useAppSelector as Ue, selectCartSyncStatus as go, updateQuantityOptimistic as Ui, removeFromCartOptimistic as rr, getCitiesForState as fo, loadLocationData as yo, getStates as bo, useAddressValidation as or, useCart as $t, useAuth as vo, selectCartItems as xo, useCheckout as ko, syncCartToServer as wo, clearSearchHistory as So, setReduxSearchQuery as gn, getSearchSuggestions as Co, addToSearchHistory as sr, useWishlist as No, toggleCart as Qe, fetchProducts as Ko, useProduct as To, useProductReviews as Io, useSubmitProductReview as Eo } from "@team-shiphouse/shiphouse-sdk/client";
import "axios";
import "@tanstack/react-query";
function _o(t, e = "desktop") {
  const i = {}, n = (r) => {
    if (Array.isArray(r)) {
      r.forEach((o) => {
        i[o.inputKey] = o.value;
      });
      return;
    }
    r && typeof r == "object" && Object.entries(r).forEach(([o, l]) => {
      i[o] = l;
    });
  };
  return n(t.desktop), (e === "tablet" || e === "mobile") && n(t.tablet), e === "mobile" && n(t.mobile), i;
}
function he(t, e) {
  const n = (r) => {
    const o = _o(
      r.data,
      r.viewportMode || "desktop"
    );
    return Z.createElement(t, { ...r, values: o });
  };
  return Object.assign(n, e), n.displayName = e.identifier, n;
}
function wt(t, e) {
  const i = t.toLowerCase(), r = {
    primary: "primary",
    secondary: "secondary",
    accent: "accent",
    text: "text",
    primarygradientstart: "primaryGradientStart",
    primarygradientend: "primaryGradientEnd",
    secondarygradientstart: "secondaryGradientStart",
    secondarygradientend: "secondaryGradientEnd"
  }[i];
  return r && e[r] ? e[r] : t;
}
const Fo = [
  {
    title: "Button Text",
    description: "The text content for the button",
    inputKey: "button-text",
    type: "text"
  },
  {
    title: "Button Color",
    description: "Primary color of the button",
    inputKey: "button-color",
    type: "color"
  },
  {
    title: "Button Size",
    description: "Size of the button",
    inputKey: "button-size",
    type: "select",
    acceptedValues: ["small", "medium", "large", "xlarge"]
  },
  {
    title: "Font Size",
    description: "Font size in pixels",
    inputKey: "fontSize",
    type: "number",
    acceptedRange: [12, 48]
  },
  {
    title: "Font Weight",
    description: "Font weight",
    inputKey: "fontWeight",
    type: "select",
    acceptedValues: ["normal", "medium", "semibold", "bold", "extrabold"]
  },
  {
    title: "Text Color",
    description: "Color of the button text",
    inputKey: "textColor",
    type: "color"
  },
  {
    title: "Border Radius",
    description: "Border radius in pixels",
    inputKey: "borderRadius",
    type: "number",
    acceptedRange: [0, 50]
  },
  {
    title: "Horizontal Padding",
    description: "Horizontal padding in pixels",
    inputKey: "paddingX",
    type: "number",
    acceptedRange: [0, 100]
  },
  {
    title: "Vertical Padding",
    description: "Vertical padding in pixels",
    inputKey: "paddingY",
    type: "number",
    acceptedRange: [0, 100]
  },
  {
    title: "Border Color",
    description: "Color of the border",
    inputKey: "borderColor",
    type: "color"
  },
  {
    title: "Button URL",
    description: "",
    inputKey: "buttonUrl",
    type: "link"
  }
], on = he(
  (t) => {
    const { data: e, theme: i, className: n } = t, r = (k, w) => {
      const C = e.desktop.find((T) => T.inputKey === k);
      return C ? C.value : w;
    }, o = r("button-text", "Click Me"), l = r("button-color", "primary"), a = r("button-size", "medium"), d = r("textColor", "#FFFFFF"), c = r("fontSize", 16), u = r("fontWeight", "normal"), h = r("borderRadius", 4), m = r("paddingX", 16), v = r("paddingY", 8), y = r("borderColor", l), f = i ? wt(l, i) : l, x = i ? wt(d, i) : d, b = i ? wt(y, i) : y, g = {
      backgroundColor: f,
      color: x,
      fontSize: `${c}px`,
      fontWeight: u,
      borderRadius: `${h}px`,
      padding: `${v}px ${m}px`,
      border: `1px solid ${b}`,
      cursor: "pointer",
      transition: "all 0.2s ease-in-out"
    };
    return /* @__PURE__ */ s(
      "button",
      {
        style: g,
        className: `button ${a} ${n || ""}`,
        children: o
      }
    );
  },
  {
    title: "Button",
    description: "A customizable button component",
    identifier: "button-solid",
    input: Fo,
    default: {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Click Me" },
        { inputKey: "button-color", type: "color", value: "primary" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "borderRadius", type: "number", value: 4 },
        { inputKey: "paddingX", type: "number", value: 16 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "borderColor", type: "color", value: "primary" },
        { inputKey: "buttonUrl", type: "link", value: "/product-listing?category=test" }
      ],
      tablet: [],
      mobile: []
    }
  }
), Po = [
  {
    title: "Button Text",
    description: "The text content for the button",
    inputKey: "button-text",
    type: "text"
  },
  {
    title: "Button Color",
    description: "Background color of the button (usually transparent for outline buttons)",
    inputKey: "button-color",
    type: "color"
  },
  {
    title: "Text Color",
    description: "Color of the button text",
    inputKey: "textColor",
    type: "color"
  },
  {
    title: "Border Color",
    description: "Color of the border",
    inputKey: "borderColor",
    type: "color"
  },
  {
    title: "Button Size",
    description: "Size of the button",
    inputKey: "button-size",
    type: "select",
    acceptedValues: ["small", "medium", "large", "xlarge"]
  },
  {
    title: "Font Size",
    description: "Font size in pixels",
    inputKey: "fontSize",
    type: "number",
    acceptedRange: [12, 48]
  },
  {
    title: "Font Weight",
    description: "Font weight",
    inputKey: "fontWeight",
    type: "select",
    acceptedValues: [
      "normal",
      "medium",
      "semibold",
      "bold",
      "extrabold"
    ]
  },
  {
    title: "Border Radius",
    description: "Border radius in pixels",
    inputKey: "borderRadius",
    type: "number",
    acceptedRange: [0, 50]
  },
  {
    title: "Horizontal Padding",
    description: "Horizontal padding in pixels",
    inputKey: "paddingX",
    type: "number",
    acceptedRange: [0, 100]
  },
  {
    title: "Vertical Padding",
    description: "Vertical padding in pixels",
    inputKey: "paddingY",
    type: "number",
    acceptedRange: [0, 100]
  },
  {
    title: "Border Width",
    description: "Width of the border in pixels",
    inputKey: "borderWidth",
    type: "number",
    acceptedRange: [1, 10]
  },
  {
    title: "Show Button",
    description: "Whether to show the button",
    inputKey: "showButton",
    type: "checkbox"
  }
], ar = he(
  (t) => {
    const { data: e, theme: i, className: n } = t, r = (I, E) => {
      const P = e.desktop.find(
        (S) => S.inputKey === I
      );
      return P ? P.value : E;
    }, o = r("button-text", "Click Me"), l = r("button-color", "transparent"), a = r("textColor", "#000000"), d = r("borderColor", "#D1D5DB"), c = r("button-size", "medium"), u = r("fontSize", 16), h = r("fontWeight", "medium"), m = r("borderRadius", 8), v = r("paddingX", 24), y = r("paddingY", 12), f = r("borderWidth", 1), x = r("showButton", !0), b = i ? wt(l, i) : l, g = i ? wt(a, i) : a, k = i ? wt(d, i) : d;
    if (!x)
      return null;
    const w = {
      backgroundColor: b,
      color: g,
      fontSize: `${u}px`,
      fontWeight: h,
      borderRadius: `${m}px`,
      padding: `${y}px ${v}px`,
      border: `${f}px solid ${k}`,
      cursor: "pointer",
      transition: "all 0.2s ease-in-out",
      outline: "none"
    }, C = (I) => {
      I.currentTarget.style.backgroundColor = k, I.currentTarget.style.color = b === "transparent" ? "#FFFFFF" : g;
    }, T = (I) => {
      I.currentTarget.style.backgroundColor = b, I.currentTarget.style.color = g;
    };
    return /* @__PURE__ */ s(
      "button",
      {
        style: w,
        className: `button-outline ${c} ${n || ""}`,
        onMouseEnter: C,
        onMouseLeave: T,
        children: o
      }
    );
  },
  {
    title: "Button Outline",
    description: "A customizable outline button component with border styling",
    identifier: "button-outline",
    input: Po,
    default: {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Click Me" },
        { inputKey: "button-color", type: "color", value: "transparent" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "borderColor", type: "color", value: "#D1D5DB" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 8 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 12 },
        { inputKey: "borderWidth", type: "number", value: 1 },
        { inputKey: "showButton", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    }
  }
), Lo = [
  {
    title: "Button Text",
    description: "The text content for the CTA button",
    inputKey: "buttonText",
    type: "text"
  },
  {
    title: "CTA Variant",
    description: "Style variant of the CTA button",
    inputKey: "variant",
    type: "select",
    acceptedValues: ["primary", "secondary", "accent", "white", "black"]
  },
  {
    title: "Button Size",
    description: "Size of the button",
    inputKey: "size",
    type: "select",
    acceptedValues: ["sm", "md", "lg", "xl"]
  },
  {
    title: "Disabled",
    description: "Whether button is disabled",
    inputKey: "disabled",
    type: "checkbox"
  },
  {
    title: "Loading",
    description: "Whether button is in loading state",
    inputKey: "loading",
    type: "checkbox"
  },
  {
    title: "Full Width",
    description: "Whether button should take full width",
    inputKey: "fullWidth",
    type: "checkbox"
  },
  {
    title: "Button Type",
    description: "Button type for forms",
    inputKey: "type",
    type: "select",
    acceptedValues: ["button", "submit", "reset"]
  },
  {
    title: "Click Action",
    description: "URL or action when button is clicked",
    inputKey: "action",
    type: "link"
  }
], Ao = {
  primary: "bg-black text-white hover:bg-gray-800 focus:ring-gray-500 shadow-lg hover:shadow-xl",
  secondary: "bg-white text-black border-2 border-black hover:bg-black hover:text-white focus:ring-gray-500 shadow-lg hover:shadow-xl",
  accent: "bg-orange-600 text-white hover:bg-orange-700 focus:ring-orange-500 shadow-lg hover:shadow-xl",
  white: "bg-white text-black hover:bg-gray-100 focus:ring-gray-300 shadow-lg hover:shadow-xl",
  black: "bg-black text-white hover:bg-gray-900 focus:ring-gray-500 shadow-lg hover:shadow-xl"
}, Ro = {
  sm: "px-4 py-2 text-sm font-semibold",
  md: "px-6 py-3 text-base font-semibold",
  lg: "px-8 py-4 text-lg font-bold",
  xl: "px-10 py-5 text-xl font-bold"
}, zo = "inline-flex items-center justify-center rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transform hover:scale-105 active:scale-95", Bo = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (f, x) => {
      const b = e.desktop.find((g) => g.inputKey === f);
      return b ? b.value : x;
    }, o = r("buttonText", "Call to Action"), l = r("variant", "primary"), a = r("size", "md"), d = r("disabled", !1), c = r("loading", !1), u = r("fullWidth", !1), h = r("type", "button"), m = r("action", ""), v = (f) => {
      m && m.startsWith("http") ? window.open(m, "_blank") : m && console.log("Action:", m);
    }, y = [
      zo,
      Ao[l],
      Ro[a],
      u ? "w-full" : "",
      c ? "cursor-wait" : "",
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ p(
      "button",
      {
        type: h,
        disabled: d || c,
        onClick: v,
        className: y,
        "aria-disabled": d || c,
        children: [
          c && /* @__PURE__ */ p(
            "svg",
            {
              className: "mr-2 -ml-1 h-5 w-5 animate-spin",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              children: [
                /* @__PURE__ */ s(
                  "circle",
                  {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4"
                  }
                ),
                /* @__PURE__ */ s(
                  "path",
                  {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }
                )
              ]
            }
          ),
          n || o
        ]
      }
    );
  },
  {
    title: "CTA Button",
    description: "A call-to-action button component with enhanced styling and animations",
    identifier: "cta-button",
    input: Lo,
    default: {
      desktop: [
        { inputKey: "buttonText", type: "text", value: "Call to Action" },
        { inputKey: "variant", type: "select", value: "primary" },
        { inputKey: "size", type: "select", value: "md" },
        { inputKey: "disabled", type: "checkbox", value: !1 },
        { inputKey: "loading", type: "checkbox", value: !1 },
        { inputKey: "fullWidth", type: "checkbox", value: !1 },
        { inputKey: "type", type: "select", value: "button" },
        { inputKey: "action", type: "link", value: "" }
      ],
      tablet: [],
      mobile: []
    }
  }
), $o = [
  {
    title: "Icon Name",
    description: "Name of the predefined icon to display",
    inputKey: "iconName",
    type: "select",
    acceptedValues: [
      "search",
      "heart",
      "shopping-bag",
      "user",
      "menu",
      "close",
      "chevron-down",
      "chevron-up",
      "chevron-left",
      "chevron-right",
      "star",
      "check",
      "x-mark",
      "plus",
      "minus",
      "home",
      "location"
    ]
  },
  {
    title: "Button Variant",
    description: "Style variant of the button",
    inputKey: "variant",
    type: "select",
    acceptedValues: ["primary", "secondary", "ghost", "outline", "danger"]
  },
  {
    title: "Button Size",
    description: "Size of the button",
    inputKey: "size",
    type: "select",
    acceptedValues: ["xs", "sm", "md", "lg", "xl"]
  },
  {
    title: "Disabled",
    description: "Whether button is disabled",
    inputKey: "disabled",
    type: "checkbox"
  },
  {
    title: "Loading",
    description: "Whether button is in loading state",
    inputKey: "loading",
    type: "checkbox"
  },
  {
    title: "Button Type",
    description: "Button type for forms",
    inputKey: "type",
    type: "select",
    acceptedValues: ["button", "submit", "reset"]
  },
  {
    title: "Accessible Label",
    description: "Accessible label for screen readers",
    inputKey: "ariaLabel",
    type: "text"
  },
  {
    title: "Click Action",
    description: "URL or action when button is clicked",
    inputKey: "action",
    type: "link"
  }
], Oo = {
  primary: "bg-black text-white hover:bg-gray-800 focus:ring-gray-500",
  secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300 focus:ring-gray-400",
  ghost: "bg-transparent text-gray-900 hover:bg-gray-100 focus:ring-gray-300",
  outline: "bg-transparent border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white focus:ring-gray-500",
  danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500"
}, Mo = {
  xs: "p-1",
  sm: "p-1.5",
  md: "p-2",
  lg: "p-3",
  xl: "p-4"
}, Ii = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-8 h-8"
}, fn = {
  search: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
  heart: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z",
  "shopping-bag": "M16 11V7a4 4 0 00-8 0v4M5 9h14l-1 12H6L5 9z",
  user: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
  menu: "M4 6h16M4 12h16M4 18h16",
  close: "M6 18L18 6M6 6l12 12",
  "chevron-down": "M19 9l-7 7-7-7",
  "chevron-up": "M5 15l7-7 7 7",
  "chevron-left": "M15 18l-6-6 6-6",
  "chevron-right": "M9 18l6-6-6-6",
  star: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z",
  check: "M5 13l4 4L19 7",
  "x-mark": "M6 18L18 6M6 6l12 12",
  plus: "M12 4v16m8-8H4",
  minus: "M20 12H4",
  home: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
  location: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z"
}, Do = "inline-flex items-center justify-center font-medium rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed", Wo = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (x, b) => {
      const g = e.desktop.find((k) => k.inputKey === x);
      return g ? g.value : b;
    }, o = r("iconName", ""), l = r("variant", "primary"), a = r("size", "md"), d = r("disabled", !1), c = r("loading", !1), u = r("type", "button"), h = r("ariaLabel", "Icon button"), m = r("action", ""), v = (x) => {
      m && m.startsWith("http") ? window.open(m, "_blank") : m && console.log("Action:", m);
    }, y = [
      Do,
      Oo[l],
      Mo[a],
      c ? "cursor-wait" : "",
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ s(
      "button",
      {
        type: u,
        disabled: d || c,
        onClick: v,
        className: y,
        "aria-label": h,
        "aria-disabled": d || c,
        children: c ? /* @__PURE__ */ p(
          "svg",
          {
            className: `animate-spin ${Ii[a]}`,
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            children: [
              /* @__PURE__ */ s(
                "circle",
                {
                  className: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  strokeWidth: "4"
                }
              ),
              /* @__PURE__ */ s(
                "path",
                {
                  className: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                }
              )
            ]
          }
        ) : n ? /* @__PURE__ */ s("span", { className: Ii[a], children: n }) : o && fn[o] ? /* @__PURE__ */ s(
          "svg",
          {
            className: Ii[a],
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ s(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: fn[o]
              }
            )
          }
        ) : null
      }
    );
  },
  {
    title: "Icon Button",
    description: "A button component with icon support and multiple variants",
    identifier: "icon-button",
    input: $o,
    default: {
      desktop: [
        { inputKey: "iconName", type: "select", value: "" },
        { inputKey: "variant", type: "select", value: "primary" },
        { inputKey: "size", type: "select", value: "md" },
        { inputKey: "disabled", type: "checkbox", value: !1 },
        { inputKey: "loading", type: "checkbox", value: !1 },
        { inputKey: "type", type: "select", value: "button" },
        { inputKey: "ariaLabel", type: "text", value: "Icon button" },
        { inputKey: "action", type: "link", value: "" }
      ],
      tablet: [],
      mobile: []
    }
  }
), Ho = [
  {
    title: "Button Text",
    description: "The text content for the link button",
    inputKey: "buttonText",
    type: "text"
  },
  {
    title: "Link URL",
    description: "The destination URL for the link",
    inputKey: "href",
    type: "link"
  },
  {
    title: "Button Variant",
    description: "Style variant of the button",
    inputKey: "variant",
    type: "select",
    acceptedValues: ["primary", "secondary", "ghost", "outline", "danger"]
  },
  {
    title: "Button Size",
    description: "Size of the button",
    inputKey: "size",
    type: "select",
    acceptedValues: ["xs", "sm", "md", "lg", "xl"]
  },
  {
    title: "Disabled",
    description: "Whether link is disabled",
    inputKey: "disabled",
    type: "checkbox"
  },
  {
    title: "Full Width",
    description: "Whether button should take full width",
    inputKey: "fullWidth",
    type: "checkbox"
  },
  {
    title: "External Link",
    description: "Whether link opens in new tab",
    inputKey: "external",
    type: "checkbox"
  }
], jo = {
  primary: "bg-black text-white hover:bg-gray-800 focus:ring-gray-500",
  secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300 focus:ring-gray-400",
  ghost: "bg-transparent text-gray-900 hover:bg-gray-100 focus:ring-gray-300",
  outline: "bg-transparent border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white focus:ring-gray-500",
  danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500"
}, Vo = {
  xs: "px-2 py-1 text-xs",
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-6 py-3 text-lg",
  xl: "px-8 py-4 text-xl"
}, Uo = "inline-flex items-center justify-center font-medium rounded-md transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed no-underline", qo = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (y, f) => {
      const x = e.desktop.find((b) => b.inputKey === y);
      return x ? x.value : f;
    }, o = r("buttonText", "Link Button"), l = r("href", "#"), a = r("variant", "primary"), d = r("size", "md"), c = r("disabled", !1), u = r("fullWidth", !1), h = r("external", !1), m = [
      Uo,
      jo[a],
      Vo[d],
      u ? "w-full" : "",
      c ? "pointer-events-none" : "",
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ s("a", { ...{
      href: c ? void 0 : l,
      target: h ? "_blank" : void 0,
      rel: h ? "noopener noreferrer" : void 0,
      className: m,
      "aria-disabled": c
    }, children: n || o });
  },
  {
    title: "Link Button",
    description: "A button component styled as a link with navigation functionality",
    identifier: "link-button",
    input: Ho,
    default: {
      desktop: [
        { inputKey: "buttonText", type: "text", value: "Link Button" },
        { inputKey: "href", type: "link", value: "#" },
        { inputKey: "variant", type: "select", value: "primary" },
        { inputKey: "size", type: "select", value: "md" },
        { inputKey: "disabled", type: "checkbox", value: !1 },
        { inputKey: "fullWidth", type: "checkbox", value: !1 },
        { inputKey: "external", type: "checkbox", value: !1 }
      ],
      tablet: [],
      mobile: []
    }
  }
), Go = he(
  (t) => {
    const e = "inline-flex items-center justify-center rounded-md font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50", {
      text: i,
      variant: n,
      size: r,
      color: o,
      action: l,
      disabled: a,
      borderRadius: d,
      paddingX: c,
      paddingY: u,
      fontSize: h,
      fontWeight: m,
      textColor: v,
      hoverColor: y,
      borderColor: f,
      borderWidth: x,
      icon: b,
      iconPosition: g,
      fullWidth: k,
      loading: w,
      loadingText: C
    } = t.values, T = {
      small: "h-8 px-3 text-sm",
      medium: "h-10 px-4 py-2",
      large: "h-12 px-6 text-lg",
      xlarge: "h-14 px-8 text-xl"
    }, I = {
      primary: "bg-primary text-primary-foreground hover:bg-primary/90",
      secondary: "bg-secondary text-secondary-foreground hover:bg-secondary/80",
      outline: "border border-input bg-background hover:bg-accent hover:text-accent-foreground",
      ghost: "hover:bg-accent hover:text-accent-foreground",
      destructive: "bg-destructive text-destructive-foreground hover:bg-destructive/90",
      link: "text-primary underline-offset-4 hover:underline"
    }, E = `${e} ${T[r] || T.medium} ${I[n] || I.primary} ${k ? "w-full" : ""} ${t.className || ""}`, P = {
      backgroundColor: n === "primary" ? o : void 0,
      color: v || (n === "primary" ? "#ffffff" : o),
      fontSize: h ? `${h}px` : void 0,
      fontWeight: m || "medium",
      borderRadius: d ? `${d}px` : void 0,
      paddingLeft: c ? `${c}px` : void 0,
      paddingRight: c ? `${c}px` : void 0,
      paddingTop: u ? `${u}px` : void 0,
      paddingBottom: u ? `${u}px` : void 0,
      borderColor: f || o,
      borderWidth: x ? `${x}px` : void 0,
      borderStyle: x ? "solid" : void 0
    }, S = () => {
      l && l !== "#" && !a && !w && window.open(l, "_blank", "noopener,noreferrer");
    }, K = () => b ? /* @__PURE__ */ s("span", { className: `inline-block ${g === "right" ? "ml-2" : "mr-2"}`, children: b }) : null;
    return /* @__PURE__ */ s(
      "button",
      {
        className: E,
        style: P,
        onClick: S,
        disabled: a || w,
        children: w ? /* @__PURE__ */ p(se, { children: [
          /* @__PURE__ */ p("svg", { className: "animate-spin -ml-1 mr-2 h-4 w-4", xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", children: [
            /* @__PURE__ */ s("circle", { className: "opacity-25", cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "4" }),
            /* @__PURE__ */ s("path", { className: "opacity-75", fill: "currentColor", d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" })
          ] }),
          C || "Loading..."
        ] }) : /* @__PURE__ */ p(se, { children: [
          g !== "right" && K(),
          i,
          g === "right" && K()
        ] })
      }
    );
  },
  {
    title: "Modern Button Component",
    description: "A modern button component with advanced styling and interaction options",
    identifier: "button-modern",
    input: [
      {
        title: "Button Text",
        description: "The text content for the button",
        inputKey: "text",
        type: "text"
      },
      {
        title: "Variant",
        description: "Visual style variant of the button",
        inputKey: "variant",
        type: "select",
        acceptedValues: ["primary", "secondary", "outline", "ghost", "destructive", "link"]
      },
      {
        title: "Size",
        description: "Size of the button",
        inputKey: "size",
        type: "select",
        acceptedValues: ["small", "medium", "large", "xlarge"]
      },
      {
        title: "Color",
        description: "Primary color of the button",
        inputKey: "color",
        type: "color"
      },
      {
        title: "Action URL",
        description: "URL to navigate to when clicked",
        inputKey: "action",
        type: "text"
      },
      {
        title: "Disabled",
        description: "Whether the button is disabled",
        inputKey: "disabled",
        type: "checkbox"
      },
      {
        title: "Border Radius",
        description: "Border radius in pixels",
        inputKey: "borderRadius",
        type: "number",
        acceptedRange: [0, 50]
      },
      {
        title: "Horizontal Padding",
        description: "Horizontal padding in pixels",
        inputKey: "paddingX",
        type: "number",
        acceptedRange: [0, 100]
      },
      {
        title: "Vertical Padding",
        description: "Vertical padding in pixels",
        inputKey: "paddingY",
        type: "number",
        acceptedRange: [0, 100]
      },
      {
        title: "Font Size",
        description: "Font size in pixels",
        inputKey: "fontSize",
        type: "number",
        acceptedRange: [12, 48]
      },
      {
        title: "Font Weight",
        description: "Font weight",
        inputKey: "fontWeight",
        type: "select",
        acceptedValues: ["normal", "medium", "semibold", "bold", "extrabold"]
      },
      {
        title: "Text Color",
        description: "Color of the button text",
        inputKey: "textColor",
        type: "color"
      },
      {
        title: "Hover Color",
        description: "Color on hover",
        inputKey: "hoverColor",
        type: "color"
      },
      {
        title: "Border Color",
        description: "Color of the border",
        inputKey: "borderColor",
        type: "color"
      },
      {
        title: "Border Width",
        description: "Width of the border in pixels",
        inputKey: "borderWidth",
        type: "number",
        acceptedRange: [0, 10]
      },
      {
        title: "Icon",
        description: "Icon to display (HTML or SVG)",
        inputKey: "icon",
        type: "text"
      },
      {
        title: "Icon Position",
        description: "Position of the icon relative to text",
        inputKey: "iconPosition",
        type: "select",
        acceptedValues: ["left", "right"]
      },
      {
        title: "Full Width",
        description: "Whether the button should take full width",
        inputKey: "fullWidth",
        type: "checkbox"
      },
      {
        title: "Loading",
        description: "Whether the button is in loading state",
        inputKey: "loading",
        type: "checkbox"
      },
      {
        title: "Loading Text",
        description: "Text to show when loading",
        inputKey: "loadingText",
        type: "text"
      }
    ],
    default: {
      desktop: [
        { inputKey: "text", type: "text", value: "Modern Button" },
        { inputKey: "variant", type: "select", value: "primary" },
        { inputKey: "size", type: "select", value: "medium" },
        { inputKey: "color", type: "color", value: "#3B82F6" },
        { inputKey: "action", type: "text", value: "#" },
        { inputKey: "disabled", type: "checkbox", value: !1 },
        { inputKey: "borderRadius", type: "number", value: 6 },
        { inputKey: "paddingX", type: "number", value: 16 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "textColor", type: "color", value: "#ffffff" },
        { inputKey: "hoverColor", type: "color", value: "#2563EB" },
        { inputKey: "borderColor", type: "color", value: "#3B82F6" },
        { inputKey: "borderWidth", type: "number", value: 1 },
        { inputKey: "icon", type: "text", value: "" },
        { inputKey: "iconPosition", type: "select", value: "left" },
        { inputKey: "fullWidth", type: "checkbox", value: !1 },
        { inputKey: "loading", type: "checkbox", value: !1 },
        { inputKey: "loadingText", type: "text", value: "Loading..." }
      ],
      tablet: [
        { inputKey: "size", type: "select", value: "medium" },
        { inputKey: "paddingX", type: "number", value: 14 },
        { inputKey: "paddingY", type: "number", value: 6 }
      ],
      mobile: [
        { inputKey: "size", type: "select", value: "small" },
        { inputKey: "paddingX", type: "number", value: 12 },
        { inputKey: "paddingY", type: "number", value: 4 },
        { inputKey: "fontSize", type: "number", value: 14 }
      ]
    }
  }
), Yo = [
  {
    title: "Button Text",
    description: "The text content for the button",
    inputKey: "buttonText",
    type: "text"
  },
  {
    title: "Button Variant",
    description: "Style variant of the button",
    inputKey: "variant",
    type: "select",
    acceptedValues: ["primary", "secondary", "ghost", "outline", "danger", "pill"]
  },
  {
    title: "Button Size",
    description: "Size of the button",
    inputKey: "size",
    type: "select",
    acceptedValues: ["xs", "sm", "md", "lg", "xl"]
  },
  {
    title: "Disabled",
    description: "Whether button is disabled",
    inputKey: "disabled",
    type: "checkbox"
  },
  {
    title: "Loading",
    description: "Whether button is in loading state",
    inputKey: "loading",
    type: "checkbox"
  },
  {
    title: "Full Width",
    description: "Whether button should take full width",
    inputKey: "fullWidth",
    type: "checkbox"
  },
  {
    title: "Button Type",
    description: "Button type for forms",
    inputKey: "type",
    type: "select",
    acceptedValues: ["button", "submit", "reset"]
  },
  {
    title: "Click Action",
    description: "URL or action when button is clicked",
    inputKey: "action",
    type: "link"
  }
], Xo = {
  primary: "bg-black text-white hover:bg-gray-800 focus:ring-gray-500",
  secondary: "bg-gray-200 text-gray-900 hover:bg-gray-300 focus:ring-gray-400",
  ghost: "bg-transparent text-gray-900 hover:bg-gray-100 focus:ring-gray-300",
  outline: "bg-transparent border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white focus:ring-gray-500",
  danger: "bg-red-600 text-white hover:bg-red-700 focus:ring-red-500",
  pill: "bg-gray-300 text-black hover:bg-gray-400 focus:ring-gray-500"
}, Qo = {
  xs: "px-2 py-1 text-xs",
  sm: "px-3 py-1.5 text-sm",
  md: "px-4 py-2 text-base",
  lg: "px-6 py-3 text-lg",
  xl: "px-8 py-4 text-xl"
}, Jo = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (f, x) => {
      const b = e.desktop.find((g) => g.inputKey === f);
      return b ? b.value : x;
    }, o = r("buttonText", "Click Me"), l = r("variant", "primary"), a = r("size", "md"), d = r("disabled", !1), c = r("loading", !1), u = r("fullWidth", !1), h = r("type", "button"), m = r("action", ""), v = (f) => {
      m && m.startsWith("http") ? window.open(m, "_blank") : m && console.log("Action:", m);
    }, y = [
      "inline-flex items-center justify-center font-medium transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed",
      l === "pill" ? "rounded-full" : "rounded-md",
      Xo[l],
      Qo[a],
      u ? "w-full" : "",
      c ? "cursor-wait" : "",
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ p(
      "button",
      {
        type: h,
        disabled: d || c,
        onClick: v,
        className: y,
        "aria-disabled": d || c,
        children: [
          c && /* @__PURE__ */ p(
            "svg",
            {
              className: "mr-2 -ml-1 h-4 w-4 animate-spin",
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              children: [
                /* @__PURE__ */ s(
                  "circle",
                  {
                    className: "opacity-25",
                    cx: "12",
                    cy: "12",
                    r: "10",
                    stroke: "currentColor",
                    strokeWidth: "4"
                  }
                ),
                /* @__PURE__ */ s(
                  "path",
                  {
                    className: "opacity-75",
                    fill: "currentColor",
                    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  }
                )
              ]
            }
          ),
          n || o
        ]
      }
    );
  },
  {
    title: "UI Button",
    description: "A comprehensive button component with multiple variants and states",
    identifier: "ui-button",
    input: Yo,
    default: {
      desktop: [
        { inputKey: "buttonText", type: "text", value: "Click Me" },
        { inputKey: "variant", type: "select", value: "primary" },
        { inputKey: "size", type: "select", value: "md" },
        { inputKey: "disabled", type: "checkbox", value: !1 },
        { inputKey: "loading", type: "checkbox", value: !1 },
        { inputKey: "fullWidth", type: "checkbox", value: !1 },
        { inputKey: "type", type: "select", value: "button" },
        { inputKey: "action", type: "link", value: "" }
      ],
      tablet: [],
      mobile: []
    }
  }
), Zo = he(
  (t) => {
    const i = `background-image-component ${t.className || ""}`, [n, r] = O(!1), {
      assetId: o,
      backgroundImageSrc: l,
      backgroundSize: a,
      backgroundPosition: d,
      backgroundRepeat: c,
      backgroundAttachment: u,
      opacity: h,
      borderRadius: m,
      borderColor: v,
      borderWidth: y,
      shadow: f,
      minHeight: x,
      imageWidth: b,
      imageHeight: g
    } = t.values, k = x !== void 0 ? x : 200, w = o || l || "", C = w ? nn(w, {
      width: b || 1200,
      height: g || 600,
      fit: "cover"
    }) : "", T = {
      backgroundImage: C && !n ? `url(${C})` : void 0,
      backgroundSize: a || "cover",
      backgroundPosition: d || "center",
      backgroundRepeat: c || "no-repeat",
      backgroundAttachment: u || "scroll",
      opacity: h !== void 0 ? h : 1,
      borderRadius: m ? `${m}px` : void 0,
      borderColor: v || void 0,
      borderWidth: y ? `${y}px` : void 0,
      borderStyle: y ? "solid" : void 0,
      boxShadow: f || void 0,
      minHeight: k ? `${k}px` : void 0
    };
    return !w || w.trim() === "" ? /* @__PURE__ */ s(
      "div",
      {
        className: `inset-0 bg-gray-200 ${i}`,
        style: T,
        children: /* @__PURE__ */ s("div", { className: "flex items-center justify-center h-full", children: /* @__PURE__ */ s("div", { className: "text-gray-500 text-sm", children: "No background image selected" }) })
      }
    ) : n ? /* @__PURE__ */ s("div", { className: `inset-0 bg-gray-300 ${i}`, style: T, children: /* @__PURE__ */ s("div", { className: "flex items-center justify-center h-full", children: /* @__PURE__ */ s("div", { className: "text-gray-500 text-sm", children: "Image not found" }) }) }) : /* @__PURE__ */ p(se, { children: [
      /* @__PURE__ */ s(
        "img",
        {
          src: C,
          alt: "",
          style: { display: "none" },
          onError: () => r(!0)
        }
      ),
      /* @__PURE__ */ s(
        "div",
        {
          className: `inset-0 ${i}`,
          style: T,
          children: t.children
        }
      )
    ] });
  },
  {
    title: "Background Image",
    description: "A background image component that fetches images by asset ID with customizable styling",
    identifier: "background-image",
    input: [
      {
        description: "Asset ID for the background image",
        inputKey: "assetId",
        title: "Background Image Asset ID",
        type: "text"
      },
      {
        description: "Asset ID for the background image (legacy field)",
        inputKey: "backgroundImageSrc",
        title: "Background Image Source (Legacy)",
        type: "text"
      },
      {
        description: "How the background image should be sized",
        inputKey: "backgroundSize",
        title: "Background Size",
        type: "select",
        acceptedValues: ["cover", "contain", "auto", "100%", "100% 100%"]
      },
      {
        description: "Position of the background image",
        inputKey: "backgroundPosition",
        title: "Background Position",
        type: "select",
        acceptedValues: ["center", "top", "bottom", "left", "right", "top left", "top right", "bottom left", "bottom right"]
      },
      {
        description: "How the background image should repeat",
        inputKey: "backgroundRepeat",
        title: "Background Repeat",
        type: "select",
        acceptedValues: ["no-repeat", "repeat", "repeat-x", "repeat-y", "space", "round"]
      },
      {
        description: "How the background image should be attached",
        inputKey: "backgroundAttachment",
        title: "Background Attachment",
        type: "select",
        acceptedValues: ["scroll", "fixed", "local"]
      },
      {
        description: "Opacity of the background image (0-1)",
        inputKey: "opacity",
        title: "Opacity",
        type: "number",
        acceptedRange: [0, 1]
      },
      {
        description: "Border radius in pixels",
        inputKey: "borderRadius",
        title: "Border Radius",
        type: "number",
        acceptedRange: [0, 100]
      },
      {
        description: "Color of the border",
        inputKey: "borderColor",
        title: "Border Color",
        type: "color"
      },
      {
        description: "Width of the border in pixels",
        inputKey: "borderWidth",
        title: "Border Width",
        type: "number",
        acceptedRange: [0, 20]
      },
      {
        description: "CSS box shadow value",
        inputKey: "shadow",
        title: "Shadow",
        type: "text"
      },
      {
        description: "Minimum height in pixels",
        inputKey: "minHeight",
        title: "Minimum Height",
        type: "number",
        acceptedRange: [0, 1e3]
      },
      {
        description: "Image width for optimization (optional)",
        inputKey: "imageWidth",
        title: "Image Width",
        type: "number",
        acceptedRange: [100, 3e3]
      },
      {
        description: "Image height for optimization (optional)",
        inputKey: "imageHeight",
        title: "Image Height",
        type: "number",
        acceptedRange: [100, 3e3]
      }
    ],
    default: {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: ""
        },
        {
          inputKey: "backgroundSize",
          type: "select",
          value: "cover"
        },
        {
          inputKey: "backgroundPosition",
          type: "select",
          value: "center"
        },
        {
          inputKey: "backgroundRepeat",
          type: "select",
          value: "no-repeat"
        },
        {
          inputKey: "backgroundAttachment",
          type: "select",
          value: "scroll"
        },
        {
          inputKey: "opacity",
          type: "number",
          value: 1
        },
        {
          inputKey: "borderRadius",
          type: "number",
          value: 0
        },
        {
          inputKey: "borderColor",
          type: "color",
          value: "#000000"
        },
        {
          inputKey: "borderWidth",
          type: "number",
          value: 0
        },
        {
          inputKey: "shadow",
          type: "text",
          value: ""
        },
        {
          inputKey: "minHeight",
          type: "number",
          value: 200
        },
        {
          inputKey: "imageWidth",
          type: "number",
          value: 1200
        },
        {
          inputKey: "imageHeight",
          type: "number",
          value: 600
        }
      ],
      tablet: [],
      mobile: []
    }
  }
), es = he(
  (t) => {
    const i = `image-component ${t.className || ""}`, [n, r] = O(!1), [o, l] = O(!0), {
      assetId: a,
      src: d,
      alt: c,
      altText: u,
      width: h,
      height: m,
      borderRadius: v,
      objectFit: y,
      objectPosition: f,
      borderColor: x,
      borderWidth: b,
      shadow: g,
      opacity: k
    } = t.values, w = a || d || "", C = c || u || "Image", T = w ? nn(w, {
      width: h || 400,
      height: m || 300,
      fit: "inside"
    }) : "", I = {
      width: h ? `${h}px` : "100%",
      height: m ? `${m}px` : "auto",
      borderRadius: v ? `${v}px` : void 0,
      objectFit: y || "cover",
      objectPosition: f || "center",
      borderColor: x || void 0,
      borderWidth: b ? `${b}px` : void 0,
      borderStyle: b ? "solid" : void 0,
      boxShadow: g || void 0,
      opacity: k !== void 0 ? k : 1
    };
    return !w || w.trim() === "" ? /* @__PURE__ */ s("div", { className: `bg-gray-200 ${i}`, style: I, children: /* @__PURE__ */ s("div", { className: "flex items-center justify-center h-32", children: /* @__PURE__ */ s("div", { className: "text-gray-500 text-sm", children: "No image selected" }) }) }) : o && !n ? /* @__PURE__ */ p(se, { children: [
      /* @__PURE__ */ s("div", { className: `bg-gray-200 animate-pulse ${i}`, style: { ...I, display: o ? "flex" : "none" }, children: /* @__PURE__ */ s("div", { className: "flex items-center justify-center h-32 w-full", children: /* @__PURE__ */ s("div", { className: "text-gray-500", children: "Loading image..." }) }) }),
      /* @__PURE__ */ s(
        "img",
        {
          src: T,
          alt: C,
          className: i,
          style: { ...I, display: "none" },
          onLoad: () => l(!1),
          onError: () => {
            r(!0), l(!1);
          }
        }
      )
    ] }) : n ? /* @__PURE__ */ s("div", { className: `bg-gray-300 ${i}`, style: I, children: /* @__PURE__ */ s("div", { className: "flex items-center justify-center h-32", children: /* @__PURE__ */ s("div", { className: "text-gray-500 text-sm", children: "Image not found" }) }) }) : /* @__PURE__ */ s(
      "img",
      {
        src: T,
        alt: C,
        className: i,
        style: I,
        onLoad: () => l(!1),
        onError: () => {
          r(!0), l(!1);
        }
      }
    );
  },
  {
    title: "Image",
    description: "An image component that fetches images by asset ID with customizable styling",
    identifier: "image",
    input: [
      {
        description: "Asset ID for the image",
        inputKey: "assetId",
        title: "Image Asset ID",
        type: "text"
      },
      {
        description: "Asset ID for the image (legacy field)",
        inputKey: "src",
        title: "Image Source (Legacy)",
        type: "text"
      },
      {
        description: "Alt text for accessibility",
        inputKey: "alt",
        title: "Alt Text",
        type: "text"
      },
      {
        description: "Alt text for accessibility (legacy field)",
        inputKey: "altText",
        title: "Alt Text (Legacy)",
        type: "text"
      },
      {
        description: "Width of the image in pixels",
        inputKey: "width",
        title: "Width",
        type: "number",
        acceptedRange: [1, 2e3]
      },
      {
        description: "Height of the image in pixels",
        inputKey: "height",
        title: "Height",
        type: "number",
        acceptedRange: [1, 2e3]
      },
      {
        description: "Border radius in pixels",
        inputKey: "borderRadius",
        title: "Border Radius",
        type: "number",
        acceptedRange: [0, 100]
      },
      {
        description: "How the image should fit within its container",
        inputKey: "objectFit",
        title: "Object Fit",
        type: "select",
        acceptedValues: ["cover", "contain", "fill", "none", "scale-down"]
      },
      {
        description: "Position of the image within its container",
        inputKey: "objectPosition",
        title: "Object Position",
        type: "select",
        acceptedValues: ["center", "top", "bottom", "left", "right", "top left", "top right", "bottom left", "bottom right"]
      },
      {
        description: "Color of the border",
        inputKey: "borderColor",
        title: "Border Color",
        type: "color"
      },
      {
        description: "Width of the border in pixels",
        inputKey: "borderWidth",
        title: "Border Width",
        type: "number",
        acceptedRange: [0, 20]
      },
      {
        description: "CSS box shadow value",
        inputKey: "shadow",
        title: "Shadow",
        type: "text"
      },
      {
        description: "Opacity of the image (0-1)",
        inputKey: "opacity",
        title: "Opacity",
        type: "number",
        acceptedRange: [0, 1]
      }
    ],
    default: {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: ""
        },
        {
          inputKey: "alt",
          type: "text",
          value: "Image"
        },
        {
          inputKey: "width",
          type: "number",
          value: 400
        },
        {
          inputKey: "height",
          type: "number",
          value: 300
        },
        {
          inputKey: "borderRadius",
          type: "number",
          value: 0
        },
        {
          inputKey: "objectFit",
          type: "select",
          value: "cover"
        },
        {
          inputKey: "objectPosition",
          type: "select",
          value: "center"
        },
        {
          inputKey: "borderColor",
          type: "color",
          value: "#000000"
        },
        {
          inputKey: "borderWidth",
          type: "number",
          value: 0
        },
        {
          inputKey: "shadow",
          type: "text",
          value: ""
        },
        {
          inputKey: "opacity",
          type: "number",
          value: 1
        }
      ],
      tablet: [
        {
          inputKey: "width",
          type: "number",
          value: 300
        },
        {
          inputKey: "height",
          type: "number",
          value: 225
        }
      ],
      mobile: [
        {
          inputKey: "width",
          type: "number",
          value: 250
        },
        {
          inputKey: "height",
          type: "number",
          value: 188
        }
      ]
    }
  }
), ts = [
  {
    title: "Desktop Image",
    description: "Image source URL for desktop devices",
    inputKey: "desktopSrc",
    type: "text"
  },
  {
    title: "Tablet Image",
    description: "Image source URL for tablet devices",
    inputKey: "tabletSrc",
    type: "text"
  },
  {
    title: "Mobile Image",
    description: "Image source URL for mobile devices",
    inputKey: "mobileSrc",
    type: "text"
  },
  {
    title: "Fallback Image",
    description: "Fallback image source URL",
    inputKey: "fallbackSrc",
    type: "text"
  },
  {
    title: "Alt Text",
    description: "Alternative text for accessibility",
    inputKey: "alt",
    type: "text"
  },
  {
    title: "Aspect Ratio",
    description: "Aspect ratio for the image (width/height)",
    inputKey: "aspectRatio",
    type: "number",
    acceptedRange: [0.1, 10]
  },
  {
    title: "Object Fit",
    description: "How the image should fit within its container",
    inputKey: "objectFit",
    type: "select",
    acceptedValues: ["contain", "cover", "fill", "none", "scale-down"]
  },
  {
    title: "Object Position",
    description: "Position of the image within its container",
    inputKey: "objectPosition",
    type: "select",
    acceptedValues: ["center", "top", "bottom", "left", "right", "top left", "top right", "bottom left", "bottom right"]
  },
  {
    title: "Lazy Loading",
    description: "Whether to enable lazy loading",
    inputKey: "lazy",
    type: "checkbox"
  },
  {
    title: "Placeholder URL",
    description: "Placeholder image URL while loading",
    inputKey: "placeholder",
    type: "text"
  }
], yn = {
  contain: "object-contain",
  cover: "object-cover",
  fill: "object-fill",
  none: "object-none",
  "scale-down": "object-scale-down"
}, is = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (w, C) => {
      const T = e.desktop.find((I) => I.inputKey === w);
      return T ? T.value : C;
    }, o = r("desktopSrc", ""), l = r("tabletSrc", ""), a = r("mobileSrc", ""), d = r("fallbackSrc", ""), c = r("alt", ""), u = r("aspectRatio", 0), h = r("objectFit", "cover"), m = r("objectPosition", "center"), v = r("lazy", !0), y = r("placeholder", ""), f = [
      "w-full h-full",
      yn[h],
      "transition-opacity duration-300",
      i
    ].filter(Boolean).join(" "), x = u > 0 ? { aspectRatio: u.toString() } : {}, b = {
      objectPosition: m
    }, g = () => /* @__PURE__ */ s(
      "div",
      {
        className: `flex items-center justify-center bg-gray-200 ${i}`,
        style: x,
        role: "img",
        "aria-label": c,
        children: /* @__PURE__ */ s(
          "svg",
          {
            className: "h-8 w-8 text-gray-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ s(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              }
            )
          }
        )
      }
    );
    if (!o && !l && !a && !d)
      return /* @__PURE__ */ s(g, {});
    const k = o || l || a || d;
    return /* @__PURE__ */ p("div", { className: "relative", style: x, children: [
      y && /* @__PURE__ */ s(
        "img",
        {
          src: y,
          alt: "",
          className: `absolute inset-0 h-full w-full ${yn[h]} blur-sm opacity-50`,
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ p("picture", { children: [
        o && /* @__PURE__ */ s(
          "source",
          {
            srcSet: o,
            media: "(min-width: 1024px)"
          }
        ),
        l && /* @__PURE__ */ s(
          "source",
          {
            srcSet: l,
            media: "(min-width: 768px)"
          }
        ),
        a && /* @__PURE__ */ s(
          "source",
          {
            srcSet: a,
            media: "(max-width: 767px)"
          }
        ),
        /* @__PURE__ */ s(
          "img",
          {
            src: k,
            alt: c,
            className: f,
            style: b,
            loading: v ? "lazy" : "eager",
            onError: (w) => {
              var T;
              const C = w.target;
              C.style.display = "none", (T = C.parentElement) != null && T.parentElement && (C.parentElement.parentElement.innerHTML = `
                  <div class="flex items-center justify-center bg-gray-200 h-full w-full" role="img" aria-label="${c}">
                    <svg class="h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                    </svg>
                  </div>
                `);
            }
          }
        )
      ] }),
      n
    ] });
  },
  {
    title: "Responsive Image",
    description: "A responsive image component with multiple sources for different breakpoints",
    identifier: "responsive-image",
    input: ts,
    default: {
      desktop: [
        { inputKey: "desktopSrc", type: "text", value: "" },
        { inputKey: "tabletSrc", type: "text", value: "" },
        { inputKey: "mobileSrc", type: "text", value: "" },
        { inputKey: "fallbackSrc", type: "text", value: "" },
        { inputKey: "alt", type: "text", value: "" },
        { inputKey: "aspectRatio", type: "number", value: 0 },
        { inputKey: "objectFit", type: "select", value: "cover" },
        { inputKey: "objectPosition", type: "select", value: "center" },
        { inputKey: "lazy", type: "checkbox", value: !0 },
        { inputKey: "placeholder", type: "text", value: "" }
      ],
      tablet: [],
      mobile: []
    }
  }
), ns = [
  {
    title: "Image Source",
    description: "Image source URL",
    inputKey: "src",
    type: "text"
  },
  {
    title: "Alt Text",
    description: "Alternative text for accessibility",
    inputKey: "alt",
    type: "text"
  },
  {
    title: "Width",
    description: "Image width in pixels",
    inputKey: "width",
    type: "number",
    acceptedRange: [1, 2e3]
  },
  {
    title: "Height",
    description: "Image height in pixels",
    inputKey: "height",
    type: "number",
    acceptedRange: [1, 2e3]
  },
  {
    title: "Aspect Ratio",
    description: "Aspect ratio for the image (width/height)",
    inputKey: "aspectRatio",
    type: "number",
    acceptedRange: [0.1, 10]
  },
  {
    title: "Object Fit",
    description: "How the image should fit within its container",
    inputKey: "objectFit",
    type: "select",
    acceptedValues: ["contain", "cover", "fill", "none", "scale-down"]
  },
  {
    title: "Object Position",
    description: "Position of the image within its container",
    inputKey: "objectPosition",
    type: "select",
    acceptedValues: ["center", "top", "bottom", "left", "right", "top left", "top right", "bottom left", "bottom right"]
  },
  {
    title: "Lazy Loading",
    description: "Whether to enable lazy loading",
    inputKey: "lazy",
    type: "checkbox"
  },
  {
    title: "Placeholder URL",
    description: "Placeholder image URL while loading",
    inputKey: "placeholder",
    type: "text"
  }
], bn = {
  contain: "object-contain",
  cover: "object-cover",
  fill: "object-fill",
  none: "object-none",
  "scale-down": "object-scale-down"
}, rs = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (g, k) => {
      const w = e.desktop.find((C) => C.inputKey === g);
      return w ? w.value : k;
    }, o = r("src", ""), l = r("alt", ""), a = r("width", 0), d = r("height", 0), c = r("aspectRatio", 0), u = r("objectFit", "cover"), h = r("objectPosition", "center"), m = r("lazy", !0), v = r("placeholder", ""), y = [
      bn[u],
      "transition-opacity duration-300",
      i
    ].filter(Boolean).join(" "), f = {
      width: a > 0 ? `${a}px` : void 0,
      height: d > 0 ? `${d}px` : void 0,
      aspectRatio: c > 0 ? c.toString() : void 0
    }, x = {
      objectPosition: h
    }, b = () => /* @__PURE__ */ s(
      "div",
      {
        className: `flex items-center justify-center bg-gray-200 ${i}`,
        style: f,
        role: "img",
        "aria-label": l,
        children: /* @__PURE__ */ s(
          "svg",
          {
            className: "h-8 w-8 text-gray-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ s(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              }
            )
          }
        )
      }
    );
    return o ? /* @__PURE__ */ p("div", { className: "relative", style: f, children: [
      v && /* @__PURE__ */ s(
        "img",
        {
          src: v,
          alt: "",
          className: `absolute inset-0 h-full w-full ${bn[u]} blur-sm opacity-50`,
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ s(
        "img",
        {
          src: o,
          alt: l,
          width: a > 0 ? a : void 0,
          height: d > 0 ? d : void 0,
          loading: m ? "lazy" : "eager",
          className: y,
          style: x,
          onError: (g) => {
            const k = g.target;
            k.style.display = "none", k.parentElement && (k.parentElement.innerHTML = `
                <div class="flex items-center justify-center bg-gray-200 h-full w-full" role="img" aria-label="${l}">
                  <svg class="h-8 w-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
                  </svg>
                </div>
              `);
          }
        }
      ),
      n
    ] }) : /* @__PURE__ */ s(b, {});
  },
  {
    title: "UI Image",
    description: "A feature-rich image component with lazy loading, aspect ratio, and object fit support",
    identifier: "ui-image",
    input: ns,
    default: {
      desktop: [
        { inputKey: "src", type: "text", value: "" },
        { inputKey: "alt", type: "text", value: "" },
        { inputKey: "width", type: "number", value: 0 },
        { inputKey: "height", type: "number", value: 0 },
        { inputKey: "aspectRatio", type: "number", value: 0 },
        { inputKey: "objectFit", type: "select", value: "cover" },
        { inputKey: "objectPosition", type: "select", value: "center" },
        { inputKey: "lazy", type: "checkbox", value: !0 },
        { inputKey: "placeholder", type: "text", value: "" }
      ],
      tablet: [],
      mobile: []
    }
  }
), os = [
  {
    title: "Container Size",
    description: "Maximum width of the container",
    inputKey: "size",
    type: "select",
    acceptedValues: ["sm", "md", "lg", "xl", "2xl", "full"]
  },
  {
    title: "Padding",
    description: "Padding variant for the container",
    inputKey: "padding",
    type: "select",
    acceptedValues: ["none", "sm", "md", "lg", "xl"]
  },
  {
    title: "Center Container",
    description: "Whether to center the container horizontally",
    inputKey: "center",
    type: "checkbox"
  },
  {
    title: "Content",
    description: "Content to display inside the container",
    inputKey: "content",
    type: "richtext"
  }
], ss = {
  sm: "max-w-sm",
  md: "max-w-md",
  lg: "max-w-4xl",
  xl: "max-w-6xl",
  "2xl": "max-w-7xl",
  full: "max-w-full"
}, as = {
  none: "",
  sm: "px-4 py-2",
  md: "px-6 py-4",
  lg: "px-8 py-6",
  xl: "px-12 py-8"
}, ls = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (u, h) => {
      const m = e.desktop.find((v) => v.inputKey === u);
      return m ? m.value : h;
    }, o = r("size", "xl"), l = r("padding", "md"), a = r("center", !0), d = r("content", ""), c = [
      ss[o],
      as[l],
      a ? "mx-auto" : "",
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ s("div", { className: c, children: n || d && /* @__PURE__ */ s("div", { dangerouslySetInnerHTML: { __html: d } }) });
  },
  {
    title: "Container",
    description: "A responsive container component with size and padding variants",
    identifier: "container",
    input: os,
    default: {
      desktop: [
        { inputKey: "size", type: "select", value: "xl" },
        { inputKey: "padding", type: "select", value: "md" },
        { inputKey: "center", type: "checkbox", value: !0 },
        { inputKey: "content", type: "richtext", value: "" }
      ],
      tablet: [],
      mobile: []
    }
  }
), cs = [
  {
    title: "Flex Direction",
    description: "Direction of the flex container",
    inputKey: "direction",
    type: "select",
    acceptedValues: ["row", "row-reverse", "col", "col-reverse"]
  },
  {
    title: "Flex Wrap",
    description: "Flex wrap behavior",
    inputKey: "wrap",
    type: "select",
    acceptedValues: ["nowrap", "wrap", "wrap-reverse"]
  },
  {
    title: "Justify Content",
    description: "Justify content along the main axis",
    inputKey: "justify",
    type: "select",
    acceptedValues: ["start", "end", "center", "between", "around", "evenly"]
  },
  {
    title: "Align Items",
    description: "Align items along the cross axis",
    inputKey: "align",
    type: "select",
    acceptedValues: ["start", "end", "center", "baseline", "stretch"]
  },
  {
    title: "Gap",
    description: "Gap between flex items",
    inputKey: "gap",
    type: "select",
    acceptedValues: ["none", "xs", "sm", "md", "lg", "xl"]
  },
  {
    title: "Grow",
    description: "Whether flex container should grow to fill available space",
    inputKey: "grow",
    type: "checkbox"
  },
  {
    title: "Content",
    description: "Content to display inside the flex container",
    inputKey: "content",
    type: "richtext"
  }
], ds = {
  row: "flex-row",
  "row-reverse": "flex-row-reverse",
  col: "flex-col",
  "col-reverse": "flex-col-reverse"
}, us = {
  nowrap: "flex-nowrap",
  wrap: "flex-wrap",
  "wrap-reverse": "flex-wrap-reverse"
}, ps = {
  start: "justify-start",
  end: "justify-end",
  center: "justify-center",
  between: "justify-between",
  around: "justify-around",
  evenly: "justify-evenly"
}, ms = {
  start: "items-start",
  end: "items-end",
  center: "items-center",
  baseline: "items-baseline",
  stretch: "items-stretch"
}, hs = {
  none: "gap-0",
  xs: "gap-1",
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
  xl: "gap-8"
}, gs = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (v, y) => {
      const f = e.desktop.find((x) => x.inputKey === v);
      return f ? f.value : y;
    }, o = r("direction", "row"), l = r("wrap", "nowrap"), a = r("justify", "start"), d = r("align", "stretch"), c = r("gap", "none"), u = r("grow", !1), h = r("content", ""), m = [
      "flex",
      ds[o],
      us[l],
      ps[a],
      ms[d],
      hs[c],
      u ? "flex-grow" : "",
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ s("div", { className: m, children: n || h && /* @__PURE__ */ s("div", { dangerouslySetInnerHTML: { __html: h } }) });
  },
  {
    title: "Flex",
    description: "A flexible layout component using CSS Flexbox with configurable properties",
    identifier: "flex",
    input: cs,
    default: {
      desktop: [
        { inputKey: "direction", type: "select", value: "row" },
        { inputKey: "wrap", type: "select", value: "nowrap" },
        { inputKey: "justify", type: "select", value: "start" },
        { inputKey: "align", type: "select", value: "stretch" },
        { inputKey: "gap", type: "select", value: "none" },
        { inputKey: "grow", type: "checkbox", value: !1 },
        { inputKey: "content", type: "richtext", value: "" }
      ],
      tablet: [],
      mobile: []
    }
  }
), fs = [
  {
    title: "Mobile Columns",
    description: "Number of columns on mobile devices",
    inputKey: "cols",
    type: "select",
    acceptedValues: ["1", "2", "3", "4", "5", "6", "12"]
  },
  {
    title: "Tablet Columns",
    description: "Number of columns on tablet devices (md breakpoint)",
    inputKey: "mdCols",
    type: "select",
    acceptedValues: ["1", "2", "3", "4", "5", "6", "12"]
  },
  {
    title: "Desktop Columns",
    description: "Number of columns on desktop devices (lg breakpoint)",
    inputKey: "lgCols",
    type: "select",
    acceptedValues: ["1", "2", "3", "4", "5", "6", "12"]
  },
  {
    title: "Gap",
    description: "Gap between grid items",
    inputKey: "gap",
    type: "select",
    acceptedValues: ["none", "xs", "sm", "md", "lg", "xl"]
  },
  {
    title: "Align Items",
    description: "Vertical alignment of grid items",
    inputKey: "alignItems",
    type: "select",
    acceptedValues: ["start", "center", "end", "stretch"]
  },
  {
    title: "Justify Items",
    description: "Horizontal alignment of grid items",
    inputKey: "justifyItems",
    type: "select",
    acceptedValues: ["start", "center", "end", "stretch"]
  },
  {
    title: "Content",
    description: "Content to display inside the grid",
    inputKey: "content",
    type: "richtext"
  }
], ys = {
  1: "grid-cols-1",
  2: "grid-cols-2",
  3: "grid-cols-3",
  4: "grid-cols-4",
  5: "grid-cols-5",
  6: "grid-cols-6",
  12: "grid-cols-12"
}, bs = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
  5: "md:grid-cols-5",
  6: "md:grid-cols-6",
  12: "md:grid-cols-12"
}, vs = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
  5: "lg:grid-cols-5",
  6: "lg:grid-cols-6",
  12: "lg:grid-cols-12"
}, xs = {
  none: "gap-0",
  xs: "gap-1",
  sm: "gap-2",
  md: "gap-4",
  lg: "gap-6",
  xl: "gap-8"
}, ks = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch"
}, ws = {
  start: "justify-items-start",
  center: "justify-items-center",
  end: "justify-items-end",
  stretch: "justify-items-stretch"
}, Ss = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (v, y) => {
      const f = e.desktop.find((x) => x.inputKey === v);
      return f ? f.value : y;
    }, o = r("cols", "1"), l = r("mdCols", ""), a = r("lgCols", ""), d = r("gap", "md"), c = r("alignItems", "stretch"), u = r("justifyItems", "stretch"), h = r("content", ""), m = [
      "grid",
      ys[o],
      l ? bs[l] : "",
      a ? vs[a] : "",
      xs[d],
      ks[c],
      ws[u],
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ s("div", { className: m, children: n || h && /* @__PURE__ */ s("div", { dangerouslySetInnerHTML: { __html: h } }) });
  },
  {
    title: "Grid",
    description: "A responsive CSS Grid component with configurable columns and alignment",
    identifier: "grid",
    input: fs,
    default: {
      desktop: [
        { inputKey: "cols", type: "select", value: "1" },
        { inputKey: "mdCols", type: "select", value: "" },
        { inputKey: "lgCols", type: "select", value: "" },
        { inputKey: "gap", type: "select", value: "md" },
        { inputKey: "alignItems", type: "select", value: "stretch" },
        { inputKey: "justifyItems", type: "select", value: "stretch" },
        { inputKey: "content", type: "richtext", value: "" }
      ],
      tablet: [],
      mobile: []
    }
  }
), Cs = [
  {
    title: "Padding",
    description: "Section padding variant",
    inputKey: "padding",
    type: "select",
    acceptedValues: ["none", "sm", "md", "lg", "xl"]
  },
  {
    title: "Background",
    description: "Background color variant",
    inputKey: "background",
    type: "select",
    acceptedValues: ["transparent", "white", "gray", "black", "primary"]
  },
  {
    title: "Full Width",
    description: "Whether section should take full width",
    inputKey: "fullWidth",
    type: "checkbox"
  },
  {
    title: "HTML Element",
    description: "HTML element to render",
    inputKey: "as",
    type: "select",
    acceptedValues: ["section", "div", "article", "aside", "main", "header", "footer"]
  },
  {
    title: "Content",
    description: "Content to display inside the section",
    inputKey: "content",
    type: "richtext"
  }
], Ns = {
  none: "",
  sm: "py-4",
  md: "py-8",
  lg: "py-12",
  xl: "py-16"
}, Ks = {
  transparent: "bg-transparent",
  white: "bg-white",
  gray: "bg-gray-50",
  black: "bg-black text-white",
  primary: "bg-gray-900 text-white"
}, Ts = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = t.values, o = (v, y) => {
      if (r && v in r)
        return r[v];
      if (Array.isArray(e.desktop)) {
        const f = e.desktop.find(
          (x) => x.inputKey === v
        );
        return f ? f.value : y;
      }
      return e.desktop && typeof e.desktop == "object" && v in e.desktop ? e.desktop[v] : y;
    }, l = o("padding", "md"), a = o("background", "transparent"), d = o("fullWidth", !0), c = o("as", "section"), u = o("content", ""), h = c, m = [
      Ns[l],
      Ks[a],
      d ? "w-full" : "",
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ s(h, { className: m, children: n || u && /* @__PURE__ */ s("div", { dangerouslySetInnerHTML: { __html: u } }) });
  },
  {
    title: "Section",
    description: "A semantic section wrapper component with configurable padding and background",
    identifier: "section",
    input: Cs,
    default: {
      desktop: [
        { inputKey: "padding", type: "select", value: "md" },
        { inputKey: "background", type: "select", value: "transparent" },
        { inputKey: "fullWidth", type: "checkbox", value: !0 },
        { inputKey: "as", type: "select", value: "section" },
        { inputKey: "content", type: "richtext", value: "" }
      ],
      tablet: [],
      mobile: []
    }
  }
), Is = [
  {
    title: "Spacing Size",
    description: "Size of the spacing",
    inputKey: "size",
    type: "select",
    acceptedValues: ["xs", "sm", "md", "lg", "xl", "2xl", "3xl"]
  },
  {
    title: "Direction",
    description: "Direction of the spacing",
    inputKey: "direction",
    type: "select",
    acceptedValues: ["vertical", "horizontal", "both"]
  }
], Es = {
  xs: "h-1",
  sm: "h-2",
  md: "h-4",
  lg: "h-6",
  xl: "h-8",
  "2xl": "h-12",
  "3xl": "h-16"
}, _s = {
  xs: "w-1",
  sm: "w-2",
  md: "w-4",
  lg: "w-6",
  xl: "w-8",
  "2xl": "w-12",
  "3xl": "w-16"
}, Fs = {
  xs: "w-1 h-1",
  sm: "w-2 h-2",
  md: "w-4 h-4",
  lg: "w-6 h-6",
  xl: "w-8 h-8",
  "2xl": "w-12 h-12",
  "3xl": "w-16 h-16"
}, Ps = he(
  (t) => {
    const { data: e, className: i } = t, n = (d, c) => {
      const u = e.desktop.find((h) => h.inputKey === d);
      return u ? u.value : c;
    }, r = n("size", "md"), o = n("direction", "vertical");
    let l = "";
    switch (o) {
      case "vertical":
        l = Es[r];
        break;
      case "horizontal":
        l = _s[r];
        break;
      case "both":
        l = Fs[r];
        break;
    }
    const a = [l, i].filter(Boolean).join(" ");
    return /* @__PURE__ */ s("div", { className: a, "aria-hidden": "true" });
  },
  {
    title: "Spacer",
    description: "A spacing utility component for creating consistent spacing in layouts",
    identifier: "spacer",
    input: Is,
    default: {
      desktop: [
        { inputKey: "size", type: "select", value: "md" },
        { inputKey: "direction", type: "select", value: "vertical" }
      ],
      tablet: [],
      mobile: []
    }
  }
), Ls = [
  {
    title: "Icon Name",
    description: "Name of the predefined icon to display",
    inputKey: "name",
    type: "select",
    acceptedValues: [
      "search",
      "heart",
      "shopping-bag",
      "user",
      "menu",
      "close",
      "chevron-down",
      "chevron-up",
      "chevron-left",
      "chevron-right",
      "star",
      "check",
      "x-mark",
      "plus",
      "minus",
      "home",
      "location"
    ]
  },
  {
    title: "Icon Size",
    description: "Size of the icon",
    inputKey: "size",
    type: "select",
    acceptedValues: ["xs", "sm", "md", "lg", "xl", "2xl"]
  },
  {
    title: "Icon Color",
    description: "Color of the icon",
    inputKey: "color",
    type: "select",
    acceptedValues: ["primary", "secondary", "accent", "muted", "white", "black", "current"]
  },
  {
    title: "Custom Size",
    description: "Custom size in pixels (overrides size preset)",
    inputKey: "customSize",
    type: "number",
    acceptedRange: [8, 128]
  },
  {
    title: "Accessible Label",
    description: "Accessible label for screen readers",
    inputKey: "ariaLabel",
    type: "text"
  },
  {
    title: "Decorative",
    description: "Whether icon is decorative (hidden from screen readers)",
    inputKey: "decorative",
    type: "checkbox"
  }
], As = {
  xs: "w-3 h-3",
  sm: "w-4 h-4",
  md: "w-5 h-5",
  lg: "w-6 h-6",
  xl: "w-8 h-8",
  "2xl": "w-10 h-10"
}, Rs = {
  primary: "text-gray-900",
  secondary: "text-gray-700",
  accent: "text-orange-600",
  muted: "text-gray-500",
  white: "text-white",
  black: "text-black",
  current: "text-current"
}, vn = {
  search: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z",
  heart: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z",
  "shopping-bag": "M16 11V7a4 4 0 00-8 0v4M5 9h14l-1 12H6L5 9z",
  user: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
  menu: "M4 6h16M4 12h16M4 18h16",
  close: "M6 18L18 6M6 6l12 12",
  "chevron-down": "M19 9l-7 7-7-7",
  "chevron-up": "M5 15l7-7 7 7",
  "chevron-left": "M15 18l-6-6 6-6",
  "chevron-right": "M9 18l6-6-6-6",
  star: "M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z",
  check: "M5 13l4 4L19 7",
  "x-mark": "M6 18L18 6M6 6l12 12",
  plus: "M12 4v16m8-8H4",
  minus: "M20 12H4",
  home: "M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6",
  location: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z M15 11a3 3 0 11-6 0 3 3 0 016 0z"
}, zs = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (y, f) => {
      const x = e.desktop.find((b) => b.inputKey === y);
      return x ? x.value : f;
    }, o = r("name", ""), l = r("size", "md"), a = r("color", "current"), d = r("customSize", 0), c = r("ariaLabel", ""), u = r("decorative", !1), v = {
      className: [
        d > 0 ? `w-${d} h-${d}` : As[l],
        Rs[a],
        "inline-block flex-shrink-0",
        i
      ].filter(Boolean).join(" "),
      fill: "none",
      stroke: "currentColor",
      viewBox: "0 0 24 24",
      "aria-hidden": u,
      "aria-label": u ? void 0 : c,
      role: u ? void 0 : "img"
    };
    return n ? /* @__PURE__ */ s("svg", { ...v, children: n }) : o && vn[o] ? /* @__PURE__ */ s("svg", { ...v, children: /* @__PURE__ */ s(
      "path",
      {
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        d: vn[o]
      }
    ) }) : /* @__PURE__ */ s("svg", { ...v });
  },
  {
    title: "Icon",
    description: "A customizable icon component with predefined Nike-style icons",
    identifier: "icon",
    input: Ls,
    default: {
      desktop: [
        { inputKey: "name", type: "select", value: "" },
        { inputKey: "size", type: "select", value: "md" },
        { inputKey: "color", type: "select", value: "current" },
        { inputKey: "customSize", type: "number", value: 0 },
        { inputKey: "ariaLabel", type: "text", value: "" },
        { inputKey: "decorative", type: "checkbox", value: !1 }
      ],
      tablet: [],
      mobile: []
    }
  }
), Bs = he(
  (t) => {
    const i = `heading-component ${t.className || ""}`, {
      text: n,
      level: r,
      fontSize: o,
      fontWeight: l,
      textColor: a,
      textAlign: d,
      marginBottom: c
    } = t.values, u = {
      fontSize: o ? `${o}px` : void 0,
      fontWeight: l || "bold",
      color: a || "#000000",
      textAlign: d || "left",
      marginBottom: c ? `${c}px` : void 0
    }, h = `h${r}`;
    return Z.createElement(
      h,
      {
        className: i,
        style: u
      },
      n
    );
  },
  {
    title: "Heading Component",
    description: "A heading component with configurable heading levels and styling",
    identifier: "heading-text",
    input: [
      {
        title: "Heading Text",
        description: "The text content for the heading",
        inputKey: "text",
        type: "text"
      },
      {
        title: "Heading Level",
        description: "HTML heading level (h1-h6)",
        inputKey: "level",
        type: "select",
        acceptedValues: ["1", "2", "3", "4", "5", "6"]
      },
      {
        title: "Font Size",
        description: "Font size in pixels (overrides default heading size)",
        inputKey: "fontSize",
        type: "number",
        acceptedRange: [12, 96]
      },
      {
        title: "Font Weight",
        description: "Font weight for the heading",
        inputKey: "fontWeight",
        type: "select",
        acceptedValues: [
          "normal",
          "bold",
          "lighter",
          "bolder",
          "100",
          "200",
          "300",
          "400",
          "500",
          "600",
          "700",
          "800",
          "900"
        ]
      },
      {
        title: "Text Color",
        description: "Color of the heading text",
        inputKey: "textColor",
        type: "color"
      },
      {
        title: "Text Alignment",
        description: "Text alignment within the container",
        inputKey: "textAlign",
        type: "select",
        acceptedValues: ["left", "center", "right", "justify"]
      },
      {
        title: "Margin Bottom",
        description: "Bottom margin in pixels",
        inputKey: "marginBottom",
        type: "number",
        acceptedRange: [0, 100]
      }
    ],
    default: {
      desktop: [
        { inputKey: "text", type: "text", value: "Default Heading" },
        { inputKey: "level", type: "select", value: "2" },
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 28 },
        { inputKey: "marginBottom", type: "number", value: 12 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 24 },
        { inputKey: "marginBottom", type: "number", value: 8 }
      ]
    }
  }
), $s = [
  {
    title: "Link Text",
    description: "The text content for the link",
    inputKey: "linkText",
    type: "text"
  },
  {
    title: "Link URL",
    description: "The destination URL for the link",
    inputKey: "href",
    type: "link"
  },
  {
    title: "Text Size",
    description: "Size of the link text",
    inputKey: "size",
    type: "select",
    acceptedValues: ["xs", "sm", "md", "lg", "xl"]
  },
  {
    title: "Font Weight",
    description: "Weight variant of the font",
    inputKey: "weight",
    type: "select",
    acceptedValues: ["light", "normal", "medium", "semibold", "bold"]
  },
  {
    title: "Link Variant",
    description: "Color and style variant of the link",
    inputKey: "variant",
    type: "select",
    acceptedValues: ["primary", "secondary", "accent", "muted", "white", "black", "underline", "no-underline"]
  },
  {
    title: "Hover Effect",
    description: "Hover effect style",
    inputKey: "hover",
    type: "select",
    acceptedValues: ["underline", "opacity", "color", "none"]
  },
  {
    title: "External Link",
    description: "Whether link opens in new tab",
    inputKey: "external",
    type: "checkbox"
  },
  {
    title: "Disabled",
    description: "Whether link is disabled",
    inputKey: "disabled",
    type: "checkbox"
  }
], Os = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
  xl: "text-xl"
}, Ms = {
  light: "font-light",
  normal: "font-normal",
  medium: "font-medium",
  semibold: "font-semibold",
  bold: "font-bold"
}, Ds = {
  primary: "text-gray-900 hover:text-gray-700",
  secondary: "text-gray-700 hover:text-gray-900",
  accent: "text-orange-600 hover:text-orange-700",
  muted: "text-gray-500 hover:text-gray-700",
  white: "text-white hover:text-gray-200",
  black: "text-black hover:text-gray-800",
  underline: "text-gray-900 underline hover:text-gray-700",
  "no-underline": "text-gray-900 no-underline hover:text-gray-700"
}, Ws = {
  underline: "hover:underline",
  opacity: "hover:opacity-80",
  color: "",
  // Color change is handled in variant classes
  none: ""
}, Hs = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (f, x) => {
      const b = e.desktop.find((g) => g.inputKey === f);
      return b ? b.value : x;
    }, o = r("linkText", "Link"), l = r("href", "#"), a = r("size", "md"), d = r("weight", "normal"), c = r("variant", "primary"), u = r("hover", "color"), h = r("external", !1), m = r("disabled", !1), v = [
      Os[a],
      Ms[d],
      Ds[c],
      Ws[u],
      m ? "opacity-50 cursor-not-allowed pointer-events-none" : "cursor-pointer",
      "transition-colors duration-200",
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ s("a", { ...{
      href: m ? void 0 : l,
      target: h ? "_blank" : void 0,
      rel: h ? "noopener noreferrer" : void 0,
      className: v,
      "aria-disabled": m
    }, children: n || o });
  },
  {
    title: "Link",
    description: "A customizable link component with various styling options and hover effects",
    identifier: "link-text",
    input: $s,
    default: {
      desktop: [
        { inputKey: "linkText", type: "text", value: "Link" },
        { inputKey: "href", type: "link", value: "#" },
        { inputKey: "size", type: "select", value: "md" },
        { inputKey: "weight", type: "select", value: "normal" },
        { inputKey: "variant", type: "select", value: "primary" },
        { inputKey: "hover", type: "select", value: "color" },
        { inputKey: "external", type: "checkbox", value: !1 },
        { inputKey: "disabled", type: "checkbox", value: !1 }
      ],
      tablet: [],
      mobile: []
    }
  }
), js = he(
  (t) => {
    const i = `rich-text-component ${t.className || ""}`, {
      content: n,
      fontSize: r,
      fontWeight: o,
      textColor: l,
      textAlign: a,
      lineHeight: d,
      maxWidth: c
    } = t.values, u = {
      fontSize: r ? `${r}px` : void 0,
      fontWeight: o || "normal",
      color: l || "#000000",
      textAlign: a || "left",
      lineHeight: d || "normal",
      maxWidth: c ? `${c}px` : void 0
    };
    return /* @__PURE__ */ s(
      "div",
      {
        className: i,
        style: u,
        dangerouslySetInnerHTML: { __html: n }
      }
    );
  },
  {
    title: "Rich Text Component",
    description: "A rich text component that supports HTML content with customizable styling",
    identifier: "rich-text-block",
    input: [
      {
        title: "Rich Text Content",
        description: "HTML content for rich text formatting",
        inputKey: "content",
        type: "richtext"
      },
      {
        title: "Font Size",
        description: "Font size in pixels",
        inputKey: "fontSize",
        type: "number",
        acceptedRange: [8, 72]
      },
      {
        title: "Font Weight",
        description: "Font weight for the text",
        inputKey: "fontWeight",
        type: "select",
        acceptedValues: [
          "normal",
          "bold",
          "lighter",
          "bolder",
          "100",
          "200",
          "300",
          "400",
          "500",
          "600",
          "700",
          "800",
          "900"
        ]
      },
      {
        title: "Text Color",
        description: "Color of the text",
        inputKey: "textColor",
        type: "color"
      },
      {
        title: "Text Alignment",
        description: "Text alignment within the container",
        inputKey: "textAlign",
        type: "select",
        acceptedValues: ["left", "center", "right", "justify"]
      },
      {
        title: "Line Height",
        description: "Line height for the text",
        inputKey: "lineHeight",
        type: "select",
        acceptedValues: ["normal", "1", "1.2", "1.4", "1.5", "1.6", "2"]
      },
      {
        title: "Max Width",
        description: "Maximum width of the text container in pixels",
        inputKey: "maxWidth",
        type: "number",
        acceptedRange: [100, 2e3]
      }
    ],
    // Important: add 'as const' for type inference
    default: {
      desktop: [
        {
          inputKey: "content",
          type: "richtext",
          value: "<p>Default rich text content with <strong>bold</strong> and <em>italic</em> formatting.</p>"
        },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "lineHeight", type: "select", value: "1.5" },
        { inputKey: "maxWidth", type: "number", value: 800 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "maxWidth", type: "number", value: 600 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 12 },
        { inputKey: "maxWidth", type: "number", value: 350 }
      ]
    }
  }
), Vs = he(
  (t) => {
    const i = `text-component ${t.className || ""}`, {
      text: n,
      fontSize: r,
      textColor: o,
      textAlign: l,
      marginBottom: a
    } = t.values, d = {
      fontSize: r ? `${r}px` : void 0,
      color: o || "#000000",
      textAlign: l || "left",
      marginBottom: a ? `${a}px` : void 0
    };
    return /* @__PURE__ */ s("p", { className: i, style: d, children: n });
  },
  {
    title: "Text Component",
    description: "A flexible text component with customizable styling options",
    identifier: "text-block",
    input: [
      {
        title: "Text Content",
        description: "The text content to display",
        inputKey: "text",
        type: "text"
      },
      {
        title: "Font Size",
        description: "Font size in pixels",
        inputKey: "fontSize",
        type: "number",
        acceptedRange: [8, 72]
      },
      {
        title: "Text Color",
        description: "Color of the text",
        inputKey: "textColor",
        type: "color"
      },
      {
        title: "Text Alignment",
        description: "Text alignment within the container",
        inputKey: "textAlign",
        type: "select",
        acceptedValues: ["left", "center", "right", "justify"]
      },
      {
        title: "Margin Bottom",
        description: "Bottom margin in pixels",
        inputKey: "marginBottom",
        type: "number",
        acceptedRange: [0, 100]
      }
    ],
    default: {
      desktop: [
        { inputKey: "text", type: "text", value: "Default text content" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "marginBottom", type: "number", value: 0 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "marginBottom", type: "number", value: 0 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 12 },
        { inputKey: "marginBottom", type: "number", value: 0 }
      ]
    }
  }
), Us = [
  {
    title: "Heading Text",
    description: "The heading text content",
    inputKey: "headingText",
    type: "text"
  },
  {
    title: "Heading Level",
    description: "The semantic heading level (h1-h6)",
    inputKey: "level",
    type: "select",
    acceptedValues: ["1", "2", "3", "4", "5", "6"]
  },
  {
    title: "Visual Size",
    description: "Visual size variant independent of semantic level",
    inputKey: "size",
    type: "select",
    acceptedValues: ["xs", "sm", "md", "lg", "xl", "2xl", "3xl", "4xl", "5xl"]
  },
  {
    title: "Font Weight",
    description: "Weight variant of the font",
    inputKey: "weight",
    type: "select",
    acceptedValues: ["light", "normal", "medium", "semibold", "bold", "extrabold"]
  },
  {
    title: "Text Color",
    description: "Color variant of the heading",
    inputKey: "color",
    type: "select",
    acceptedValues: ["primary", "secondary", "accent", "muted", "white", "black"]
  },
  {
    title: "Text Alignment",
    description: "Alignment of the heading",
    inputKey: "align",
    type: "select",
    acceptedValues: ["left", "center", "right"]
  }
], qs = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
  xl: "text-xl",
  "2xl": "text-2xl",
  "3xl": "text-3xl",
  "4xl": "text-4xl",
  "5xl": "text-5xl"
}, Gs = {
  light: "font-light",
  normal: "font-normal",
  medium: "font-medium",
  semibold: "font-semibold",
  bold: "font-bold",
  extrabold: "font-extrabold"
}, Ys = {
  primary: "text-gray-900",
  secondary: "text-gray-700",
  accent: "text-orange-600",
  muted: "text-gray-500",
  white: "text-white",
  black: "text-black"
}, Xs = {
  left: "text-left",
  center: "text-center",
  right: "text-right"
}, Qs = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (m, v) => {
      const y = e.desktop.find((f) => f.inputKey === m);
      return y ? y.value : v;
    }, o = r("headingText", "Heading"), l = r("level", "1"), a = r("size", "lg"), d = r("weight", "bold"), c = r("color", "primary"), u = r("align", "left"), h = [
      qs[a],
      Gs[d],
      Ys[c],
      Xs[u],
      i
    ].filter(Boolean).join(" ");
    return Z.createElement(
      `h${l}`,
      { className: h },
      n || o
    );
  },
  {
    title: "UI Heading",
    description: "A semantic heading component with configurable levels and visual styling",
    identifier: "ui-heading",
    input: Us,
    default: {
      desktop: [
        { inputKey: "headingText", type: "text", value: "Heading" },
        { inputKey: "level", type: "select", value: "1" },
        { inputKey: "size", type: "select", value: "lg" },
        { inputKey: "weight", type: "select", value: "bold" },
        { inputKey: "color", type: "select", value: "primary" },
        { inputKey: "align", type: "select", value: "left" }
      ],
      tablet: [],
      mobile: []
    }
  }
), Js = [
  {
    title: "Text Content",
    description: "The text content to display",
    inputKey: "textContent",
    type: "richtext"
  },
  {
    title: "Text Size",
    description: "Size variant of the text",
    inputKey: "size",
    type: "select",
    acceptedValues: ["xs", "sm", "md", "lg", "xl"]
  },
  {
    title: "Font Weight",
    description: "Weight variant of the font",
    inputKey: "weight",
    type: "select",
    acceptedValues: ["light", "normal", "medium", "semibold", "bold"]
  },
  {
    title: "Text Color",
    description: "Color variant of the text",
    inputKey: "color",
    type: "select",
    acceptedValues: ["primary", "secondary", "accent", "muted", "white", "black", "error", "success"]
  },
  {
    title: "Text Alignment",
    description: "Alignment of the text",
    inputKey: "align",
    type: "select",
    acceptedValues: ["left", "center", "right", "justify"]
  },
  {
    title: "Text Transform",
    description: "Text transformation style",
    inputKey: "transform",
    type: "select",
    acceptedValues: ["none", "uppercase", "lowercase", "capitalize"]
  },
  {
    title: "Line Height",
    description: "Line height variant",
    inputKey: "leading",
    type: "select",
    acceptedValues: ["tight", "normal", "relaxed", "loose"]
  },
  {
    title: "Truncate",
    description: "Whether text should truncate with ellipsis",
    inputKey: "truncate",
    type: "checkbox"
  },
  {
    title: "HTML Element",
    description: "HTML element to render",
    inputKey: "as",
    type: "select",
    acceptedValues: ["p", "span", "div", "small", "strong", "em"]
  }
], Zs = {
  xs: "text-xs",
  sm: "text-sm",
  md: "text-base",
  lg: "text-lg",
  xl: "text-xl"
}, ea = {
  light: "font-light",
  normal: "font-normal",
  medium: "font-medium",
  semibold: "font-semibold",
  bold: "font-bold"
}, ta = {
  primary: "text-gray-900",
  secondary: "text-gray-700",
  accent: "text-orange-600",
  muted: "text-gray-500",
  white: "text-white",
  black: "text-black",
  error: "text-red-600",
  success: "text-green-600"
}, ia = {
  left: "text-left",
  center: "text-center",
  right: "text-right",
  justify: "text-justify"
}, na = {
  none: "",
  uppercase: "uppercase",
  lowercase: "lowercase",
  capitalize: "capitalize"
}, ra = {
  tight: "leading-tight",
  normal: "leading-normal",
  relaxed: "leading-relaxed",
  loose: "leading-loose"
}, oa = he(
  (t) => {
    const { data: e, className: i, children: n } = t, r = (x, b) => {
      const g = e.desktop.find((k) => k.inputKey === x);
      return g ? g.value : b;
    }, o = r("textContent", ""), l = r("size", "md"), a = r("weight", "normal"), d = r("color", "primary"), c = r("align", "left"), u = r("transform", "none"), h = r("leading", "normal"), m = r("truncate", !1), y = r("as", "p"), f = [
      Zs[l],
      ea[a],
      ta[d],
      ia[c],
      na[u],
      ra[h],
      m ? "truncate" : "",
      i
    ].filter(Boolean).join(" ");
    return /* @__PURE__ */ s(y, { className: f, children: n || o && /* @__PURE__ */ s("span", { dangerouslySetInnerHTML: { __html: o } }) });
  },
  {
    title: "UI Text",
    description: "A comprehensive text component with extensive styling options",
    identifier: "ui-text",
    input: Js,
    default: {
      desktop: [
        { inputKey: "textContent", type: "richtext", value: "" },
        { inputKey: "size", type: "select", value: "md" },
        { inputKey: "weight", type: "select", value: "normal" },
        { inputKey: "color", type: "select", value: "primary" },
        { inputKey: "align", type: "select", value: "left" },
        { inputKey: "transform", type: "select", value: "none" },
        { inputKey: "leading", type: "select", value: "normal" },
        { inputKey: "truncate", type: "checkbox", value: !1 },
        { inputKey: "as", type: "select", value: "p" }
      ],
      tablet: [],
      mobile: []
    }
  }
), sa = {
  "button-solid": on,
  "button-outline": ar,
  "cta-button": Bo,
  "icon-button": Wo,
  "link-button": qo,
  "button-modern": Go,
  "ui-button": Jo,
  "background-image": Zo,
  image: es,
  "responsive-image": is,
  "ui-image": rs,
  container: ls,
  flex: gs,
  grid: Ss,
  section: Ts,
  spacer: Ps,
  icon: zs,
  "heading-text": Bs,
  "link-text": Hs,
  "rich-text-block": js,
  "text-block": Vs,
  "ui-heading": Qs,
  "ui-text": oa
};
function aa(t) {
  return sa[t];
}
const ni = (t, e, i, n) => `${t}::${e}::${i}::${n}`;
class la {
  constructor() {
    this.data = /* @__PURE__ */ new Map(), this.subs = /* @__PURE__ */ new Map();
  }
  initializeSection(e, i) {
    e && Object.entries(i || {}).forEach(([n, r]) => {
      ["desktop", "tablet", "mobile"].forEach((l) => {
        ((r == null ? void 0 : r[l]) || []).forEach((d) => {
          const c = ni(
            e,
            n,
            l,
            d.inputKey
          );
          this.data.has(c) || this.data.set(c, d.value);
        });
      });
    });
  }
  getField(e, i, n, r = "desktop") {
    const o = ni(e, i, r, n);
    return this.data.get(o);
  }
  setField(e, i, n, r, o = "desktop") {
    const l = ni(e, i, o, n), a = this.data.get(l);
    if (!!(a === r || Number.isNaN(a) && Number.isNaN(r))) return;
    this.data.set(l, r);
    const c = this.subs.get(l);
    c && c.forEach((u) => u());
  }
  subscribe(e, i, n, r, o = "desktop") {
    const l = ni(e, i, o, n);
    let a = this.subs.get(l);
    return a || (a = /* @__PURE__ */ new Set(), this.subs.set(l, a)), a.add(r), () => {
      a.delete(r), a.size === 0 && this.subs.delete(l);
    };
  }
  // Method to get snapshot for hook - used by client wrapper
  getSnapshot(e, i, n, r, o = "desktop") {
    if (!e || !i) return r;
    const l = this.getField(e, i, n, o);
    return l === void 0 ? r : l;
  }
}
const Pt = new la();
function ca(t) {
  const e = t.defaultData || {};
  return function(n) {
    const r = { ...e, ...n.data }, o = n.uniqueSectionIdentifier || n.uniqueSectionId || null;
    if (o)
      try {
        Pt.initializeSection(o, r);
      } catch (l) {
        console.warn("componentDataStore initialization failed", l);
      }
    return /* @__PURE__ */ s(t, { ...n, data: r });
  };
}
function Hu(t, e, i, n, r = "desktop") {
  const o = () => Pt.getSnapshot(
    t,
    e,
    i,
    n,
    r
  );
  return Zr((a) => !t || !e ? () => {
  } : Pt.subscribe(
    t,
    e,
    i,
    a,
    r
  ), o, o);
}
const xn = /* @__PURE__ */ new Set(), da = {
  home: "home",
  product: "product-description/:slug",
  productListing: "product-listing",
  checkout: "checkout",
  account: "account-dashboard",
  orders: "order-tracking",
  signIn: "sign-in",
  verifyOtp: "verify-otp"
};
function ue(t, e) {
  if (xn.has(e.identifier))
    return t;
  xn.add(e.identifier);
  const i = ca(t), r = (l) => Z.createElement(i, {
    ...l,
    config: e,
    theme: l.theme
  }), o = lr(e.components);
  return Object.assign(r, {
    ...e,
    defaultData: o
    // Store default data directly on the section component
  }), r.displayName = e.identifier, r;
}
function F(t, e, i, n) {
  return {
    componentType: t,
    componentIdentifier: e,
    data: i,
    name: n == null ? void 0 : n.name,
    description: n == null ? void 0 : n.description
  };
}
function R(t, e, i, n = "desktop") {
  const r = t[i];
  if (!r) {
    console.warn(
      `Component data not found for identifier: ${i}`
    );
    return;
  }
  if (!aa(e)) {
    console.warn(
      `Component type not found in registry: ${e} for identifier: ${i}`
    );
    return;
  }
  return ua(r, n);
}
function ua(t, e) {
  const i = ri(t.desktop), n = kn(i, t.tablet), r = kn(n, t.mobile), o = e === "desktop" ? i : e === "tablet" ? n : r;
  return {
    ...t,
    desktop: ri(o),
    tablet: ri(o),
    mobile: ri(o)
  };
}
function ri(t) {
  return Array.isArray(t) ? t.map((e) => ({ ...e })) : { ...t && typeof t == "object" ? t : {} };
}
function kn(t, e) {
  return Array.isArray(t) || Array.isArray(e) ? pa(
    Array.isArray(t) ? t : [],
    Array.isArray(e) ? e : []
  ) : {
    ...t && typeof t == "object" ? t : {},
    ...e && typeof e == "object" ? e : {}
  };
}
function pa(t, e) {
  const i = /* @__PURE__ */ new Map();
  return t.forEach((n) => {
    i.set(n.inputKey, { ...n });
  }), e.forEach((n) => {
    const r = i.get(n.inputKey);
    i.set(n.inputKey, {
      ...r || {},
      ...n
    });
  }), Array.from(i.values());
}
function lr(t) {
  const e = {};
  return t.forEach((i) => {
    e[i.componentIdentifier] = {
      componentSlug: i.componentType,
      name: i.name || wn(i.componentType),
      description: i.description || `${wn(i.componentType)} component`,
      ...i.data
    };
  }), e;
}
function wn(t) {
  return t.split("-").map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function ma(t) {
  return lr(t.components);
}
function ju(t) {
  return ma(t);
}
function Vu(t, e, i, n, r = "desktop") {
  Pt.setField(
    t,
    e,
    i,
    n,
    r
  );
}
function Uu(t, e, i, n = "desktop") {
  return Pt.getField(
    t,
    e,
    i,
    n
  );
}
function B(t, e, i, n = "desktop") {
  if (!t)
    return i;
  const r = t[n] ?? t.desktop;
  if (Array.isArray(r)) {
    const o = r.find((l) => l.inputKey === e);
    if (o !== void 0)
      return o.value ?? i;
  }
  if (r && typeof r == "object") {
    const o = r[e];
    if (o !== void 0)
      return o ?? i;
  }
  return i;
}
const ha = {}, $e = ({
  src: t,
  alt: e,
  className: i = "",
  placeholderClassName: n,
  showPlaceholderIcon: r = !0,
  placeholderText: o,
  cdnWidth: l = 600,
  cdnHeight: a = 400,
  cdnFit: d = "fit",
  cdnFormat: c = "webp",
  ...u
}) => {
  if (t && typeof t == "string" && t.trim() !== "") {
    const y = nn(t, {
      width: l,
      height: a,
      fit: {
        fit: "inside",
        cover: "cover",
        contain: "contain"
      }[d] || "inside",
      format: c
    });
    return /* @__PURE__ */ s("img", { src: y, alt: e, className: i, ...u });
  }
  return /* @__PURE__ */ s(
    "div",
    {
      className: `flex items-center justify-center bg-gray-200 ${n || i}`,
      role: "img",
      "aria-label": e || "Image placeholder",
      children: r && /* @__PURE__ */ p("div", { className: "flex flex-col items-center justify-center text-gray-400", children: [
        /* @__PURE__ */ s(oo, { className: "h-8 w-8" }),
        o && /* @__PURE__ */ s("span", { className: "mt-2 text-xs", children: o })
      ] })
    }
  );
};
function et(t) {
  if (typeof window < "u" && typeof require > "u")
    return null;
  try {
    return (typeof __webpack_require__ < "u" ? __webpack_require__ : require)(t);
  } catch {
    return null;
  }
}
function ga() {
  if (typeof window < "u" && window.__NEXT_DATA__)
    return "nextjs";
  try {
    if (et(["next", "navigation"].join("/"))) return "nextjs";
  } catch {
  }
  try {
    if (et(["react-router", "dom"].join("-"))) return "react-router";
  } catch {
  }
  return "none";
}
let Ei = null;
function sn() {
  return Ei === null && (Ei = ga()), Ei;
}
const Lt = (t) => {
  const e = sn(), { href: i, children: n, className: r, onClick: o, target: l, rel: a, replace: d, ...c } = t;
  if (e === "nextjs")
    try {
      const u = et(["next", "link"].join("/"));
      if (u && u.default) {
        const h = u.default;
        return /* @__PURE__ */ s(
          h,
          {
            href: i,
            className: r,
            onClick: o,
            target: l,
            rel: a,
            replace: d,
            ...c,
            children: n
          }
        );
      }
    } catch (u) {
      console.warn("[Navigation Adapter] Next.js Link failed to load:", u);
    }
  if (e === "react-router")
    try {
      const u = et(["react-router", "dom"].join("-"));
      if (u && u.Link) {
        const h = u.Link;
        return /* @__PURE__ */ s(
          h,
          {
            to: i,
            className: r,
            onClick: o,
            target: l,
            rel: a,
            replace: d,
            ...c,
            children: n
          }
        );
      }
    } catch (u) {
      console.warn("[Navigation Adapter] React Router Link failed to load:", u);
    }
  return /* @__PURE__ */ s(
    "a",
    {
      href: i,
      className: r,
      onClick: o,
      target: l,
      rel: a,
      ...c,
      children: n
    }
  );
};
function an() {
  const t = sn();
  if (t === "nextjs")
    try {
      const e = et(["next", "navigation"].join("/"));
      if (e && e.useRouter) {
        const i = e.useRouter();
        return {
          push: i.push,
          replace: i.replace,
          back: i.back,
          forward: i.forward,
          refresh: i.refresh,
          prefetch: i.prefetch
        };
      }
    } catch (e) {
      console.warn("[Navigation Adapter] Next.js useRouter failed to load:", e);
    }
  if (t === "react-router")
    try {
      const e = et(["react-router", "dom"].join("-"));
      if (e && e.useNavigate) {
        const i = e.useNavigate();
        return {
          push: (n) => i(n),
          replace: (n) => i(n, { replace: !0 }),
          back: () => i(-1),
          forward: () => i(1),
          refresh: () => window.location.reload()
        };
      }
    } catch (e) {
      console.warn("[Navigation Adapter] React Router useNavigate failed to load:", e);
    }
  return {
    push: (e) => {
      window.location.href = e;
    },
    replace: (e) => {
      window.location.replace(e);
    },
    back: () => {
      window.history.back();
    },
    forward: () => {
      window.history.forward();
    },
    refresh: () => {
      window.location.reload();
    }
  };
}
function fa() {
  const t = sn(), [e, i] = O(new URLSearchParams());
  if (U(() => {
    typeof window < "u" && i(new URLSearchParams(window.location.search));
  }, []), t === "nextjs")
    try {
      const n = et(["next", "navigation"].join("/"));
      if (n && n.useSearchParams)
        return n.useSearchParams();
    } catch (n) {
      console.warn("[Navigation Adapter] Next.js useSearchParams failed to load:", n);
    }
  if (t === "react-router")
    try {
      const n = et(["react-router", "dom"].join("-"));
      if (n && n.useSearchParams) {
        const [r] = n.useSearchParams();
        return r;
      }
    } catch (n) {
      console.warn("[Navigation Adapter] React Router useSearchParams failed to load:", n);
    }
  return e;
}
function cr(t) {
  return { ...da, ...t };
}
function dr() {
  if (typeof window > "u" || !window.location)
    return { isPreview: !1 };
  const t = window.location.pathname.match(/^\/preview\/([^\/]+)/);
  return t && t[1] ? {
    isPreview: !0,
    site: t[1]
  } : { isPreview: !1 };
}
function _i(t) {
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(t);
}
function ze(t) {
  if (console.log("[getRouteOptions] routeContext.site:", t == null ? void 0 : t.site, "isUUIDLike:", t != null && t.site ? _i(t.site) : "N/A"), t != null && t.site && !_i(t.site))
    return console.log("[getRouteOptions] Using context site:", t.site), {
      prefix: "preview",
      includeSite: !0,
      site: t.site
    };
  console.log("[getRouteOptions] Skipping context, will try URL detection");
  const e = dr();
  return console.log("[getRouteOptions] detectPreviewMode result:", e), e.isPreview && e.site && !_i(e.site) ? (console.log("[getRouteOptions] Using URL-detected site:", e.site), {
    prefix: "preview",
    includeSite: !0,
    site: e.site
  }) : (console.log("[getRouteOptions] Defaulting to production mode (no prefix)"), { prefix: "", includeSite: !1 });
}
function ya(t) {
  return t.toLowerCase().replace(/[^a-z0-9\s-]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").trim();
}
function ba(t) {
  var n, r;
  const e = (n = t.handle) == null ? void 0 : n.trim();
  if (e) return e;
  const i = (r = t.slug) == null ? void 0 : r.trim();
  return i || ya(t.title || "product");
}
function At(t, e, i) {
  const n = t.startsWith("/") ? t.slice(1) : t, r = i || ze(e);
  let o = "";
  if (r.prefix && r.includeSite) {
    const a = r.site || (e == null ? void 0 : e.site) || "default";
    o = `/${r.prefix}/${a}/${n}`;
  } else
    o = `/${n}`;
  const l = e != null && e.site ? "context" : dr().isPreview ? "url" : "default";
  return console.log(
    "[RouteHelper] buildRoute:",
    t,
    "| mode:",
    r.prefix ? "preview" : "production",
    "| theme:",
    r.site || "none",
    "| via:",
    l,
    "→",
    o
  ), o;
}
function va(t, e, i, n) {
  const o = cr(i).product.replace(":slug", t);
  return console.log("[RouteHelper] buildProductRoute:", t, "→", o), At(o, e, n);
}
function Se(t, e, i, n) {
  console.log("[RouteHelper] getNamedRoute:", t);
  const r = cr(i), o = r[t];
  return o ? At(o, e, n) : (console.log(`[RouteHelper] Route "${t}" not found, falling back to home`), At(r.home, e, n));
}
function Ki(t, e, i, n) {
  const r = At(t, e, n);
  if (!i || Object.keys(i).length === 0)
    return r;
  const o = new URLSearchParams(i).toString(), l = `${r}?${o}`;
  return console.log("[RouteHelper] buildRouteWithParams:", t, i, "→", l), l;
}
const xa = {
  NODE_ENV: "production",
  API_BASE_URL: "https://server.shiphouse.in",
  STORE_ID: "default-store"
};
let Rt = { ...xa };
function ka() {
  if (typeof process < "u" && process.env) {
    const t = {};
    process.env.NODE_ENV && (t.NODE_ENV = process.env.NODE_ENV), process.env.ENV && (t.ENV = process.env.ENV), process.env.VITE_ENV && (t.VITE_ENV = process.env.VITE_ENV), process.env.VITE_API_BASE_URL && (t.API_BASE_URL = process.env.VITE_API_BASE_URL), process.env.NEXT_PUBLIC_API_URL && (t.NEXT_PUBLIC_API_URL = process.env.NEXT_PUBLIC_API_URL), process.env.VITE_STORE_ID && (t.STORE_ID = process.env.VITE_STORE_ID), process.env.NEXT_PUBLIC_STORE_ID && (t.NEXT_PUBLIC_STORE_ID = process.env.NEXT_PUBLIC_STORE_ID), process.env.NEXT_PUBLIC_SHIPHOUSE_STORE_ID && (t.NEXT_PUBLIC_SHIPHOUSE_STORE_ID = process.env.NEXT_PUBLIC_SHIPHOUSE_STORE_ID), process.env.NEXT_PUBLIC_SHIPHOUSE_API_URL && (t.NEXT_PUBLIC_SHIPHOUSE_API_URL = process.env.NEXT_PUBLIC_SHIPHOUSE_API_URL), process.env.VITE_AUTH_TOKEN && (t.AUTH_TOKEN = process.env.VITE_AUTH_TOKEN), process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID && (t.NEXT_PUBLIC_RAZORPAY_KEY_ID = process.env.NEXT_PUBLIC_RAZORPAY_KEY_ID), process.env.VITE_DEBUG === "true" && (t.DEBUG = !0), (process.env.SHIPHOUSE_SDK_FAKE_DATA === "true" || process.env.SCREENSHOT_USE_FAKE_DATA === "true" || process.env.VITE_SHIPHOUSE_SDK_FAKE_DATA === "true" || process.env.VITE_SCREENSHOT_USE_FAKE_DATA === "true" || process.env.NEXT_PUBLIC_SHIPHOUSE_SDK_FAKE_DATA === "true" || process.env.NEXT_PUBLIC_SCREENSHOT_USE_FAKE_DATA === "true") && (t.SHIPHOUSE_SDK_FAKE_DATA = !0), process.env.VITE_TEMPLATE_SLUG && (t.TEMPLATE_SLUG = process.env.VITE_TEMPLATE_SLUG), process.env.VITE_RAZORPAY_KEY_ID && (t.RAZORPAY_KEY_ID = process.env.VITE_RAZORPAY_KEY_ID), process.env.VITE_BUILDER_API_KEY && (t.BUILDER_API_KEY = process.env.VITE_BUILDER_API_KEY), process.env.NEXT_PUBLIC_BUILDER_API_KEY && (t.NEXT_PUBLIC_BUILDER_API_KEY = process.env.NEXT_PUBLIC_BUILDER_API_KEY), Object.keys(t).length > 0 && (Rt = {
      ...Rt,
      ...t
    });
  }
}
ka();
function Ot() {
  return Rt.NODE_ENV === "development";
}
const ur = new Proxy(Rt, {
  get(t, e) {
    return Rt[e];
  }
}), be = "/nike-assets", z = {
  // Hero Section Assets
  hero: {
    main: `${be}/hero/hero.avif`
  },
  // Promotional Section Assets
  promotions: {
    promotion1: `${be}/promotions/promotion1.avif`,
    promotion2: `${be}/promotions/promotion2.avif`
  },
  // Featured Section Assets
  featured: {
    featured1: `${be}/featured/featured1.avif`,
    featured2: `${be}/featured/featured2.avif`,
    featured3: `${be}/featured/featured3.avif`
  },
  // Trending Section Assets
  trending: {
    trending1: `${be}/trending/trending1.avif`,
    trending2: `${be}/trending/trending2.avif`,
    trending3: `${be}/trending/trending3.avif`
  },
  // Don't Miss Section Assets
  dontMiss: {
    main: `${be}/dont-miss/image.avif`
  },
  // Shop By Icons Assets
  shopBy: {
    image1: `${be}/shopby/image1.avif`,
    image2: `${be}/shopby/image2.avif`,
    image3: `${be}/shopby/image3.avif`,
    image4: `${be}/shopby/image4.avif`
  },
  // Preview Images for Section Registry
  previews: {
    hero: `${be}/previews/hero-preview.jpg`,
    latest: `${be}/previews/latest-preview.jpg`,
    featured: `${be}/previews/featured-preview.jpg`,
    dontMiss: `${be}/previews/dont-miss-preview.jpg`,
    shopBy: `${be}/previews/shop-by-preview.jpg`,
    trending: `${be}/previews/trending-preview.jpg`
  }
}, ve = {
  sessionToken: "fake-session-token",
  refreshToken: "fake-refresh-token",
  userId: "fake-user-1",
  productSlug: "nike-air-max-90",
  orderId: "order-0",
  cartId: "cart-1",
  addressId: "address-profile-0",
  phone: "919876543210"
}, wa = {
  cartId: ve.cartId,
  subtotal: 1599500,
  total: 1599500,
  itemCount: 3,
  items: [
    {
      id: "cart-item-0",
      variantId: "variant-0",
      sku: "NK-AM90-BLK-09",
      title: "Nike Air Max 90",
      quantity: 1,
      price: 1299900,
      image: z.featured.featured1,
      size: "US 9",
      color: "Black",
      category: "Shoes",
      tags: ["Running", "Lifestyle"],
      product: {
        title: "Nike Air Max 90",
        category: "Shoes",
        tags: ["Running", "Lifestyle"],
        assets: [
          {
            asset: {
              path: z.featured.featured1
            }
          }
        ],
        variants: [
          {
            id: "variant-0",
            title: "US 9 / Black",
            sku: "NK-AM90-BLK-09",
            price: 1299900,
            assets: [
              {
                asset: {
                  path: z.featured.featured1
                }
              }
            ]
          }
        ]
      },
      variant: {
        id: "variant-0",
        title: "US 9 / Black",
        sku: "NK-AM90-BLK-09",
        price: 1299900,
        assets: [
          {
            asset: {
              path: z.featured.featured1
            }
          }
        ]
      }
    },
    {
      id: "cart-item-1",
      variantId: "variant-1",
      sku: "NK-DFT-TEE-WHT-M",
      title: "Nike Dri-FIT T-Shirt",
      quantity: 2,
      price: 149800,
      image: z.featured.featured2,
      size: "M",
      color: "White",
      category: "Apparel",
      tags: ["Training", "Basics"],
      product: {
        title: "Nike Dri-FIT T-Shirt",
        category: "Apparel",
        tags: ["Training", "Basics"],
        assets: [
          {
            asset: {
              path: z.featured.featured2
            }
          }
        ],
        variants: [
          {
            id: "variant-1",
            title: "M / White",
            sku: "NK-DFT-TEE-WHT-M",
            price: 149800,
            assets: [
              {
                asset: {
                  path: z.featured.featured2
                }
              }
            ]
          }
        ]
      },
      variant: {
        id: "variant-1",
        title: "M / White",
        sku: "NK-DFT-TEE-WHT-M",
        price: 149800,
        assets: [
          {
            asset: {
              path: z.featured.featured2
            }
          }
        ]
      }
    }
  ],
  calculation: {
    items: [
      {
        variant_id: "variant-0",
        quantity: 1,
        original_price: 1299900,
        price: 1299900,
        sub_total: 1299900,
        discounts: []
      },
      {
        variant_id: "variant-1",
        quantity: 2,
        original_price: 149800,
        price: 149800,
        sub_total: 299600,
        discounts: []
      }
    ],
    discounts: [],
    charges: [],
    total_taxes: [],
    items_sub_total: 1599500,
    total_discounts: 0,
    total_charges: 0,
    total_tax: 0,
    grand_total_int: 1599500
  },
  addresses: [
    {
      id: ve.addressId,
      originalId: ve.addressId,
      firstName: "Nitin",
      lastName: "Kumar",
      address1: "221B Brigade Road",
      address2: "Shivajinagar",
      city: "Bengaluru",
      province: "Karnataka",
      country: "India",
      zip: "560001",
      phone: ve.phone,
      isDefault: !0
    }
  ],
  customer: {
    id: ve.userId,
    default_address_id: ve.addressId,
    first_name: "Nitin",
    last_name: "Kumar",
    email: "nitin@example.com",
    phone_number: ve.phone
  },
  paymentMethods: [
    {
      id: "card",
      type: "card",
      name: "Card",
      description: "Pay with credit or debit card",
      isDefault: !0
    },
    {
      id: "upi",
      type: "upi",
      name: "UPI",
      description: "Pay with UPI"
    }
  ]
}, Sa = {
  user: {
    id: ve.userId,
    phoneNumber: ve.phone,
    email: "nitin@example.com",
    firstName: "Nitin",
    lastName: "Kumar",
    joinedDate: "2023-01-15T00:00:00.000Z",
    membershipLevel: "Nike Member",
    showSignOut: !0
  },
  addresses: [
    {
      id: ve.addressId,
      addressLine1: "221B Brigade Road",
      addressLine2: "Shivajinagar",
      city: "Bengaluru",
      state: "Karnataka",
      postalCode: "560001"
    },
    {
      id: "address-profile-1",
      addressLine1: "14 MG Road",
      addressLine2: "Indiranagar",
      city: "Bengaluru",
      state: "Karnataka",
      postalCode: "560038"
    }
  ],
  quickActions: [
    {
      title: "Shop",
      icon: "shopping-bag",
      link: "/nike-india/product-listing",
      description: "Browse products"
    },
    {
      title: "Favorites",
      icon: "heart",
      link: "/nike-india/favorites",
      description: "Saved items"
    },
    {
      title: "Orders",
      icon: "package",
      link: "/nike-india/order-tracking",
      description: "Track orders"
    },
    {
      title: "Help",
      icon: "help-circle",
      link: "/help",
      description: "Get support"
    }
  ]
}, Ee = [
  "/nike-assets/hero/hero.avif",
  "/nike-assets/featured/featured1.avif",
  "/nike-assets/featured/featured2.avif",
  "/nike-assets/trending/trending1.avif"
], Ca = {
  id: "fake-product-1",
  slug: ve.productSlug,
  handle: ve.productSlug,
  title: "Nike Air Max 90",
  collectionName: "Featured",
  description: {
    ops: [
      {
        insert: "Deterministic fake product for screenshot generation. The image gallery uses stable local Nike assets so screenshots do not depend on remote image availability."
      }
    ]
  },
  options: [
    {
      key: "size",
      title: "Size",
      position: 1,
      values: ["US 8", "US 9", "US 10"]
    }
  ],
  assets: Ee.map((t, e) => ({
    id: `fake-product-asset-${e}`,
    position: e,
    usage: "image",
    asset: {
      path: t
    }
  })),
  variants: [
    {
      id: "fake-product-variant-0",
      title: "US 8 / Black",
      sku: "NK-AM90-BLK-08",
      price: 1299900,
      option1: "US 8",
      track_inventory: !0,
      inventory: 12,
      assets: [
        {
          id: "fake-product-variant-asset-0",
          asset: {
            path: Ee[0]
          }
        }
      ]
    },
    {
      id: "fake-product-variant-1",
      title: "US 9 / Black",
      sku: "NK-AM90-BLK-09",
      price: 1299900,
      option1: "US 9",
      track_inventory: !0,
      inventory: 8,
      assets: [
        {
          id: "fake-product-variant-asset-1",
          asset: {
            path: Ee[1]
          }
        }
      ]
    },
    {
      id: "fake-product-variant-2",
      title: "US 10 / Black",
      sku: "NK-AM90-BLK-10",
      price: 1299900,
      option1: "US 10",
      track_inventory: !0,
      inventory: 5,
      assets: [
        {
          id: "fake-product-variant-asset-2",
          asset: {
            path: Ee[2]
          }
        }
      ]
    }
  ]
}, Na = [
  {
    id: "fake-trending-0",
    slug: "nike-zoom-vomero-5",
    handle: "nike-zoom-vomero-5",
    title: "Nike Zoom Vomero 5",
    collectionName: "Trending",
    assets: [
      {
        id: "fake-trending-asset-0",
        position: 0,
        usage: "image",
        asset: {
          path: Ee[0]
        }
      }
    ],
    variants: [
      {
        id: "fake-trending-variant-0",
        title: "US 9 / Black",
        sku: "NK-VOM-09",
        price: 1499500,
        option1: "US 9",
        track_inventory: !0,
        inventory: 12,
        assets: [
          {
            id: "fake-trending-variant-asset-0",
            asset: {
              path: Ee[0]
            }
          }
        ]
      }
    ]
  },
  {
    id: "fake-trending-1",
    slug: "nike-motiva",
    handle: "nike-motiva",
    title: "Nike Motiva",
    collectionName: "Trending",
    assets: [
      {
        id: "fake-trending-asset-1",
        position: 0,
        usage: "image",
        asset: {
          path: Ee[1]
        }
      }
    ],
    variants: [
      {
        id: "fake-trending-variant-1",
        title: "US 8 / White",
        sku: "NK-MOT-08",
        price: 1079500,
        option1: "US 8",
        track_inventory: !0,
        inventory: 8,
        assets: [
          {
            id: "fake-trending-variant-asset-1",
            asset: {
              path: Ee[1]
            }
          }
        ]
      }
    ]
  },
  {
    id: "fake-trending-2",
    slug: "nike-pegasus",
    handle: "nike-pegasus",
    title: "Nike Pegasus",
    collectionName: "Trending",
    assets: [
      {
        id: "fake-trending-asset-2",
        position: 0,
        usage: "image",
        asset: {
          path: Ee[2]
        }
      }
    ],
    variants: [
      {
        id: "fake-trending-variant-2",
        title: "US 10 / Grey",
        sku: "NK-PEG-10",
        price: 1299500,
        option1: "US 10",
        track_inventory: !0,
        inventory: 5,
        assets: [
          {
            id: "fake-trending-variant-asset-2",
            asset: {
              path: Ee[2]
            }
          }
        ]
      }
    ]
  },
  {
    id: "fake-trending-3",
    slug: "nike-dri-fit-tee",
    handle: "nike-dri-fit-tee",
    title: "Nike Dri-FIT T-Shirt",
    collectionName: "Trending",
    assets: [
      {
        id: "fake-trending-asset-3",
        position: 0,
        usage: "image",
        asset: {
          path: Ee[3]
        }
      }
    ],
    variants: [
      {
        id: "fake-trending-variant-3",
        title: "M / White",
        sku: "NK-DFT-M-WHT",
        price: 299900,
        option1: "M",
        track_inventory: !0,
        inventory: 18,
        assets: [
          {
            id: "fake-trending-variant-asset-3",
            asset: {
              path: Ee[3]
            }
          }
        ]
      }
    ]
  }
], Ka = [
  {
    id: "ticket-0",
    subject: "Missing size option on order",
    description: "The size selector did not appear for my recent order.",
    status: "open",
    priority: "normal",
    order_id: ve.orderId,
    created_at: "2025-04-02T10:00:00.000Z",
    updated_at: "2025-04-02T10:00:00.000Z"
  },
  {
    id: "ticket-1",
    subject: "Delivery address update",
    description: "Need to change the saved delivery address before shipment.",
    status: "in_progress",
    priority: "high",
    order_id: ve.orderId,
    created_at: "2025-04-01T12:30:00.000Z",
    updated_at: "2025-04-02T08:15:00.000Z"
  },
  {
    id: "ticket-2",
    subject: "Refund timing question",
    description: "Checking when the refund for my cancelled order will arrive.",
    status: "resolved",
    priority: "low",
    order_id: "order-1",
    created_at: "2025-03-28T09:45:00.000Z",
    updated_at: "2025-03-29T14:20:00.000Z"
  }
];
function me() {
  return !!ur.SHIPHOUSE_SDK_FAKE_DATA;
}
function pr() {
  return wa;
}
function Ta() {
  return Ee.map((t, e) => ({
    url: t,
    alt: `Nike Air Max 90 - View ${e + 1}`,
    id: `fake-product-gallery-${e}`
  }));
}
function Ia() {
  return Ca;
}
function Ea() {
  return Sa;
}
function mr() {
  return [...Na];
}
function _a() {
  return [...Ka];
}
function pi(t = 3) {
  const e = /* @__PURE__ */ new Date("2025-04-01T09:30:00.000Z");
  return [
    {
      id: "order-0",
      date: e.toISOString(),
      total: 12999,
      status: "DELIVERED",
      items: [
        {
          name: "Nike Air Max 90",
          image: z.featured.featured1,
          price: 12999,
          quantity: 1
        }
      ]
    },
    {
      id: "order-1",
      date: new Date(e.getTime() - 864e5 * 6).toISOString(),
      total: 8999,
      status: "SHIPPED",
      items: [
        {
          name: "Nike Dri-FIT T-Shirt",
          image: z.featured.featured2,
          price: 2999,
          quantity: 2
        },
        {
          name: "Nike Pro Shorts",
          image: z.featured.featured3,
          price: 1999,
          quantity: 1
        }
      ]
    },
    {
      id: "order-2",
      date: new Date(e.getTime() - 864e5 * 13).toISOString(),
      total: 15999,
      status: "PROCESSING",
      items: [
        {
          name: "Nike Zoom Pegasus",
          image: z.trending.trending1,
          price: 15999,
          quantity: 1
        }
      ]
    }
  ].slice(0, t);
}
const Fa = ({
  recentOrders: t = [],
  maxOrdersToShow: e = 3
}) => {
  const i = (l) => {
    switch (l) {
      case "NEW":
      case "pending":
        return "Processing";
      case "PROCESSING":
      case "processing":
        return "Processing";
      case "SHIPPED":
      case "shipped":
        return "Shipped";
      case "DELIVERED":
      case "delivered":
        return "Delivered";
      case "CANCELLED":
      case "cancelled":
      case "canceled":
        return "Cancelled";
      default:
        return l;
    }
  }, n = (l) => `₹${l.toLocaleString("en-IN")}`, r = (l) => {
    try {
      return new Date(l).toLocaleDateString("en-IN", {
        year: "numeric",
        month: "short",
        day: "numeric"
      });
    } catch {
      return l;
    }
  }, o = t.slice(0, e);
  return o.length === 0 ? /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
    /* @__PURE__ */ s("h2", { className: "mb-4 text-lg font-semibold text-gray-900", children: "Recent Orders" }),
    /* @__PURE__ */ p("div", { className: "flex flex-col items-center justify-center py-12 text-center", children: [
      /* @__PURE__ */ s(_t, { className: "mb-4 h-12 w-12 text-gray-400" }),
      /* @__PURE__ */ s("p", { className: "text-sm text-gray-600", children: "No orders yet" }),
      /* @__PURE__ */ s("p", { className: "mt-1 text-xs text-gray-500", children: "Your order history will appear here" })
    ] })
  ] }) : /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
    /* @__PURE__ */ s("h2", { className: "mb-4 text-lg font-semibold text-gray-900", children: "Recent Orders" }),
    /* @__PURE__ */ p("div", { className: "space-y-4", children: [
      o.map((l) => /* @__PURE__ */ p(
        "div",
        {
          className: "border-b border-gray-100 pb-4 last:border-0",
          children: [
            /* @__PURE__ */ p("div", { className: "mb-2 flex items-center justify-between", children: [
              /* @__PURE__ */ p("div", { children: [
                /* @__PURE__ */ p("p", { className: "text-sm font-medium text-gray-900", children: [
                  "Order #",
                  l.id
                ] }),
                /* @__PURE__ */ s("p", { className: "text-xs text-gray-500", children: r(l.date) })
              ] }),
              /* @__PURE__ */ p("div", { className: "text-right", children: [
                /* @__PURE__ */ s("p", { className: "text-sm font-medium text-gray-900", children: n(l.total) }),
                /* @__PURE__ */ s("p", { className: "text-xs text-gray-600", children: i(l.status) })
              ] })
            ] }),
            l.items && l.items.length > 0 && /* @__PURE__ */ s("div", { className: "mt-2 space-y-2", children: l.items.map((a, d) => /* @__PURE__ */ p("div", { className: "flex items-center gap-3", children: [
              a.image && /* @__PURE__ */ s(
                $e,
                {
                  src: a.image,
                  alt: a.name || "Product",
                  className: "h-12 w-12 rounded object-cover"
                }
              ),
              /* @__PURE__ */ p("div", { className: "flex-1", children: [
                /* @__PURE__ */ s("p", { className: "text-sm text-gray-900", children: a.name }),
                /* @__PURE__ */ p("p", { className: "text-xs text-gray-500", children: [
                  "Qty: ",
                  a.quantity,
                  " × ",
                  n(a.price)
                ] })
              ] })
            ] }, d)) })
          ]
        },
        l.id
      )),
      t.length > e && /* @__PURE__ */ s("button", { className: "mt-4 w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-900 hover:bg-gray-50", children: "View All Orders" })
    ] })
  ] });
}, Pa = ({
  maxOrdersToShow: t = 3,
  routes: e
}) => {
  const [i, n] = O([]), [r, o] = O(!0), [l, a] = O(null), d = an(), c = ft(), u = ze(c ?? void 0), h = ce(async () => {
    console.log("[OrdersList] ========== Starting fetchOrders =========="), o(!0), a(null);
    try {
      const f = Ve();
      if (console.log("[OrdersList] SDK instance obtained"), me()) {
        console.warn("[OrdersList] Fake preview mode active; using deterministic orders"), n(pi(t).map((C) => ({
          id: C.id,
          order_number: C.id,
          created_at: C.date,
          calculation: {
            grand_total_int: C.total,
            total_quantity: C.items.reduce((T, I) => T + I.quantity, 0)
          },
          order_status: C.status,
          payment_status: "PAID",
          supported_payment_type: ["CARD"],
          variants: C.items.map((T) => ({
            title: T.name,
            assets: T.image ? [{ asset: { path: T.image } }] : []
          })),
          order_sets: []
        }))), o(!1);
        return;
      }
      const x = f.getAuthToken(), b = !!x;
      console.log("[OrdersList] SDK auth token present:", b), console.log("[OrdersList] Auth token (first 20 chars):", x ? x.substring(0, 20) + "..." : "null");
      const g = typeof window < "u" ? localStorage.getItem("shiphouse-session") : null;
      console.log("[OrdersList] localStorage token present:", !!g), b || (console.warn("[OrdersList] ⚠️ No auth token in SDK! Orders fetch will likely fail"), me() && f.setAuthToken(ve.sessionToken), g && (console.log("[OrdersList] Found token in localStorage, setting in SDK..."), f.setAuthToken(g)));
      const k = {
        page: 1,
        page_size: t || 10
      };
      console.log("[OrdersList] Calling sdk.orders.getOrders with params:", k);
      const w = await f.orders.getOrders(k);
      if (console.log("[OrdersList] ========== Orders Response =========="), console.log("[OrdersList] response.valid:", w.valid), console.log("[OrdersList] response.message:", w.message), console.log("[OrdersList] response.data:", w.data), console.log("[OrdersList] response.data type:", typeof w.data), console.log("[OrdersList] response.data is array:", Array.isArray(w.data)), Array.isArray(w.data) && (console.log("[OrdersList] response.data.length:", w.data.length), w.data.length > 0 && console.log("[OrdersList] First order:", JSON.stringify(w.data[0], null, 2))), console.log("[OrdersList] Full response:", JSON.stringify(w, null, 2)), w.valid && w.data) {
        const C = Array.isArray(w.data) ? w.data : [];
        console.log("[OrdersList] ✅ Setting orders, count:", C.length), n(C);
      } else {
        if (me()) {
          console.warn("[OrdersList] Fake preview mode fallback activated for orders"), n(pi(t).map((C) => ({
            id: C.id,
            order_number: C.id,
            created_at: C.date,
            calculation: {
              grand_total_int: C.total,
              total_quantity: C.items.reduce((T, I) => T + I.quantity, 0)
            },
            order_status: C.status,
            payment_status: "PAID",
            supported_payment_type: ["CARD"],
            variants: C.items.map((T) => ({
              title: T.name,
              assets: T.image ? [{ asset: { path: T.image } }] : []
            })),
            order_sets: []
          })));
          return;
        }
        console.error("[OrdersList] ❌ Invalid response:", w.message), a(w.message || "Failed to load orders"), n([]);
      }
    } catch (f) {
      if (console.error("[OrdersList] ❌ Error fetching orders:", f), console.error("[OrdersList] Error stack:", f.stack), me()) {
        console.warn("[OrdersList] Fake preview mode fallback activated after fetch error"), n(pi(t).map((x) => ({
          id: x.id,
          order_number: x.id,
          created_at: x.date,
          calculation: {
            grand_total_int: x.total,
            total_quantity: x.items.reduce((b, g) => b + g.quantity, 0)
          },
          order_status: x.status,
          payment_status: "PAID",
          supported_payment_type: ["CARD"],
          variants: x.items.map((b) => ({
            title: b.name,
            assets: b.image ? [{ asset: { path: b.image } }] : []
          })),
          order_sets: []
        })));
        return;
      }
      a(f.message || "Failed to load orders"), n([]);
    } finally {
      o(!1), console.log("[OrdersList] ========== fetchOrders complete ==========");
    }
  }, [t]);
  U(() => {
    console.log("[OrdersList] Component mounted, calling fetchOrders"), h();
  }, [h]);
  const m = (f) => {
    switch (f) {
      case "NEW":
        return { label: "New Order", color: "text-blue-600 bg-blue-50" };
      case "CONFIRMED":
        return { label: "Confirmed", color: "text-green-600 bg-green-50" };
      case "PROCESSING":
        return { label: "Processing", color: "text-indigo-600 bg-indigo-50" };
      case "DISPATCHED":
      case "DISPATCHING":
        return { label: "Dispatched", color: "text-orange-600 bg-orange-50" };
      case "SHIPPED":
      case "IN_TRANSIT":
        return { label: "In Transit", color: "text-cyan-600 bg-cyan-50" };
      case "OUT_FOR_DELIVERY":
        return { label: "Out for Delivery", color: "text-purple-600 bg-purple-50" };
      case "DELIVERED":
        return { label: "Delivered", color: "text-emerald-600 bg-emerald-50" };
      case "CANCELLED":
        return { label: "Cancelled", color: "text-red-600 bg-red-50" };
      case "RTO_INITIATED":
      case "RTO_IN_TRANSIT":
        return { label: "Return in Transit", color: "text-amber-600 bg-amber-50" };
      case "RTO_DELIVERED":
        return { label: "Returned", color: "text-gray-600 bg-gray-50" };
      default:
        return {
          label: f.replace(/_/g, " ").replace(/\b\w/g, (x) => x.toUpperCase()),
          color: "text-gray-600 bg-gray-50"
        };
    }
  }, v = Z.useMemo(() => i.map((f) => {
    var C, T, I, E, P, S, K, _, L;
    const x = (C = f.variants) == null ? void 0 : C[0], b = (T = x == null ? void 0 : x.assets) == null ? void 0 : T[0], g = (I = b == null ? void 0 : b.asset) == null ? void 0 : I.path, k = ((E = f.calculation) == null ? void 0 : E.total_quantity) || 0, w = ((P = f.variants) == null ? void 0 : P.map((N) => (N == null ? void 0 : N.title) || "Product").join(", ")) || "Product";
    return {
      id: f.id || "",
      orderNumber: f.order_number || "N/A",
      date: f.created_at || "",
      total: ((S = f.calculation) == null ? void 0 : S.grand_total_int) || 0,
      totalQuantity: k,
      orderStatus: f.order_status || "NEW",
      paymentStatus: f.payment_status || "NULL",
      paymentType: ((K = f.supported_payment_type) == null ? void 0 : K[0]) || "",
      image: g,
      variantTitles: w,
      variantCount: ((_ = f.variants) == null ? void 0 : _.length) || 0,
      needsVerification: ((L = f.order_sets) == null ? void 0 : L.some((N) => N == null ? void 0 : N.needs_verification)) || !1
    };
  }), [i]), y = (f) => {
    console.log("[OrdersList] Navigating to order tracking:", f);
    const x = Ki(
      (e == null ? void 0 : e.orders) || "order-tracking",
      c ?? void 0,
      { orderId: f },
      u
    );
    d.push(x);
  };
  return r ? /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
    /* @__PURE__ */ p("div", { className: "mb-4 flex items-center justify-between", children: [
      /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900", children: "Recent Orders" }),
      /* @__PURE__ */ s(
        "a",
        {
          href: Se("orders", c ?? void 0, e, u),
          className: "text-sm text-gray-600 underline hover:text-gray-900",
          children: "View All"
        }
      )
    ] }),
    /* @__PURE__ */ p("div", { className: "py-8 text-center", children: [
      /* @__PURE__ */ s("div", { className: "animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4" }),
      /* @__PURE__ */ s("p", { className: "text-gray-600", children: "Loading orders..." })
    ] })
  ] }) : l ? /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
    /* @__PURE__ */ p("div", { className: "mb-4 flex items-center justify-between", children: [
      /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900", children: "Recent Orders" }),
      /* @__PURE__ */ s(
        "a",
        {
          href: Se("orders", c ?? void 0, e, u),
          className: "text-sm text-gray-600 underline hover:text-gray-900",
          children: "View All"
        }
      )
    ] }),
    /* @__PURE__ */ p("div", { className: "py-8 text-center", children: [
      /* @__PURE__ */ s(_t, { className: "mx-auto mb-4 h-12 w-12 text-red-300" }),
      /* @__PURE__ */ s("p", { className: "text-red-600 mb-2", children: "Failed to load orders" }),
      /* @__PURE__ */ s("p", { className: "text-sm text-gray-600", children: l }),
      /* @__PURE__ */ s(
        "button",
        {
          onClick: () => h(),
          className: "mt-4 text-sm font-medium text-black hover:underline",
          children: "Try Again"
        }
      )
    ] })
  ] }) : /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
    /* @__PURE__ */ p("div", { className: "mb-4 flex items-center justify-between", children: [
      /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900", children: "Recent Orders" }),
      /* @__PURE__ */ s(
        "a",
        {
          href: Se("orders", c ?? void 0, e, u),
          className: "text-sm text-gray-600 underline hover:text-gray-900",
          children: "View All"
        }
      )
    ] }),
    v.length > 0 ? /* @__PURE__ */ s("div", { className: "space-y-4", children: v.slice(0, t).map((f, x) => {
      const b = m(f.orderStatus);
      return /* @__PURE__ */ p(
        "div",
        {
          onClick: () => y(f.id),
          className: "flex items-start justify-between border-b border-gray-100 pb-4 last:border-b-0 cursor-pointer hover:bg-gray-50 transition-colors rounded-lg p-3 -mx-3",
          children: [
            /* @__PURE__ */ p("div", { className: "flex items-start space-x-4 flex-1", children: [
              /* @__PURE__ */ s(
                $e,
                {
                  src: f.image,
                  alt: f.variantTitles,
                  className: "h-20 w-20 rounded-lg object-cover flex-shrink-0",
                  showPlaceholderIcon: !0
                }
              ),
              /* @__PURE__ */ p("div", { className: "flex-1 min-w-0", children: [
                /* @__PURE__ */ p("div", { className: "flex items-start justify-between mb-1", children: [
                  /* @__PURE__ */ p("p", { className: "font-semibold text-gray-900 text-sm", children: [
                    "Order #",
                    f.orderNumber
                  ] }),
                  /* @__PURE__ */ s(
                    "span",
                    {
                      className: `text-xs font-medium px-2 py-1 rounded-full ${b.color}`,
                      children: b.label
                    }
                  )
                ] }),
                /* @__PURE__ */ p("p", { className: "text-sm text-gray-600 truncate mb-1", title: f.variantTitles, children: [
                  f.variantTitles,
                  f.variantCount > 1 && ` +${f.variantCount - 1} more`
                ] }),
                /* @__PURE__ */ p("p", { className: "text-xs text-gray-500", children: [
                  new Date(f.date).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric"
                  }),
                  " • ",
                  f.totalQuantity,
                  " item",
                  f.totalQuantity !== 1 ? "s" : ""
                ] }),
                /* @__PURE__ */ p("div", { className: "mt-2 flex items-center gap-3 text-xs", children: [
                  /* @__PURE__ */ p("span", { className: "text-gray-600", children: [
                    "Payment: ",
                    /* @__PURE__ */ s("span", { className: "font-medium capitalize", children: f.paymentStatus === "NULL" ? "Pending" : f.paymentStatus === "CAPTURED" ? "Paid" : f.paymentStatus })
                  ] }),
                  f.paymentType && /* @__PURE__ */ p("span", { className: "text-gray-500", children: [
                    "• ",
                    f.paymentType
                  ] })
                ] })
              ] })
            ] }),
            /* @__PURE__ */ s("div", { className: "text-right ml-4 flex-shrink-0", children: /* @__PURE__ */ s("p", { className: "font-bold text-gray-900", children: Bt(f.total) }) })
          ]
        },
        x
      );
    }) }) : /* @__PURE__ */ p("div", { className: "py-8 text-center", children: [
      /* @__PURE__ */ s(_t, { className: "mx-auto mb-4 h-12 w-12 text-gray-300" }),
      /* @__PURE__ */ s("p", { className: "text-gray-600", children: "No orders yet" }),
      /* @__PURE__ */ s(
        "a",
        {
          href: Se("productListing", c ?? void 0, e, u),
          className: "mt-2 inline-block text-sm font-medium text-black hover:underline",
          children: "Start Shopping"
        }
      )
    ] })
  ] });
}, La = ({
  currentData: t,
  onClose: e,
  onSuccess: i
}) => {
  const [n, r] = O({
    first_name: t.firstName || "",
    last_name: t.lastName || "",
    email: t.email || ""
  }), [o, l] = O(!1), [a, d] = O(null), c = async (h) => {
    h.preventDefault(), l(!0), d(null);
    try {
      const m = Ve();
      if (!m.getAuthToken()) {
        const f = localStorage.getItem("shiphouse-session");
        if (f)
          m.setAuthToken(f);
        else
          throw new Error("Not authenticated");
      }
      const y = await m.customer.updateProfile(n);
      y.valid ? (console.log("[ProfileEdit] Profile updated successfully:", y), i(), e()) : d(y.message || "Failed to update profile");
    } catch (m) {
      console.error("[ProfileEdit] Error updating profile:", m), d(m.message || "An error occurred while updating profile");
    } finally {
      l(!1);
    }
  }, u = (h) => {
    const { name: m, value: v } = h.target;
    r((y) => ({ ...y, [m]: v }));
  };
  return /* @__PURE__ */ s("div", { className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4", children: /* @__PURE__ */ p("div", { className: "bg-white rounded-lg shadow-xl max-w-md w-full", children: [
    /* @__PURE__ */ p("div", { className: "flex items-center justify-between p-4 border-b", children: [
      /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900", children: "Edit Profile" }),
      /* @__PURE__ */ s(
        "button",
        {
          onClick: e,
          className: "p-1 hover:bg-gray-100 rounded-full transition-colors",
          children: /* @__PURE__ */ s(rn, { className: "w-5 h-5 text-gray-500" })
        }
      )
    ] }),
    /* @__PURE__ */ p("form", { onSubmit: c, className: "p-4 space-y-4", children: [
      t.phoneNumber && /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s("label", { className: "block text-sm font-medium text-gray-700 mb-1", children: "Phone Number" }),
        /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            value: `+${t.phoneNumber}`,
            disabled: !0,
            className: "w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-500 cursor-not-allowed"
          }
        ),
        /* @__PURE__ */ s("p", { className: "mt-1 text-xs text-gray-500", children: "Phone number cannot be changed" })
      ] }),
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s(
          "label",
          {
            htmlFor: "first_name",
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: "First Name"
          }
        ),
        /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            id: "first_name",
            name: "first_name",
            value: n.first_name,
            onChange: u,
            placeholder: "Enter your first name",
            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
          }
        )
      ] }),
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s(
          "label",
          {
            htmlFor: "last_name",
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: "Last Name"
          }
        ),
        /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            id: "last_name",
            name: "last_name",
            value: n.last_name,
            onChange: u,
            placeholder: "Enter your last name",
            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
          }
        )
      ] }),
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s(
          "label",
          {
            htmlFor: "email",
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: "Email Address"
          }
        ),
        /* @__PURE__ */ s(
          "input",
          {
            type: "email",
            id: "email",
            name: "email",
            value: n.email,
            onChange: u,
            placeholder: "Enter your email address",
            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
          }
        )
      ] }),
      a && /* @__PURE__ */ s("div", { className: "p-3 bg-red-50 border border-red-200 rounded-lg", children: /* @__PURE__ */ s("p", { className: "text-sm text-red-600", children: a }) }),
      /* @__PURE__ */ p("div", { className: "flex gap-3 pt-2", children: [
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            onClick: e,
            disabled: o,
            className: "flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "submit",
            disabled: o,
            className: "flex-1 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 flex items-center justify-center gap-2",
            children: o ? /* @__PURE__ */ p(se, { children: [
              /* @__PURE__ */ s(Ft, { className: "w-4 h-4 animate-spin" }),
              "Saving..."
            ] }) : /* @__PURE__ */ p(se, { children: [
              /* @__PURE__ */ s(so, { className: "w-4 h-4" }),
              "Save Changes"
            ] })
          }
        )
      ] })
    ] })
  ] }) });
}, Aa = ({ onClose: t, onSuccess: e }) => {
  const [i, n] = O({
    subject: "",
    description: "",
    priority: "normal",
    order_id: ""
  }), [r, o] = O(!1), [l, a] = O(null), [d, c] = O([]), [u, h] = O(""), [m, v] = O(!1), [y, f] = O(!1), [x, b] = O(null), g = oe(null);
  return U(() => {
    (async () => {
      try {
        const C = Ve();
        if (!C.getAuthToken()) {
          me() && C.setAuthToken(ve.sessionToken);
          const E = localStorage.getItem("shiphouse-session");
          if (E)
            C.setAuthToken(E);
          else
            return;
        }
        const I = await C.orders.getOrders({
          page: 1,
          limit: 5
        });
        if (I.valid && I.data) {
          const E = Array.isArray(I.data) ? I.data : [];
          c(E);
        }
      } catch (C) {
        console.error("[CreateTicket] Error fetching orders:", C);
      }
    })();
  }, []), U(() => {
    const C = setTimeout(async () => {
      if (!u.trim()) {
        try {
          const I = await Ve().orders.getOrders({
            page: 1,
            limit: 5
          });
          if (I.valid && I.data) {
            const E = Array.isArray(I.data) ? I.data : [];
            c(E);
          }
        } catch (T) {
          console.error("[CreateTicket] Error reloading orders:", T);
        }
        f(!1);
        return;
      }
      f(!0);
      try {
        const I = await Ve().orders.searchOrders(u, {
          page: 1,
          limit: 10
        });
        if (I.valid && I.data) {
          const E = Array.isArray(I.data) ? I.data : [];
          c(E);
        }
      } catch (T) {
        console.error("[CreateTicket] Error searching orders:", T);
      } finally {
        f(!1);
      }
    }, 300);
    return () => clearTimeout(C);
  }, [u]), U(() => {
    const w = (C) => {
      g.current && !g.current.contains(C.target) && v(!1);
    };
    return document.addEventListener("mousedown", w), () => document.removeEventListener("mousedown", w);
  }, []), /* @__PURE__ */ s("div", { className: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4", children: /* @__PURE__ */ p("div", { className: "bg-white rounded-lg shadow-xl max-w-lg w-full max-h-[90vh] overflow-y-auto", children: [
    /* @__PURE__ */ p("div", { className: "flex items-center justify-between p-4 border-b sticky top-0 bg-white", children: [
      /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900", children: "Create Support Ticket" }),
      /* @__PURE__ */ s(
        "button",
        {
          onClick: t,
          className: "p-1 hover:bg-gray-100 rounded-full transition-colors",
          children: /* @__PURE__ */ s(rn, { className: "w-5 h-5 text-gray-500" })
        }
      )
    ] }),
    /* @__PURE__ */ p("form", { onSubmit: async (w) => {
      if (w.preventDefault(), o(!0), a(null), i.subject.length < 5) {
        a("Subject must be at least 5 characters"), o(!1);
        return;
      }
      if (!i.order_id) {
        a("Please select an order"), o(!1);
        return;
      }
      if (i.description.length < 20) {
        a("Description must be at least 20 characters"), o(!1);
        return;
      }
      try {
        const C = Ve();
        if (!C.getAuthToken()) {
          me() && C.setAuthToken(ve.sessionToken);
          const P = localStorage.getItem("shiphouse-session");
          if (P)
            C.setAuthToken(P);
          else
            throw new Error("Not authenticated");
        }
        const I = {
          subject: i.subject,
          description: i.description,
          priority: i.priority,
          order_id: i.order_id
        }, E = await C.support.createTicket(I);
        E.valid ? (console.log("[CreateTicket] Ticket created successfully:", E), e(), t()) : a(E.message || "Failed to create ticket");
      } catch (C) {
        console.error("[CreateTicket] Error creating ticket:", C), a(C.message || "An error occurred while creating the ticket");
      } finally {
        o(!1);
      }
    }, className: "p-4 space-y-4", children: [
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ p(
          "label",
          {
            htmlFor: "subject",
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: [
              "Subject ",
              /* @__PURE__ */ s("span", { className: "text-red-500", children: "*" })
            ]
          }
        ),
        /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            id: "subject",
            value: i.subject,
            onChange: (w) => n((C) => ({ ...C, subject: w.target.value })),
            placeholder: "Brief summary of your issue",
            maxLength: 200,
            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent"
          }
        ),
        /* @__PURE__ */ p("p", { className: "mt-1 text-xs text-gray-500", children: [
          i.subject.length,
          "/200 characters (min 5)"
        ] })
      ] }),
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ p(
          "label",
          {
            htmlFor: "order_id",
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: [
              "Related Order ",
              /* @__PURE__ */ s("span", { className: "text-red-500", children: "*" })
            ]
          }
        ),
        /* @__PURE__ */ p("div", { className: "relative", ref: g, children: [
          /* @__PURE__ */ p(
            "button",
            {
              type: "button",
              onClick: () => v(!m),
              className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent text-left flex items-center justify-between bg-white",
              children: [
                /* @__PURE__ */ s("span", { className: x ? "text-gray-900" : "text-gray-500", children: x ? `Order #${x.order_number}` : "Select an order" }),
                /* @__PURE__ */ s(Qn, { className: `w-4 h-4 text-gray-400 transition-transform ${m ? "rotate-180" : ""}` })
              ]
            }
          ),
          m && /* @__PURE__ */ p("div", { className: "absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-lg shadow-lg max-h-64 overflow-hidden", children: [
            /* @__PURE__ */ s("div", { className: "p-2 border-b border-gray-200", children: /* @__PURE__ */ p("div", { className: "relative", children: [
              /* @__PURE__ */ s(lo, { className: "absolute left-2 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" }),
              /* @__PURE__ */ s(
                "input",
                {
                  type: "text",
                  value: u,
                  onChange: (w) => h(w.target.value),
                  placeholder: "Search by order number...",
                  className: "w-full pl-8 pr-3 py-1.5 text-sm border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent",
                  onClick: (w) => w.stopPropagation()
                }
              )
            ] }) }),
            /* @__PURE__ */ s("div", { className: "max-h-48 overflow-y-auto", children: y ? /* @__PURE__ */ p("div", { className: "p-4 text-center", children: [
              /* @__PURE__ */ s(Ft, { className: "w-5 h-5 animate-spin mx-auto text-gray-400" }),
              /* @__PURE__ */ s("p", { className: "text-xs text-gray-500 mt-2", children: "Searching..." })
            ] }) : d.length > 0 ? /* @__PURE__ */ p(se, { children: [
              /* @__PURE__ */ s(
                "button",
                {
                  type: "button",
                  onClick: () => {
                    b(null), n((w) => ({ ...w, order_id: "" })), v(!1), h("");
                  },
                  className: "w-full px-3 py-2 text-left text-sm text-gray-500 hover:bg-gray-50 border-b border-gray-100",
                  children: /* @__PURE__ */ s("span", { className: "italic", children: "Clear selection" })
                }
              ),
              d.map((w) => {
                var I, E, P;
                const C = ((I = w.calculation) == null ? void 0 : I.total_quantity) || 0, T = {};
                return (E = w.variants) == null || E.forEach((S) => {
                  const K = S.product_title || S.title || "Product";
                  T[K] || (T[K] = []), T[K].push(S);
                }), /* @__PURE__ */ s(
                  "button",
                  {
                    type: "button",
                    onClick: () => {
                      b(w), n((S) => ({ ...S, order_id: w.id })), v(!1), h("");
                    },
                    className: `w-full px-3 py-2 text-left hover:bg-gray-50 border-b border-gray-100 last:border-b-0 ${(x == null ? void 0 : x.id) === w.id ? "bg-gray-50" : ""}`,
                    children: /* @__PURE__ */ p("div", { className: "flex items-start justify-between gap-3", children: [
                      /* @__PURE__ */ p("div", { className: "flex-1 min-w-0", children: [
                        /* @__PURE__ */ p("p", { className: "text-sm font-medium text-gray-900 mb-1", children: [
                          "Order #",
                          w.order_number
                        ] }),
                        /* @__PURE__ */ s("div", { className: "space-y-1 mb-1.5", children: Object.entries(T).map(([S, K], _) => /* @__PURE__ */ p("div", { className: "text-xs", children: [
                          /* @__PURE__ */ p("p", { className: "text-gray-700 font-medium", children: [
                            "▸ ",
                            S
                          ] }),
                          K.map((L, N) => /* @__PURE__ */ p("p", { className: "text-gray-500 ml-3", children: [
                            "→ ",
                            L.title || L.option1 || "Variant",
                            L.quantity && ` (×${L.quantity})`
                          ] }, N))
                        ] }, _)) }),
                        /* @__PURE__ */ p("p", { className: "text-xs text-gray-500", children: [
                          new Date(w.created_at).toLocaleDateString(),
                          " •",
                          " ",
                          C,
                          " item",
                          C !== 1 ? "s" : "",
                          " •",
                          " ",
                          w.order_status
                        ] })
                      ] }),
                      ((P = w.calculation) == null ? void 0 : P.grand_total_int) && /* @__PURE__ */ s("p", { className: "text-sm font-medium text-gray-700 flex-shrink-0", children: Bt(w.calculation.grand_total_int) })
                    ] })
                  },
                  w.id
                );
              })
            ] }) : /* @__PURE__ */ s("div", { className: "p-4 text-center", children: /* @__PURE__ */ s("p", { className: "text-sm text-gray-500", children: u ? "No orders found" : "No recent orders" }) }) })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ p(
          "label",
          {
            htmlFor: "description",
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: [
              "Description ",
              /* @__PURE__ */ s("span", { className: "text-red-500", children: "*" })
            ]
          }
        ),
        /* @__PURE__ */ s(
          "textarea",
          {
            id: "description",
            value: i.description,
            onChange: (w) => n((C) => ({
              ...C,
              description: w.target.value
            })),
            placeholder: "Please describe your issue in detail...",
            maxLength: 2e3,
            rows: 5,
            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent resize-none"
          }
        ),
        /* @__PURE__ */ p("p", { className: "mt-1 text-xs text-gray-500", children: [
          i.description.length,
          "/2000 characters (min 20)"
        ] })
      ] }),
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s(
          "label",
          {
            htmlFor: "priority",
            className: "block text-sm font-medium text-gray-700 mb-1",
            children: "Priority"
          }
        ),
        /* @__PURE__ */ p(
          "select",
          {
            id: "priority",
            value: i.priority,
            onChange: (w) => n((C) => ({
              ...C,
              priority: w.target.value
            })),
            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black focus:border-transparent",
            children: [
              /* @__PURE__ */ s("option", { value: "low", children: "Low" }),
              /* @__PURE__ */ s("option", { value: "normal", children: "Normal" }),
              /* @__PURE__ */ s("option", { value: "high", children: "High" }),
              /* @__PURE__ */ s("option", { value: "urgent", children: "Urgent" })
            ]
          }
        )
      ] }),
      l && /* @__PURE__ */ s("div", { className: "p-3 bg-red-50 border border-red-200 rounded-lg", children: /* @__PURE__ */ s("p", { className: "text-sm text-red-600", children: l }) }),
      /* @__PURE__ */ p("div", { className: "flex gap-3 pt-2", children: [
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            onClick: t,
            disabled: r,
            className: "flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors disabled:opacity-50",
            children: "Cancel"
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "submit",
            disabled: r,
            className: "flex-1 px-4 py-2 bg-black text-white rounded-lg hover:bg-gray-800 transition-colors disabled:opacity-50 flex items-center justify-center gap-2",
            children: r ? /* @__PURE__ */ p(se, { children: [
              /* @__PURE__ */ s(Ft, { className: "w-4 h-4 animate-spin" }),
              "Creating..."
            ] }) : /* @__PURE__ */ p(se, { children: [
              /* @__PURE__ */ s(co, { className: "w-4 h-4" }),
              "Create Ticket"
            ] })
          }
        )
      ] })
    ] })
  ] }) });
}, Ra = ({
  storeId: t,
  maxTicketsToShow: e = 5
}) => {
  const [i, n] = O([]), [r, o] = O(!0), [l, a] = O(null), [d, c] = O(!1), u = ce(async () => {
    o(!0), a(null);
    try {
      if (me()) {
        n(_a().slice(0, e));
        return;
      }
      const v = Ve();
      if (!v.getAuthToken()) {
        const x = localStorage.getItem("shiphouse-session");
        if (x)
          v.setAuthToken(x);
        else {
          console.log("[SupportTickets] No auth token found"), o(!1);
          return;
        }
      }
      const f = await v.support.getTickets({
        page: 1,
        limit: e
      });
      if (f.valid && f.data) {
        const x = Array.isArray(f.data) ? f.data : [];
        console.log("[SupportTickets] Fetched tickets:", x.length), n(x);
      } else f.valid || (console.error("[SupportTickets] Invalid response:", f.message), n([]));
    } catch (v) {
      console.error("[SupportTickets] Error fetching tickets:", v), a(v.message || "Failed to load tickets");
    } finally {
      o(!1);
    }
  }, [e]);
  U(() => {
    (t || me()) && u();
  }, [u, t]);
  const h = (v) => {
    switch (v == null ? void 0 : v.toLowerCase()) {
      case "open":
        return {
          label: "Open",
          color: "text-blue-600 bg-blue-50",
          icon: Hi
        };
      case "in_progress":
      case "inprogress":
        return {
          label: "In Progress",
          color: "text-orange-600 bg-orange-50",
          icon: hn
        };
      case "resolved":
      case "closed":
        return {
          label: "Resolved",
          color: "text-green-600 bg-green-50",
          icon: ji
        };
      case "pending":
        return {
          label: "Pending",
          color: "text-yellow-600 bg-yellow-50",
          icon: hn
        };
      default:
        return {
          label: v || "Unknown",
          color: "text-gray-600 bg-gray-50",
          icon: mn
        };
    }
  }, m = (v) => {
    switch (v == null ? void 0 : v.toLowerCase()) {
      case "urgent":
        return { label: "Urgent", color: "text-red-600" };
      case "high":
        return { label: "High", color: "text-orange-600" };
      case "normal":
        return { label: "Normal", color: "text-blue-600" };
      case "low":
        return { label: "Low", color: "text-gray-600" };
      default:
        return { label: v || "Normal", color: "text-gray-600" };
    }
  };
  return r ? /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
    /* @__PURE__ */ s("div", { className: "flex items-center justify-between mb-4", children: /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900", children: "Support Tickets" }) }),
    /* @__PURE__ */ p("div", { className: "py-8 text-center", children: [
      /* @__PURE__ */ s(Ft, { className: "w-8 h-8 animate-spin mx-auto mb-2 text-gray-400" }),
      /* @__PURE__ */ s("p", { className: "text-gray-600", children: "Loading tickets..." })
    ] })
  ] }) : /* @__PURE__ */ p(se, { children: [
    /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
      /* @__PURE__ */ p("div", { className: "flex items-center justify-between mb-4", children: [
        /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900", children: "Support Tickets" }),
        /* @__PURE__ */ p(
          "button",
          {
            onClick: () => c(!0),
            className: "flex items-center gap-1 text-sm text-white bg-black px-3 py-1.5 rounded-full hover:bg-gray-800 transition-colors",
            children: [
              /* @__PURE__ */ s(pn, { className: "w-4 h-4" }),
              "New Ticket"
            ]
          }
        )
      ] }),
      l ? /* @__PURE__ */ p("div", { className: "py-8 text-center", children: [
        /* @__PURE__ */ s(Hi, { className: "mx-auto mb-4 h-12 w-12 text-red-300" }),
        /* @__PURE__ */ s("p", { className: "text-red-600 mb-2", children: "Failed to load tickets" }),
        /* @__PURE__ */ s("p", { className: "text-sm text-gray-600", children: l }),
        /* @__PURE__ */ s(
          "button",
          {
            onClick: u,
            className: "mt-4 text-sm font-medium text-black hover:underline",
            children: "Try Again"
          }
        )
      ] }) : i.length > 0 ? /* @__PURE__ */ s("div", { className: "space-y-3", children: i.map((v) => {
        const y = h(v.status), f = m(v.priority), x = y.icon;
        return /* @__PURE__ */ p(
          "div",
          {
            className: "flex items-start justify-between p-3 border border-gray-100 rounded-lg hover:bg-gray-50 transition-colors cursor-pointer",
            children: [
              /* @__PURE__ */ p("div", { className: "flex-1 min-w-0", children: [
                /* @__PURE__ */ p("div", { className: "flex items-center gap-2 mb-1", children: [
                  /* @__PURE__ */ p(
                    "span",
                    {
                      className: `inline-flex items-center gap-1 text-xs font-medium px-2 py-0.5 rounded-full ${y.color}`,
                      children: [
                        /* @__PURE__ */ s(x, { className: "w-3 h-3" }),
                        y.label
                      ]
                    }
                  ),
                  /* @__PURE__ */ s("span", { className: `text-xs ${f.color}`, children: f.label })
                ] }),
                /* @__PURE__ */ s("h4", { className: "text-sm font-medium text-gray-900 truncate", children: v.subject }),
                /* @__PURE__ */ p("p", { className: "text-xs text-gray-500 mt-1", children: [
                  "Created",
                  " ",
                  new Date(v.created_at).toLocaleDateString("en-US", {
                    year: "numeric",
                    month: "short",
                    day: "numeric"
                  }),
                  v.order_id && ` • Order #${v.order_id}`
                ] })
              ] }),
              /* @__PURE__ */ s(ao, { className: "w-5 h-5 text-gray-400 flex-shrink-0 ml-2" })
            ]
          },
          v.id
        );
      }) }) : /* @__PURE__ */ p("div", { className: "py-8 text-center", children: [
        /* @__PURE__ */ s(mn, { className: "mx-auto mb-4 h-12 w-12 text-gray-300" }),
        /* @__PURE__ */ s("p", { className: "text-gray-600 mb-2", children: "No support tickets yet" }),
        /* @__PURE__ */ s("p", { className: "text-sm text-gray-500 mb-4", children: "Need help? Create a support ticket and we'll get back to you." }),
        /* @__PURE__ */ p(
          "button",
          {
            onClick: () => c(!0),
            className: "inline-flex items-center gap-2 text-sm font-medium text-white bg-black px-4 py-2 rounded-full hover:bg-gray-800 transition-colors",
            children: [
              /* @__PURE__ */ s(pn, { className: "w-4 h-4" }),
              "Create Your First Ticket"
            ]
          }
        )
      ] })
    ] }),
    d && /* @__PURE__ */ s(
      Aa,
      {
        onClose: () => c(!1),
        onSuccess: () => {
          u();
        }
      }
    )
  ] });
}, za = [
  // User Profile Configuration
  F(
    "text-block",
    "user-profile-config",
    {
      desktop: [
        { inputKey: "firstName", type: "text", value: "Nitin" },
        { inputKey: "lastName", type: "text", value: "Kumar" },
        { inputKey: "email", type: "text", value: "nitin@example.com" },
        { inputKey: "joinedDate", type: "text", value: "2023-01-15" },
        { inputKey: "membershipLevel", type: "text", value: "Nike Member" },
        { inputKey: "showSignOut", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "User Profile Configuration",
      description: "User profile information and membership details"
    }
  ),
  // Quick Actions Configuration
  F(
    "text-block",
    "quick-actions-config",
    {
      desktop: [
        { inputKey: "showQuickActions", type: "checkbox", value: !0 },
        { inputKey: "actionsPerRow", type: "number", value: 4 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Quick Actions Configuration",
      description: "Configuration for quick action buttons"
    }
  ),
  // Recent Orders Configuration
  F(
    "text-block",
    "recent-orders-config",
    {
      desktop: [
        { inputKey: "showRecentOrders", type: "checkbox", value: !0 },
        { inputKey: "maxOrdersToShow", type: "number", value: 3 },
        { inputKey: "showViewAllLink", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Recent Orders Configuration",
      description: "Configuration for recent orders display"
    }
  )
], Ba = ({
  data: t,
  // theme = nikeTheme,
  config: e,
  routes: i,
  storeId: n,
  viewportMode: r
}) => {
  const [o, l] = O(null), [a, d] = O([]), [c, u] = O(!0), [h, m] = O(!1), v = n || process.env.NEXT_PUBLIC_STORE_ID || "", y = ce(async () => {
    u(!0);
    try {
      if (me()) {
        const C = Ea();
        l(C.user), d(C.addresses);
        return;
      }
      const g = Ve();
      if (!g.getAuthToken()) {
        const C = typeof window < "u" ? localStorage.getItem("shiphouse-session") : null;
        if (me() && g.setAuthToken(ve.sessionToken), C)
          g.setAuthToken(C);
        else {
          console.log("[AccountDashboard Client] No auth token found"), u(!1);
          return;
        }
      }
      const w = await g.customer.getProfile();
      if (console.log("[AccountDashboard Client] Customer profile response:", w), w.valid && w.data) {
        const C = w.data;
        l({
          id: C.id,
          phoneNumber: C.phone_number,
          email: C.email || void 0,
          firstName: C.first_name || void 0,
          lastName: C.last_name || void 0,
          joinedDate: C.created_at || void 0,
          membershipLevel: "Nike Member",
          showSignOut: !0
        }), Array.isArray(C.customer_addresses) && C.customer_addresses.length > 0 && d(C.customer_addresses.map((T) => ({
          id: T.id,
          addressLine1: T.address_line_one,
          addressLine2: T.address_line_two,
          city: T.city,
          state: T.state,
          postalCode: T.postal_code
        })));
      }
    } catch (g) {
      console.error("[AccountDashboard Client] Error fetching customer profile:", g);
    } finally {
      u(!1);
    }
  }, []);
  U(() => {
    y();
  }, [y]);
  const f = (t == null ? void 0 : t.quickActions) || [], x = Array.isArray(f) && f.length > 0 ? f : [
    {
      title: "Shop",
      icon: "shopping-bag",
      link: "/nike-india/product-listing",
      description: "Browse products"
    },
    {
      title: "Favorites",
      icon: "heart",
      link: "/nike-india/favorites",
      description: "Saved items"
    },
    {
      title: "Orders",
      icon: "package",
      link: "/nike-india/order-tracking",
      description: "Track orders"
    },
    {
      title: "Help",
      icon: "help-circle",
      link: "/help",
      description: "Get support"
    }
  ], b = [
    { title: "Address Book", description: "Manage shipping addresses" },
    { title: "Payment Methods", description: "Manage payment options" },
    {
      title: "Communication Preferences",
      description: "Email and SMS preferences"
    },
    { title: "Help & Support", description: "Get help with your account" }
  ];
  return /* @__PURE__ */ p(
    "section",
    {
      className: `nike-account-dashboard-section ${(e == null ? void 0 : e.className) || ""}`,
      children: [
        /* @__PURE__ */ p("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8", children: [
          /* @__PURE__ */ s("div", { className: "mb-8", children: /* @__PURE__ */ p("div", { className: "flex items-center justify-between", children: [
            /* @__PURE__ */ s("div", { children: c ? /* @__PURE__ */ p("div", { className: "animate-pulse", children: [
              /* @__PURE__ */ s("div", { className: "h-8 w-48 bg-gray-200 rounded mb-2" }),
              /* @__PURE__ */ s("div", { className: "h-4 w-32 bg-gray-200 rounded" })
            ] }) : /* @__PURE__ */ p(se, { children: [
              /* @__PURE__ */ s("h1", { className: "text-3xl font-bold text-gray-900", children: o != null && o.firstName ? `Hello, ${o.firstName}` : o != null && o.phoneNumber ? "Welcome Back" : "Hello, Guest" }),
              o != null && o.joinedDate ? /* @__PURE__ */ p("p", { className: "mt-1 text-sm text-gray-600", children: [
                o.membershipLevel || "Nike Member",
                " since ",
                new Date(o.joinedDate).getFullYear()
              ] }) : null
            ] }) }),
            (o == null ? void 0 : o.showSignOut) && /* @__PURE__ */ s("button", { className: "text-sm text-gray-600 underline hover:text-gray-900", children: "Sign Out" })
          ] }) }),
          /* @__PURE__ */ p("div", { className: "grid grid-cols-1 gap-8 lg:grid-cols-3", children: [
            /* @__PURE__ */ p("div", { className: "space-y-8 lg:col-span-2", children: [
              /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
                /* @__PURE__ */ s("h2", { className: "mb-4 text-lg font-semibold text-gray-900", children: "Quick Actions" }),
                /* @__PURE__ */ s("div", { className: "grid gap-4 grid-cols-2 sm:grid-cols-4", children: x.map((g, k) => {
                  const C = ((T) => {
                    switch (T) {
                      case "shopping-bag":
                        return Vi;
                      case "heart":
                        return Jn;
                      case "package":
                        return _t;
                      case "help-circle":
                        return po;
                      default:
                        return Vi;
                    }
                  })(g.icon);
                  return /* @__PURE__ */ p(
                    "a",
                    {
                      href: g.link,
                      className: "flex flex-col items-center rounded-lg border border-gray-200 p-4 transition-colors hover:border-gray-300",
                      children: [
                        /* @__PURE__ */ s(C, { className: "mb-2 h-8 w-8 text-gray-600" }),
                        /* @__PURE__ */ s("span", { className: "text-sm font-medium text-gray-900", children: g.title })
                      ]
                    },
                    k
                  );
                }) })
              ] }),
              me() ? /* @__PURE__ */ s(
                Fa,
                {
                  recentOrders: pi(3),
                  maxOrdersToShow: 3
                }
              ) : /* @__PURE__ */ s(Pa, { maxOrdersToShow: 3, routes: i }),
              v && /* @__PURE__ */ s(Ra, { storeId: v, maxTicketsToShow: 5 })
            ] }),
            /* @__PURE__ */ p("div", { className: "space-y-6", children: [
              /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
                /* @__PURE__ */ p("div", { className: "flex items-center justify-between mb-4", children: [
                  /* @__PURE__ */ s("h3", { className: "text-lg font-semibold text-gray-900", children: "Account Details" }),
                  o && /* @__PURE__ */ p(
                    "button",
                    {
                      onClick: () => m(!0),
                      className: "flex items-center gap-1 text-sm text-gray-600 hover:text-gray-900 transition-colors",
                      children: [
                        /* @__PURE__ */ s(uo, { className: "w-4 h-4" }),
                        "Edit"
                      ]
                    }
                  )
                ] }),
                c ? /* @__PURE__ */ p("div", { className: "animate-pulse space-y-3", children: [
                  /* @__PURE__ */ s("div", { className: "h-4 w-32 bg-gray-200 rounded" }),
                  /* @__PURE__ */ s("div", { className: "h-4 w-40 bg-gray-200 rounded" }),
                  /* @__PURE__ */ s("div", { className: "h-4 w-36 bg-gray-200 rounded" })
                ] }) : /* @__PURE__ */ s("div", { className: "space-y-4", children: /* @__PURE__ */ p("div", { className: "flex items-center justify-between", children: [
                  /* @__PURE__ */ p("div", { className: "space-y-2", children: [
                    o != null && o.firstName || o != null && o.lastName ? /* @__PURE__ */ s("p", { className: "text-sm font-medium text-gray-900", children: `${o.firstName || ""} ${o.lastName || ""}`.trim() }) : null,
                    o != null && o.phoneNumber ? /* @__PURE__ */ p("p", { className: "text-sm text-gray-600", children: [
                      /* @__PURE__ */ s("span", { className: "font-medium", children: "Phone:" }),
                      " +",
                      o.phoneNumber
                    ] }) : null,
                    o != null && o.email ? /* @__PURE__ */ p("p", { className: "text-sm text-gray-600", children: [
                      /* @__PURE__ */ s("span", { className: "font-medium", children: "Email:" }),
                      " ",
                      o.email
                    ] }) : null,
                    o != null && o.joinedDate ? /* @__PURE__ */ p("p", { className: "text-sm text-gray-500", children: [
                      "Member since ",
                      new Date(o.joinedDate).toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "long",
                        day: "numeric"
                      })
                    ] }) : null
                  ] }),
                  o ? /* @__PURE__ */ s("span", { className: "inline-flex items-center rounded-full bg-black px-2.5 py-0.5 text-xs font-medium text-white self-start", children: "MEMBER" }) : null
                ] }) })
              ] }),
              a.length > 0 ? /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
                /* @__PURE__ */ s("h3", { className: "mb-4 text-lg font-semibold text-gray-900", children: "Saved Addresses" }),
                /* @__PURE__ */ p("div", { className: "space-y-4", children: [
                  a.slice(0, 2).map((g, k) => /* @__PURE__ */ p(
                    "div",
                    {
                      className: "border-b border-gray-100 pb-3 last:border-b-0 last:pb-0",
                      children: [
                        /* @__PURE__ */ p("p", { className: "text-sm text-gray-900", children: [
                          g.addressLine1,
                          g.addressLine2 ? `, ${g.addressLine2}` : ""
                        ] }),
                        /* @__PURE__ */ p("p", { className: "text-sm text-gray-600", children: [
                          g.city,
                          ", ",
                          g.state,
                          " ",
                          g.postalCode
                        ] })
                      ]
                    },
                    g.id || k
                  )),
                  a.length > 2 ? /* @__PURE__ */ p("p", { className: "text-sm text-gray-500", children: [
                    "+",
                    a.length - 2,
                    " more address",
                    a.length - 2 > 1 ? "es" : ""
                  ] }) : null
                ] })
              ] }) : null,
              /* @__PURE__ */ p("div", { className: "rounded-lg border border-gray-200 bg-white p-6", children: [
                /* @__PURE__ */ s("h3", { className: "mb-4 text-lg font-semibold text-gray-900", children: "Account Settings" }),
                /* @__PURE__ */ s("div", { className: "space-y-4", children: b.map((g, k) => /* @__PURE__ */ s(
                  "button",
                  {
                    className: "w-full border-b border-gray-100 py-2 text-left text-sm text-gray-600 hover:text-gray-900",
                    children: g.title
                  },
                  k
                )) })
              ] })
            ] })
          ] })
        ] }),
        h && o && /* @__PURE__ */ s(
          La,
          {
            currentData: {
              firstName: o.firstName,
              lastName: o.lastName,
              email: o.email,
              phoneNumber: o.phoneNumber
            },
            onClose: () => m(!1),
            onSuccess: () => {
              y();
            }
          }
        )
      ]
    }
  );
}, $a = ue(Ba, {
  identifier: "nike.nikeaccount.accountdashboard",
  title: "Account Dashboard",
  featuredImage: "public/placeholder.png",
  description: "User account dashboard with profile info, quick actions, recent orders, and account settings",
  category: "account",
  className: "nike-account-dashboard",
  components: za,
  renderMode: "client"
}), hr = {
  primary: "#000000",
  // Nike Black - Primary brand color
  secondary: "#FFFFFF",
  // Nike White - Secondary brand color
  accent: "#FF6B35",
  // Nike Orange - Accent color for CTAs
  text: "#111111",
  // Dark Text - Primary text color
  primaryGradientStart: "#000000",
  // Black gradient start
  primaryGradientEnd: "#333333",
  // Dark gray gradient end
  secondaryGradientStart: "#F7F7F7",
  // Light gray gradient start
  secondaryGradientEnd: "#FFFFFF"
  // White gradient end
}, Oa = 1e4;
function gr() {
  try {
    return Function("return typeof import !== 'undefined' ? import.meta?.env : undefined")();
  } catch {
    return;
  }
}
function Ma(t) {
  if (typeof process < "u" && process.env) return process.env[t];
}
function Da(t) {
  try {
    const e = gr();
    if (e) return e[t];
  } catch {
  }
}
function Oe(...t) {
  for (const e of t) {
    const i = Ma(e);
    if (i) return i;
  }
  for (const e of t) {
    const i = Da(e);
    if (i) return i;
  }
}
function xt(t) {
  return !!t && t.toLowerCase() === "true";
}
function Wa(t) {
  return (function() {
    if (typeof window < "u") {
      const i = window.location.hostname;
      return i === "localhost" || i === "127.0.0.1" || i.startsWith("192.168.");
    }
    return !1;
  })() ? "http://localhost:8000" : Oe("API_BASE_URL", "VITE_API_URL", "NEXT_PUBLIC_API_URL", "NEXT_PUBLIC_API_BASE_URL") || (t === "development" ? "http://localhost:8000" : "https://server.shiphouse.in");
}
function Ha() {
  const t = (function() {
    const e = Oe("ENV", "VITE_ENV", "NODE_ENV");
    if (e) {
      const i = e.toLowerCase();
      if (i === "development" || i === "dev") return "development";
      if (i === "production" || i === "prod") return "production";
      if (i === "test") return "test";
    }
    try {
      const i = gr();
      if (i) {
        if (i.DEV === !0) return "development";
        if (i.PROD === !0) return "production";
        if (i.MODE) {
          const n = String(i.MODE).toLowerCase();
          if (n === "development" || n === "dev") return "development";
          if (n === "test") return "test";
        }
      }
    } catch {
    }
    return "production";
  })();
  return { ENV: t, isDevelopment: t === "development", isProduction: t === "production", isTest: t === "test", API_BASE_URL: Wa(t), API_TIMEOUT: (function(e, i) {
    if (!e) return i;
    const n = parseInt(e, 10);
    return isNaN(n) ? i : n;
  })(Oe("API_TIMEOUT", "VITE_API_TIMEOUT"), Oa), STORE_ID: Oe("STORE_ID", "VITE_STORE_ID", "NEXT_PUBLIC_STORE_ID"), TEST_MODE: xt(Oe("TEST_MODE", "NEXT_PUBLIC_TEST_MODE", "REACT_APP_TEST_MODE")), INTEGRATION_TESTS: xt(Oe("INTEGRATION_TESTS")), SHIPHOUSE_SDK_FAKE_DATA: xt(Oe("SHIPHOUSE_SDK_FAKE_DATA", "SCREENSHOT_USE_FAKE_DATA", "NEXT_PUBLIC_SHIPHOUSE_SDK_FAKE_DATA", "NEXT_PUBLIC_SCREENSHOT_USE_FAKE_DATA", "VITE_SHIPHOUSE_SDK_FAKE_DATA", "VITE_SCREENSHOT_USE_FAKE_DATA", "REACT_APP_SHIPHOUSE_SDK_FAKE_DATA", "REACT_APP_SCREENSHOT_USE_FAKE_DATA")), ENABLE_DEBUG: xt(Oe("ENABLE_DEBUG", "VITE_ENABLE_DEBUG")), ENABLE_IMAGE_LOGGING: xt(Oe("ENABLE_IMAGE_LOGGING", "NEXT_PUBLIC_ENABLE_IMAGE_LOGGING")), ENABLE_ANALYTICS: xt(Oe("ENABLE_ANALYTICS", "VITE_ENABLE_ANALYTICS")) };
}
let Je = null;
function fr() {
  return Je || (Je = Ha(), console.log("🔍 Shiphouse SDK Environment:", { mode: Je.ENV, apiBaseUrl: Je.API_BASE_URL, storeId: Je.STORE_ID || "(not set)", testMode: Je.TEST_MODE, fakeDataMode: Je.SHIPHOUSE_SDK_FAKE_DATA })), Je;
}
function oi() {
  return fr().isDevelopment;
}
const Re = fr();
Re.API_TIMEOUT, Re.TEST_MODE;
Re.isDevelopment;
Re.ENV;
const ja = Re.TEST_MODE, Va = Re.SHIPHOUSE_SDK_FAKE_DATA, qi = Re.API_BASE_URL;
function Ua(t, e) {
  return "test";
}
function qa(t, e) {
  return "test";
}
function yr(t) {
  return !!t.testMode;
}
function Ga(t) {
  if (yr(t)) {
    const e = Ua(t.storeId), i = qa();
    console.log("🧪 SDK Test Mode Enabled"), console.log("📋 Configuration:"), console.log(`   • Base URL: "${qi}"`), console.log(`   • Original Store ID: "${t.storeId}"`), console.log(`   • URL Store ID: "${e}"`), console.log(`   • Auth Token: "${i}"`), console.log('🔧 Server Detection: If storeId="test" OR token="test" → Generate fake data');
  }
}
const br = { sessionToken: "fake-session-token", refreshToken: "fake-refresh-token" };
function ln() {
  return !!Re.SHIPHOUSE_SDK_FAKE_DATA;
}
function Ya() {
  return br.sessionToken;
}
function vr() {
  return br.refreshToken;
}
function fi(t) {
  return t || (ln() ? Ya() : void 0);
}
const j = { log: (...t) => {
  oi() && console.log(...t);
}, error: (...t) => {
  oi() && console.error(...t);
}, warn: (...t) => {
  oi() && console.warn(...t);
}, info: (...t) => {
  oi() && console.info(...t);
} }, Sn = { DEFAULT: 3e4 }, si = { MAX_RETRIES: 3, RETRY_DELAY: 1e3 }, Cn = "cdn.shiphouse.in", ai = Re.isDevelopment || Re.ENABLE_IMAGE_LOGGING;
function Xa(t, e) {
  if (!t) return ai && console.log("🖼️ [getAsset] Empty path, returning placeholder"), "/placeholder.png";
  if (t.startsWith("http://") || t.startsWith("https://") || t.startsWith("//") || t.startsWith("data:") || t.startsWith("/nike-assets")) return ai && console.log("🖼️ [getAsset] Already full URL, returning as-is:", t), t;
  const i = (function(o) {
    return o ? o.startsWith("public/") ? o.substring(7) : o : "";
  })(t);
  if (!e || Object.keys(e).length === 0) {
    const o = `https://${Cn}/${i}`;
    return ai && console.log("🖼️ [getAsset] No size config, returning raw CDN URL:", o), o;
  }
  const n = new URLSearchParams();
  n.append("url", `${Cn}/${i}`), e.width && n.append("w", e.width.toString()), e.height && n.append("h", e.height.toString()), e.fit && n.append("fit", e.fit), e.quality && n.append("q", e.quality.toString()), e.format && n.append("output", e.format), e.progressive && n.append("il", ""), e.blur && n.append("blur", e.blur.toString());
  const r = `https://wsrv.nl/?${n.toString()}`;
  return ai && (console.group("🖼️ [getAsset] URL Generation"), console.log("📥 Input Path:", t), console.log("🔄 Normalized:", i), console.log("⚙️  Config:", e), console.log("✅ Final URL:", r), console.groupEnd()), r;
}
function Qa(t, e = 400, i = 400, n = "fit", r = "webp") {
  return Xa(t, { width: e, height: i, fit: { fit: "inside", cover: "cover", contain: "contain" }[n] || "inside", format: r });
}
function Ja(t, e = 400, i = 400, n = "fit") {
  var r;
  return (r = t == null ? void 0 : t.asset) != null && r.path ? Qa(t.asset.path, e, i, n) : "/placeholder.png";
}
const Za = ({ routes: t, initialOrderId: e }) => {
  var E, P, S, K, _, L, N, $, A, M, q, H, X, re;
  const i = fa(), n = ft(), r = ze(n ?? void 0), o = ((E = n == null ? void 0 : n.searchParams) == null ? void 0 : E.orderId) || ((P = n == null ? void 0 : n.query) == null ? void 0 : P.orderId) || "", l = i.get("orderId") || o || e || "", [a, d] = O(null), [c, u] = O(!0), [h, m] = O(null), v = {
    id: ve.orderId,
    order_number: "NK-2025-000128",
    created_at: "2025-04-01T09:30:00.000Z",
    confirmed_at: "2025-04-01T10:05:00.000Z",
    processing_at: "2025-04-01T13:20:00.000Z",
    shipped_at: "2025-04-02T09:15:00.000Z",
    out_for_delivery_at: "2025-04-03T07:45:00.000Z",
    delivered_at: "2025-04-03T14:20:00.000Z",
    order_status: "DELIVERED",
    payment_status: "CAPTURED",
    supported_payment_type: ["CARD"],
    items: [
      {
        id: "item-0",
        variant_id: "variant-0",
        quantity: 1
      },
      {
        id: "item-1",
        variant_id: "variant-1",
        quantity: 2
      }
    ],
    variants: [
      {
        id: "variant-0",
        title: "Nike Air Max 90",
        product_slug: "nike-air-max-90",
        option1: "US 9",
        option2: "Black",
        price: 1299900,
        sku: "NK-AM90-BLK-09",
        assets: [
          {
            asset: {
              path: z.featured.featured1
            }
          }
        ]
      },
      {
        id: "variant-1",
        title: "Nike Dri-FIT T-Shirt",
        product_slug: "nike-dri-fit-t-shirt",
        option1: "M",
        option2: "White",
        price: 299900,
        sku: "NK-DFT-TEE-WHT-M",
        assets: [
          {
            asset: {
              path: z.featured.featured2
            }
          }
        ]
      }
    ],
    calculation: {
      items_sub_total: 1899800,
      shipping_charge: 0,
      cod_charge: 0,
      tax_amount: 0,
      discount_amount: 0,
      total_amount: 1899800
    },
    shipping_address: {
      address_line_one: "221B, Brigade Road",
      address_line_two: "Shivajinagar",
      city: "Bengaluru",
      state: "Karnataka",
      postal_code: "560001",
      country: "India",
      created_by: "fake-preview"
    },
    billing_address: {
      address_line_one: "221B, Brigade Road",
      address_line_two: "Shivajinagar",
      city: "Bengaluru",
      state: "Karnataka",
      postal_code: "560001",
      country: "India",
      created_by: "fake-preview"
    },
    order_sets: [
      {
        shipping_details: {
          tracking_id: "TRK-FAKE-000128",
          courier_name: "Shiphouse Express",
          shipped_at: "2025-04-02T09:15:00.000Z",
          out_for_delivery_at: "2025-04-03T07:45:00.000Z",
          expected_delivery: "2025-04-03T14:00:00.000Z",
          delivered_at: "2025-04-03T14:20:00.000Z"
        }
      }
    ]
  }, y = (V) => {
    var G;
    return (G = V == null ? void 0 : V.assets) != null && G.length ? Ja(V.assets[0], 100, 100) : "";
  };
  U(() => {
    (async () => {
      const G = me();
      if (!l && !G) {
        m("No order ID provided"), u(!1);
        return;
      }
      if (u(!0), m(null), G) {
        d(v), u(!1);
        return;
      }
      try {
        const ie = await Ve().orders.getOrder(l);
        console.log("[OrderTrackingContent] Order response:", ie), ie.valid && ie.data ? d(ie.data) : m(ie.message || "Failed to load order");
      } catch (Y) {
        console.error("[OrderTrackingContent] Error fetching order:", Y), m(Y.message || "Failed to load order");
      } finally {
        u(!1);
      }
    })();
  }, [l]);
  const f = (V) => {
    switch (V) {
      case "NEW":
        return {
          label: "New Order",
          color: "text-blue-600 bg-blue-50",
          step: 1
        };
      case "CONFIRMED":
        return {
          label: "Confirmed",
          color: "text-green-600 bg-green-50",
          step: 2
        };
      case "PROCESSING":
        return {
          label: "Processing",
          color: "text-indigo-600 bg-indigo-50",
          step: 2
        };
      case "DISPATCHED":
      case "DISPATCHING":
        return {
          label: "Dispatched",
          color: "text-orange-600 bg-orange-50",
          step: 3
        };
      case "SHIPPED":
      case "IN_TRANSIT":
        return {
          label: "In Transit",
          color: "text-cyan-600 bg-cyan-50",
          step: 3
        };
      case "OUT_FOR_DELIVERY":
        return {
          label: "Out for Delivery",
          color: "text-purple-600 bg-purple-50",
          step: 4
        };
      case "DELIVERED":
        return {
          label: "Delivered",
          color: "text-emerald-600 bg-emerald-50",
          step: 5
        };
      default:
        return { label: V, color: "text-gray-600 bg-gray-50", step: 1 };
    }
  }, x = (V) => {
    switch (V) {
      case "NULL":
        return "Pending";
      case "CAPTURED":
        return "Paid";
      case "FAILED":
        return "Failed";
      case "REFUNDED":
        return "Refunded";
      default:
        return V;
    }
  };
  if (c)
    return /* @__PURE__ */ s("div", { className: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12", children: /* @__PURE__ */ s("div", { className: "flex items-center justify-center min-h-[400px]", children: /* @__PURE__ */ p("div", { className: "text-center", children: [
      /* @__PURE__ */ s("div", { className: "animate-spin rounded-full h-16 w-16 border-b-2 border-gray-900 mx-auto mb-4" }),
      /* @__PURE__ */ s("p", { className: "text-gray-600", children: "Loading order details..." })
    ] }) }) });
  if (h || !a)
    return /* @__PURE__ */ s("div", { className: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12", children: /* @__PURE__ */ s("div", { className: "bg-red-50 border border-red-200 rounded-lg p-8", children: /* @__PURE__ */ p("div", { className: "flex items-start", children: [
      /* @__PURE__ */ s(Hi, { className: "h-8 w-8 text-red-600 mr-4 flex-shrink-0" }),
      /* @__PURE__ */ p("div", { className: "flex-1", children: [
        /* @__PURE__ */ s("h2", { className: "text-xl font-semibold text-red-800 mb-2", children: "Unable to Load Order" }),
        /* @__PURE__ */ s("p", { className: "text-red-600 mb-6", children: h || "Order not found or you don't have permission to view it." }),
        /* @__PURE__ */ s(
          "a",
          {
            href: Se(
              "account",
              n ?? void 0,
              t,
              r
            ),
            className: "inline-block px-6 py-3 bg-black text-white rounded-full hover:bg-gray-800 transition-colors",
            children: "Return to Account"
          }
        )
      ] })
    ] }) }) });
  const b = f(a.order_status), g = b.step, k = (V) => V ? new Date(V).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  }) : null, w = [
    { icon: ji, label: "Order Placed", step: 1, key: "PLACED" },
    { icon: _t, label: "Processing", step: 2, key: "PROCESSING" },
    { icon: mo, label: "Shipped", step: 3, key: "SHIPPED" },
    {
      icon: ho,
      label: "Out for Delivery",
      step: 4,
      key: "OUT_FOR_DELIVERY"
    },
    { icon: ji, label: "Delivered", step: 5, key: "DELIVERED" }
  ], C = (K = (S = a.order_sets) == null ? void 0 : S[0]) == null ? void 0 : K.shipping_details, T = (V) => {
    switch (V) {
      case "PLACED":
        return k(a.created_at);
      case "PROCESSING":
        return k(
          a.processing_at || a.confirmed_at || a.created_at
        );
      case "SHIPPED":
        return C != null && C.tracking_id || C != null && C.courier_name ? [C.tracking_id, C.courier_name].filter(Boolean).join(" · ") : k(C == null ? void 0 : C.shipped_at);
      case "OUT_FOR_DELIVERY":
        return k(
          (C == null ? void 0 : C.expected_delivery) || (C == null ? void 0 : C.out_for_delivery_at)
        );
      case "DELIVERED":
        return k((C == null ? void 0 : C.delivered_at) || a.delivered_at);
      default:
        return null;
    }
  }, I = (V) => {
    if (!V)
      return null;
    const G = V.address_line_one || V.address1, Y = V.address_line_two || V.address2, ie = V.city, ae = V.state || V.province, ge = V.postal_code || V.zip, ye = V.country;
    return /* @__PURE__ */ p("div", { className: "space-y-1 text-gray-600", children: [
      G && /* @__PURE__ */ s("p", { children: G }),
      Y && /* @__PURE__ */ s("p", { children: Y }),
      (ie || ae || ge) && /* @__PURE__ */ s("p", { children: [ie, ae, ge].filter(Boolean).join(", ") }),
      ye && /* @__PURE__ */ s("p", { children: ye }),
      V.created_by && /* @__PURE__ */ p("p", { className: "text-sm text-gray-500", children: [
        "Created by: ",
        V.created_by
      ] })
    ] });
  };
  return /* @__PURE__ */ p("div", { className: "max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12", children: [
    /* @__PURE__ */ s("div", { className: "mb-8", children: /* @__PURE__ */ p("div", { className: "flex items-center justify-between mb-4", children: [
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ p("h1", { className: "text-3xl font-bold text-gray-900", children: [
          "Order #",
          a.order_number
        ] }),
        /* @__PURE__ */ p("p", { className: "text-gray-600 mt-1", children: [
          "Placed on",
          " ",
          new Date(a.created_at).toLocaleDateString("en-US", {
            year: "numeric",
            month: "long",
            day: "numeric"
          })
        ] })
      ] }),
      /* @__PURE__ */ s(
        "span",
        {
          className: `px-4 py-2 rounded-full text-sm font-medium ${b.color}`,
          children: b.label
        }
      )
    ] }) }),
    /* @__PURE__ */ p("div", { className: "grid grid-cols-1 lg:grid-cols-3 gap-8", children: [
      /* @__PURE__ */ p("div", { className: "lg:col-span-2 space-y-6", children: [
        /* @__PURE__ */ p("div", { className: "bg-white rounded-lg border border-gray-200 p-6", children: [
          /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900 mb-4", children: "Order Status" }),
          /* @__PURE__ */ s("div", { className: "relative space-y-3", children: w.map((V, G) => {
            const Y = V.icon, ie = g >= V.step, ae = g === V.step, ge = G === w.length - 1, ye = T(V.key), de = !ie && !ae && !ye;
            return /* @__PURE__ */ p(
              "div",
              {
                className: `relative flex items-start ${de ? "opacity-70" : ""}`,
                children: [
                  /* @__PURE__ */ p("div", { className: "relative flex flex-col items-center", children: [
                    /* @__PURE__ */ s(
                      "div",
                      {
                        className: `flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center z-10 ${ie ? "bg-black text-white" : "bg-gray-100 text-gray-400"}`,
                        children: /* @__PURE__ */ s(Y, { className: "w-5 h-5" })
                      }
                    ),
                    !ge && /* @__PURE__ */ s(
                      "div",
                      {
                        className: `w-0.5 ${de ? "h-8" : "h-12"} mt-1 ${g > V.step ? "bg-black" : "bg-gray-200"}`
                      }
                    )
                  ] }),
                  /* @__PURE__ */ p(
                    "div",
                    {
                      className: `ml-3 flex-1 ${ge ? "" : de ? "pb-2" : "pb-4"}`,
                      children: [
                        /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: [
                          /* @__PURE__ */ s(
                            "h3",
                            {
                              className: `font-medium text-base ${ie ? "text-gray-900" : "text-gray-500"}`,
                              children: V.label
                            }
                          ),
                          ae && /* @__PURE__ */ s("span", { className: "text-xs text-black/70 px-2 py-0.5 bg-black/5 rounded-full", children: "Current" }),
                          de && /* @__PURE__ */ s("span", { className: "text-xs text-gray-400", children: "Pending" })
                        ] }),
                        !de && ye && /* @__PURE__ */ s("p", { className: "text-sm text-gray-600 mt-1", children: ye })
                      ]
                    }
                  )
                ]
              },
              G
            );
          }) })
        ] }),
        /* @__PURE__ */ p("div", { className: "bg-white rounded-lg border border-gray-200 p-6", children: [
          /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900 mb-4", children: "Order Items" }),
          /* @__PURE__ */ s("div", { className: "space-y-4", children: (_ = a.items) == null ? void 0 : _.map((V, G) => {
            var ye;
            const Y = (ye = a.variants) == null ? void 0 : ye.find(
              (de) => de.id === V.variant_id
            );
            if (!Y)
              return console.warn("Variant not found for item:", V), null;
            const ie = y(Y), ae = [
              Y.option1,
              Y.option2,
              Y.option3
            ].filter(Boolean).join(" / "), ge = Y.title || Y.product_slug || "Product";
            return /* @__PURE__ */ p(
              "div",
              {
                className: "flex items-center space-x-4 pb-4 border-b last:border-b-0",
                children: [
                  /* @__PURE__ */ s("div", { className: "w-20 h-20 flex-shrink-0", children: /* @__PURE__ */ s(
                    $e,
                    {
                      src: ie,
                      alt: ge,
                      className: "w-full h-full object-cover rounded-lg",
                      showPlaceholderIcon: !0,
                      cdnWidth: 100,
                      cdnHeight: 100,
                      cdnFit: "fit"
                    }
                  ) }),
                  /* @__PURE__ */ p("div", { className: "flex-1 min-w-0", children: [
                    /* @__PURE__ */ s("h3", { className: "font-medium text-gray-900", children: ge }),
                    ae && /* @__PURE__ */ s("p", { className: "text-sm text-gray-600 mt-1", children: ae }),
                    /* @__PURE__ */ p("p", { className: "text-sm text-gray-600 mt-1", children: [
                      "Quantity: ",
                      V.quantity
                    ] }),
                    Y.sku && /* @__PURE__ */ p("p", { className: "text-xs text-gray-500 mt-1", children: [
                      "SKU: ",
                      Y.sku
                    ] })
                  ] }),
                  /* @__PURE__ */ p("div", { className: "flex-shrink-0 text-right", children: [
                    /* @__PURE__ */ p("p", { className: "font-semibold text-gray-900", children: [
                      "₹",
                      (Y.price / 100).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      })
                    ] }),
                    V.quantity > 1 && /* @__PURE__ */ p("p", { className: "text-sm text-gray-600 mt-1", children: [
                      "₹",
                      (Y.price * V.quantity / 100).toLocaleString("en-IN", {
                        minimumFractionDigits: 2
                      }),
                      " ",
                      "total"
                    ] })
                  ] })
                ]
              },
              V.id || G
            );
          }) })
        ] }),
        (a.shipping_address || a.billing_address) && /* @__PURE__ */ p("div", { className: "bg-white rounded-lg border border-gray-200 p-6", children: [
          /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900 mb-4", children: "Address Details" }),
          /* @__PURE__ */ p("div", { className: "grid gap-6 md:grid-cols-2", children: [
            a.shipping_address && /* @__PURE__ */ p("div", { children: [
              /* @__PURE__ */ s("h3", { className: "mb-2 text-sm font-medium text-gray-900", children: "Shipping Address" }),
              I(a.shipping_address)
            ] }),
            a.billing_address && /* @__PURE__ */ p("div", { children: [
              /* @__PURE__ */ s("h3", { className: "mb-2 text-sm font-medium text-gray-900", children: "Billing Address" }),
              I(a.billing_address)
            ] })
          ] })
        ] })
      ] }),
      /* @__PURE__ */ p("div", { className: "space-y-6", children: [
        /* @__PURE__ */ p("div", { className: "bg-white rounded-lg border border-gray-200 p-6", children: [
          /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900 mb-4", children: "Order Summary" }),
          /* @__PURE__ */ p("div", { className: "space-y-3", children: [
            /* @__PURE__ */ p("div", { className: "flex justify-between text-sm", children: [
              /* @__PURE__ */ s("span", { className: "text-gray-600", children: "Subtotal" }),
              /* @__PURE__ */ p("span", { className: "text-gray-900", children: [
                "₹",
                ((((L = a.calculation) == null ? void 0 : L.items_sub_total) || 0) / 100).toLocaleString("en-IN", {
                  minimumFractionDigits: 2
                })
              ] })
            ] }),
            ((N = a.calculation) == null ? void 0 : N.total_charges) > 0 && /* @__PURE__ */ p("div", { className: "flex justify-between text-sm", children: [
              /* @__PURE__ */ s("span", { className: "text-gray-600", children: "Shipping" }),
              /* @__PURE__ */ p("span", { className: "text-gray-900", children: [
                "₹",
                (((($ = a.calculation) == null ? void 0 : $.total_charges) || 0) / 100).toLocaleString("en-IN", {
                  minimumFractionDigits: 2
                })
              ] })
            ] }),
            ((A = a.calculation) == null ? void 0 : A.total_discounts) > 0 && /* @__PURE__ */ p("div", { className: "flex justify-between text-sm", children: [
              /* @__PURE__ */ s("span", { className: "text-gray-600", children: "Discount" }),
              /* @__PURE__ */ p("span", { className: "text-green-600", children: [
                "-₹",
                ((((M = a.calculation) == null ? void 0 : M.total_discounts) || 0) / 100).toLocaleString("en-IN", {
                  minimumFractionDigits: 2
                })
              ] })
            ] }),
            ((q = a.calculation) == null ? void 0 : q.total_tax) > 0 && /* @__PURE__ */ p("div", { className: "flex justify-between text-sm", children: [
              /* @__PURE__ */ s("span", { className: "text-gray-600", children: "Tax" }),
              /* @__PURE__ */ p("span", { className: "text-gray-900", children: [
                "₹",
                ((((H = a.calculation) == null ? void 0 : H.total_tax) || 0) / 100).toLocaleString(
                  "en-IN",
                  {
                    minimumFractionDigits: 2
                  }
                )
              ] })
            ] }),
            /* @__PURE__ */ p("div", { className: "border-t pt-3 flex justify-between font-semibold", children: [
              /* @__PURE__ */ s("span", { className: "text-gray-900", children: "Total" }),
              /* @__PURE__ */ p("span", { className: "text-gray-900", children: [
                "₹",
                ((((X = a.calculation) == null ? void 0 : X.grand_total_int) || 0) / 100).toLocaleString("en-IN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })
              ] })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ p("div", { className: "bg-white rounded-lg border border-gray-200 p-6", children: [
          /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900 mb-4", children: "Payment Information" }),
          /* @__PURE__ */ p("div", { className: "space-y-2 text-sm", children: [
            /* @__PURE__ */ p("div", { className: "flex justify-between", children: [
              /* @__PURE__ */ s("span", { className: "text-gray-600", children: "Status" }),
              /* @__PURE__ */ s("span", { className: "font-medium text-gray-900", children: x(a.payment_status) })
            ] }),
            /* @__PURE__ */ p("div", { className: "flex justify-between", children: [
              /* @__PURE__ */ s("span", { className: "text-gray-600", children: "Method" }),
              /* @__PURE__ */ s("span", { className: "font-medium text-gray-900 capitalize", children: ((re = a.supported_payment_type) == null ? void 0 : re[0]) || "N/A" })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ p("div", { className: "bg-gray-50 rounded-lg border border-gray-200 p-6", children: [
          /* @__PURE__ */ s("h2", { className: "text-lg font-semibold text-gray-900 mb-2", children: "Need Help?" }),
          /* @__PURE__ */ s("p", { className: "text-sm text-gray-600 mb-4", children: "Contact our support team for any questions about your order." }),
          /* @__PURE__ */ s("button", { className: "w-full px-4 py-2 bg-black text-white rounded-full hover:bg-gray-800 transition-colors", children: "Contact Support" })
        ] })
      ] })
    ] })
  ] });
}, el = [
  F(
    "text-block",
    "order-tracking-config",
    {
      desktop: [
        { inputKey: "showTimeline", type: "checkbox", value: !0 },
        { inputKey: "showOrderItems", type: "checkbox", value: !0 },
        { inputKey: "showShippingAddress", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Order Tracking Configuration",
      description: "Display options for order tracking section"
    }
  )
], tl = ({
  data: t,
  theme: e = hr,
  config: i,
  routes: n,
  viewportMode: r
}) => {
  const o = (t == null ? void 0 : t.orderId) || (i == null ? void 0 : i.orderId) || (me() ? ve.orderId : "order-0");
  return /* @__PURE__ */ s(
    "section",
    {
      className: `nike-order-tracking-section ${(i == null ? void 0 : i.className) || ""}`,
      children: /* @__PURE__ */ s(
        Za,
        {
          theme: e,
          routes: n,
          initialOrderId: o
        }
      )
    }
  );
}, il = ue(tl, {
  identifier: "nike.nikeaccount.ordertracking",
  title: "Order Tracking",
  featuredImage: "public/placeholder.png",
  description: "Order tracking display with status progression, delivery details, and order summary",
  category: "nike",
  className: "nike-order-tracking",
  components: el,
  renderMode: "client"
}), nl = [
  // Page Header Component
  F(
    "heading-text",
    "otp-page-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Verify Your Phone Number" },
        { inputKey: "level", type: "select", value: "1" },
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#111111" },
        { inputKey: "textAlign", type: "select", value: "center" },
        { inputKey: "marginBottom", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 28 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 24 }]
    },
    {
      name: "OTP Page Title",
      description: "Main heading for the OTP verification page"
    }
  ),
  // Page Subtitle Component
  F(
    "text-block",
    "otp-page-subtitle",
    {
      desktop: [
        {
          inputKey: "text",
          type: "text",
          value: "Enter the 6-digit code sent to your phone"
        },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#6B7280" },
        { inputKey: "textAlign", type: "select", value: "center" },
        { inputKey: "marginBottom", type: "number", value: 32 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "OTP Page Subtitle",
      description: "Subtitle text explaining OTP verification"
    }
  ),
  // OTP Input Container Component
  F(
    "container",
    "otp-input-container",
    {
      desktop: [
        { inputKey: "gap", type: "number", value: 12 },
        { inputKey: "justifyContent", type: "select", value: "center" },
        { inputKey: "marginBottom", type: "number", value: 24 }
      ],
      tablet: [],
      mobile: [{ inputKey: "gap", type: "number", value: 8 }]
    },
    {
      name: "OTP Input Container",
      description: "Container for OTP input fields"
    }
  ),
  // Individual OTP Input Styling
  F(
    "text-block",
    "otp-digit-input",
    {
      desktop: [
        { inputKey: "width", type: "number", value: 48 },
        { inputKey: "height", type: "number", value: 48 },
        { inputKey: "fontSize", type: "number", value: 18 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textAlign", type: "select", value: "center" },
        { inputKey: "borderColor", type: "color", value: "#D1D5DB" },
        { inputKey: "focusBorderColor", type: "color", value: "#000000" },
        { inputKey: "borderRadius", type: "number", value: 6 },
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" }
      ],
      tablet: [],
      mobile: [
        { inputKey: "width", type: "number", value: 40 },
        { inputKey: "height", type: "number", value: 40 },
        { inputKey: "fontSize", type: "number", value: 16 }
      ]
    },
    {
      name: "OTP Digit Input",
      description: "Individual OTP digit input field styling"
    }
  ),
  // Verify Button Component
  F(
    "button-solid",
    "verify-button",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Verify OTP" },
        { inputKey: "backgroundColor", type: "color", value: "#000000" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "hoverBackgroundColor", type: "color", value: "#374151" },
        { inputKey: "borderRadius", type: "number", value: 6 },
        { inputKey: "paddingX", type: "number", value: 16 },
        { inputKey: "paddingY", type: "number", value: 12 },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "width", type: "select", value: "full" },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Verify Button",
      description: "Button to verify the entered OTP"
    }
  ),
  // Resend OTP Button Component
  F(
    "button-outline",
    "resend-otp-button",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Resend OTP" },
        { inputKey: "borderColor", type: "color", value: "#D1D5DB" },
        { inputKey: "textColor", type: "color", value: "#374151" },
        { inputKey: "hoverBorderColor", type: "color", value: "#000000" },
        { inputKey: "hoverTextColor", type: "color", value: "#000000" },
        { inputKey: "borderRadius", type: "number", value: 6 },
        { inputKey: "paddingX", type: "number", value: 16 },
        { inputKey: "paddingY", type: "number", value: 12 },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "width", type: "select", value: "full" },
        { inputKey: "marginBottom", type: "number", value: 24 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Resend OTP Button",
      description: "Button to resend OTP to phone number"
    }
  ),
  // Back to Sign In Link Component
  F(
    "link-text",
    "back-to-signin-link",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Back to Sign In" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "textColor", type: "color", value: "#6B7280" },
        { inputKey: "hoverTextColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "center" },
        { inputKey: "textDecoration", type: "select", value: "underline" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Back to Sign In Link",
      description: "Link to go back to the sign-in page"
    }
  ),
  // Container Styling Component
  F(
    "container",
    "otp-form-container",
    {
      desktop: [
        { inputKey: "maxWidth", type: "number", value: 448 },
        // max-w-md (28rem = 448px)
        { inputKey: "paddingX", type: "number", value: 16 },
        { inputKey: "paddingY", type: "number", value: 32 },
        { inputKey: "marginX", type: "select", value: "auto" },
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" }
      ],
      tablet: [{ inputKey: "paddingX", type: "number", value: 24 }],
      mobile: [{ inputKey: "paddingX", type: "number", value: 16 }]
    },
    {
      name: "OTP Form Container",
      description: "Container styling for the OTP verification form"
    }
  )
], rl = ({
  data: t,
  className: e,
  theme: i,
  routes: n,
  routeContext: r,
  viewportMode: o = "desktop"
}) => {
  const l = (A, M, q) => {
    var X;
    const H = A == null ? void 0 : A[o];
    return ((X = H == null ? void 0 : H.find((re) => re.inputKey === M)) == null ? void 0 : X.value) ?? q;
  }, a = R(t, "heading-text", "otp-page-title", o), d = R(
    t,
    "text-block",
    "otp-page-subtitle",
    o
  ), c = R(
    t,
    "container",
    "otp-form-container",
    o
  ), u = R(t, "text-block", "otp-digit-input", o), h = R(
    t,
    "button-solid",
    "verify-button",
    o
  ), m = R(
    t,
    "button-outline",
    "resend-otp-button",
    o
  ), v = R(
    t,
    "link-text",
    "back-to-signin-link",
    o
  ), y = ze(r ?? void 0), f = l(c, "maxWidth", 448), x = l(c, "paddingX", 16), b = l(c, "paddingY", 32), g = l(a, "text", "Verify Your Phone Number"), k = l(a, "fontSize", 32), w = l(a, "textColor", "#111111"), C = l(d, "text", "Enter the 6-digit code sent to your phone"), T = l(d, "fontSize", 14), I = l(d, "textColor", "#6B7280"), E = l(u, "width", 48), P = l(u, "height", 48), S = l(u, "fontSize", 18), K = l(u, "borderColor", "#D1D5DB"), _ = l(u, "focusBorderColor", "#000000"), L = l(v, "text", "Back to Sign In"), N = l(v, "textColor", "#6B7280"), $ = l(v, "hoverTextColor", "#000000");
  return /* @__PURE__ */ s("section", { className: `nike-otp-verification-section ${e || ""}`, children: /* @__PURE__ */ s(
    "main",
    {
      style: {
        maxWidth: `${f}px`,
        paddingLeft: `${x}px`,
        paddingRight: `${x}px`,
        paddingTop: `${b}px`,
        paddingBottom: `${b}px`,
        margin: "0 auto"
      },
      children: /* @__PURE__ */ p("div", { style: { display: "flex", flexDirection: "column", gap: "32px" }, children: [
        /* @__PURE__ */ p("div", { style: { textAlign: "center" }, children: [
          /* @__PURE__ */ s(
            "h1",
            {
              style: {
                fontSize: `${k}px`,
                fontWeight: "bold",
                color: w,
                marginBottom: "8px",
                lineHeight: "1.2"
              },
              children: g
            }
          ),
          /* @__PURE__ */ s(
            "p",
            {
              style: {
                fontSize: `${T}px`,
                color: I,
                marginTop: "8px"
              },
              children: C
            }
          )
        ] }),
        /* @__PURE__ */ p(
          "form",
          {
            onSubmit: (A) => {
              A.preventDefault(), alert("OTP Verified! Redirecting to account..."), window.location.href = Se("account", r, n, y);
            },
            style: { display: "flex", flexDirection: "column", gap: "24px" },
            children: [
              /* @__PURE__ */ s(
                "div",
                {
                  style: {
                    display: "flex",
                    justifyContent: "center",
                    gap: "12px",
                    marginBottom: "24px"
                  },
                  children: [1, 2, 3, 4, 5, 6].map((A) => /* @__PURE__ */ s(
                    "input",
                    {
                      type: "text",
                      maxLength: 1,
                      style: {
                        width: `${E}px`,
                        height: `${P}px`,
                        fontSize: `${S}px`,
                        fontWeight: "bold",
                        textAlign: "center",
                        border: `1px solid ${K}`,
                        borderRadius: "6px",
                        backgroundColor: "#FFFFFF",
                        outline: "none",
                        transition: "border-color 0.15s ease-in-out"
                      },
                      onFocus: (M) => {
                        M.target.style.borderColor = _, M.target.style.boxShadow = `0 0 0 1px ${_}`;
                      },
                      onBlur: (M) => {
                        M.target.style.borderColor = K, M.target.style.boxShadow = "none";
                      },
                      onChange: (M) => {
                        M.target.value && M.target.nextElementSibling && M.target.nextElementSibling.focus();
                      },
                      onKeyDown: (M) => {
                        M.key === "Backspace" && !M.currentTarget.value && M.currentTarget.previousElementSibling && M.currentTarget.previousElementSibling.focus();
                      }
                    },
                    A
                  ))
                }
              ),
              /* @__PURE__ */ s("div", { style: { width: "100%" }, children: /* @__PURE__ */ s(
                on,
                {
                  data: h || { desktop: [], tablet: [], mobile: [] },
                  theme: i,
                  className: "w-full"
                }
              ) }),
              /* @__PURE__ */ s("div", { style: { width: "100%" }, children: /* @__PURE__ */ s(
                ar,
                {
                  data: m || { desktop: [], tablet: [], mobile: [] },
                  theme: i,
                  className: "w-full"
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ s("div", { style: { textAlign: "center" }, children: /* @__PURE__ */ s(
          "a",
          {
            href: Se("signIn", r, n, y),
            className: "hover:[color:var(--back-link-hover-color)] transition-colors duration-150",
            style: {
              fontSize: "14px",
              fontWeight: "500",
              color: N,
              textDecoration: "underline",
              "--back-link-hover-color": $
            },
            children: L
          }
        ) })
      ] })
    }
  ) });
}, ol = ue(rl, {
  identifier: "nike.nikeauthentication.otpverification",
  title: "OTP Verify",
  featuredImage: z.previews.trending,
  // Using trending as placeholder
  description: "OTP verification form with 6-digit input fields and resend functionality for Nike authentication",
  category: "authentication",
  className: "nike-otp-verification",
  components: nl,
  renderMode: "client"
}), sl = [
  // Page Header Component
  F(
    "heading-text",
    "auth-page-title",
    {
      desktop: [
        {
          inputKey: "text",
          type: "text",
          value: "Your Account For Everything Nike"
        },
        { inputKey: "level", type: "select", value: "1" },
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#111111" },
        { inputKey: "textAlign", type: "select", value: "center" },
        { inputKey: "marginBottom", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 28 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 24 }]
    },
    {
      name: "Page Title",
      description: "Main heading for the authentication page"
    }
  ),
  // Page Subtitle Component
  F(
    "text-block",
    "auth-page-subtitle",
    {
      desktop: [
        {
          inputKey: "text",
          type: "text",
          value: "Sign in to access your Nike account"
        },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#6B7280" },
        { inputKey: "textAlign", type: "select", value: "center" },
        { inputKey: "marginBottom", type: "number", value: 32 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Page Subtitle",
      description: "Subtitle text below the main heading"
    }
  ),
  // Phone Number Input Component
  F(
    "text-block",
    "phone-number-input",
    {
      desktop: [
        { inputKey: "placeholder", type: "text", value: "Phone number" },
        { inputKey: "inputType", type: "select", value: "tel" },
        { inputKey: "required", type: "checkbox", value: !0 },
        { inputKey: "borderColor", type: "color", value: "#D1D5DB" },
        { inputKey: "focusBorderColor", type: "color", value: "#000000" },
        { inputKey: "borderRadius", type: "number", value: 6 },
        { inputKey: "paddingX", type: "number", value: 12 },
        { inputKey: "paddingY", type: "number", value: 12 },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "marginBottom", type: "number", value: 24 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Phone Number Input",
      description: "Input field for phone number entry"
    }
  ),
  // Verify OTP Button Component
  F(
    "button-solid",
    "verify-otp-button",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Send OTP" },
        { inputKey: "backgroundColor", type: "color", value: "#000000" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "hoverBackgroundColor", type: "color", value: "#374151" },
        { inputKey: "borderRadius", type: "number", value: 6 },
        { inputKey: "paddingX", type: "number", value: 16 },
        { inputKey: "paddingY", type: "number", value: 12 },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "width", type: "select", value: "full" },
        { inputKey: "marginBottom", type: "number", value: 24 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Verify OTP Button",
      description: "Button to initiate OTP verification process"
    }
  ),
  // Privacy Policy Text Component
  F(
    "text-block",
    "privacy-policy-text",
    {
      desktop: [
        {
          inputKey: "text",
          type: "text",
          value: "By logging in, you agree to Nike's Privacy Policy and Terms of Use."
        },
        { inputKey: "fontSize", type: "number", value: 12 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#6B7280" },
        { inputKey: "textAlign", type: "select", value: "center" },
        { inputKey: "lineHeight", type: "number", value: 1.5 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Privacy Policy Text",
      description: "Legal disclaimer text about privacy policy and terms"
    }
  ),
  // Container Styling Component
  F(
    "container",
    "auth-form-container",
    {
      desktop: [
        { inputKey: "maxWidth", type: "number", value: 448 },
        // max-w-md (28rem = 448px)
        { inputKey: "paddingX", type: "number", value: 16 },
        { inputKey: "paddingY", type: "number", value: 32 },
        { inputKey: "marginX", type: "select", value: "auto" },
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" }
      ],
      tablet: [{ inputKey: "paddingX", type: "number", value: 24 }],
      mobile: [{ inputKey: "paddingX", type: "number", value: 16 }]
    },
    {
      name: "Form Container",
      description: "Container styling for the authentication form"
    }
  )
], al = ({
  data: t,
  className: e,
  viewportMode: i = "desktop"
}) => {
  const n = (S, K, _) => {
    var N;
    const L = S == null ? void 0 : S[i];
    return ((N = L == null ? void 0 : L.find(($) => $.inputKey === K)) == null ? void 0 : N.value) ?? _;
  }, r = R(t, "heading-text", "auth-page-title", i), o = R(
    t,
    "text-block",
    "auth-page-subtitle",
    i
  ), l = R(
    t,
    "text-block",
    "phone-number-input",
    i
  ), a = R(
    t,
    "button-solid",
    "verify-otp-button",
    i
  ), d = R(
    t,
    "text-block",
    "privacy-policy-text",
    i
  ), c = R(
    t,
    "container",
    "auth-form-container",
    i
  ), u = n(c, "maxWidth", 448), h = n(c, "paddingX", 16), m = n(c, "paddingY", 32), v = n(r, "text", "Your Account For Everything Nike"), y = n(r, "fontSize", 32), f = n(r, "textColor", "#111111"), x = n(o, "text", "Sign in to access your Nike account"), b = n(o, "fontSize", 14), g = n(o, "textColor", "#6B7280"), k = n(l, "placeholder", "Phone number"), w = n(l, "paddingX", 12), C = n(l, "paddingY", 12), T = n(l, "borderColor", "#D1D5DB"), I = n(
    d,
    "text",
    "By logging in, you agree to Nike's Privacy Policy and Terms of Use."
  ), E = n(d, "fontSize", 12), P = n(d, "textColor", "#6B7280");
  return /* @__PURE__ */ s("section", { className: `nike-phone-auth-form-section ${e || ""}`, children: /* @__PURE__ */ s(
    "main",
    {
      style: {
        maxWidth: `${u}px`,
        paddingLeft: `${h}px`,
        paddingRight: `${h}px`,
        paddingTop: `${m}px`,
        paddingBottom: `${m}px`,
        margin: "0 auto"
      },
      children: /* @__PURE__ */ p("div", { style: { display: "flex", flexDirection: "column", gap: "32px" }, children: [
        /* @__PURE__ */ p("div", { style: { textAlign: "center" }, children: [
          /* @__PURE__ */ s(
            "h1",
            {
              style: {
                fontSize: `${y}px`,
                fontWeight: "bold",
                color: f,
                marginBottom: "8px",
                lineHeight: "1.2"
              },
              children: v
            }
          ),
          /* @__PURE__ */ s(
            "p",
            {
              style: {
                fontSize: `${b}px`,
                color: g,
                marginTop: "8px"
              },
              children: x
            }
          )
        ] }),
        /* @__PURE__ */ p(
          "form",
          {
            method: "post",
            style: { display: "flex", flexDirection: "column", gap: "24px" },
            children: [
              /* @__PURE__ */ p("div", { children: [
                /* @__PURE__ */ s("label", { htmlFor: "phone", style: { display: "none" }, children: "Phone number" }),
                /* @__PURE__ */ s(
                  "input",
                  {
                    id: "phone",
                    name: "phone",
                    type: "tel",
                    autoComplete: "tel",
                    required: !0,
                    placeholder: k,
                    style: {
                      width: "100%",
                      borderRadius: "6px",
                      border: `1px solid ${T}`,
                      paddingLeft: `${w}px`,
                      paddingRight: `${w}px`,
                      paddingTop: `${C}px`,
                      paddingBottom: `${C}px`,
                      fontSize: "16px",
                      color: "#111111",
                      outline: "none",
                      transition: "border-color 0.15s ease-in-out"
                    }
                  }
                )
              ] }),
              /* @__PURE__ */ s("div", { style: { width: "100%" }, children: /* @__PURE__ */ s(
                on,
                {
                  data: a || { desktop: [], tablet: [], mobile: [] },
                  theme: hr,
                  className: "w-full"
                }
              ) }),
              /* @__PURE__ */ s(
                "p",
                {
                  style: {
                    fontSize: `${E}px`,
                    color: P,
                    textAlign: "center",
                    lineHeight: "1.5"
                  },
                  children: I
                }
              )
            ]
          }
        )
      ] })
    }
  ) });
}, ll = ue(al, {
  identifier: "nike.nikeauthentication.phoneauthform",
  title: "Phone Auth",
  featuredImage: z.previews.trending,
  // Using trending as placeholder
  description: "Phone number authentication form with OTP verification for Nike sign-in process",
  category: "authentication",
  className: "nike-phone-auth-form",
  components: sl,
  renderMode: "client"
}), cl = ({
  theme: t,
  onLoginSuccess: e
}) => {
  const [i, n] = O("phone"), [r, o] = O(""), [l, a] = O(""), [d, c] = O(""), [u, h] = O(!1), [m, v] = O("");
  return U(() => {
    const x = localStorage.getItem("shiphouse-session");
    console.log("[CheckoutLoginForm] mounted", {
      hasStoredToken: !!x,
      hasOnLoginSuccess: !!e
    }), x && (pt().setAuthToken(x), e && e());
  }, []), U(() => {
    console.log("[CheckoutLoginForm] state changed", {
      step: i,
      loading: u,
      hasError: !!m,
      authenticationIdPresent: !!d,
      phoneNumberLength: r.length,
      otpLength: l.length
    });
  }, [i, u, m, d, r, l]), /* @__PURE__ */ p("div", { className: "max-w-2xl", children: [
    /* @__PURE__ */ s("p", { className: "text-sm text-gray-600 mb-6", children: "Please log in to continue with your order. We'll send you an OTP to verify your phone number." }),
    i === "phone" ? /* @__PURE__ */ p("form", { onSubmit: async (x) => {
      x.preventDefault(), h(!0), v("");
      try {
        const g = await pt().auth.login(r);
        g != null && g.valid && (g != null && g.data) ? (c(g.data.authenticationId), n("otp")) : (console.error("[CheckoutLoginForm] Login failed:", g == null ? void 0 : g.message), v((g == null ? void 0 : g.message) || "Failed to send OTP"));
      } catch (b) {
        console.error("[CheckoutLoginForm] Exception in handleSendOTP:", b), v(b.message || "An error occurred. Please try again.");
      } finally {
        h(!1);
      }
    }, className: "space-y-4", children: [
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s(
          "label",
          {
            htmlFor: "phone",
            className: "block text-sm font-medium mb-2",
            style: { color: (t == null ? void 0 : t.text) ?? "inherit" },
            children: "Phone Number"
          }
        ),
        /* @__PURE__ */ s(
          "input",
          {
            type: "tel",
            id: "phone",
            value: r,
            onChange: (x) => o(x.target.value),
            required: !0,
            className: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black",
            placeholder: "Enter your phone number"
          }
        )
      ] }),
      m && /* @__PURE__ */ s("div", { className: "text-red-600 text-sm bg-red-50 p-3 rounded", children: m }),
      /* @__PURE__ */ s(
        "button",
        {
          type: "submit",
          disabled: u,
          className: "w-full md:w-auto px-8 py-3 rounded-full font-medium transition-colors disabled:opacity-50",
          style: {
            backgroundColor: (t == null ? void 0 : t.primary) ?? "#000",
            color: "white"
          },
          children: u ? "Sending..." : "Send OTP"
        }
      )
    ] }) : /* @__PURE__ */ p("form", { onSubmit: async (x) => {
      x.preventDefault(), h(!0), v("");
      try {
        const b = pt(), g = await b.auth.verifyOTP(d, l);
        let k = g == null ? void 0 : g.data;
        if (k != null && k.data && typeof k.data == "object" && (k = k.data), g != null && g.valid && (k != null && k.sessionToken)) {
          const { sessionToken: w, refreshToken: C, userId: T, newUser: I, customer: E } = k;
          b.setAuthToken(w), localStorage.setItem("shiphouse-session", w), C && localStorage.setItem("shiphouse-refresh-token", C), T && localStorage.setItem("shiphouse-user-id", T), I !== void 0 && localStorage.setItem("shiphouse-new-user", String(I)), e ? e() : console.error("[CheckoutLoginForm] ERROR: onLoginSuccess callback not provided!");
        } else
          console.error("[CheckoutLoginForm] Verification failed - response invalid or missing sessionToken"), v((g == null ? void 0 : g.message) || "Invalid OTP");
      } catch (b) {
        console.error("OTP verification error:", b), v(b.message || "An error occurred. Please try again.");
      } finally {
        h(!1);
      }
    }, className: "space-y-4", children: [
      /* @__PURE__ */ p("div", { className: "max-w-md", children: [
        /* @__PURE__ */ s(
          "label",
          {
            htmlFor: "otp",
            className: "block text-sm font-medium mb-2",
            style: { color: (t == null ? void 0 : t.text) ?? "inherit" },
            children: "Enter 6-digit OTP"
          }
        ),
        /* @__PURE__ */ p("p", { className: "text-sm text-gray-600 mb-3", children: [
          "We sent an OTP to ",
          r
        ] }),
        /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            id: "otp",
            value: l,
            onChange: (x) => a(x.target.value.replace(/\D/g, "")),
            maxLength: 6,
            required: !0,
            className: "w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black text-center text-2xl tracking-widest",
            placeholder: "000000"
          }
        )
      ] }),
      m && /* @__PURE__ */ s("div", { className: "text-red-600 text-sm bg-red-50 p-3 rounded", children: m }),
      /* @__PURE__ */ p("div", { className: "flex gap-3", children: [
        /* @__PURE__ */ s(
          "button",
          {
            type: "submit",
            disabled: u || l.length !== 6,
            className: "px-8 py-3 rounded-full font-medium transition-colors disabled:opacity-50",
            style: {
              backgroundColor: (t == null ? void 0 : t.primary) ?? "#000",
              color: "white"
            },
            children: u ? "Verifying..." : "Verify OTP"
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            onClick: () => {
              n("phone"), a(""), v("");
            },
            className: "px-6 py-3 text-sm text-gray-600 hover:text-black underline",
            children: "Change phone number"
          }
        )
      ] })
    ] })
  ] });
}, dl = (t) => {
  var e;
  try {
    return ((e = t == null ? void 0 : t.search) == null ? void 0 : e.suggestions) || [];
  } catch {
    return [];
  }
}, ul = (t) => {
  var e;
  try {
    return ((e = t == null ? void 0 : t.search) == null ? void 0 : e.history) || [];
  } catch {
    return [];
  }
}, pl = (t) => {
  var e;
  try {
    return ((e = t == null ? void 0 : t.search) == null ? void 0 : e.recentQueries) || [];
  } catch {
    return [];
  }
}, ml = (t) => {
  var e;
  try {
    return ((e = t == null ? void 0 : t.cart) == null ? void 0 : e.items) || [];
  } catch {
    return [];
  }
}, hl = (t) => {
  var e;
  try {
    return ((e = t == null ? void 0 : t.products) == null ? void 0 : e.items) || [];
  } catch {
    return [];
  }
}, gl = (t) => {
  var e;
  try {
    return ((e = t == null ? void 0 : t.products) == null ? void 0 : e.loading) || !1;
  } catch {
    return !1;
  }
}, fl = (t) => {
  var e;
  try {
    return ((e = t == null ? void 0 : t.products) == null ? void 0 : e.pagination) || { currentPage: 1, totalPages: 1, total: 0, itemsPerPage: 12 };
  } catch {
    return { currentPage: 1, totalPages: 1, total: 0, itemsPerPage: 12 };
  }
}, Nn = (t) => t == null || isNaN(t) ? "₹0" : He(t), xr = eo(({
  cartItem: t,
  maxQuantity: e,
  theme: i,
  isQuantityOpen: n,
  onQuantityChange: r,
  onRemoveItem: o,
  onToggleQuantity: l
}) => {
  var x, b, g, k, w;
  const a = er(t), d = tr(t), c = ir(t), u = nr(t), h = a && a.trim().length > 0, m = ((x = t.product) == null ? void 0 : x.tags) || [], v = (b = t.product) == null ? void 0 : b.category, y = t.variant_id || t.id, f = n === y;
  return /* @__PURE__ */ p("div", { className: "flex gap-4 p-4 border border-gray-200 rounded-lg hover:border-gray-300 transition-colors", children: [
    /* @__PURE__ */ s("div", { className: "flex-shrink-0", children: /* @__PURE__ */ s("div", { className: "w-28 h-28 bg-gray-100 rounded-md overflow-hidden flex items-center justify-center border border-gray-200", children: h ? /* @__PURE__ */ s(
      $e,
      {
        src: a,
        alt: d,
        className: "w-full h-full object-cover",
        showPlaceholderIcon: !0
      }
    ) : /* @__PURE__ */ p("div", { className: "text-center", children: [
      /* @__PURE__ */ s(
        "svg",
        {
          className: "w-12 h-12 text-gray-400 mx-auto",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: /* @__PURE__ */ s(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
              d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
            }
          )
        }
      ),
      /* @__PURE__ */ s("p", { className: "text-xs text-gray-500 mt-1", children: "No image" })
    ] }) }) }),
    /* @__PURE__ */ p("div", { className: "flex-grow min-w-0", children: [
      /* @__PURE__ */ p("div", { className: "flex flex-wrap gap-2 mb-2", children: [
        v && /* @__PURE__ */ s("span", { className: "inline-block px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded font-medium", children: v }),
        m && m.length > 0 && m.slice(0, 2).map((C, T) => /* @__PURE__ */ s("span", { className: "inline-block px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded", children: typeof C == "string" ? C : C.name }, T))
      ] }),
      /* @__PURE__ */ s("h4", { className: "font-bold text-gray-900 text-sm leading-tight mb-1", children: d }),
      c && /* @__PURE__ */ p("p", { className: "text-xs text-gray-600 mb-2", children: [
        /* @__PURE__ */ s("span", { className: "font-medium", children: "Variant:" }),
        " ",
        c
      ] }),
      /* @__PURE__ */ p("div", { className: "flex flex-wrap gap-4 text-xs text-gray-600 mb-2", children: [
        ((g = t.variant) == null ? void 0 : g.size) && /* @__PURE__ */ p("span", { children: [
          /* @__PURE__ */ s("span", { className: "font-medium", children: "Size:" }),
          " ",
          t.variant.size
        ] }),
        ((k = t.variant) == null ? void 0 : k.color) && /* @__PURE__ */ p("span", { children: [
          /* @__PURE__ */ s("span", { className: "font-medium", children: "Color:" }),
          " ",
          t.variant.color
        ] }),
        ((w = t.variant) == null ? void 0 : w.sku) && /* @__PURE__ */ p("span", { children: [
          /* @__PURE__ */ s("span", { className: "font-medium", children: "SKU:" }),
          " ",
          t.variant.sku
        ] })
      ] }),
      /* @__PURE__ */ p("div", { className: "flex items-center gap-4 mt-3", children: [
        /* @__PURE__ */ p("div", { children: [
          /* @__PURE__ */ s("p", { className: "text-xs text-gray-500", children: "Price per unit" }),
          /* @__PURE__ */ s("p", { className: "font-semibold text-gray-900", children: Nn(u) })
        ] }),
        /* @__PURE__ */ p("div", { children: [
          /* @__PURE__ */ s("p", { className: "text-xs text-gray-500", children: "Subtotal" }),
          /* @__PURE__ */ s("p", { className: "font-semibold text-gray-900", children: Nn(u * t.quantity) })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: "flex flex-col items-end justify-between flex-shrink-0 gap-3", children: /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: [
      /* @__PURE__ */ p("div", { className: "relative", children: [
        /* @__PURE__ */ p(
          "button",
          {
            onClick: () => l(y),
            className: "flex items-center gap-1 px-3 py-2 border border-gray-300 rounded text-sm font-medium hover:bg-gray-50 transition-colors",
            style: {
              borderColor: (i == null ? void 0 : i.primary) || "#ccc"
            },
            children: [
              "Qty: ",
              t.quantity,
              /* @__PURE__ */ s(Qn, { size: 14 })
            ]
          }
        ),
        f && /* @__PURE__ */ s("div", { className: "absolute top-full right-0 mt-1 bg-white border border-gray-300 rounded shadow-lg z-10 min-w-max", children: Array.from({ length: e }, (C, T) => T + 1).map(
          (C) => /* @__PURE__ */ s(
            "button",
            {
              onClick: () => r(y, C),
              className: `block w-full text-left px-4 py-2 text-sm hover:bg-gray-100 transition-colors ${t.quantity === C ? "bg-gray-50 font-semibold" : ""}`,
              children: C
            },
            C
          )
        ) })
      ] }),
      /* @__PURE__ */ s(
        "button",
        {
          onClick: () => o(y),
          className: "p-2 text-red-600 hover:bg-red-50 rounded transition-colors border border-red-200",
          title: "Remove item",
          children: /* @__PURE__ */ s(Zn, { size: 18 })
        }
      )
    ] }) })
  ] });
});
xr.displayName = "CartItemRow";
const yl = ({
  maxQuantity: t = 10,
  theme: e
}) => {
  const i = tt(), n = Ue(ml), r = Ue(go), [o, l] = O(null), a = r === "syncing", d = ce((h, m) => {
    i(Ui({ variantId: h, quantity: m })), l(null);
  }, [i]), c = ce((h) => {
    i(rr({ variantId: h }));
  }, [i]), u = ce((h) => {
    l((m) => m === h ? null : h);
  }, []);
  return n.length === 0 ? /* @__PURE__ */ s("div", { className: "py-8 text-center", children: /* @__PURE__ */ s("p", { className: "text-gray-500", children: "Your cart is empty" }) }) : /* @__PURE__ */ p("div", { className: "space-y-4", children: [
    a && /* @__PURE__ */ p("div", { className: "flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-200 rounded-lg text-sm text-blue-700", children: [
      /* @__PURE__ */ s(Ft, { className: "w-4 h-4 animate-spin" }),
      /* @__PURE__ */ s("span", { children: "Updating cart..." })
    ] }),
    n.map((h, m) => /* @__PURE__ */ s(
      xr,
      {
        cartItem: h,
        maxQuantity: t,
        theme: e,
        isQuantityOpen: o,
        onQuantityChange: d,
        onRemoveItem: c,
        onToggleQuantity: u
      },
      h.variant_id || h.id || m
    ))
  ] });
}, kr = Z.memo(({ address: t, isSelected: e, onSelect: i }) => {
  const n = ce(() => {
    i(t.id);
  }, [t.id, i]);
  return /* @__PURE__ */ p(
    "label",
    {
      className: `block p-4 border-2 rounded-lg cursor-pointer transition-colors ${e ? "border-black bg-gray-50" : "border-gray-200 hover:border-gray-400"}`,
      children: [
        /* @__PURE__ */ s(
          "input",
          {
            type: "radio",
            name: "address",
            value: t.id,
            checked: e,
            onChange: n,
            className: "sr-only"
          }
        ),
        /* @__PURE__ */ p("div", { className: "flex items-start justify-between", children: [
          /* @__PURE__ */ p("div", { className: "flex-1", children: [
            /* @__PURE__ */ p("div", { className: "font-medium mb-1", children: [
              t.firstName,
              " ",
              t.lastName
            ] }),
            /* @__PURE__ */ p("div", { className: "text-sm text-gray-600", children: [
              t.address1,
              t.address2 && `, ${t.address2}`,
              /* @__PURE__ */ s("br", {}),
              t.city,
              ", ",
              t.province,
              " ",
              t.zip,
              /* @__PURE__ */ s("br", {}),
              t.country,
              t.phone && /* @__PURE__ */ p(se, { children: [
                /* @__PURE__ */ s("br", {}),
                "Phone: ",
                t.phone
              ] })
            ] }),
            t.isDefault && /* @__PURE__ */ s("span", { className: "inline-block mt-2 text-xs bg-black text-white px-2 py-1 rounded", children: "Default" })
          ] }),
          e && /* @__PURE__ */ s("div", { className: "ml-4", children: /* @__PURE__ */ s(
            "svg",
            {
              className: "w-6 h-6",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24",
              children: /* @__PURE__ */ s(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: 2,
                  d: "M5 13l4 4L19 7"
                }
              )
            }
          ) })
        ] })
      ]
    }
  );
});
kr.displayName = "AddressCard";
const bl = ({ addresses: t = [], customer: e, theme: i, onAddressSelect: n, onAddressAdded: r }) => {
  const o = Ke(() => {
    var N, $;
    return ((N = t.find((A) => A.isDefault)) == null ? void 0 : N.id) || (($ = t[0]) == null ? void 0 : $.id) || null;
  }, [t]), l = Ke(() => t.length === 0, [t.length]), [a, d] = O(o), [c, u] = O(l);
  U(() => {
    d((N) => N !== o ? (console.log("[CheckoutAddressSelection] Syncing selectedAddressId from", N, "to", o), o) : N);
  }, [o]), U(() => {
    u((N) => N !== l ? (console.log("[CheckoutAddressSelection] Syncing showAddForm:", l), l) : N);
  }, [l]);
  const [h, m] = O([]), [v, y] = O([]), [f, x] = O(!0), [b, g] = O({
    address_line_one: "",
    address_line_two: "",
    city: "",
    state: "",
    country: "India",
    postal_code: "",
    is_default: !1,
    billing_address: !1
  });
  U(() => {
    let N = !0;
    async function $() {
      try {
        if (await yo(), N) {
          const A = bo();
          m(A), x(!1);
        }
      } catch (A) {
        console.error("Failed to load location data:", A), N && x(!1);
      }
    }
    return $(), () => {
      N = !1;
    };
  }, []);
  const k = b.state;
  U(() => {
    if (k) {
      const N = fo(k);
      y(N);
    } else
      y([]);
  }, [k]);
  const w = oe(n), C = oe(r);
  U(() => {
    w.current = n, C.current = r;
  }, [n, r]);
  const T = ce((N) => {
    var $;
    console.log("[CheckoutAddressSelection] handleSelectAddress called with:", N), d(N), ($ = w.current) == null || $.call(w, N);
  }, []), I = ce((N) => {
    g(($) => ({ ...$, address_line_one: N.target.value }));
  }, []), E = ce((N) => {
    g(($) => ({ ...$, address_line_two: N.target.value }));
  }, []), P = ce((N) => {
    g(($) => ({ ...$, postal_code: N.target.value }));
  }, []), S = ce((N) => {
    g(($) => ({ ...$, state: N.target.value, city: "" }));
  }, []), K = ce((N) => {
    g(($) => ({ ...$, city: N.target.value }));
  }, []), _ = ce((N) => {
    g(($) => ({ ...$, billing_address: N.target.checked }));
  }, []), L = ce(
    async (N) => {
      var $, A;
      N.preventDefault();
      try {
        const M = pt(), q = {
          address_line_one: b.address_line_one,
          address_line_two: b.address_line_two || "",
          city: b.city,
          state: b.state,
          postal_code: b.postal_code,
          billing_address: b.billing_address || !1
        };
        console.log("[CheckoutAddressSelection] Adding address:", q);
        const H = await M.customer.addAddress(q);
        if (console.log("[CheckoutAddressSelection] Add address response:", H), H != null && H.valid && (H != null && H.data)) {
          const X = (($ = H.data) == null ? void 0 : $.address) || H.data;
          console.log("[CheckoutAddressSelection] Address data:", X);
          const re = {
            id: X.id || `new-${Date.now()}`,
            address1: X.address_line_one,
            address2: X.address_line_two || "",
            city: X.city,
            province: X.state,
            zip: X.postal_code,
            country: b.country || "India",
            isDefault: !1
          };
          console.log("[CheckoutAddressSelection] Transformed address:", re), (A = C.current) == null || A.call(C, re), g({
            address_line_one: "",
            address_line_two: "",
            city: "",
            state: "",
            country: "India",
            postal_code: "",
            is_default: !1,
            billing_address: !1
          }), u(!1);
        } else
          console.error("Failed to add address:", H == null ? void 0 : H.message), alert("Failed to add address: " + ((H == null ? void 0 : H.message) || "Unknown error"));
      } catch (M) {
        console.error("Failed to add address:", M), alert("Failed to add address: " + (M.message || "Unknown error"));
      }
    },
    [b]
  );
  return /* @__PURE__ */ p("div", { className: "bg-white border border-gray-200 rounded-lg p-6", children: [
    t.length > 0 ? /* @__PURE__ */ s("div", { className: "space-y-3 mb-4", children: t.map((N) => /* @__PURE__ */ s(
      kr,
      {
        address: N,
        isSelected: a === N.id,
        onSelect: T
      },
      N.id
    )) }) : null,
    t.length > 0 && !c ? /* @__PURE__ */ s(
      "button",
      {
        onClick: () => u(!0),
        className: "w-full py-3 border-2 border-black rounded-full font-medium hover:bg-black hover:text-white transition-colors",
        children: "+ Add New Address"
      }
    ) : null,
    c && /* @__PURE__ */ p("form", { onSubmit: L, className: "space-y-4 mt-4", children: [
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s("label", { className: "block text-sm font-medium mb-2", children: "Address Line 1 *" }),
        /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            value: b.address_line_one,
            onChange: I,
            required: !0,
            placeholder: "House/Flat No, Building Name",
            className: "w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-black"
          }
        )
      ] }),
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s("label", { className: "block text-sm font-medium mb-2", children: "Address Line 2" }),
        /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            value: b.address_line_two,
            onChange: E,
            placeholder: "Street, Area, Locality (Optional)",
            className: "w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-black"
          }
        )
      ] }),
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s("label", { className: "block text-sm font-medium mb-2", children: "Pincode *" }),
        /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            value: b.postal_code,
            onChange: P,
            required: !0,
            maxLength: 6,
            placeholder: "6-digit pincode",
            className: "w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-black"
          }
        )
      ] }),
      /* @__PURE__ */ p("div", { className: "grid grid-cols-2 gap-4", children: [
        /* @__PURE__ */ p("div", { children: [
          /* @__PURE__ */ s("label", { className: "block text-sm font-medium mb-2", children: "State *" }),
          /* @__PURE__ */ p(
            "select",
            {
              value: b.state,
              onChange: S,
              required: !0,
              className: "w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-black",
              children: [
                /* @__PURE__ */ s("option", { value: "", children: "Select State" }),
                h.map((N) => /* @__PURE__ */ s("option", { value: N.name, children: N.name }, N.id))
              ]
            }
          )
        ] }),
        /* @__PURE__ */ p("div", { children: [
          /* @__PURE__ */ s("label", { className: "block text-sm font-medium mb-2", children: "City *" }),
          /* @__PURE__ */ p(
            "select",
            {
              value: b.city,
              onChange: K,
              required: !0,
              disabled: !b.state,
              className: "w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-black disabled:bg-gray-100 disabled:cursor-not-allowed",
              children: [
                /* @__PURE__ */ s("option", { value: "", children: b.state ? "Select City" : "Select state first" }),
                v.map((N) => /* @__PURE__ */ s("option", { value: N.name, children: N.name }, N.id))
              ]
            }
          )
        ] })
      ] }),
      /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ s(
          "input",
          {
            type: "checkbox",
            id: "billingAddress",
            checked: b.billing_address,
            onChange: _,
            className: "w-4 h-4"
          }
        ),
        /* @__PURE__ */ s("label", { htmlFor: "billingAddress", className: "text-sm", children: "Billing address is different from shipping address" })
      ] }),
      /* @__PURE__ */ p("div", { className: "flex gap-3", children: [
        /* @__PURE__ */ s(
          "button",
          {
            type: "submit",
            className: "flex-1 py-3 rounded-full font-medium text-white",
            style: { backgroundColor: i.primary },
            children: "Save Address"
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "button",
            onClick: () => u(!1),
            className: "flex-1 py-3 border-2 border-gray-300 rounded-full font-medium hover:bg-gray-100",
            children: "Cancel"
          }
        )
      ] })
    ] })
  ] });
}, vl = (t, e) => {
  var n, r;
  return console.log("[CheckoutAddressSelection] arePropsEqual check"), t.addresses.length !== e.addresses.length ? (console.log("[CheckoutAddressSelection] Re-render: addresses length changed", {
    prev: t.addresses.length,
    next: e.addresses.length
  }), !1) : t.addresses.every((o, l) => {
    const a = e.addresses[l];
    return o.id === (a == null ? void 0 : a.id) && o.isDefault === (a == null ? void 0 : a.isDefault);
  }) ? ((n = t.customer) == null ? void 0 : n.id) !== ((r = e.customer) == null ? void 0 : r.id) ? (console.log("[CheckoutAddressSelection] Re-render: customer ID changed"), !1) : t.theme.primary !== e.theme.primary || t.theme.text !== e.theme.text || t.theme.accent !== e.theme.accent ? (console.log("[CheckoutAddressSelection] Re-render: theme changed"), !1) : t.onAddressSelect !== e.onAddressSelect ? (console.log("[CheckoutAddressSelection] Re-render: onAddressSelect callback changed"), !1) : t.onAddressAdded !== e.onAddressAdded ? (console.log("[CheckoutAddressSelection] Re-render: onAddressAdded callback changed"), !1) : (console.log("[CheckoutAddressSelection] Props equal - preventing re-render ✓"), !0) : (console.log("[CheckoutAddressSelection] Re-render: address IDs or isDefault changed"), !1);
}, Kn = Z.memo(
  bl,
  vl
), xl = ({
  methods: t = [],
  hasValidAddress: e = !1,
  addressValidationMessage: i = "Please provide a valid address",
  theme: n,
  cart: r,
  isVerifying: o = !1,
  selectedAddress: l,
  isSyncing: a = !1
}) => {
  var x, b;
  const d = an(), [c, u] = O(
    ((x = t.find((g) => g.isDefault)) == null ? void 0 : x.id) || ((b = t[0]) == null ? void 0 : b.id) || null
  ), [h, m] = O(!1), [v, y] = O(""), f = async () => {
    if (!e) {
      y(i || "Please select or add a delivery address");
      return;
    }
    if (!c) {
      y("Please select a payment method");
      return;
    }
    if (!l) {
      y("Please select a delivery address");
      return;
    }
    if (!(r != null && r.cartId)) {
      y("Cart not found");
      return;
    }
    m(!0), y("");
    try {
      const g = pt(), k = l.originalId || l.id;
      console.log("[CheckoutPaymentMethods] Creating order with:", {
        cartId: r.cartId,
        paymentMethod: c,
        addressId: k
      });
      const w = await g.orders.createOrder(
        r.cartId,
        c,
        k
      );
      w.valid && w.data ? d.push("./account-dashboard") : y(w.message || "Failed to place order");
    } catch (g) {
      y(g.message || "An error occurred. Please try again.");
    } finally {
      m(!1);
    }
  };
  return t.length === 0 && !o ? null : /* @__PURE__ */ s("div", { className: "bg-white border border-gray-200 rounded-lg p-6", children: o ? /* @__PURE__ */ s("div", { className: "flex items-center justify-center py-8", children: /* @__PURE__ */ p("div", { className: "flex flex-col items-center gap-3", children: [
    /* @__PURE__ */ s("div", { className: "animate-spin rounded-full h-10 w-10 border-b-2 border-gray-900" }),
    /* @__PURE__ */ s("p", { className: "text-gray-600", children: "Verifying delivery availability..." })
  ] }) }) : t.length === 0 ? /* @__PURE__ */ p("div", { className: "py-8 text-center", children: [
    /* @__PURE__ */ s("p", { className: "text-red-600 font-medium", children: "Delivery not available to this address" }),
    /* @__PURE__ */ s("p", { className: "text-gray-600 text-sm mt-2", children: "Please select a different delivery address" })
  ] }) : /* @__PURE__ */ p(se, { children: [
    /* @__PURE__ */ s("div", { className: "space-y-3 mb-6", children: t.map((g) => /* @__PURE__ */ p(
      "label",
      {
        className: `block p-4 border-2 rounded-lg cursor-pointer transition-colors ${c === g.id ? "border-black bg-gray-50" : "border-gray-200 hover:border-gray-400"}`,
        children: [
          /* @__PURE__ */ s(
            "input",
            {
              type: "radio",
              name: "payment",
              value: g.id,
              checked: c === g.id,
              onChange: () => u(g.id),
              className: "sr-only"
            }
          ),
          /* @__PURE__ */ p("div", { className: "flex items-start justify-between", children: [
            /* @__PURE__ */ p("div", { className: "flex-1", children: [
              /* @__PURE__ */ s("div", { className: "font-medium mb-1", children: g.name }),
              /* @__PURE__ */ s("div", { className: "text-sm text-gray-600", children: g.description })
            ] }),
            c === g.id && /* @__PURE__ */ s("div", { className: "ml-4", children: /* @__PURE__ */ s(
              "svg",
              {
                className: "w-6 h-6",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M5 13l4 4L19 7"
                  }
                )
              }
            ) })
          ] })
        ]
      },
      g.id
    )) }),
    v && /* @__PURE__ */ s("div", { className: "mb-4 text-red-600 text-sm bg-red-50 p-3 rounded", children: v }),
    /* @__PURE__ */ p("div", { className: "relative group", children: [
      /* @__PURE__ */ s(
        "button",
        {
          onClick: f,
          disabled: h || !c || !e || a,
          className: "w-full py-4 rounded-full font-medium text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
          style: {
            backgroundColor: n.primary
          },
          children: h ? "Processing..." : a ? "Updating cart..." : "Place Order"
        }
      ),
      !e && /* @__PURE__ */ p("div", { className: "hidden group-hover:block absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded whitespace-nowrap z-10", children: [
        i,
        /* @__PURE__ */ s("div", { className: "absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900" })
      ] })
    ] })
  ] }) });
}, kl = ({
  methods: t,
  selectedAddress: e,
  theme: i,
  cart: n,
  verifiedPaymentTypes: r,
  isVerifying: o = !1,
  isSyncing: l = !1
}) => {
  const a = Z.useMemo(() => {
    if (!r || r.length === 0)
      return t || [];
    console.log("[CheckoutPaymentSection] Filtering methods", {
      verifiedPaymentTypes: r,
      allMethods: t
    });
    const v = (t || []).filter(
      (y) => r.includes(y.id)
    );
    return console.log("[CheckoutPaymentSection] Filtered methods:", v), v;
  }, [t, r]), d = Z.useMemo(() => a, [
    a.map((v) => v.id).join(",")
  ]), c = Z.useMemo(() => {
    if (!e)
      return console.log("[CheckoutPaymentSection] No selected address"), null;
    const v = {
      address_line_one: e.address1,
      address_line_two: e.address2,
      city: e.city,
      state: e.province,
      postal_code: e.zip
    };
    return console.log("[CheckoutPaymentSection] Address for validation:", {
      selectedAddressId: e.id,
      selectedAddress: e,
      validationAddress: v
    }), v;
  }, [
    e == null ? void 0 : e.id,
    e == null ? void 0 : e.address1,
    e == null ? void 0 : e.address2,
    e == null ? void 0 : e.city,
    e == null ? void 0 : e.province,
    e == null ? void 0 : e.zip
  ]), u = Z.useMemo(() => i, [i.primary, i.text, i.accent]), { isValid: h, message: m } = or(c);
  return Z.useEffect(() => {
    console.log("[CheckoutPaymentSection] Validation state updated:", {
      isValid: h,
      message: m,
      selectedAddressId: e == null ? void 0 : e.id
    });
  }, [h, m, e == null ? void 0 : e.id]), /* @__PURE__ */ s(
    xl,
    {
      methods: d,
      hasValidAddress: h,
      addressValidationMessage: m,
      theme: u,
      cart: n,
      isVerifying: o,
      selectedAddress: e,
      isSyncing: l
    }
  );
}, wl = ({
  cart: t,
  theme: e
}) => {
  const [i, n] = O(""), [r, o] = O(""), [l, a] = O(""), {
    discountCodes: d,
    applyDiscount: c,
    removeDiscount: u,
    syncError: h
  } = $t(), m = d.length > 0 ? d : (t == null ? void 0 : t.discount_codes) || [];
  U(() => {
    if (l) {
      const f = setTimeout(() => a(""), 3e3);
      return () => clearTimeout(f);
    }
  }, [l]), U(() => {
    h && o(h);
  }, [h]);
  const v = async (f) => {
    if (f.preventDefault(), o(""), a(""), !i.trim()) {
      o("Please enter a coupon code");
      return;
    }
    if (m.includes(i)) {
      o("This coupon is already applied");
      return;
    }
    c(i), n(""), a("Coupon applied!");
  }, y = (f) => {
    o(""), a(""), u(f);
  };
  return /* @__PURE__ */ p("div", { className: "bg-white border border-gray-200 rounded-lg p-6", children: [
    /* @__PURE__ */ s("h3", { className: "text-lg font-bold mb-4", style: { color: e.text }, children: "Promo Code" }),
    m.length > 0 && /* @__PURE__ */ s("div", { className: "mb-4 space-y-2", children: m.map((f) => /* @__PURE__ */ p(
      "div",
      {
        className: "flex items-center justify-between bg-green-50 border border-green-200 rounded-lg p-3",
        children: [
          /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ s(
              "svg",
              {
                className: "w-5 h-5 text-green-600",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M5 13l4 4L19 7"
                  }
                )
              }
            ),
            /* @__PURE__ */ s("span", { className: "font-medium text-green-800", children: f })
          ] }),
          /* @__PURE__ */ s(
            "button",
            {
              onClick: () => y(f),
              className: "text-sm text-red-600 hover:text-red-800",
              children: "Remove"
            }
          )
        ]
      },
      f
    )) }),
    /* @__PURE__ */ p("form", { onSubmit: v, className: "space-y-3", children: [
      /* @__PURE__ */ p("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ s(
          "input",
          {
            type: "text",
            value: i,
            onChange: (f) => n(f.target.value.toUpperCase()),
            placeholder: "Enter promo code",
            className: "flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-black"
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            type: "submit",
            disabled: !i,
            className: "px-6 py-2 border-2 border-black rounded-lg font-medium hover:bg-black hover:text-white transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
            children: "Apply"
          }
        )
      ] }),
      r && /* @__PURE__ */ s("div", { className: "text-red-600 text-sm", children: r }),
      l && /* @__PURE__ */ s("div", { className: "text-green-600 text-sm", children: l })
    ] })
  ] });
}, Sl = ({
  addresses: t,
  cart: e,
  paymentMethods: i,
  customer: n,
  checkout: r,
  onAddressChange: o,
  isSyncing: l = !1,
  theme: a
}) => {
  const d = t || [], c = oe(d);
  U(() => {
    c.current = d;
  }, [d]);
  const u = oe(o), h = oe(r);
  U(() => {
    u.current = o, h.current = r;
  }, [o, r]);
  const m = Ke(() => d.find((S) => S.isDefault) || d[0] || null, [d]), [v, y] = O(m), [f, x] = O(null), [b, g] = O(!1), k = oe(null), w = oe(null), C = oe(!0), T = oe(!1), I = oe(d.length);
  U(() => {
    I.current === 0 && d.length > 0 && (console.log("[CheckoutFlow] Addresses loaded after login, resetting manual selection flag"), T.current = !1), I.current = d.length;
  }, [d.length]), U(() => {
    if (T.current) {
      console.log("[CheckoutFlow] Skipping default sync - user has manual selection");
      return;
    }
    m && m.id !== (v == null ? void 0 : v.id) && (console.log("[CheckoutFlow] Syncing to default address:", m.id), y(m));
  }, [m == null ? void 0 : m.id, v == null ? void 0 : v.id]), U(() => {
    const S = e == null ? void 0 : e.cartId, K = v == null ? void 0 : v.id, _ = S !== k.current, L = K !== w.current;
    if (console.log("[CheckoutFlow] Verification useEffect triggered", {
      selectedAddressId: K,
      cartId: S,
      cartIdChanged: _,
      addressIdChanged: L,
      prevCartId: k.current,
      prevAddressId: w.current,
      isInitialMount: C.current,
      hasAddress: !!v,
      hasCart: !!S
    }), C.current) {
      if (C.current = !1, k.current = S || null, w.current = K || null, !S || !K) {
        console.log("[CheckoutFlow] Skipping initial verification - missing data");
        return;
      }
    } else if (!_ && !L) {
      console.log("[CheckoutFlow] Skipping verification - IDs unchanged");
      return;
    }
    k.current = S || null, w.current = K || null, (async () => {
      if (!v || !S) {
        console.log("[CheckoutFlow] Skipping verification - missing data", {
          hasAddress: !!v,
          hasCart: !!S
        }), x(null);
        return;
      }
      console.log("[CheckoutFlow] Starting address verification", {
        addressId: v.originalId || v.id,
        cartId: S
      }), g(!0);
      try {
        const $ = pt(), A = v.originalId || v.id, M = await $.orders.verifyOrderAddress(S, A);
        console.log("[CheckoutFlow] Verification response:", M), M.valid && M.data ? x(M.data) : (console.error("[CheckoutFlow] Address verification failed:", M.message), x([]));
      } catch ($) {
        console.error("[CheckoutFlow] Address verification error:", $), x([]);
      } finally {
        g(!1);
      }
    })();
  }, [v == null ? void 0 : v.id, e == null ? void 0 : e.cartId]);
  const E = ce((S) => {
    var _;
    console.log("[CheckoutFlow] handleAddressSelect called", { addressId: S });
    const K = c.current.find((L) => L.id === S);
    console.log("[CheckoutFlow] Found address:", K), K && (console.log("[CheckoutFlow] Setting selected address to:", K.id), T.current = !0, y(K), (_ = u.current) == null || _.call(u, K));
  }, []), P = ce(async (S) => {
    var _;
    console.log("[CheckoutFlow] New address added:", S), await h.current.fetchProfile() && (console.log("[CheckoutFlow] Refetched addresses after add"), T.current = !0, y(S), (_ = u.current) == null || _.call(u, S));
  }, []);
  return /* @__PURE__ */ p(se, { children: [
    /* @__PURE__ */ p("div", { children: [
      /* @__PURE__ */ p("div", { className: "flex items-center gap-3 mb-4", children: [
        /* @__PURE__ */ s("div", { className: "flex items-center justify-center w-8 h-8 rounded-full bg-black text-white font-bold", children: "1" }),
        /* @__PURE__ */ s("h2", { className: "text-xl font-bold", children: "Order Items" })
      ] }),
      /* @__PURE__ */ s("div", { className: "bg-white rounded-lg border border-gray-200 p-6", children: /* @__PURE__ */ s(yl, { maxQuantity: 10, theme: a }) })
    ] }),
    /* @__PURE__ */ p("div", { children: [
      /* @__PURE__ */ p("div", { className: "flex items-center gap-3 mb-4", children: [
        /* @__PURE__ */ s("div", { className: "flex items-center justify-center w-8 h-8 rounded-full bg-black text-white font-bold", children: "2" }),
        /* @__PURE__ */ s("h2", { className: "text-xl font-bold", children: "Delivery Address" })
      ] }),
      d.length > 0 ? /* @__PURE__ */ s(
        Kn,
        {
          addresses: d,
          customer: n,
          theme: a,
          onAddressSelect: E,
          onAddressAdded: P
        }
      ) : /* @__PURE__ */ p("div", { className: "bg-white rounded-lg border border-gray-200 p-6", children: [
        /* @__PURE__ */ s("p", { className: "text-gray-600 mb-4", children: "No addresses found. Please add a delivery address." }),
        /* @__PURE__ */ s(
          Kn,
          {
            addresses: d,
            customer: n,
            theme: a,
            onAddressSelect: E,
            onAddressAdded: P
          }
        )
      ] })
    ] }),
    v ? /* @__PURE__ */ p("div", { children: [
      /* @__PURE__ */ p("div", { className: "flex items-center gap-3 mb-4", children: [
        /* @__PURE__ */ s("div", { className: "flex items-center justify-center w-8 h-8 rounded-full bg-black text-white font-bold", children: "3" }),
        /* @__PURE__ */ s("h2", { className: "text-xl font-bold", children: "Payment Method" })
      ] }),
      /* @__PURE__ */ s(
        kl,
        {
          methods: i,
          selectedAddress: v,
          theme: a,
          cart: e,
          verifiedPaymentTypes: f,
          isVerifying: b,
          isSyncing: l
        }
      )
    ] }) : null
  ] });
}, Cl = (t, e) => {
  var n, r, o, l;
  return console.log("[CheckoutFlow] arePropsEqual check"), t.addresses.length !== e.addresses.length ? (console.log("[CheckoutFlow] Re-render: addresses length changed", {
    prev: t.addresses.length,
    next: e.addresses.length
  }), !1) : t.addresses.every((a, d) => {
    var c;
    return a.id === ((c = e.addresses[d]) == null ? void 0 : c.id);
  }) ? ((n = t.customer) == null ? void 0 : n.id) !== ((r = e.customer) == null ? void 0 : r.id) ? (console.log("[CheckoutFlow] Re-render: customer ID changed", {
    prev: (o = t.customer) == null ? void 0 : o.id,
    next: (l = e.customer) == null ? void 0 : l.id
  }), !1) : t.cart !== e.cart ? (console.log("[CheckoutFlow] Re-render: cart reference changed"), !1) : t.theme.primary !== e.theme.primary || t.theme.text !== e.theme.text || t.theme.accent !== e.theme.accent ? (console.log("[CheckoutFlow] Re-render: theme changed"), !1) : t.onAddressChange !== e.onAddressChange ? (console.log("[CheckoutFlow] Re-render: onAddressChange callback changed"), !1) : t.checkout !== e.checkout ? (console.log("[CheckoutFlow] Re-render: checkout object changed"), !1) : t.paymentMethods.length !== e.paymentMethods.length ? (console.log("[CheckoutFlow] Re-render: paymentMethods length changed"), !1) : t.isSyncing !== e.isSyncing ? (console.log("[CheckoutFlow] Re-render: isSyncing changed"), !1) : (console.log("[CheckoutFlow] Props are equal - preventing re-render ✓"), !0) : (console.log("[CheckoutFlow] Re-render: address IDs changed"), !1);
}, Nl = Z.memo(Sl, Cl), Kl = [
  // Section Title Component
  F(
    "heading-text",
    "cart-summary-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Summary" },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 24 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "marginBottom", type: "number", value: 24 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 20 },
        { inputKey: "marginBottom", type: "number", value: 20 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 18 },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ]
    },
    {
      name: "Cart Summary Title",
      description: "Main heading for the cart summary section"
    }
  ),
  // Cart Configuration
  F(
    "text-block",
    "cart-config",
    {
      desktop: [
        { inputKey: "showSubtotal", type: "checkbox", value: !0 },
        { inputKey: "showDelivery", type: "checkbox", value: !0 },
        { inputKey: "showSavings", type: "checkbox", value: !0 },
        { inputKey: "showTax", type: "checkbox", value: !1 },
        { inputKey: "deliveryFee", type: "number", value: 0 },
        { inputKey: "taxRate", type: "number", value: 0 },
        { inputKey: "freeDeliveryThreshold", type: "number", value: 14e3 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Cart Configuration",
      description: "Configuration for cart display options and pricing"
    }
  ),
  // Sample Cart Items for Preview
  F(
    "text-block",
    "sample-cart-items",
    {
      desktop: [
        { inputKey: "item1Name", type: "text", value: "Nike Air Max 270" },
        { inputKey: "item1Price", type: "number", value: 12995 },
        { inputKey: "item1MRP", type: "number", value: 14995 },
        { inputKey: "item1Quantity", type: "number", value: 1 },
        { inputKey: "item2Name", type: "text", value: "Nike Dri-FIT T-Shirt" },
        { inputKey: "item2Price", type: "number", value: 1695 },
        { inputKey: "item2MRP", type: "number", value: 1995 },
        { inputKey: "item2Quantity", type: "number", value: 2 },
        { inputKey: "showSampleItems", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Sample Cart Items",
      description: "Sample items for preview (in real implementation, this would come from cart context)"
    }
  ),
  // Pricing Display Configuration
  F(
    "text-block",
    "pricing-config",
    {
      desktop: [
        { inputKey: "currency", type: "text", value: "₹" },
        { inputKey: "currencyPosition", type: "select", value: "before" },
        { inputKey: "showDecimals", type: "checkbox", value: !1 },
        { inputKey: "useCommas", type: "checkbox", value: !0 },
        { inputKey: "subtotalLabel", type: "text", value: "Subtotal" },
        { inputKey: "deliveryLabel", type: "text", value: "Delivery/Shipping" },
        { inputKey: "savingsLabel", type: "text", value: "You're saving" },
        { inputKey: "totalLabel", type: "text", value: "Total" },
        { inputKey: "freeDeliveryText", type: "text", value: "Free" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Pricing Display",
      description: "Configuration for how prices are displayed"
    }
  ),
  // Member Checkout Button
  F(
    "button-solid",
    "member-checkout-btn",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Member Checkout" },
        { inputKey: "button-color", type: "color", value: "#000000" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "button-size", type: "select", value: "large" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "marginBottom", type: "number", value: 12 },
        { inputKey: "showButton", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Member Checkout Button",
      description: "Primary checkout button for members"
    }
  ),
  // Guest Checkout Button
  F(
    "button-outline",
    "guest-checkout-btn",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Guest Checkout" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "borderColor", type: "color", value: "#D1D5DB" },
        { inputKey: "button-size", type: "select", value: "large" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "showButton", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Guest Checkout Button",
      description: "Secondary checkout button for guest users"
    }
  ),
  // Container Styling
  F(
    "text-block",
    "container-styling",
    {
      desktop: [
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" },
        { inputKey: "borderColor", type: "color", value: "#E5E7EB" },
        { inputKey: "borderRadius", type: "number", value: 8 },
        { inputKey: "padding", type: "number", value: 24 },
        { inputKey: "showBorder", type: "checkbox", value: !0 },
        { inputKey: "showShadow", type: "checkbox", value: !1 },
        { inputKey: "isSticky", type: "checkbox", value: !0 }
      ],
      tablet: [{ inputKey: "padding", type: "number", value: 20 }],
      mobile: [{ inputKey: "padding", type: "number", value: 16 }]
    },
    {
      name: "Container Styling",
      description: "Overall container appearance and behavior"
    }
  )
], Tl = ({ data: t, className: e }) => {
  var A, M, q, H, X, re, V, G, Y, ie, ae, ge, ye, de, qe, De, it, nt, rt, ot, st, at, lt, ct, Q, te, Ne, dt, Mt, Dt, Wt, Ht, jt, Vt, Ut, Ct, qt, Gt, Yt, Ge, Ti, Nt, Xt, Qt, Jt, Zt, ei, ti, ii, Kt;
  const i = (t == null ? void 0 : t.cart) || {}, n = me() && (!i || Object.keys(i).length === 0) ? pr() : i, {
    items: r = [],
    subtotal: o = 0,
    total: l = 0,
    calculation: a
  } = n, d = R(
    t,
    "heading-text",
    "cart-summary-title"
  ), c = R(t, "text-block", "cart-config"), u = R(
    t,
    "text-block",
    "sample-cart-items"
  ), h = R(
    t,
    "text-block",
    "pricing-config"
  );
  R(
    t,
    "button-solid",
    "member-checkout-btn"
  ), R(
    t,
    "button-outline",
    "guest-checkout-btn"
  );
  const m = R(
    t,
    "text-block",
    "container-styling"
  ), v = ((M = (A = c == null ? void 0 : c.desktop) == null ? void 0 : A.find(
    (W) => W.inputKey === "showSubtotal"
  )) == null ? void 0 : M.value) !== !1, y = ((H = (q = c == null ? void 0 : c.desktop) == null ? void 0 : q.find(
    (W) => W.inputKey === "showDelivery"
  )) == null ? void 0 : H.value) !== !1, f = ((re = (X = c == null ? void 0 : c.desktop) == null ? void 0 : X.find(
    (W) => W.inputKey === "showSavings"
  )) == null ? void 0 : re.value) !== !1, x = ((G = (V = c == null ? void 0 : c.desktop) == null ? void 0 : V.find((W) => W.inputKey === "showTax")) == null ? void 0 : G.value) === !0, b = ((ie = (Y = c == null ? void 0 : c.desktop) == null ? void 0 : Y.find(
    (W) => W.inputKey === "deliveryFee"
  )) == null ? void 0 : ie.value) || 0;
  (ge = (ae = c == null ? void 0 : c.desktop) == null ? void 0 : ae.find((W) => W.inputKey === "taxRate")) != null && ge.value;
  const g = ((de = (ye = c == null ? void 0 : c.desktop) == null ? void 0 : ye.find(
    (W) => W.inputKey === "freeDeliveryThreshold"
  )) == null ? void 0 : de.value) || 14e3;
  (De = (qe = u == null ? void 0 : u.desktop) == null ? void 0 : qe.find(
    (W) => W.inputKey === "showSampleItems"
  )) == null || De.value;
  const k = o, w = l, C = (a == null ? void 0 : a.items) || [], T = (a == null ? void 0 : a.discounts) || [];
  a != null && a.charges;
  const I = (a == null ? void 0 : a.total_taxes) || [], E = (a == null ? void 0 : a.items_sub_total) || 0, P = (a == null ? void 0 : a.total_discounts) || 0, S = (a == null ? void 0 : a.total_charges) || 0, K = (a == null ? void 0 : a.total_tax) || 0, _ = (a == null ? void 0 : a.grand_total_int) || w, L = k >= g * 100 ? 0 : b * 100;
  (nt = (it = h == null ? void 0 : h.desktop) == null ? void 0 : it.find(
    (W) => W.inputKey === "currency"
  )) != null && nt.value;
  const N = (W) => Bt(W), $ = `
    ${((ot = (rt = m == null ? void 0 : m.desktop) == null ? void 0 : rt.find((W) => W.inputKey === "isSticky")) == null ? void 0 : ot.value) !== !1 ? "sticky top-4" : ""}
    ${((at = (st = m == null ? void 0 : m.desktop) == null ? void 0 : st.find((W) => W.inputKey === "showBorder")) == null ? void 0 : at.value) !== !1 ? "border" : ""}
    ${((ct = (lt = m == null ? void 0 : m.desktop) == null ? void 0 : lt.find((W) => W.inputKey === "showShadow")) == null ? void 0 : ct.value) === !0 ? "shadow-lg" : ""}
  `.trim();
  return /* @__PURE__ */ s(
    "section",
    {
      className: `nike-cart-summary-section ${e || ""} bg-white py-8`,
      children: /* @__PURE__ */ s("div", { className: "w-full", children: /* @__PURE__ */ p(
        "div",
        {
          className: `w-full ${$}`,
          style: {
            backgroundColor: ((te = (Q = m == null ? void 0 : m.desktop) == null ? void 0 : Q.find(
              (W) => W.inputKey === "backgroundColor"
            )) == null ? void 0 : te.value) || "#FFFFFF",
            borderColor: ((dt = (Ne = m == null ? void 0 : m.desktop) == null ? void 0 : Ne.find(
              (W) => W.inputKey === "borderColor"
            )) == null ? void 0 : dt.value) || "#E5E7EB",
            borderRadius: `${((Dt = (Mt = m == null ? void 0 : m.desktop) == null ? void 0 : Mt.find((W) => W.inputKey === "borderRadius")) == null ? void 0 : Dt.value) || 8}px`,
            padding: `${((Ht = (Wt = m == null ? void 0 : m.desktop) == null ? void 0 : Wt.find((W) => W.inputKey === "padding")) == null ? void 0 : Ht.value) || 24}px`
          },
          children: [
            /* @__PURE__ */ s(
              "h3",
              {
                className: "font-bold",
                style: {
                  fontSize: `${((Vt = (jt = d == null ? void 0 : d.desktop) == null ? void 0 : jt.find((W) => W.inputKey === "fontSize")) == null ? void 0 : Vt.value) || 24}px`,
                  color: ((Ct = (Ut = d == null ? void 0 : d.desktop) == null ? void 0 : Ut.find(
                    (W) => W.inputKey === "textColor"
                  )) == null ? void 0 : Ct.value) || "#000000",
                  marginBottom: `${((Gt = (qt = d == null ? void 0 : d.desktop) == null ? void 0 : qt.find((W) => W.inputKey === "marginBottom")) == null ? void 0 : Gt.value) || 24}px`
                },
                children: ((Ge = (Yt = d == null ? void 0 : d.desktop) == null ? void 0 : Yt.find((W) => W.inputKey === "text")) == null ? void 0 : Ge.value) || "Summary"
              }
            ),
            /* @__PURE__ */ p("div", { className: "space-y-4", children: [
              C.length > 0 && /* @__PURE__ */ p("div", { className: "space-y-3 pb-3 border-b border-gray-200", children: [
                /* @__PURE__ */ s("h4", { className: "text-sm font-semibold text-gray-900 uppercase", children: "Items" }),
                C.map((W, Ye) => {
                  var le, Ce, xe;
                  const Le = r.find((pe) => pe.variant_id === W.variant_id), D = ((le = Le == null ? void 0 : Le.product) == null ? void 0 : le.title) || ((Ce = Le == null ? void 0 : Le.variant) == null ? void 0 : Ce.title) || "Product", J = ((xe = Le == null ? void 0 : Le.variant) == null ? void 0 : xe.title) || "";
                  return /* @__PURE__ */ p("div", { className: "space-y-2 pb-2 border-b border-gray-100 last:border-b-0", children: [
                    /* @__PURE__ */ p("div", { className: "flex justify-between items-start", children: [
                      /* @__PURE__ */ p("div", { className: "flex-1", children: [
                        /* @__PURE__ */ s("p", { className: "text-sm font-medium text-gray-900", children: D }),
                        J && /* @__PURE__ */ s("p", { className: "text-xs text-gray-500", children: J }),
                        /* @__PURE__ */ p("p", { className: "text-xs text-gray-500", children: [
                          "Qty: ",
                          W.quantity
                        ] })
                      ] }),
                      /* @__PURE__ */ p("div", { className: "text-right", children: [
                        /* @__PURE__ */ s("p", { className: "text-sm font-medium text-gray-900", children: N(W.original_price * W.quantity) }),
                        W.original_price !== W.price && /* @__PURE__ */ s("p", { className: "text-xs text-gray-500 line-through", children: N(W.original_price * W.quantity) })
                      ] })
                    ] }),
                    W.discounts && W.discounts.length > 0 && /* @__PURE__ */ s("div", { className: "ml-4 space-y-1", children: W.discounts.map((pe, Ie) => /* @__PURE__ */ p("div", { className: "flex justify-between text-xs", children: [
                      /* @__PURE__ */ p("span", { className: "text-green-600", children: [
                        pe.discount_code || pe.discount_name,
                        pe.discount_type === "percentage" && ` (${pe.discount_amount}%)`
                      ] }),
                      /* @__PURE__ */ p("span", { className: "text-green-600 font-medium", children: [
                        "-",
                        N(pe.total_discount)
                      ] })
                    ] }, Ie)) }),
                    /* @__PURE__ */ p("div", { className: "flex justify-between text-sm font-medium", children: [
                      /* @__PURE__ */ s("span", { className: "text-gray-700", children: "Item Subtotal" }),
                      /* @__PURE__ */ s("span", { className: "text-gray-900", children: N(W.sub_total) })
                    ] })
                  ] }, Ye);
                })
              ] }),
              /* @__PURE__ */ p("div", { className: "space-y-3", children: [
                v && /* @__PURE__ */ p("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ s("span", { className: "text-gray-700 font-medium", children: ((Nt = (Ti = h == null ? void 0 : h.desktop) == null ? void 0 : Ti.find(
                    (W) => W.inputKey === "subtotalLabel"
                  )) == null ? void 0 : Nt.value) || "Subtotal" }),
                  /* @__PURE__ */ s("span", { className: "font-medium text-gray-900", children: N(E) })
                ] }),
                T.length > 0 && /* @__PURE__ */ p("div", { className: "space-y-2 pb-3 border-b border-gray-200", children: [
                  /* @__PURE__ */ s("h4", { className: "text-sm font-semibold text-gray-700", children: "Discounts Applied" }),
                  T.map((W, Ye) => /* @__PURE__ */ p("div", { className: "flex justify-between text-sm", children: [
                    /* @__PURE__ */ p("span", { className: "text-green-600", children: [
                      W.discount_code || W.discount_name,
                      W.discount_type === "percentage" && ` (${W.discount_amount}%)`
                    ] }),
                    /* @__PURE__ */ p("span", { className: "text-green-600 font-medium", children: [
                      "-",
                      N(W.total_discount)
                    ] })
                  ] }, Ye))
                ] }),
                y && /* @__PURE__ */ p("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ s("span", { className: "text-gray-700", children: ((Qt = (Xt = h == null ? void 0 : h.desktop) == null ? void 0 : Xt.find(
                    (W) => W.inputKey === "deliveryLabel"
                  )) == null ? void 0 : Qt.value) || "Delivery/Shipping" }),
                  /* @__PURE__ */ s("span", { className: "font-medium text-gray-900", children: S > 0 ? N(S) : L === 0 ? ((Zt = (Jt = h == null ? void 0 : h.desktop) == null ? void 0 : Jt.find(
                    (W) => W.inputKey === "freeDeliveryText"
                  )) == null ? void 0 : Zt.value) || "Free" : N(L) })
                ] }),
                x && (K > 0 || I.length > 0) && /* @__PURE__ */ s("div", { className: "space-y-2", children: I.length > 0 ? /* @__PURE__ */ p(se, { children: [
                  /* @__PURE__ */ s("h4", { className: "text-sm font-semibold text-gray-700", children: "Taxes" }),
                  I.map((W, Ye) => /* @__PURE__ */ p("div", { className: "flex justify-between text-sm", children: [
                    /* @__PURE__ */ p("span", { className: "text-gray-700", children: [
                      W.tax_name || "Tax",
                      " (",
                      W.tax_rate,
                      "%)"
                    ] }),
                    /* @__PURE__ */ s("span", { className: "font-medium text-gray-900", children: N(W.tax_amount) })
                  ] }, Ye))
                ] }) : K > 0 && /* @__PURE__ */ p("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ s("span", { className: "text-gray-700", children: "Tax" }),
                  /* @__PURE__ */ s("span", { className: "font-medium text-gray-900", children: N(K) })
                ] }) }),
                f && P > 0 && /* @__PURE__ */ p("div", { className: "flex justify-between text-green-600 font-medium", children: [
                  /* @__PURE__ */ s("span", { children: ((ti = (ei = h == null ? void 0 : h.desktop) == null ? void 0 : ei.find(
                    (W) => W.inputKey === "savingsLabel"
                  )) == null ? void 0 : ti.value) || "Total Savings" }),
                  /* @__PURE__ */ p("span", { children: [
                    "-",
                    N(P)
                  ] })
                ] }),
                /* @__PURE__ */ s("div", { className: "border-t-2 border-gray-300 pt-3 mt-3", children: /* @__PURE__ */ p("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ s("span", { className: "text-lg font-bold text-gray-900", children: ((Kt = (ii = h == null ? void 0 : h.desktop) == null ? void 0 : ii.find(
                    (W) => W.inputKey === "totalLabel"
                  )) == null ? void 0 : Kt.value) || "Total" }),
                  /* @__PURE__ */ s("span", { className: "text-lg font-bold text-gray-900", children: N(_) })
                ] }) })
              ] })
            ] }),
            /* @__PURE__ */ s("div", { className: "mt-6", children: /* @__PURE__ */ p("div", { className: "relative group", children: [
              /* @__PURE__ */ s(
                "button",
                {
                  className: "w-full font-medium transition-colors hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed",
                  style: {
                    backgroundColor: "#000000",
                    color: "#FFFFFF",
                    borderRadius: "50px",
                    paddingLeft: "24px",
                    paddingRight: "24px",
                    paddingTop: "16px",
                    paddingBottom: "16px",
                    border: "none",
                    cursor: "pointer"
                  },
                  disabled: r.length === 0 || (t == null ? void 0 : t.hasValidAddress) === !1 || (t == null ? void 0 : t.isSyncing) === !0,
                  title: (t == null ? void 0 : t.hasValidAddress) === !1 ? t == null ? void 0 : t.addressValidationMessage : t != null && t.isSyncing ? "Updating cart..." : void 0,
                  children: t != null && t.isSyncing ? "Updating..." : "Checkout"
                }
              ),
              (t == null ? void 0 : t.hasValidAddress) === !1 && /* @__PURE__ */ p("div", { className: "hidden group-hover:block absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 px-3 py-2 bg-gray-900 text-white text-sm rounded whitespace-nowrap z-10", children: [
                String((t == null ? void 0 : t.addressValidationMessage) || ""),
                /* @__PURE__ */ s("div", { className: "absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-900" })
              ] })
            ] }) }),
            y && k < g && /* @__PURE__ */ p("div", { className: "mt-4 text-sm text-gray-600 text-center", children: [
              "Add ",
              N(g - k),
              " more for free delivery"
            ] })
          ]
        }
      ) })
    }
  );
}, yi = ue(Tl, {
  identifier: "nike.nikeproduct.cartsummary",
  title: "Cart Summary",
  featuredImage: z.previews.trending,
  // Using trending as placeholder
  description: "Configurable cart summary with pricing breakdown, checkout buttons, and Nike branding",
  category: "product",
  className: "nike-cart-summary",
  components: Kl,
  renderMode: "client"
}), Il = ({
  cart: t,
  theme: e,
  config: i,
  storeId: n,
  selectedAddress: r,
  isSyncing: o = !1
}) => {
  const l = Ke(
    () => r ? {
      address_line_one: r.address1,
      address_line_two: r.address2,
      city: r.city,
      state: r.province,
      postal_code: r.zip
    } : null,
    [
      r == null ? void 0 : r.address1,
      r == null ? void 0 : r.address2,
      r == null ? void 0 : r.city,
      r == null ? void 0 : r.province,
      r == null ? void 0 : r.zip
    ]
  ), { isValid: a, message: d } = or(l), c = Ke(
    () => ({
      cart: t,
      hasValidAddress: a,
      addressValidationMessage: d,
      isSyncing: o
    }),
    [t, a, d, o]
  );
  return /* @__PURE__ */ s(
    yi,
    {
      data: c,
      theme: e,
      storeId: n,
      config: i
    }
  );
}, El = ({
  addresses: t,
  paymentMethods: e,
  customer: i,
  cart: n,
  checkout: r,
  theme: o,
  storeId: l,
  cartSummaryConfig: a
}) => {
  const d = Ke(() => (t == null ? void 0 : t.find((m) => m.isDefault)) || (t == null ? void 0 : t[0]) || null, [t]), [c, u] = O(d), h = ce((m) => {
    u(m);
  }, []);
  return /* @__PURE__ */ p("div", { className: "grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-12 mt-8", children: [
    /* @__PURE__ */ s("div", { className: "lg:col-span-2 space-y-8", children: /* @__PURE__ */ s(
      Nl,
      {
        addresses: t,
        cart: n,
        paymentMethods: e,
        customer: i,
        checkout: r,
        onAddressChange: h,
        theme: o,
        isSyncing: n == null ? void 0 : n.isSyncing
      }
    ) }),
    /* @__PURE__ */ s("div", { className: "lg:col-span-1", children: /* @__PURE__ */ p("div", { className: "sticky top-8 space-y-6", children: [
      /* @__PURE__ */ s(wl, { cart: n, theme: o }),
      /* @__PURE__ */ s(
        Il,
        {
          cart: n,
          theme: o,
          storeId: l,
          config: a,
          selectedAddress: c,
          isSyncing: n == null ? void 0 : n.isSyncing
        }
      )
    ] }) })
  ] });
};
function _l({
  paymentMethods: t,
  storeId: e
}) {
  var b;
  const { isAuthenticated: i, isLoading: n } = vo(), r = tt(), o = Ue(xo), l = Ke(() => ({ autoFetch: !0 }), []), a = Ke(() => ({ autoFetch: !0 }), []), d = $t(l), c = ko(a), [u, h] = O(i), m = Ke(() => ({
    accent: "#FF6B35",
    primary: "#000000",
    secondary: "#FFFFFF",
    primaryGradientEnd: "#333333",
    primaryGradientStart: "#000000",
    secondaryGradientEnd: "#FFFFFF",
    secondaryGradientStart: "#F7F7F7",
    text: "#111111"
  }), []), v = Ke(() => ({
    category: "nike",
    featuredImage: "public/placeholder.png",
    className: "nike-cart-summary",
    components: yi.components,
    defaultData: yi.defaultData,
    description: "Configurable cart summary with pricing breakdown and checkout buttons",
    identifier: "nike-cart-summary-section",
    title: "Cart Summary"
  }), []), y = Ke(() => ((c.paymentTypes && c.paymentTypes.length > 0 ? c.paymentTypes : t || []) || []).map((k) => {
    const w = String(k);
    return w === "PREPAID" ? { id: w, type: "online", name: "Online Payment", description: "Pay securely online", isDefault: !0 } : w === "POSTPAID" ? { id: w, type: "cash_on_delivery", name: "Cash on Delivery", description: "Pay on delivery", isDefault: !1 } : w === "SEMIPREPAID" || w === "SEMI-PREPAID" ? { id: w, type: "mixed", name: "Semi-prepaid", description: "Partial online payment and partial on delivery", isDefault: !1 } : { id: w, type: "unknown", name: w, description: "" };
  }), [c.paymentTypes, t]), f = ce(() => {
    c.fetchProfile(), o && o.length > 0 ? (console.log("[CheckoutContainer] Syncing local cart to server after login:", o.length, "items"), r(wo())) : (console.log("[CheckoutContainer] No local cart items, fetching server cart"), d.refreshCart()), h(!0);
  }, [c.fetchProfile, d.refreshCart, o, r]);
  Z.useEffect(() => {
    console.log("[CheckoutContainer] auth effect fired", {
      isAuthenticated: i,
      authLoading: n,
      currentShowCheckout: u
    }), i && (console.log("[CheckoutContainer] Authenticated user detected, enabling checkout layout"), h(!0));
  }, [i, n, u]);
  const x = n || d.fetchingCart || c.loading;
  return console.log("[CheckoutContainer] render state", {
    storeId: e,
    isAuthenticated: i,
    authLoading: n,
    showCheckout: u,
    cartFetchingCart: d.fetchingCart,
    cartIsLoading: d.isLoading,
    checkoutLoading: c.loading,
    localCartItemsLength: (o == null ? void 0 : o.length) || 0,
    checkoutAddressesLength: ((b = c.addresses) == null ? void 0 : b.length) || 0,
    checkoutCustomerPresent: !!c.customer,
    isInitialLoading: x,
    branch: x ? "loading" : u ? "checkout" : "login"
  }), x ? (console.log("[CheckoutContainer] Rendering loading state"), /* @__PURE__ */ s("div", { className: "flex items-center justify-center min-h-[400px]", children: /* @__PURE__ */ p("div", { className: "text-center", children: [
    /* @__PURE__ */ s("div", { className: "animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mx-auto mb-4" }),
    /* @__PURE__ */ s("p", { className: "text-gray-600", children: "Loading checkout..." })
  ] }) })) : u ? (console.log("[CheckoutContainer] Rendering checkout layout"), /* @__PURE__ */ s(
    El,
    {
      addresses: c.addresses || [],
      cart: d,
      paymentMethods: y,
      customer: c.customer,
      checkout: c,
      theme: m,
      storeId: e,
      cartSummaryConfig: v
    }
  )) : (console.log("[CheckoutContainer] Rendering login form"), /* @__PURE__ */ p("div", { className: "checkout-login-container max-w-md mx-auto py-12", children: [
    /* @__PURE__ */ s("h2", { className: "text-2xl font-bold mb-6 text-center", children: "Sign in to continue" }),
    /* @__PURE__ */ s(
      cl,
      {
        theme: m,
        onLoginSuccess: f
      }
    )
  ] }));
}
const Fl = [
  // Page Title Component
  F(
    "heading-text",
    "nike-checkout-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Checkout" },
        { inputKey: "level", type: "select", value: "h1" },
        { inputKey: "fontSize", type: "number", value: 24 },
        { inputKey: "color", type: "color", value: "#111111" },
        { inputKey: "fontWeight", type: "select", value: "bold" }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 22 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 20 }]
    },
    {
      name: "Checkout Title",
      description: "Main checkout page title"
    }
  ),
  // Background Color Component
  F(
    "text-block",
    "nike-checkout-background",
    {
      desktop: [{ inputKey: "text", type: "color", value: "#FFFFFF" }],
      tablet: [],
      mobile: []
    },
    {
      name: "Background Color",
      description: "Background color for checkout page"
    }
  ),
  // Max Width Component
  F(
    "text-block",
    "nike-checkout-max-width",
    {
      desktop: [{ inputKey: "text", type: "text", value: "1280px" }],
      tablet: [],
      mobile: []
    },
    {
      name: "Max Width",
      description: "Maximum width for checkout container"
    }
  )
], mi = ({ data: t, storeId: e }) => {
  var m, v, y, f, x, b, g, k, w, C, T, I;
  console.log("[NikeCheckoutSection] render", {
    storeId: e,
    dataKeys: t ? Object.keys(t) : [],
    hasDefaultData: !!(mi != null && mi.defaultData)
  });
  const i = R(
    t,
    "heading-text",
    "nike-checkout-title"
  ), n = R(
    t,
    "text-block",
    "nike-checkout-background"
  ), r = R(
    t,
    "text-block",
    "nike-checkout-max-width"
  ), o = ((v = (m = i == null ? void 0 : i.desktop) == null ? void 0 : m.find((E) => E.inputKey === "text")) == null ? void 0 : v.value) || "Checkout", l = ((f = (y = i == null ? void 0 : i.desktop) == null ? void 0 : y.find((E) => E.inputKey === "fontSize")) == null ? void 0 : f.value) || 24, a = ((b = (x = i == null ? void 0 : i.desktop) == null ? void 0 : x.find((E) => E.inputKey === "color")) == null ? void 0 : b.value) || "#111111", d = ((k = (g = i == null ? void 0 : i.desktop) == null ? void 0 : g.find((E) => E.inputKey === "fontWeight")) == null ? void 0 : k.value) || "bold", c = ((C = (w = n == null ? void 0 : n.desktop) == null ? void 0 : w.find((E) => E.inputKey === "text")) == null ? void 0 : C.value) || "#FFFFFF", u = ((I = (T = r == null ? void 0 : r.desktop) == null ? void 0 : T.find((E) => E.inputKey === "text")) == null ? void 0 : I.value) || "1280px", h = {
    cart: null,
    addresses: [],
    paymentMethods: []
  };
  return /* @__PURE__ */ p(
    "div",
    {
      id: "nike-checkout-section",
      className: "nike-checkout-section",
      style: { backgroundColor: c },
      children: [
        /* @__PURE__ */ s(
          "div",
          {
            "data-debug": "nike-checkout-section-mounted",
            style: { display: "none" }
          }
        ),
        /* @__PURE__ */ p("div", { className: "mx-auto px-4 sm:px-6 lg:px-8 py-8", style: { maxWidth: u }, children: [
          /* @__PURE__ */ s("div", { className: "mb-8", children: /* @__PURE__ */ s(
            "h1",
            {
              style: {
                fontSize: `${l}px`,
                color: a,
                fontWeight: d
              },
              children: o
            }
          ) }),
          /* @__PURE__ */ s(
            _l,
            {
              initialAddresses: h.addresses,
              initialCart: h.cart,
              paymentMethods: h.paymentMethods,
              storeId: e
            }
          )
        ] })
      ]
    }
  );
}, Pl = ue(mi, {
  identifier: "nike.nikecheckout.checkout",
  title: "Checkout",
  featuredImage: "",
  // Should be replaced with actual checkout preview
  description: "Complete Nike checkout flow with authentication, cart items, address selection, and payment methods",
  category: "checkout",
  className: "nike-checkout",
  components: Fl,
  renderMode: "client"
}), Ll = [
  // Tabs Configuration
  F(
    "text-block",
    "tabs-config",
    {
      desktop: [
        { inputKey: "showTabs", type: "checkbox", value: !0 },
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" },
        { inputKey: "borderColor", type: "color", value: "#E5E7EB" },
        { inputKey: "scrollable", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: [{ inputKey: "scrollable", type: "checkbox", value: !0 }]
    },
    {
      name: "Tabs Configuration",
      description: "Category tabs layout and styling options"
    }
  ),
  // Category Tabs
  F(
    "text-block",
    "category-tabs",
    {
      desktop: [
        { inputKey: "tab1", type: "text", value: "Lifestyle" },
        { inputKey: "tab2", type: "text", value: "Jordan" },
        { inputKey: "tab3", type: "text", value: "Running" },
        { inputKey: "tab4", type: "text", value: "Basketball" },
        { inputKey: "tab5", type: "text", value: "American Football" },
        { inputKey: "tab6", type: "text", value: "Football" },
        { inputKey: "tab7", type: "text", value: "Training & Gym" },
        { inputKey: "tab8", type: "text", value: "Skateboarding" },
        { inputKey: "tab9", type: "text", value: "Golf" },
        { inputKey: "tab10", type: "text", value: "Tennis" },
        { inputKey: "tab11", type: "text", value: "Athletics" },
        { inputKey: "tab12", type: "text", value: "Walking" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Category Tabs",
      description: "Category tab labels"
    }
  )
], Al = ({ data: t, viewportMode: e }) => {
  const [i, n] = O(null), r = R(t, "text-block", "tabs-config", e), o = R(
    t,
    "text-block",
    "category-tabs",
    e
  ), l = B(r, "showTabs", !0), a = B(r, "backgroundColor", "#FFFFFF"), d = B(r, "borderColor", "#E5E7EB"), c = B(r, "scrollable", !0), u = [];
  for (let m = 1; m <= 12; m++) {
    const v = B(o, `tab${m}`, "");
    v && u.push({
      id: `tab-${m}`,
      label: v,
      value: v.toLowerCase().replace(/[^a-z0-9]/g, "-")
    });
  }
  const h = (m) => {
    n(i === m ? null : m);
  };
  return !l || u.length === 0 ? null : /* @__PURE__ */ p(
    "section",
    {
      className: "border-b py-4",
      style: {
        backgroundColor: a,
        borderColor: d
      },
      children: [
        /* @__PURE__ */ s("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: /* @__PURE__ */ s(
          "div",
          {
            className: `flex gap-4 ${c ? "overflow-x-auto scrollbar-hide" : "flex-wrap"}`,
            children: u.map((m) => /* @__PURE__ */ s(
              "button",
              {
                onClick: () => h(m.value),
                className: `flex-shrink-0 whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2 ${i === m.value ? "bg-black text-white" : "bg-gray-100 text-gray-700 hover:bg-gray-200 hover:text-black"}`,
                children: m.label
              },
              m.id
            ))
          }
        ) }),
        /* @__PURE__ */ s("style", { children: `
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      ` })
      ]
    }
  );
}, Rl = ue(Al, {
  identifier: "nike.nikeecommerce.categoryfiltertabs",
  title: "Category Tabs",
  featuredImage: z.previews.trending,
  description: "Horizontal category filter tabs for quick product filtering",
  category: "ecommerce",
  className: "nike-category-filter-tabs",
  components: Ll,
  renderMode: "client"
}), zl = [
  // Page Header Configuration
  F(
    "text-block",
    "page-header-config",
    {
      desktop: [
        { inputKey: "title", type: "text", value: "Men's Shoes" },
        { inputKey: "productCount", type: "number", value: 6 },
        { inputKey: "showFilterToggle", type: "checkbox", value: !0 },
        { inputKey: "filterToggleText", type: "text", value: "Hide Filters" },
        { inputKey: "showSortDropdown", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: [
        { inputKey: "showFilterToggle", type: "checkbox", value: !0 },
        { inputKey: "filterToggleText", type: "text", value: "Show Filters" }
      ]
    },
    {
      name: "Page Header Configuration",
      description: "Page title, product count, and controls configuration"
    }
  ),
  // Sort Options Configuration
  F(
    "text-block",
    "sort-options-config",
    {
      desktop: [
        { inputKey: "defaultSort", type: "text", value: "Sort By" },
        { inputKey: "option1", type: "text", value: "Newest" },
        { inputKey: "option2", type: "text", value: "Price: Low-High" },
        { inputKey: "option3", type: "text", value: "Price: High-Low" },
        { inputKey: "option4", type: "text", value: "Best Rating" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Sort Options",
      description: "Available sorting options for products"
    }
  )
], Bl = ({ data: t, viewportMode: e }) => {
  const i = R(
    t,
    "text-block",
    "page-header-config",
    e
  ), n = R(
    t,
    "text-block",
    "sort-options-config",
    e
  ), r = B(i, "title", "Men's Shoes"), o = B(i, "productCount", 0), l = B(i, "showFilterToggle", !0), a = B(i, "filterToggleText", "Hide Filters"), d = B(i, "showSortDropdown", !0), u = [
    B(n, "defaultSort", "Sort By"),
    B(n, "option1", "Newest"),
    B(n, "option2", "Price: Low-High"),
    B(n, "option3", "Price: High-Low"),
    B(n, "option4", "Best Rating")
  ];
  return /* @__PURE__ */ s("section", { className: "border-b border-gray-200 bg-white py-4", children: /* @__PURE__ */ p("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: [
    /* @__PURE__ */ s("div", { className: "mb-4", children: /* @__PURE__ */ p("h1", { className: "text-2xl font-bold text-black", children: [
      r,
      /* @__PURE__ */ p("span", { className: "text-gray-600", children: [
        "(",
        o,
        ")"
      ] })
    ] }) }),
    /* @__PURE__ */ p("div", { className: "flex items-center justify-between", children: [
      l && /* @__PURE__ */ p("button", { className: "flex items-center gap-2 rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 lg:hidden", children: [
        /* @__PURE__ */ s("span", { children: a }),
        /* @__PURE__ */ s(
          "svg",
          {
            className: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ s(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z"
              }
            )
          }
        )
      ] }),
      l && /* @__PURE__ */ p("button", { className: "hidden items-center gap-2 text-sm font-medium text-gray-700 transition-colors hover:text-black lg:flex", children: [
        /* @__PURE__ */ s("span", { children: a }),
        /* @__PURE__ */ s(
          "svg",
          {
            className: "h-4 w-4",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ s(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.207A1 1 0 013 6.5V4z"
              }
            )
          }
        )
      ] }),
      d && /* @__PURE__ */ s("select", { className: "rounded border border-gray-300 bg-white px-3 py-2 text-sm font-medium text-gray-700 focus:border-black focus:outline-none focus:ring-1 focus:ring-black", children: u.map((h, m) => /* @__PURE__ */ s(
        "option",
        {
          value: h.toLowerCase().replace(/[^a-z0-9]/g, "-"),
          children: h
        },
        m
      )) })
    ] })
  ] }) });
}, $l = ue(Bl, {
  identifier: "nike.nikeecommerce.productlistingheader",
  title: "Listing Header",
  featuredImage: z.previews.trending,
  description: "Product listing page header with title, count, filter toggle, and sort controls",
  category: "nike",
  className: "nike-product-listing-header",
  components: zl,
  renderMode: "client"
}), Ol = [
  // Section Configuration
  F(
    "text-block",
    "section-config",
    {
      desktop: [
        { inputKey: "sectionTitle", type: "text", value: "Related Categories" },
        { inputKey: "showSection", type: "checkbox", value: !0 },
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" },
        { inputKey: "borderColor", type: "color", value: "#E5E7EB" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Section Configuration",
      description: "Related categories section settings"
    }
  ),
  // Category Links Configuration
  F(
    "text-block",
    "category-links",
    {
      desktop: [
        { inputKey: "category1", type: "text", value: "Best Men's Shoes" },
        { inputKey: "category2", type: "text", value: "New Men's Shoes" },
        {
          inputKey: "category3",
          type: "text",
          value: "Men's Black Running Shoes"
        },
        { inputKey: "category4", type: "text", value: "Men's Crew Socks" },
        {
          inputKey: "category5",
          type: "text",
          value: "Men's Joggers & Tracksuit Bottoms"
        },
        {
          inputKey: "category6",
          type: "text",
          value: "Men's Cross Training Shoes"
        },
        {
          inputKey: "category7",
          type: "text",
          value: "Men's Road Running Shoes"
        },
        {
          inputKey: "category8",
          type: "text",
          value: "Men's Basketball Low-Top Shoes"
        },
        {
          inputKey: "category9",
          type: "text",
          value: "Men's Sale Running Shoes"
        },
        { inputKey: "category10", type: "text", value: "Turf Football Shoe" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Category Links",
      description: "Related category link texts"
    }
  )
], Ml = ({ data: t, viewportMode: e }) => {
  const i = R(
    t,
    "text-block",
    "section-config",
    e
  ), n = R(
    t,
    "text-block",
    "category-links",
    e
  ), r = B(i, "sectionTitle", "Related Categories"), o = B(i, "showSection", !0), l = B(i, "backgroundColor", "#FFFFFF"), a = B(i, "borderColor", "#E5E7EB"), d = [];
  for (let c = 1; c <= 10; c++) {
    const u = B(n, `category${c}`, "");
    u && d.push({
      id: `category-${c}`,
      name: u,
      url: `/nike/products?category=${u.toLowerCase().replace(/[^a-z0-9]/g, "-")}`
    });
  }
  return !o || d.length === 0 ? null : /* @__PURE__ */ s(
    "section",
    {
      className: "border-t py-6",
      style: {
        backgroundColor: l,
        borderColor: a
      },
      children: /* @__PURE__ */ p("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: [
        /* @__PURE__ */ s("h3", { className: "mb-6 text-lg font-bold text-black", children: r }),
        /* @__PURE__ */ s("div", { className: "flex flex-wrap gap-3", children: d.map((c) => /* @__PURE__ */ s(
          "a",
          {
            href: c.url,
            className: "inline-flex items-center rounded-full border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-all duration-200 hover:border-gray-400 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2",
            "aria-label": `Browse ${c.name}`,
            children: c.name
          },
          c.id
        )) })
      ] })
    }
  );
}, Dl = ue(Ml, {
  identifier: "nike.nikeecommerce.relatedcategories",
  title: "Related Categories",
  featuredImage: z.previews.trending,
  description: "Related category links section for product listing pages",
  category: "nike",
  className: "nike-related-categories",
  components: Ol,
  renderMode: "client"
}), Wl = [
  // Section Configuration
  F(
    "text-block",
    "section-config",
    {
      desktop: [
        { inputKey: "sectionTitle", type: "text", value: "Related Stories" },
        { inputKey: "showSection", type: "checkbox", value: !0 },
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" },
        { inputKey: "showNavigation", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Section Configuration",
      description: "Related stories section settings"
    }
  ),
  // Story 1 Configuration
  F(
    "background-image",
    "story-1-image",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: "public/placeholder.png" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Story 1 Image",
      description: "First story image configuration"
    }
  ),
  F(
    "text-block",
    "story-1-content",
    {
      desktop: [
        { inputKey: "category", type: "text", value: "Buying guide" },
        {
          inputKey: "title",
          type: "text",
          value: "The Best Nike Sneakers to Wear in Winter"
        },
        {
          inputKey: "description",
          type: "text",
          value: "Stay warm and stylish with these top Nike sneaker picks for cold weather."
        },
        {
          inputKey: "url",
          type: "text",
          value: "/nike/stories/best-winter-sneakers"
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Story 1 Content",
      description: "First story text content"
    }
  ),
  // Story 2 Configuration
  F(
    "background-image",
    "story-2-image",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: "public/placeholder.png" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Story 2 Image",
      description: "Second story image configuration"
    }
  ),
  F(
    "text-block",
    "story-2-content",
    {
      desktop: [
        { inputKey: "category", type: "text", value: "Buying guide" },
        {
          inputKey: "title",
          type: "text",
          value: "13 Nike gift ideas for tennis players"
        },
        {
          inputKey: "description",
          type: "text",
          value: "Perfect gift ideas for the tennis enthusiast in your life."
        },
        { inputKey: "url", type: "text", value: "/nike/stories/tennis-gifts" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Story 2 Content",
      description: "Second story text content"
    }
  ),
  // Story 3 Configuration
  F(
    "background-image",
    "story-3-image",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: "public/placeholder.png" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Story 3 Image",
      description: "Third story image configuration"
    }
  ),
  F(
    "text-block",
    "story-3-content",
    {
      desktop: [
        { inputKey: "category", type: "text", value: "Buying guide" },
        {
          inputKey: "title",
          type: "text",
          value: "The 11 Best Nike Gifts for Cyclists"
        },
        {
          inputKey: "description",
          type: "text",
          value: "Essential Nike gear for cyclists of all levels."
        },
        { inputKey: "url", type: "text", value: "/nike/stories/cycling-gifts" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Story 3 Content",
      description: "Third story text content"
    }
  )
], Hl = ({ data: t, storeId: e, viewportMode: i }) => {
  const [n, r] = O(0), o = (S, K) => {
    var N;
    const _ = R(t, "background-image", S, i), L = (_ == null ? void 0 : _[i || "desktop"]) ?? (_ == null ? void 0 : _.desktop);
    return Array.isArray(L) && ((N = L[0]) == null ? void 0 : N.value) || K;
  }, l = o("story-1-image", "public/placeholder.png"), a = o("story-2-image", "public/placeholder.png"), d = o("story-3-image", "public/placeholder.png"), [c, u] = O(
    typeof l == "string" && !l.startsWith("http") ? "public/placeholder.png" : l
  ), [h, m] = O(
    typeof a == "string" && !a.startsWith("http") ? "public/placeholder.png" : a
  ), [v, y] = O(
    typeof d == "string" && !d.startsWith("http") ? "public/placeholder.png" : d
  );
  U(() => {
    (async () => {
      try {
        if (typeof l == "string" && l && e) {
          const K = await we(
            l,
            e,
            { width: 600, height: 400, fit: "cover" }
          );
          u(K);
        }
      } catch (K) {
        console.error("[RelatedStoriesClient] Failed to fetch story1 asset:", K), u("public/placeholder.png");
      }
    })();
  }, [l, e]), U(() => {
    (async () => {
      try {
        if (typeof a == "string" && a && e) {
          const K = await we(
            a,
            e,
            { width: 600, height: 400, fit: "cover" }
          );
          m(K);
        }
      } catch (K) {
        console.error("[RelatedStoriesClient] Failed to fetch story2 asset:", K), m("public/placeholder.png");
      }
    })();
  }, [a, e]), U(() => {
    (async () => {
      try {
        if (typeof d == "string" && d && e) {
          const K = await we(
            d,
            e,
            { width: 600, height: 400, fit: "cover" }
          );
          y(K);
        }
      } catch (K) {
        console.error("[RelatedStoriesClient] Failed to fetch story3 asset:", K), y("public/placeholder.png");
      }
    })();
  }, [d, e]);
  const f = R(
    t,
    "text-block",
    "section-config",
    i
  ), x = B(f, "sectionTitle", "Related Stories"), b = B(f, "showSection", !0), g = B(f, "backgroundColor", "#FFFFFF"), k = B(f, "showNavigation", !0), w = [], C = [c, h, v];
  for (let S = 1; S <= 3; S++) {
    const K = R(
      t,
      "text-block",
      `story-${S}-content`,
      i
    );
    K && w.push({
      id: S,
      image: C[S - 1],
      category: B(K, "category", "Buying guide"),
      title: B(K, "title", `Story ${S}`),
      description: B(K, "description", `Description for story ${S}`),
      url: B(K, "url", "#")
    });
  }
  const T = n > 0, I = n < w.length - 3, E = () => {
    T && r(n - 1);
  }, P = () => {
    I && r(n + 1);
  };
  return !b || w.length === 0 ? null : /* @__PURE__ */ s("section", { className: "py-6", style: { backgroundColor: g }, children: /* @__PURE__ */ p("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: [
    /* @__PURE__ */ p("div", { className: "mb-6 flex items-center justify-between", children: [
      /* @__PURE__ */ s("h3", { className: "text-lg font-bold text-black", children: x }),
      k && /* @__PURE__ */ p("div", { className: "flex gap-2", children: [
        /* @__PURE__ */ s(
          "button",
          {
            onClick: E,
            disabled: !T,
            className: "flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
            children: /* @__PURE__ */ s(
              "svg",
              {
                className: "h-4 w-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M15 19l-7-7 7-7"
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            onClick: P,
            disabled: !I,
            className: "flex h-8 w-8 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
            children: /* @__PURE__ */ s(
              "svg",
              {
                className: "h-4 w-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M9 5l7 7-7 7"
                  }
                )
              }
            )
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ s("div", { className: "overflow-hidden", children: /* @__PURE__ */ s(
      "div",
      {
        className: "flex gap-6 transition-transform duration-300",
        style: { transform: `translateX(-${n * 33.333}%)` },
        children: w.map((S) => /* @__PURE__ */ p(
          "a",
          {
            href: S.url,
            className: "group min-w-0 flex-shrink-0 basis-1/3 cursor-pointer",
            children: [
              /* @__PURE__ */ s("div", { className: "overflow-hidden rounded-lg bg-gray-100", children: /* @__PURE__ */ s(
                $e,
                {
                  src: S.image,
                  alt: S.title,
                  className: "aspect-video w-full object-cover transition-transform duration-300 group-hover:scale-105",
                  showPlaceholderIcon: !0
                }
              ) }),
              /* @__PURE__ */ p("div", { className: "mt-3", children: [
                /* @__PURE__ */ s("div", { className: "text-xs font-medium uppercase tracking-wide text-gray-500", children: S.category }),
                /* @__PURE__ */ s("h4", { className: "mt-1 text-sm font-bold text-black group-hover:underline", children: S.title }),
                /* @__PURE__ */ s("p", { className: "mt-1 text-sm text-gray-600", children: S.description })
              ] })
            ]
          },
          S.id
        ))
      }
    ) })
  ] }) });
}, jl = ue(Hl, {
  identifier: "nike.nikeecommerce.relatedstories",
  title: "Related Stories",
  featuredImage: z.previews.trending,
  description: "Horizontal scrolling section with Nike stories and buying guides",
  category: "ecommerce",
  className: "nike-related-stories",
  components: Wl,
  renderMode: "client"
}), wr = [
  // Footer Background Configuration
  F(
    "text-block",
    "footer-config",
    {
      desktop: [
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#111111" },
        { inputKey: "linkColor", type: "color", value: "#6B7280" },
        { inputKey: "linkHoverColor", type: "color", value: "#111111" },
        { inputKey: "borderColor", type: "color", value: "#E5E7EB" },
        { inputKey: "paddingY", type: "number", value: 48 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Footer Configuration",
      description: "Overall footer styling and colors"
    }
  ),
  // Resources Section
  F(
    "heading-text",
    "resources-heading",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Resources" },
        { inputKey: "level", type: "select", value: "4" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#111111" },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Resources Heading",
      description: "Heading for the Resources section"
    }
  ),
  F(
    "text-block",
    "resources-links",
    {
      desktop: [
        { inputKey: "link1", type: "text", value: "Find A Store" },
        { inputKey: "link2", type: "text", value: "Become A Member" },
        { inputKey: "link3", type: "text", value: "Running Shoe Finder" },
        { inputKey: "link4", type: "text", value: "Product Advice" },
        { inputKey: "link5", type: "text", value: "Send Us Feedback" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "lineHeight", type: "number", value: 1.6 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Resources Links",
      description: "Links for the Resources section"
    }
  ),
  // Help Section
  F(
    "heading-text",
    "help-heading",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Help" },
        { inputKey: "level", type: "select", value: "4" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#111111" },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Help Heading",
      description: "Heading for the Help section"
    }
  ),
  F(
    "text-block",
    "help-links",
    {
      desktop: [
        { inputKey: "link1", type: "text", value: "Get Help" },
        { inputKey: "link2", type: "text", value: "Order Status" },
        { inputKey: "link3", type: "text", value: "Delivery" },
        { inputKey: "link4", type: "text", value: "Returns" },
        { inputKey: "link5", type: "text", value: "Payment Options" },
        {
          inputKey: "link6",
          type: "text",
          value: "Contact Us On Nike.com Inquiries"
        },
        {
          inputKey: "link7",
          type: "text",
          value: "Contact Us On All Other Inquiries"
        },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "lineHeight", type: "number", value: 1.6 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Help Links",
      description: "Links for the Help section"
    }
  ),
  // Company Section
  F(
    "heading-text",
    "company-heading",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Company" },
        { inputKey: "level", type: "select", value: "4" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#111111" },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Company Heading",
      description: "Heading for the Company section"
    }
  ),
  F(
    "text-block",
    "company-links",
    {
      desktop: [
        { inputKey: "link1", type: "text", value: "About Nike" },
        { inputKey: "link2", type: "text", value: "News" },
        { inputKey: "link3", type: "text", value: "Careers" },
        { inputKey: "link4", type: "text", value: "Investors" },
        { inputKey: "link5", type: "text", value: "Sustainability" },
        { inputKey: "link6", type: "text", value: "Impact" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "lineHeight", type: "number", value: 1.6 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Company Links",
      description: "Links for the Company section"
    }
  ),
  // Location Selector
  F(
    "text-block",
    "location-selector",
    {
      desktop: [
        { inputKey: "country", type: "text", value: "India" },
        { inputKey: "showFlag", type: "checkbox", value: !0 },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "textColor", type: "color", value: "#6B7280" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Location Selector",
      description: "Country/region selection display"
    }
  ),
  // Footer Bottom
  F(
    "text-block",
    "footer-bottom",
    {
      desktop: [
        {
          inputKey: "copyright",
          type: "text",
          value: "© 2025 Nike, Inc. All rights reserved"
        },
        { inputKey: "link1", type: "text", value: "Guides" },
        { inputKey: "link2", type: "text", value: "Terms of Sale" },
        { inputKey: "link3", type: "text", value: "Terms of Use" },
        { inputKey: "link4", type: "text", value: "Nike Privacy Policy" },
        { inputKey: "fontSize", type: "number", value: 12 },
        { inputKey: "textColor", type: "color", value: "#6B7280" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Footer Bottom",
      description: "Copyright and legal links"
    }
  )
], Vl = ({ data: t, className: e, viewportMode: i }) => {
  const n = (y, f, x) => {
    var g;
    const b = (y == null ? void 0 : y[i || "desktop"]) ?? (y == null ? void 0 : y.desktop);
    return Array.isArray(b) ? ((g = b.find((w) => w.inputKey === f)) == null ? void 0 : g.value) ?? x : b && typeof b == "object" ? b[f] ?? x : x;
  }, r = R(t, "text-block", "footer-config", i), o = R(
    t,
    "heading-text",
    "resources-heading",
    i
  ), l = R(
    t,
    "text-block",
    "resources-links",
    i
  ), a = R(
    t,
    "heading-text",
    "help-heading",
    i
  ), d = R(t, "text-block", "help-links", i), c = R(
    t,
    "heading-text",
    "company-heading",
    i
  ), u = R(
    t,
    "text-block",
    "company-links",
    i
  ), h = R(
    t,
    "text-block",
    "location-selector",
    i
  ), m = R(t, "text-block", "footer-bottom", i), v = (y, f = 7) => {
    var b;
    const x = [];
    for (let g = 1; g <= f; g++) {
      const k = (y == null ? void 0 : y[i || "desktop"]) ?? (y == null ? void 0 : y.desktop), w = Array.isArray(k) ? (b = k.find((C) => C.inputKey === `link${g}`)) == null ? void 0 : b.value : void 0;
      w && x.push(
        /* @__PURE__ */ s(
          "a",
          {
            href: "#",
            className: "block py-2 text-sm transition-colors duration-200 hover:text-gray-900 focus:text-gray-900 focus:outline-none",
            style: {
              color: String(n(r, "linkColor", "#6B7280")),
              fontSize: `${n(y, "fontSize", 14)}px`,
              lineHeight: String(n(y, "lineHeight", 1.6))
            },
            children: w
          },
          g
        )
      );
    }
    return x;
  };
  return /* @__PURE__ */ p(
    "footer",
    {
      className: `nike-footer-section ${e || ""}`,
      style: {
        backgroundColor: String(n(r, "backgroundColor", "#FFFFFF")),
        color: String(n(r, "textColor", "#111111"))
      },
      children: [
        /* @__PURE__ */ s(
          "div",
          {
            className: "mx-auto max-w-7xl px-6",
            style: {
              paddingTop: `${n(r, "paddingY", 48)}px`,
              paddingBottom: `${n(r, "paddingY", 48)}px`
            },
            children: /* @__PURE__ */ p("div", { className: "grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4 lg:gap-12", children: [
              /* @__PURE__ */ p("div", { children: [
                /* @__PURE__ */ s(
                  "h4",
                  {
                    className: "font-bold",
                    style: {
                      fontSize: `${n(o, "fontSize", 16)}px`,
                      color: String(n(o, "textColor", "#111111")),
                      marginBottom: `${n(o, "marginBottom", 16)}px`
                    },
                    children: n(o, "text", "Resources")
                  }
                ),
                /* @__PURE__ */ s("div", { className: "space-y-1", children: v(l, 5) })
              ] }),
              /* @__PURE__ */ p("div", { children: [
                /* @__PURE__ */ s(
                  "h4",
                  {
                    className: "font-bold",
                    style: {
                      fontSize: `${n(a, "fontSize", 16)}px`,
                      color: String(n(a, "textColor", "#111111")),
                      marginBottom: `${n(a, "marginBottom", 16)}px`
                    },
                    children: n(a, "text", "Help")
                  }
                ),
                /* @__PURE__ */ s("div", { className: "space-y-1", children: v(d, 7) })
              ] }),
              /* @__PURE__ */ p("div", { children: [
                /* @__PURE__ */ s(
                  "h4",
                  {
                    className: "font-bold",
                    style: {
                      fontSize: `${n(c, "fontSize", 16)}px`,
                      color: String(n(c, "textColor", "#111111")),
                      marginBottom: `${n(c, "marginBottom", 16)}px`
                    },
                    children: n(c, "text", "Company")
                  }
                ),
                /* @__PURE__ */ s("div", { className: "space-y-1", children: v(u, 6) })
              ] }),
              /* @__PURE__ */ s("div", { className: "lg:flex lg:justify-end", children: /* @__PURE__ */ p(
                "button",
                {
                  className: "flex items-center gap-2 rounded-sm text-sm transition-colors duration-200 hover:text-gray-900 focus:text-gray-900 focus:ring-2 focus:ring-gray-300 focus:ring-offset-2 focus:outline-none",
                  style: {
                    color: String(n(h, "textColor", "#6B7280")),
                    fontSize: `${n(h, "fontSize", 14)}px`
                  },
                  children: [
                    n(h, "showFlag", !0) !== !1 && /* @__PURE__ */ p("div", { className: "flex h-4 w-6 flex-col overflow-hidden rounded-sm border border-gray-300", children: [
                      /* @__PURE__ */ s("div", { className: "h-1/3 w-full bg-orange-500" }),
                      /* @__PURE__ */ s("div", { className: "h-1/3 w-full bg-white" }),
                      /* @__PURE__ */ s("div", { className: "h-1/3 w-full bg-green-600" })
                    ] }),
                    /* @__PURE__ */ s("span", { children: n(h, "country", "India") })
                  ]
                }
              ) })
            ] })
          }
        ),
        /* @__PURE__ */ s(
          "div",
          {
            className: "border-t px-6 py-4 sm:py-6",
            style: {
              borderColor: String(n(r, "borderColor", "#E5E7EB"))
            },
            children: /* @__PURE__ */ s("div", { className: "mx-auto max-w-7xl", children: /* @__PURE__ */ p("div", { className: "flex flex-wrap items-center gap-x-4 gap-y-2 text-xs sm:gap-x-6", children: [
              /* @__PURE__ */ s(
                "span",
                {
                  style: {
                    color: String(n(m, "textColor", "#6B7280")),
                    fontSize: `${n(m, "fontSize", 12)}px`
                  },
                  children: n(m, "copyright", "© 2025 Nike, Inc. All rights reserved")
                }
              ),
              [1, 2, 3, 4].map((y) => {
                var b;
                const f = (m == null ? void 0 : m[i || "desktop"]) ?? (m == null ? void 0 : m.desktop), x = Array.isArray(f) ? (b = f.find((g) => g.inputKey === `link${y}`)) == null ? void 0 : b.value : void 0;
                return x ? /* @__PURE__ */ s(
                  "a",
                  {
                    href: "#",
                    className: "transition-colors duration-200 hover:text-gray-900",
                    style: {
                      color: String(n(m, "textColor", "#6B7280")),
                      fontSize: `${n(m, "fontSize", 12)}px`
                    },
                    children: x
                  },
                  y
                ) : null;
              })
            ] }) })
          }
        )
      ]
    }
  );
}, Ul = wr.reduce(
  (t, e) => (t[e.componentIdentifier] = e.data, t),
  {}
), ql = ue(Vl, {
  identifier: "nike.nikefooter.nikefooter",
  title: "Footer",
  featuredImage: z.previews.hero,
  // Using hero as placeholder
  description: "Complete Nike footer with configurable sections for Resources, Help, Company, and legal information",
  category: "footer",
  className: "nike-footer",
  components: wr,
  defaultData: Ul,
  renderMode: "client"
}), Sr = Z.memo(({
  query: t,
  isVisible: e,
  onSuggestionClick: i,
  onClose: n
}) => {
  const r = tt(), o = Ue(dl);
  Ue(ul);
  const l = Ue(pl), [a, d] = O(-1), c = oe(null), u = Ke(
    () => o.filter(
      (f) => f.text.toLowerCase().includes(t.toLowerCase())
    ),
    [o, t]
  ), h = Ke(
    () => l.filter(
      (f) => f.toLowerCase().includes(t.toLowerCase())
    ),
    [l, t]
  ), m = () => {
    r(So());
  }, v = Ke(() => [
    ...h.map((f) => ({
      text: f,
      type: "recent"
    })),
    ...u
  ], [h, u]), y = Ke(
    () => v.filter(
      (f, x, b) => x === b.findIndex((g) => g.text === f.text)
    ),
    [v]
  );
  return U(() => {
    const f = (x) => {
      if (e)
        switch (x.key) {
          case "ArrowDown":
            x.preventDefault(), d(
              (b) => b < y.length - 1 ? b + 1 : b
            );
            break;
          case "ArrowUp":
            x.preventDefault(), d((b) => b > 0 ? b - 1 : -1);
            break;
          case "Enter":
            x.preventDefault(), a >= 0 && y[a] && i(y[a].text);
            break;
          case "Escape":
            n();
            break;
        }
    };
    return document.addEventListener("keydown", f), () => document.removeEventListener("keydown", f);
  }, [e, a, y, i, n]), U(() => {
    d(-1);
  }, [t]), !e || y.length === 0 ? null : /* @__PURE__ */ p(
    "div",
    {
      ref: c,
      className: "absolute top-full right-0 left-0 z-50 max-h-80 overflow-y-auto rounded-lg border border-gray-200 bg-white shadow-lg",
      children: [
        h.length > 0 && /* @__PURE__ */ p("div", { className: "border-b border-gray-100", children: [
          /* @__PURE__ */ p("div", { className: "flex items-center justify-between bg-gray-50 px-4 py-2", children: [
            /* @__PURE__ */ s("span", { className: "text-xs font-medium tracking-wide text-gray-600 uppercase", children: "Recent Searches" }),
            /* @__PURE__ */ s(
              "button",
              {
                onClick: m,
                className: "text-xs text-gray-500 hover:text-gray-700",
                children: "Clear"
              }
            )
          ] }),
          h.map((f, x) => {
            const b = y.findIndex(
              (g) => g.text === f && g.type === "recent"
            );
            return /* @__PURE__ */ s(
              Tn,
              {
                text: f,
                type: "recent",
                isSelected: a === b,
                onClick: () => i(f)
              },
              `history-${x}`
            );
          })
        ] }),
        u.length > 0 && /* @__PURE__ */ p("div", { children: [
          h.length > 0 && /* @__PURE__ */ s("div", { className: "bg-gray-50 px-4 py-2", children: /* @__PURE__ */ s("span", { className: "text-xs font-medium tracking-wide text-gray-600 uppercase", children: "Suggestions" }) }),
          u.map((f, x) => {
            const b = y.findIndex(
              (g) => g.text === f.text && g.type === f.type
            );
            return /* @__PURE__ */ s(
              Tn,
              {
                text: f.text,
                type: f.type,
                isSelected: a === b,
                onClick: () => i(f.text)
              },
              `suggestion-${x}`
            );
          })
        ] }),
        y.length === 0 && t && /* @__PURE__ */ s("div", { className: "px-4 py-3 text-center text-sm text-gray-500", children: "No suggestions found" })
      ]
    }
  );
}), Tn = ({
  text: t,
  type: e,
  isSelected: i,
  onClick: n
}) => /* @__PURE__ */ p(
  "button",
  {
    className: `flex w-full items-center px-4 py-3 text-left transition-colors duration-150 hover:bg-gray-50 ${i ? "bg-gray-50" : ""}`,
    onClick: n,
    children: [
      /* @__PURE__ */ s("div", { className: "mr-3 flex-shrink-0", children: e === "recent" ? /* @__PURE__ */ s(
        "svg",
        {
          className: "h-4 w-4 text-gray-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: /* @__PURE__ */ s(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            }
          )
        }
      ) : /* @__PURE__ */ s(
        "svg",
        {
          className: "h-4 w-4 text-gray-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: /* @__PURE__ */ s(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            }
          )
        }
      ) }),
      /* @__PURE__ */ s("span", { className: "flex-1 text-sm text-gray-900", children: t }),
      /* @__PURE__ */ s(
        "svg",
        {
          className: "ml-2 h-4 w-4 text-gray-400",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: /* @__PURE__ */ s(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M7 17l9.2-9.2M17 17V7H7"
            }
          )
        }
      )
    ]
  }
), Gl = ({
  className: t = "",
  routes: e
}) => {
  const i = ft(), n = ze(i ?? void 0), r = tt(), [o, l] = O(""), [a, d] = O(!1), [c, u] = O(null), h = oe(null);
  U(() => {
    import("next/navigation").then((y) => {
      try {
        u(y.useRouter());
      } catch (f) {
        console.warn("Router initialization failed:", f);
      }
    });
  }, []), U(() => {
    const y = setTimeout(() => {
      o.length >= 2 && (r(gn(o)), r(Co(o)));
    }, 300);
    return () => clearTimeout(y);
  }, [o, r]);
  const m = (y) => {
    if (y.trim()) {
      r(
        sr({
          id: `search_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`,
          query: y.trim(),
          timestamp: Date.now(),
          resultCount: 0
          // Will be updated after search
        })
      );
      const f = Ki(
        (e == null ? void 0 : e.search) || "search",
        i ?? void 0,
        { q: y.trim() },
        n
      );
      if (c)
        try {
          c.push(f);
        } catch (x) {
          console.warn("Navigation failed:", x), typeof window < "u" && (window.location.href = f);
        }
      else typeof window < "u" && (window.location.href = f);
      l(""), d(!1), r(gn(""));
    }
  }, v = (y) => {
    y.preventDefault(), m(o);
  };
  return U(() => {
    const y = (f) => {
      h.current && !h.current.contains(f.target) && d(!1);
    };
    return document.addEventListener("mousedown", y), () => document.removeEventListener("mousedown", y);
  }, []), /* @__PURE__ */ p("div", { ref: h, className: `relative ${t}`, children: [
    /* @__PURE__ */ s("form", { onSubmit: v, children: /* @__PURE__ */ p("div", { className: "flex w-40 items-center rounded-full bg-gray-100 px-3 py-2 @lg:w-48 @lg:px-4", children: [
      /* @__PURE__ */ s(
        "svg",
        {
          "aria-hidden": "true",
          focusable: "false",
          viewBox: "0 0 24 24",
          role: "img",
          width: "24px",
          height: "24px",
          fill: "none",
          className: "mr-2 h-4 w-4 text-gray-500",
          children: /* @__PURE__ */ s(
            "path",
            {
              stroke: "currentColor",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: "1.5",
              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            }
          )
        }
      ),
      /* @__PURE__ */ s(
        "input",
        {
          type: "text",
          placeholder: "Search",
          value: o,
          onChange: (y) => l(y.target.value),
          onFocus: () => d(!0),
          className: "w-full bg-transparent text-sm font-semibold outline-none placeholder:font-semibold"
        }
      )
    ] }) }),
    a && o.length > 0 && /* @__PURE__ */ s(
      Sr,
      {
        query: o,
        isVisible: !0,
        onSuggestionClick: m,
        onClose: () => d(!1)
      }
    )
  ] });
}, Yl = ({
  className: t = "",
  routes: e
}) => {
  const i = ft(), n = ze(i ?? void 0);
  let r;
  try {
    r = an();
  } catch (S) {
    console.warn("[HeaderCartComponent] Router not available in preview mode:", S), r = null;
  }
  const [o, l] = O(!1), a = tt(), d = $t(), {
    items: c,
    itemCount: u,
    isOpen: h,
    subtotal: m,
    total: v,
    openCart: y,
    closeCart: f
  } = d, x = (S) => {
    var K;
    return S.variantId || S.variant_id || ((K = S.variant) == null ? void 0 : K.id) || S.id;
  }, b = (S) => {
    var _;
    const K = typeof S.title == "string" ? S.title.trim() : S.title;
    return K && K !== "Product" ? K : ((_ = S.product) == null ? void 0 : _.title) || "Product";
  }, g = (S) => {
    var N, $, A, M, q;
    const K = typeof S.price == "number" && S.price > 0 ? S.price : null;
    if (K !== null)
      return K;
    const _ = typeof ((N = S.variant) == null ? void 0 : N.price) == "number" && S.variant.price > 0 ? S.variant.price : null;
    if (_ !== null)
      return _;
    const L = (M = (A = ($ = S.product) == null ? void 0 : $.variants) == null ? void 0 : A.find) == null ? void 0 : M.call(
      A,
      (H) => H.id === x(S)
    );
    return typeof (L == null ? void 0 : L.price) == "number" && L.price > 0 ? L.price : typeof ((q = S.product) == null ? void 0 : q.min_price) == "number" && S.product.min_price > 0 ? S.product.min_price : 0;
  }, k = (S, K) => {
    const _ = `Remove "${K || "this item"}" from cart?`;
    window.confirm(_) && (console.log("[HeaderCartComponent] Removing item completely:", S), a(rr({ variantId: S })));
  }, w = (S) => {
    console.log("[HeaderCartComponent] Incrementing quantity:", S);
    const K = c == null ? void 0 : c.find((_) => x(_) === S);
    K && a(
      Ui({ variantId: S, quantity: K.quantity + 1 })
    );
  }, C = (S) => {
    console.log("[HeaderCartComponent] Decrementing quantity:", S);
    const K = c == null ? void 0 : c.find((_) => x(_) === S);
    K && K.quantity > 1 ? a(
      Ui({ variantId: S, quantity: K.quantity - 1 })
    ) : K && K.quantity === 1 && k(S);
  }, T = (S) => {
    var K, _, L, N, $, A, M;
    return (L = (_ = (K = S.assets) == null ? void 0 : K[0]) == null ? void 0 : _.asset) != null && L.path ? S.assets[0].asset.path : S.image && typeof S.image == "string" && S.image !== "null" ? S.image : ($ = (N = S.variant) == null ? void 0 : N.assets) != null && $.length ? ht(S.variant.assets[0], 100, 100) : (M = (A = S.product) == null ? void 0 : A.assets) != null && M.length ? ht(S.product.assets[0], 100, 100) : "";
  };
  U(() => {
    h ? requestAnimationFrame(() => {
      l(!0);
    }) : l(!1);
  }, [h]), Z.useEffect(() => {
    console.log("🛒 HeaderCartComponent: Cart state updated", {
      itemCount: u,
      isOpen: h,
      itemsLength: (c == null ? void 0 : c.length) || 0,
      items: c,
      subtotal: m,
      total: v
    });
  }, [u, h, c, m, v]);
  const I = () => {
    console.log("🛒 HeaderCartComponent: Cart button clicked, opening cart"), y();
  }, E = () => {
    console.log("🛒 HeaderCartComponent: Backdrop clicked, closing cart"), f();
  }, P = () => {
    f();
    const S = Se("checkout", i ?? void 0, e, n);
    if (r)
      try {
        r.push(S);
      } catch (K) {
        console.warn("Navigation failed:", K), typeof window < "u" && (window.location.href = S);
      }
    else typeof window < "u" && (window.location.href = S);
  };
  return /* @__PURE__ */ p(se, { children: [
    /* @__PURE__ */ p("div", { className: `relative ${t}`, children: [
      /* @__PURE__ */ s(
        "button",
        {
          "aria-label": `Shopping Bag (${u} items)`,
          onClick: I,
          className: "rounded-full p-1.5 transition-colors hover:bg-gray-100 sm:p-2",
          children: /* @__PURE__ */ s(
            "svg",
            {
              "aria-hidden": "true",
              focusable: "false",
              viewBox: "0 0 24 24",
              role: "img",
              width: "20px",
              height: "20px",
              fill: "none",
              className: "h-4 w-4 sm:h-5 sm:w-5",
              children: /* @__PURE__ */ s(
                "path",
                {
                  stroke: "currentColor",
                  strokeWidth: "1.5",
                  d: "M8.25 8.25V6a2.25 2.25 0 012.25-2.25h3a2.25 2.25 0 110 4.5H3.75v8.25a3.75 3.75 0 003.75 3.75h9a3.75 3.75 0 003.75-3.75V8.25H17.5"
                }
              )
            }
          )
        }
      ),
      u > 0 && /* @__PURE__ */ s("div", { className: "absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white sm:h-5 sm:w-5", children: u > 99 ? "99+" : u })
    ] }),
    h && /* @__PURE__ */ p(se, { children: [
      /* @__PURE__ */ s(
        "div",
        {
          className: `fixed inset-0 z-40 bg-black/50 transition-opacity duration-300 ${o ? "opacity-100" : "opacity-0"}`,
          onClick: E,
          "aria-hidden": "true"
        }
      ),
      /* @__PURE__ */ p(
        "div",
        {
          className: `fixed top-0 right-0 z-50 h-full w-96 max-w-[90vw] bg-white shadow-xl transition-transform duration-300 ease-out ${o ? "translate-x-0" : "translate-x-full"}`,
          children: [
            /* @__PURE__ */ p("div", { className: "flex items-center justify-between border-b border-gray-200 p-4", children: [
              /* @__PURE__ */ p("h2", { className: "text-lg font-semibold text-black", children: [
                "Shopping Bag (",
                u,
                ")"
              ] }),
              /* @__PURE__ */ s(
                "button",
                {
                  onClick: f,
                  className: "rounded-md p-2 transition-colors hover:bg-gray-100",
                  "aria-label": "Close cart",
                  children: /* @__PURE__ */ s(
                    "svg",
                    {
                      className: "h-6 w-6",
                      fill: "none",
                      stroke: "currentColor",
                      viewBox: "0 0 24 24",
                      children: /* @__PURE__ */ s(
                        "path",
                        {
                          strokeLinecap: "round",
                          strokeLinejoin: "round",
                          strokeWidth: 2,
                          d: "M6 18L18 6M6 6l12 12"
                        }
                      )
                    }
                  )
                }
              )
            ] }),
            /* @__PURE__ */ s("div", { className: "flex h-full flex-col", children: !c || c.length === 0 ? /* @__PURE__ */ s("div", { className: "flex flex-1 items-center justify-center p-4", children: /* @__PURE__ */ p("div", { className: "text-center", children: [
              /* @__PURE__ */ s(
                "svg",
                {
                  className: "mx-auto h-12 w-12 text-gray-400 mb-4",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  children: /* @__PURE__ */ s(
                    "path",
                    {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 1,
                      d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                    }
                  )
                }
              ),
              /* @__PURE__ */ s("h3", { className: "text-lg font-medium text-gray-900 mb-2", children: "Your bag is empty" }),
              /* @__PURE__ */ s("p", { className: "text-gray-500", children: "Add some products to get started!" })
            ] }) }) : /* @__PURE__ */ p(se, { children: [
              /* @__PURE__ */ s("div", { className: "flex-1 overflow-y-auto p-4", children: /* @__PURE__ */ s("div", { className: "space-y-4", children: c.map((S, K) => /* @__PURE__ */ p(
                "div",
                {
                  className: "flex gap-4 border-b border-gray-200 pb-4",
                  children: [
                    /* @__PURE__ */ s("div", { className: "h-20 w-20 flex-shrink-0 overflow-hidden rounded-md", children: /* @__PURE__ */ s(
                      $e,
                      {
                        src: T(S),
                        alt: b(S),
                        className: "h-full w-full object-cover object-center",
                        showPlaceholderIcon: !0,
                        cdnWidth: 100,
                        cdnHeight: 100,
                        cdnFit: "fit"
                      }
                    ) }),
                    /* @__PURE__ */ p("div", { className: "flex flex-1 flex-col gap-2", children: [
                      /* @__PURE__ */ p("div", { className: "flex justify-between", children: [
                        /* @__PURE__ */ s("h4", { className: "text-sm font-medium text-gray-900", children: b(S) }),
                        /* @__PURE__ */ s(
                          "button",
                          {
                            onClick: () => {
                              console.log(
                                "[HeaderCartComponent] Remove clicked:",
                                x(S)
                              ), k(x(S), b(S));
                            },
                            className: "text-gray-400 hover:text-red-500 transition-colors",
                            "aria-label": "Remove item",
                            children: /* @__PURE__ */ s(
                              "svg",
                              {
                                className: "h-5 w-5",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                children: /* @__PURE__ */ s(
                                  "path",
                                  {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M6 18L18 6M6 6l12 12"
                                  }
                                )
                              }
                            )
                          }
                        )
                      ] }),
                      /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: [
                        /* @__PURE__ */ s(
                          "button",
                          {
                            onClick: () => {
                              console.log(
                                "[HeaderCartComponent] Decrement clicked:",
                                {
                                  variantId: x(S),
                                  currentQty: S.quantity
                                }
                              ), C(x(S));
                            },
                            className: "w-6 h-6 flex items-center justify-center rounded border border-gray-300 hover:bg-gray-100",
                            "aria-label": "Decrease quantity",
                            children: /* @__PURE__ */ s(
                              "svg",
                              {
                                className: "w-3 h-3",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                children: /* @__PURE__ */ s(
                                  "path",
                                  {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M20 12H4"
                                  }
                                )
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ s("span", { className: "text-sm font-medium text-gray-900 min-w-[20px] text-center", children: S.quantity }),
                        /* @__PURE__ */ s(
                          "button",
                          {
                            onClick: () => {
                              console.log(
                                "[HeaderCartComponent] Increment clicked:",
                                {
                                  variantId: x(S),
                                  currentQty: S.quantity
                                }
                              ), w(x(S));
                            },
                            className: "w-6 h-6 flex items-center justify-center rounded border border-gray-300 hover:bg-gray-100",
                            "aria-label": "Increase quantity",
                            children: /* @__PURE__ */ s(
                              "svg",
                              {
                                className: "w-3 h-3",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24",
                                children: /* @__PURE__ */ s(
                                  "path",
                                  {
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    strokeWidth: 2,
                                    d: "M12 4v16m8-8H4"
                                  }
                                )
                              }
                            )
                          }
                        )
                      ] }),
                      /* @__PURE__ */ p("p", { className: "text-sm font-medium text-gray-900", children: [
                        "₹",
                        (g(S) * (S.quantity || 1)).toLocaleString()
                      ] })
                    ] })
                  ]
                },
                x(S) || K
              )) }) }),
              /* @__PURE__ */ p("div", { className: "border-t border-gray-200 p-4", children: [
                /* @__PURE__ */ p("div", { className: "flex justify-between text-base font-medium text-gray-900 mb-4", children: [
                  /* @__PURE__ */ s("p", { children: "Subtotal" }),
                  /* @__PURE__ */ p("p", { children: [
                    "₹",
                    (m || 0).toLocaleString()
                  ] })
                ] }),
                /* @__PURE__ */ s("p", { className: "mt-0.5 text-sm text-gray-500 mb-4", children: "Shipping and taxes calculated at checkout." }),
                /* @__PURE__ */ p("div", { className: "space-y-2", children: [
                  /* @__PURE__ */ s(
                    "button",
                    {
                      onClick: P,
                      className: "w-full rounded-md bg-gray-900 px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-gray-800",
                      children: "Checkout"
                    }
                  ),
                  /* @__PURE__ */ s(
                    "button",
                    {
                      className: "w-full rounded-md border border-gray-300 bg-white px-6 py-3 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50",
                      onClick: f,
                      children: "Continue Shopping"
                    }
                  )
                ] })
              ] })
            ] }) })
          ]
        }
      )
    ] })
  ] });
}, Xl = ({ className: t = "" }) => {
  const { items: e, itemCount: i } = No(), n = i || (e == null ? void 0 : e.length) || 0, [r, o] = O(null);
  U(() => {
    import("next/navigation").then((a) => {
      try {
        o(a.useRouter());
      } catch (d) {
        console.warn("Router initialization failed:", d);
      }
    });
  }, []);
  const l = () => {
    if (r)
      try {
        r.push("/nike/favorites");
      } catch (a) {
        console.warn("Navigation failed:", a), typeof window < "u" && (window.location.href = "/nike/favorites");
      }
    else typeof window < "u" && (window.location.href = "/nike/favorites");
  };
  return /* @__PURE__ */ p("div", { className: `relative ${t}`, children: [
    /* @__PURE__ */ s(
      "button",
      {
        "aria-label": `Favorites (${n} items)`,
        onClick: l,
        className: "rounded-full p-1.5 transition-colors hover:bg-gray-100 @sm:p-2",
        children: /* @__PURE__ */ s(
          "svg",
          {
            "aria-hidden": "true",
            focusable: "false",
            viewBox: "0 0 24 24",
            role: "img",
            width: "20px",
            height: "20px",
            fill: "none",
            className: "h-4 w-4 @sm:h-5 @sm:w-5",
            children: /* @__PURE__ */ s(
              "path",
              {
                stroke: "currentColor",
                strokeWidth: "1.5",
                d: "M16.794 3.75c1.324 0 2.568.516 3.504 1.451a4.96 4.96 0 010 7.008L12 20.508l-8.299-8.299a4.96 4.96 0 010-7.007A4.923 4.923 0 017.205 3.75c1.324 0 2.568.516 3.504 1.451l.76.76.531.531.53-.531.76-.76a4.926 4.926 0 013.504-1.451"
              }
            )
          }
        )
      }
    ),
    n > 0 && /* @__PURE__ */ s("div", { className: "absolute -top-1 -right-1 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-xs font-bold text-white @sm:h-5 @sm:w-5", children: n > 99 ? "99+" : n })
  ] });
}, Ql = ({
  className: t = "",
  variant: e = "nike"
}) => {
  const [i, n] = O(!1), r = () => {
    n(!i);
  }, o = () => {
    n(!1);
  }, l = () => e === "bewakoof" ? [
    "MEN",
    "WOMEN",
    "MOBILE COVERS",
    "ACCESSORIES",
    "SALE",
    "FANBOOK"
  ] : [
    "New & Featured",
    "Men",
    "Women",
    "Kids",
    "Sale",
    "SNKRS"
  ], a = () => e === "bewakoof" ? /* @__PURE__ */ p("div", { className: "text-2xl font-extrabold tracking-tight leading-none", children: [
    /* @__PURE__ */ s("span", { className: "bg-yellow-400 px-1 rounded-sm text-black", children: "bewakoof" }),
    /* @__PURE__ */ s("sup", { className: "text-[10px] ml-0.5 align-super text-black", children: "®" })
  ] }) : /* @__PURE__ */ s(
    "svg",
    {
      "aria-hidden": "true",
      className: "swoosh-svg h-8 w-auto fill-current text-black",
      focusable: "false",
      viewBox: "0 0 24 24",
      role: "img",
      children: /* @__PURE__ */ s(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
          clipRule: "evenodd"
        }
      )
    }
  ), d = l();
  return /* @__PURE__ */ p(se, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        onClick: r,
        className: `rounded-md p-1 transition-colors hover:bg-gray-100 md:hidden ${t}`,
        "aria-label": "Toggle menu",
        children: i ? /* @__PURE__ */ s(
          "svg",
          {
            className: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ s(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M6 18L18 6M6 6l12 12"
              }
            )
          }
        ) : /* @__PURE__ */ s(
          "svg",
          {
            className: "h-6 w-6",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ s(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M4 6h16M4 12h16M4 18h16"
              }
            )
          }
        )
      }
    ),
    i && /* @__PURE__ */ p(se, { children: [
      /* @__PURE__ */ s(
        "div",
        {
          className: "bg-opacity-50 fixed inset-0 z-40 bg-black md:hidden",
          onClick: o
        }
      ),
      /* @__PURE__ */ p("div", { className: "fixed top-0 left-0 z-50 h-full w-80 max-w-[85vw] transform bg-white transition-transform duration-300 ease-in-out md:hidden", children: [
        /* @__PURE__ */ p("div", { className: "flex items-center justify-between border-b border-gray-200 p-4", children: [
          /* @__PURE__ */ s(Lt, { href: "/", onClick: o, children: a() }),
          /* @__PURE__ */ s(
            "button",
            {
              onClick: o,
              className: "rounded-md p-2 transition-colors hover:bg-gray-100",
              "aria-label": "Close menu",
              children: /* @__PURE__ */ s(
                "svg",
                {
                  className: "h-6 w-6",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  children: /* @__PURE__ */ s(
                    "path",
                    {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M6 18L18 6M6 6l12 12"
                    }
                  )
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ s("div", { className: "py-4", children: /* @__PURE__ */ s("div", { className: "space-y-1", children: d.map((c) => /* @__PURE__ */ s(
          "a",
          {
            href: "#",
            className: "block px-4 py-3 text-lg font-medium text-black transition-colors hover:bg-gray-50",
            onClick: o,
            children: c
          },
          c
        )) }) })
      ] })
    ] })
  ] });
}, Jl = ({ isOpen: t, onClose: e, routes: i }) => {
  const n = tt(), r = ft(), o = ze(r ?? void 0), [l, a] = O(""), [d, c] = O(!1), [u, h] = O(null), m = oe(null);
  U(() => {
    import("next/navigation").then((f) => {
      try {
        h(f.useRouter());
      } catch (x) {
        console.warn("Router initialization failed:", x);
      }
    });
  }, []);
  const v = (f) => {
    if (f.trim()) {
      n(sr({
        id: `${Date.now()}-${f.trim()}`,
        query: f.trim(),
        timestamp: Date.now(),
        resultCount: 0
      }));
      const x = Ki(
        (i == null ? void 0 : i.search) || "search",
        r ?? void 0,
        { q: f.trim() },
        o
      );
      if (u)
        try {
          u.push(x);
        } catch (b) {
          console.warn("Navigation failed:", b), typeof window < "u" && (window.location.href = x);
        }
      else typeof window < "u" && (window.location.href = x);
      a(""), c(!1), e();
    }
  }, y = (f) => {
    f.preventDefault(), v(l);
  };
  return U(() => {
    t && setTimeout(() => {
      var x;
      const f = (x = m.current) == null ? void 0 : x.querySelector("input");
      f == null || f.focus();
    }, 100);
  }, [t]), U(() => {
    const f = (x) => {
      m.current && !m.current.contains(x.target) && c(!1);
    };
    return document.addEventListener("mousedown", f), () => document.removeEventListener("mousedown", f);
  }, []), t ? /* @__PURE__ */ p(
    "div",
    {
      ref: m,
      className: "relative border-t border-gray-200 bg-white px-4 py-3 sm:hidden",
      children: [
        /* @__PURE__ */ s("form", { onSubmit: y, children: /* @__PURE__ */ p("div", { className: "flex items-center rounded-full bg-gray-100 px-4 py-2", children: [
          /* @__PURE__ */ s(
            "svg",
            {
              "aria-hidden": "true",
              focusable: "false",
              viewBox: "0 0 24 24",
              role: "img",
              width: "20px",
              height: "20px",
              fill: "none",
              className: "mr-3 h-4 w-4 text-gray-500",
              children: /* @__PURE__ */ s(
                "path",
                {
                  stroke: "currentColor",
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: "1.5",
                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                }
              )
            }
          ),
          /* @__PURE__ */ s(
            "input",
            {
              type: "text",
              placeholder: "Search",
              value: l,
              onChange: (f) => a(f.target.value),
              onFocus: () => c(!0),
              className: "w-full bg-transparent text-sm font-semibold outline-none placeholder:font-semibold",
              autoFocus: !0
            }
          )
        ] }) }),
        d && l.length > 0 && /* @__PURE__ */ s(
          Sr,
          {
            query: l,
            isVisible: !0,
            onSuggestionClick: v,
            onClose: () => c(!1)
          }
        )
      ]
    }
  ) : null;
}, Zl = ({ routes: t }) => {
  const [e, i] = Z.useState(!1);
  return /* @__PURE__ */ p(se, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        onClick: () => {
          i(!e);
        },
        className: "rounded-full p-2 transition-colors hover:bg-gray-100 sm:hidden",
        "aria-label": "Search",
        children: /* @__PURE__ */ s(
          "svg",
          {
            "aria-hidden": "true",
            focusable: "false",
            viewBox: "0 0 24 24",
            role: "img",
            width: "20px",
            height: "20px",
            fill: "none",
            className: "h-5 w-5 text-gray-700",
            children: /* @__PURE__ */ s(
              "path",
              {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: "1.5",
                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ s(Jl, { isOpen: e, onClose: () => {
      i(!1);
    }, routes: t })
  ] });
}, ec = [
  F(
    "background-image",
    "header-background",
    {
      desktop: [
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" },
        { inputKey: "borderColor", type: "color", value: "#E5E7EB" },
        { inputKey: "borderWidth", type: "number", value: 1 }
      ],
      tablet: [
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" },
        { inputKey: "borderColor", type: "color", value: "#E5E7EB" }
      ],
      mobile: [
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" },
        { inputKey: "borderColor", type: "color", value: "#E5E7EB" }
      ]
    },
    {
      name: "Header Background",
      description: "Background styling for the header section"
    }
  ),
  F(
    "heading-text",
    "header-logo",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "NIKE" },
        { inputKey: "fontSize", type: "number", value: 24 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#000000" }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 22 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 20 }
      ]
    },
    {
      name: "Header Logo",
      description: "Logo text or brand name for the header"
    }
  ),
  F(
    "text-block",
    "header-nav-item",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "New & Featured" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "hoverColor", type: "color", value: "#6B7280" },
        { inputKey: "fontWeight", type: "select", value: "normal" }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 14 }
      ],
      mobile: []
    },
    {
      name: "Navigation Item",
      description: "Navigation menu item configuration"
    }
  ),
  F(
    "icon",
    "header-search-icon",
    {
      desktop: [
        { inputKey: "iconName", type: "select", value: "search" },
        { inputKey: "iconSize", type: "number", value: 20 },
        { inputKey: "iconColor", type: "color", value: "#000000" }
      ],
      tablet: [
        { inputKey: "iconSize", type: "number", value: 20 }
      ],
      mobile: [
        { inputKey: "iconSize", type: "number", value: 18 }
      ]
    },
    {
      name: "Search Icon",
      description: "Search icon configuration"
    }
  ),
  F(
    "icon",
    "header-cart-icon",
    {
      desktop: [
        { inputKey: "iconName", type: "select", value: "shopping-bag" },
        { inputKey: "iconSize", type: "number", value: 20 },
        { inputKey: "iconColor", type: "color", value: "#000000" }
      ],
      tablet: [
        { inputKey: "iconSize", type: "number", value: 20 }
      ],
      mobile: [
        { inputKey: "iconSize", type: "number", value: 18 }
      ]
    },
    {
      name: "Cart Icon",
      description: "Shopping cart icon configuration"
    }
  ),
  F(
    "icon",
    "header-wishlist-icon",
    {
      desktop: [
        { inputKey: "iconName", type: "select", value: "heart" },
        { inputKey: "iconSize", type: "number", value: 20 },
        { inputKey: "iconColor", type: "color", value: "#000000" }
      ],
      tablet: [
        { inputKey: "iconSize", type: "number", value: 20 }
      ],
      mobile: [
        { inputKey: "iconSize", type: "number", value: 18 }
      ]
    },
    {
      name: "Wishlist Icon",
      description: "Wishlist/favorites icon configuration"
    }
  )
], Be = (t, e, i) => {
  var r;
  const n = t == null ? void 0 : t.desktop;
  return Array.isArray(n) ? ((r = n.find((o) => o.inputKey === e)) == null ? void 0 : r.value) ?? i : n && typeof n == "object" ? n[e] ?? i : i;
}, tc = ({ routes: t }) => {
  const e = ft(), i = ze(e ?? void 0), [n, r] = O(!1), o = oe(null);
  U(() => {
    const a = (d) => {
      o.current && !o.current.contains(d.target) && r(!1);
    };
    return n && document.addEventListener("mousedown", a), () => {
      document.removeEventListener("mousedown", a);
    };
  }, [n]);
  const l = () => {
    document.cookie = "shiphouse-session=; path=/; max-age=0", localStorage.removeItem("shiphouse-session"), localStorage.removeItem("shiphouse-refresh-token"), localStorage.removeItem("shiphouse-user-id"), window.location.href = Se("home", e ?? void 0, t, i);
  };
  return /* @__PURE__ */ p("div", { className: "relative", ref: o, children: [
    /* @__PURE__ */ s(
      "button",
      {
        onClick: () => r(!n),
        className: "flex h-9 w-9 items-center justify-center rounded-full transition-colors duration-200 hover:bg-gray-100",
        "aria-label": "User Menu",
        children: /* @__PURE__ */ s(
          "svg",
          {
            className: "h-5 w-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24",
            children: /* @__PURE__ */ s(
              "path",
              {
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
              }
            )
          }
        )
      }
    ),
    n && /* @__PURE__ */ p("div", { className: "absolute right-0 mt-2 w-48 rounded-lg bg-white shadow-lg border border-gray-200 py-1 z-50", children: [
      /* @__PURE__ */ p(
        Lt,
        {
          href: Se("account", e ?? void 0, t, i),
          className: "flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors",
          onClick: () => r(!1),
          children: [
            /* @__PURE__ */ s(
              "svg",
              {
                className: "h-4 w-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                  }
                )
              }
            ),
            "Account"
          ]
        }
      ),
      /* @__PURE__ */ p(
        Lt,
        {
          href: Se("orders", e ?? void 0, t, i),
          className: "flex items-center gap-3 px-4 py-2.5 text-sm text-gray-700 hover:bg-gray-50 transition-colors",
          onClick: () => r(!1),
          children: [
            /* @__PURE__ */ s(
              "svg",
              {
                className: "h-4 w-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
                  }
                )
              }
            ),
            "Orders"
          ]
        }
      ),
      /* @__PURE__ */ s("div", { className: "border-t border-gray-100 my-1" }),
      /* @__PURE__ */ p(
        "button",
        {
          onClick: l,
          className: "flex w-full items-center gap-3 px-4 py-2.5 text-sm text-red-600 hover:bg-gray-50 transition-colors",
          children: [
            /* @__PURE__ */ s(
              "svg",
              {
                className: "h-4 w-4",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                  }
                )
              }
            ),
            "Logout"
          ]
        }
      )
    ] })
  ] });
}, ic = ({ data: t, routes: e, routeContext: i, viewportMode: n }) => {
  const r = ft() ?? i, o = ze(r ?? void 0), l = R(t, "background-image", "header-background", n), a = R(t, "heading-text", "header-logo", n), d = R(t, "text-block", "header-nav-item", n), c = R(t, "icon", "header-search-icon", n), u = R(t, "icon", "header-cart-icon", n), h = R(t, "icon", "header-wishlist-icon", n), m = Be(l, "backgroundColor", "#FFFFFF"), v = Be(l, "borderColor", "#E5E7EB"), y = Be(l, "borderWidth", 1);
  return Be(a, "fontSize", 24), Be(a, "textColor", "#000000"), Be(d, "fontSize", 14), Be(d, "textColor", "#000000"), Be(d, "hoverColor", "#6B7280"), Be(c, "iconSize", 20), Be(u, "iconSize", 20), Be(h, "iconSize", 20), /* @__PURE__ */ s(
    "nav",
    {
      className: "relative z-50 border-b bg-white",
      style: {
        borderColor: v,
        borderWidth: `${y}px`,
        backgroundColor: m
      },
      children: /* @__PURE__ */ p("div", { className: "flex items-center justify-between px-4 py-3 sm:px-6", children: [
        /* @__PURE__ */ p("div", { className: "flex items-center gap-3", children: [
          /* @__PURE__ */ s(Ql, {}),
          /* @__PURE__ */ s(Lt, { href: Se("home", r ?? void 0, e, o), children: /* @__PURE__ */ s("div", { className: "flex items-center", children: /* @__PURE__ */ s(
            "svg",
            {
              "aria-hidden": "true",
              className: "swoosh-svg h-6 w-auto fill-current text-black sm:h-8",
              focusable: "false",
              viewBox: "0 0 24 24",
              role: "img",
              children: /* @__PURE__ */ s(
                "path",
                {
                  fill: "currentColor",
                  fillRule: "evenodd",
                  d: "M21 8.719L7.836 14.303C6.74 14.768 5.818 15 5.075 15c-.836 0-1.445-.295-1.819-.884-.485-.76-.273-1.982.559-3.272.494-.754 1.122-1.446 1.734-2.108-.144.234-1.415 2.349-.025 3.345.275.2.666.298 1.147.298.386 0 .829-.063 1.316-.19L21 8.719z",
                  clipRule: "evenodd"
                }
              )
            }
          ) }) })
        ] }),
        /* @__PURE__ */ p("nav", { className: "absolute left-1/2 hidden -translate-x-1/2 transform items-center justify-center gap-6 md:flex lg:gap-8", children: [
          /* @__PURE__ */ s(
            "a",
            {
              href: "#",
              className: "font-helvetica-now text-sm text-black transition-colors duration-200 hover:text-gray-600 lg:text-base",
              children: "New & Featured"
            }
          ),
          /* @__PURE__ */ s(
            "a",
            {
              href: "#",
              className: "font-helvetica-now text-sm text-black transition-colors duration-200 hover:text-gray-600 lg:text-base",
              children: "Men"
            }
          ),
          /* @__PURE__ */ s(
            "a",
            {
              href: "#",
              className: "font-helvetica-now text-sm text-black transition-colors duration-200 hover:text-gray-600 lg:text-base",
              children: "Women"
            }
          ),
          /* @__PURE__ */ s(
            "a",
            {
              href: "#",
              className: "font-helvetica-now text-sm text-black transition-colors duration-200 hover:text-gray-600 lg:text-base",
              children: "Kids"
            }
          ),
          /* @__PURE__ */ s(
            "a",
            {
              href: "#",
              className: "font-helvetica-now text-sm text-black transition-colors duration-200 hover:text-gray-600 lg:text-base",
              children: "Sale"
            }
          ),
          /* @__PURE__ */ s(
            "a",
            {
              href: "#",
              className: "font-helvetica-now text-sm text-black transition-colors duration-200 hover:text-gray-600 lg:text-base",
              children: "SNKRS"
            }
          )
        ] }),
        /* @__PURE__ */ p("div", { className: "flex items-center gap-1 sm:gap-2", children: [
          /* @__PURE__ */ s(Gl, { className: "hidden sm:block", routes: e }),
          /* @__PURE__ */ s(Zl, { routes: e }),
          /* @__PURE__ */ s(Xl, {}),
          /* @__PURE__ */ s(Yl, { routes: e }),
          /* @__PURE__ */ s(tc, { routes: e })
        ] })
      ] })
    }
  );
}, nc = ue(ic, {
  category: "header",
  identifier: "nike.nikeheader.nikeheadersection",
  className: "nike-header",
  components: ec,
  description: "Nike Header Section with navigation, search, cart, and user menu with responsive styling",
  featuredImage: "./preview.png",
  title: "Header",
  renderMode: "client"
}), rc = [
  // Background Image Component
  F(
    "background-image",
    "nike-hero-bg",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: z.hero.main },
        { inputKey: "backgroundSize", type: "select", value: "cover" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 600 },
        { inputKey: "overlay", type: "color", value: "#000000" },
        { inputKey: "overlayOpacity", type: "number", value: 40 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 500 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 400 }]
    },
    {
      name: "Hero Background",
      description: "Main background image with overlay for the hero section"
    }
  ),
  // Hero Title Component
  F(
    "heading-text",
    "nike-hero-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "NOT IF. WHEN." },
        { inputKey: "level", type: "select", value: "1" },
        { inputKey: "fontSize", type: "number", value: 64 },
        { inputKey: "fontWeight", type: "select", value: "black" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "letterSpacing", type: "number", value: -1 },
        { inputKey: "lineHeight", type: "number", value: 1.1 },
        { inputKey: "textAlign", type: "select", value: "left" }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 48 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 36 }]
    },
    {
      name: "Hero Title",
      description: "Main headline text for the hero section"
    }
  ),
  // Hero Subtitle Component
  F(
    "text-block",
    "nike-hero-subtitle",
    {
      desktop: [
        {
          inputKey: "text",
          type: "text",
          value: "Faith Kipyegon ran faster than any woman in history at Breaking4, pushing the world closer to the 4-minute barrier."
        },
        { inputKey: "fontSize", type: "number", value: 18 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.5 },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "maxWidth", type: "number", value: 600 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "maxWidth", type: "number", value: 500 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "maxWidth", type: "number", value: 400 }
      ]
    },
    {
      name: "Hero Subtitle",
      description: "Supporting text content for the hero section"
    }
  ),
  // Hero CTA Button Component
  F(
    "button-solid",
    "nike-hero-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Watch Now" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "large" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 32 },
        { inputKey: "paddingY", type: "number", value: 12 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "hoverColor", type: "color", value: "#F3F4F6" }
      ],
      tablet: [
        { inputKey: "paddingX", type: "number", value: 28 },
        { inputKey: "paddingY", type: "number", value: 10 }
      ],
      mobile: [
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 }
      ]
    },
    {
      name: "Hero CTA Button",
      description: "Call-to-action button for the hero section"
    }
  )
], oc = ({ data: t, className: e, storeId: i, viewportMode: n }) => {
  const r = R(
    t,
    "background-image",
    "nike-hero-bg",
    n
  ), o = R(
    t,
    "heading-text",
    "nike-hero-title",
    n
  ), l = R(
    t,
    "text-block",
    "nike-hero-subtitle",
    n
  ), a = R(
    t,
    "button-solid",
    "nike-hero-cta",
    n
  ), d = B(r, "assetId", z.hero.main) || z.hero.main, [c, u] = O(
    typeof d == "string" && !d.startsWith("http") ? z.hero.main : d
  );
  return U(() => {
    (async () => {
      if (typeof d == "string" && d && i)
        try {
          const m = await we(
            d,
            i,
            { width: 1920, height: 1080, fit: "cover" }
          );
          u(m);
        } catch {
          u(z.hero.main);
        }
    })();
  }, [d, i]), /* @__PURE__ */ s(
    "section",
    {
      className: `nike-hero-section ${e || ""} relative overflow-hidden`,
      children: /* @__PURE__ */ p("div", { className: "relative h-screen min-h-[400px] w-full sm:min-h-[500px] lg:min-h-[600px]", children: [
        /* @__PURE__ */ s(
          "img",
          {
            src: c,
            alt: "Nike Hero",
            className: "h-full w-full object-cover object-center"
          }
        ),
        /* @__PURE__ */ s(
          "div",
          {
            className: "absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent",
            style: {
              background: "linear-gradient(to top, rgba(0,0,0,0.5), rgba(0,0,0,0.1), transparent)"
            }
          }
        ),
        /* @__PURE__ */ s("div", { className: "absolute inset-0 flex items-end", children: /* @__PURE__ */ s("div", { className: "container mx-auto px-4 pb-8 sm:px-6 sm:pb-12 lg:px-8 lg:pb-16", children: /* @__PURE__ */ p("div", { className: "max-w-xl text-left text-white sm:max-w-2xl", children: [
          /* @__PURE__ */ s(
            "h1",
            {
              className: "mb-3 font-black leading-tight tracking-tight sm:mb-4",
              style: {
                fontSize: `${B(o, "fontSize", 64)}px`,
                color: B(o, "textColor", "#FFFFFF"),
                letterSpacing: `${B(o, "letterSpacing", -1)}px`,
                lineHeight: B(o, "lineHeight", 1.1)
              },
              children: B(o, "text", "NOT IF. WHEN.")
            }
          ),
          /* @__PURE__ */ s("div", { className: "mb-4 space-y-1 sm:mb-6", children: /* @__PURE__ */ s(
            "p",
            {
              className: "leading-tight",
              style: {
                fontSize: `${B(l, "fontSize", 18)}px`,
                color: B(l, "textColor", "#FFFFFF"),
                lineHeight: B(l, "lineHeight", 1.5),
                maxWidth: `${B(l, "maxWidth", 600)}px`
              },
              children: B(
                l,
                "text",
                "Faith Kipyegon ran faster than any woman in history at Breaking4, pushing the world closer to the 4-minute barrier."
              )
            }
          ) }),
          /* @__PURE__ */ s("div", { className: "inline-block overflow-hidden rounded-full", children: /* @__PURE__ */ s(
            "button",
            {
              className: "shadow-md hover:[background-color:var(--cta-hover-bg)] transition-colors",
              style: {
                backgroundColor: B(a, "button-color", "#FFFFFF"),
                color: B(a, "textColor", "#000000"),
                borderRadius: `${B(a, "borderRadius", 999)}px`,
                paddingLeft: `${B(a, "paddingX", 32)}px`,
                paddingRight: `${B(a, "paddingX", 32)}px`,
                paddingTop: `${B(a, "paddingY", 12)}px`,
                paddingBottom: `${B(a, "paddingY", 12)}px`,
                fontWeight: B(a, "fontWeight", "medium"),
                border: "none",
                cursor: "pointer",
                "--cta-hover-bg": B(a, "hoverColor", "#F3F4F6")
              }
            }
          ) })
        ] }) }) })
      ] })
    }
  );
}, sc = ue(oc, {
  identifier: "nike.nikehero.nikehero",
  title: "Hero",
  featuredImage: z.previews.hero,
  description: "Full-screen hero section with Nike branding, overlay content, and call-to-action button (Client-side rendered)",
  category: "nike",
  className: "nike-hero",
  components: rc,
  renderMode: "client"
});
zt(void 0);
zt(void 0);
const ac = zt(
  void 0
), lc = () => to(ac) ?? null;
function Cr(t) {
  return t.reduce(
    (e, i) => (e[i.componentIdentifier] = i.data, e),
    {}
  );
}
const cc = Z.createContext(null), Nr = () => Z.useContext(cc), Gi = [
  // Sidebar Configuration
  F(
    "text-block",
    "sidebar-config",
    {
      desktop: [
        { inputKey: "sidebarWidth", type: "number", value: 400 },
        { inputKey: "backgroundColor", type: "color", value: "#FFFFFF" },
        {
          inputKey: "overlayColor",
          type: "color",
          value: "rgba(0, 0, 0, 0.5)"
        },
        { inputKey: "animationDuration", type: "number", value: 300 },
        { inputKey: "showDeliveryInfo", type: "checkbox", value: !0 },
        { inputKey: "freeDeliveryThreshold", type: "number", value: 14e3 }
      ],
      tablet: [],
      mobile: [
        { inputKey: "mobileWidth", type: "text", value: "100%" },
        { inputKey: "maxMobileWidth", type: "number", value: 480 }
      ]
    },
    {
      name: "Cart Sidebar Configuration",
      description: "Configuration for cart sidebar appearance and behavior"
    }
  ),
  // Header Configuration
  F(
    "heading-text",
    "sidebar-header",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Bag" },
        { inputKey: "fontSize", type: "number", value: 20 },
        { inputKey: "fontWeight", type: "select", value: "600" },
        { inputKey: "textColor", type: "color", value: "#111111" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Sidebar Header",
      description: "Header text and styling for the cart sidebar"
    }
  ),
  // Empty Cart Configuration
  F(
    "text-block",
    "empty-cart-config",
    {
      desktop: [
        { inputKey: "emptyTitle", type: "text", value: "Your bag is empty" },
        {
          inputKey: "emptySubtitle",
          type: "text",
          value: "Items in your bag are not reserved — check out now to make them yours."
        },
        {
          inputKey: "continueShoppingText",
          type: "text",
          value: "Continue Shopping"
        },
        { inputKey: "showEmptyIcon", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Empty Cart Configuration",
      description: "Configuration for empty cart state display"
    }
  ),
  // Action Buttons Configuration
  F(
    "button-solid",
    "checkout-button",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Checkout" },
        { inputKey: "backgroundColor", type: "color", value: "#111111" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "borderRadius", type: "number", value: 30 },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "500" },
        { inputKey: "padding", type: "text", value: "16px 24px" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Checkout Button",
      description: "Primary checkout button styling and text"
    }
  ),
  // Container Styling
  F(
    "text-block",
    "container-styling",
    {
      desktop: [
        { inputKey: "borderRadius", type: "number", value: 0 },
        {
          inputKey: "boxShadow",
          type: "text",
          value: "0 10px 25px rgba(0, 0, 0, 0.1)"
        },
        { inputKey: "zIndex", type: "number", value: 50 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Container Styling",
      description: "Overall container styling for the cart sidebar"
    }
  )
], dc = ({
  data: t,
  className: e,
  routeContext: i,
  routes: n,
  viewportMode: r
}) => {
  var Le;
  const o = (D, J, le) => {
    const Ce = D == null ? void 0 : D[r || "desktop"], xe = Ce == null ? void 0 : Ce.find((pe) => pe.inputKey === J);
    return (xe == null ? void 0 : xe.value) ?? le;
  }, [l, a] = O(null), d = Nr(), c = i ?? d ?? void 0;
  console.log("[CartSidebar] routeContext prop:", i), console.log(
    "[CartSidebar] fallbackRouteContext (from provider):",
    d
  ), console.log("[CartSidebar] resolvedRouteContext:", c);
  const u = ze(c);
  console.log("[CartSidebar] routeOptions:", u), U(() => {
    import("next/navigation").then((D) => {
      try {
        a(D.useRouter());
      } catch (J) {
        console.warn("Router initialization failed:", J);
      }
    });
  }, []);
  const h = $t({ autoFetch: !0, autoSync: !0 }), m = me(), v = m ? pr() : null, {
    items: y,
    isOpen: f,
    subtotal: x,
    total: b,
    itemCount: g,
    isLoading: k,
    removeItem: w,
    updateQuantity: C
  } = h, T = m && y.length === 0 && v ? [...v.items] : y, I = m && v ? v.subtotal : x, E = m && v ? v.total : b, P = m && v ? v.itemCount : g, S = m ? !0 : f, K = tt(), [_, L] = O(S), N = oe(null);
  U(() => {
    L(S);
  }, [S]);
  const $ = oe((T == null ? void 0 : T.length) || 0);
  U(() => {
    const D = $.current || 0, J = (T == null ? void 0 : T.length) || 0;
    return J > D && !f && (N.current && clearTimeout(N.current), N.current = setTimeout(() => {
      if (!f)
        try {
          K(Qe(!0));
        } catch {
          K(Qe(!0));
        }
      N.current = null;
    }, 50)), $.current = J, () => {
      N.current && clearTimeout(N.current);
    };
  }, [T == null ? void 0 : T.length, S, K]);
  const A = oe("");
  U(() => {
    const D = JSON.stringify(T);
    A.current && D !== A.current && console.log(
      "[CartSidebar] Items changed, triggering cart sync",
      T
    ), A.current = D;
  }, [T]);
  const M = T.length === 0 && !m, q = {
    itemCount: P || 0,
    subtotal: I || 0,
    shipping: (I || 0) >= 14e5 ? 0 : 5e4,
    total: E || 0
  }, X = { ...Cr(
    Gi
  ), ...t }, re = R(
    X,
    "text-block",
    "sidebar-config",
    r
  ), V = R(
    X,
    "heading-text",
    "sidebar-header",
    r
  ), G = R(
    X,
    "text-block",
    "empty-cart-config",
    r
  ), Y = R(
    X,
    "button-solid",
    "checkout-button",
    r
  ), ie = R(
    X,
    "text-block",
    "container-styling",
    r
  ), ae = o(re, "sidebarWidth", 400), ge = o(re, "backgroundColor", "#FFFFFF"), ye = o(
    re,
    "overlayColor",
    "rgba(0, 0, 0, 0.5)"
  ), de = o(re, "animationDuration", 300), qe = o(re, "showDeliveryInfo", !0) ?? !0, De = o(
    re,
    "freeDeliveryThreshold",
    14e3
  ), it = o(re, "mobileWidth", "100%"), nt = o(re, "maxMobileWidth", 480), rt = o(V, "text", "Bag"), ot = o(V, "fontSize", 20), st = o(V, "fontWeight", "600"), at = o(V, "textColor", "#111111"), lt = o(
    G,
    "emptyTitle",
    "Your bag is empty"
  ), ct = o(
    G,
    "emptySubtitle",
    "Items in your bag are not reserved — check out now to make them yours."
  ), Q = o(
    G,
    "continueShoppingText",
    "Continue Shopping"
  ), te = o(G, "showEmptyIcon", !0) ?? !0, Ne = o(Y, "text", "Checkout"), dt = o(
    Y,
    "backgroundColor",
    "#111111"
  ), Mt = o(Y, "textColor", "#FFFFFF"), Dt = o(Y, "borderRadius", 30), Wt = o(Y, "fontSize", 16), Ht = o(Y, "fontWeight", "500"), jt = o(Y, "padding", "16px 24px"), Vt = o(ie, "borderRadius", 0), Ut = o(
    ie,
    "boxShadow",
    "0 10px 25px rgba(0, 0, 0, 0.1)"
  ), Ct = o(ie, "zIndex", 50), qt = (D) => {
    D.target === D.currentTarget && (L(!1), K(Qe(!1)));
  }, Gt = () => {
    L(!1), K(Qe(!1));
    const D = Se("checkout", void 0, n);
    if (console.log("[CartSidebar] handleViewBag checkout URL:", D), l)
      try {
        l.push(D);
      } catch (J) {
        console.warn("Navigation failed:", J), typeof window < "u" && (window.location.href = D);
      }
    else typeof window < "u" && (window.location.href = D);
  }, Yt = () => {
    L(!1), K(Qe(!1));
    const D = At((n == null ? void 0 : n.home) || "home", i, {
      prefix: "template",
      includeSite: !0
    });
    if (l)
      try {
        l.push(D);
      } catch (J) {
        console.warn("Navigation failed:", J), typeof window < "u" && (window.location.href = D);
      }
    else typeof window < "u" && (window.location.href = D);
  }, Ge = lc(), Nt = (((Le = Ge == null ? void 0 : Ge.checkout) == null ? void 0 : Le.isLoading) ?? !1) || k, Xt = async () => {
    if (Ge)
      try {
        const D = await Ge.submitOrder();
        L(!1), K(Qe(!1));
        const J = D ? Ki((n == null ? void 0 : n.checkout) || "checkout", void 0, {
          orderId: D
        }) : Se("checkout", void 0, n);
        if (console.log("[CartSidebar] handleCheckout checkout URL:", J), l)
          try {
            l.push(J);
          } catch (le) {
            console.warn("Navigation failed:", le), typeof window < "u" && (console.log("Method 1 url", J), window.location.href = J);
          }
        else typeof window < "u" && (console.log("Method 2 url", J), window.location.href = J);
      } catch (D) {
        console.error("Checkout submit failed:", D);
      }
    else {
      L(!1), K(Qe(!1));
      const D = Se("checkout", void 0, n);
      if (console.log(
        "[CartSidebar] handleCheckout (no provider) checkout URL:",
        D
      ), l)
        try {
          l.push(D);
        } catch (J) {
          console.warn("Navigation failed:", J), typeof window < "u" && (console.log("Method 3 url", D), window.location.href = D);
        }
      else typeof window < "u" && (console.log("Method 4 url", D), window.location.href = D);
    }
  }, Qt = (D, J) => {
    const le = `Remove "${J || "this item"}" from cart?`;
    window.confirm(le) && (console.log("[CartSidebar] Removing item completely:", D), w(D));
  }, Jt = (D, J) => {
    console.log("[CartSidebar] Quantity change requested:", {
      variantId: D,
      newQuantity: J
    }), J > 0 && C(D, J);
  }, Zt = (D) => {
    var le;
    const J = tr(D);
    return J && J !== "Product" ? J : ((le = D.product) == null ? void 0 : le.title) || D.title || "Product";
  }, ei = (D) => {
    var Ce, xe, pe, Ie, Xe;
    const J = ir(D);
    if (J && J !== "Default Title")
      return J;
    const le = ((Ce = D.variant) == null ? void 0 : Ce.title) || ((Xe = (Ie = (pe = (xe = D.product) == null ? void 0 : xe.variants) == null ? void 0 : pe.find) == null ? void 0 : Ie.call(
      pe,
      (bt) => bt.id === (D.variant_id || D.variantId)
    )) == null ? void 0 : Xe.title);
    return le && le !== "Default" ? le : "";
  }, ti = (D) => {
    var le, Ce, xe, pe, Ie, Xe;
    const J = nr(D);
    return typeof J == "number" && J > 0 ? J : ((le = D.variant) == null ? void 0 : le.price) ?? ((Ie = (pe = (xe = (Ce = D.product) == null ? void 0 : Ce.variants) == null ? void 0 : xe.find) == null ? void 0 : pe.call(
      xe,
      (bt) => bt.id === (D.variant_id || D.variantId)
    )) == null ? void 0 : Ie.price) ?? ((Xe = D.product) == null ? void 0 : Xe.min_price) ?? D.price ?? 0;
  }, ii = (D) => {
    var le, Ce, xe, pe;
    const J = er(D);
    return J && J.trim().length > 0 ? J : D.image && typeof D.image == "string" && D.image.trim().length > 0 ? D.image : (Ce = (le = D.variant) == null ? void 0 : le.assets) != null && Ce.length ? ht(D.variant.assets[0], 200, 200) : (pe = (xe = D.product) == null ? void 0 : xe.assets) != null && pe.length ? ht(D.product.assets[0], 200, 200) : "";
  }, Kt = [
    z.featured.featured1,
    z.featured.featured2,
    z.featured.featured3,
    z.trending.trending1
  ], [W, Ye] = O(_);
  return U(() => {
    if (_)
      Ye(!0);
    else {
      const D = window.setTimeout(
        () => Ye(!1),
        Number(de) + 50
      );
      return () => window.clearTimeout(D);
    }
  }, [_, de]), W ? /* @__PURE__ */ p("div", { className: `nike-cart-sidebar-section ${e || ""}`, children: [
    /* @__PURE__ */ s(
      "div",
      {
        className: `fixed inset-0 transition-opacity ease-in-out ${_ ? "opacity-100" : "opacity-0 pointer-events-none"}`,
        style: {
          backgroundColor: ye,
          zIndex: Ct - 1,
          transitionDuration: `${de}ms`
        },
        onClick: qt
      }
    ),
    /* @__PURE__ */ p(
      "div",
      {
        className: `fixed top-0 right-0 h-full transform bg-white shadow-2xl transition-transform ease-in-out ${_ ? "translate-x-0" : "translate-x-full"}`,
        style: {
          width: `min(${ae}px, ${it})`,
          maxWidth: `${nt}px`,
          backgroundColor: ge,
          borderRadius: `${Vt}px`,
          boxShadow: Ut,
          zIndex: Ct,
          transitionDuration: `${de}ms`
        },
        children: [
          /* @__PURE__ */ p("div", { className: "flex items-center justify-between border-b border-gray-200 p-6", children: [
            /* @__PURE__ */ p(
              "h2",
              {
                style: {
                  fontSize: `${ot}px`,
                  fontWeight: st,
                  color: at
                },
                children: [
                  rt,
                  " (",
                  q.itemCount,
                  ")"
                ]
              }
            ),
            /* @__PURE__ */ s(
              "button",
              {
                onClick: () => {
                  L(!1), K(Qe(!1));
                },
                className: "rounded-full p-2 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600",
                "aria-label": "Close cart sidebar",
                children: /* @__PURE__ */ s(rn, { className: "h-5 w-5" })
              }
            )
          ] }),
          /* @__PURE__ */ s("div", { className: "flex h-full flex-col", children: M ? (
            // Empty Cart State
            /* @__PURE__ */ p("div", { className: "flex flex-1 flex-col items-center justify-center p-6 text-center", children: [
              te && /* @__PURE__ */ s("div", { className: "mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gray-100", children: /* @__PURE__ */ s(Vi, { className: "h-8 w-8 text-gray-400" }) }),
              /* @__PURE__ */ s("h3", { className: "mb-2 text-lg font-medium text-gray-900", children: lt }),
              /* @__PURE__ */ s("p", { className: "mb-6 text-sm text-gray-600", children: ct }),
              /* @__PURE__ */ s(
                "button",
                {
                  onClick: Yt,
                  className: "rounded-full bg-gray-900 px-6 py-3 font-medium text-white transition-colors hover:bg-gray-800",
                  children: Q
                }
              )
            ] })
          ) : (
            // Cart Items
            /* @__PURE__ */ p(se, { children: [
              /* @__PURE__ */ s("div", { className: "flex-1 overflow-y-auto p-6", children: /* @__PURE__ */ s("div", { className: "space-y-6", children: T.map((D, J) => {
                var Xe;
                console.log("Cart Item before render:", D);
                const le = Zt(D), Ce = m ? Kt[J % Kt.length] : ii(D), xe = ti(D), pe = ei(D), Ie = D.variant_id || D.variantId || D.id;
                return /* @__PURE__ */ p("div", { className: "flex space-x-4", children: [
                  /* @__PURE__ */ s("div", { className: "flex-shrink-0", children: /* @__PURE__ */ s(
                    $e,
                    {
                      src: Ce || "",
                      alt: le,
                      className: "h-24 w-24 rounded-lg object-cover",
                      showPlaceholderIcon: !0
                    }
                  ) }),
                  /* @__PURE__ */ p("div", { className: "flex-1 space-y-2", children: [
                    /* @__PURE__ */ s("h3", { className: "line-clamp-2 font-medium text-gray-900", children: le }),
                    pe && /* @__PURE__ */ s("p", { className: "text-sm text-gray-600", children: pe }),
                    /* @__PURE__ */ s("div", { className: "flex items-center space-x-2", children: /* @__PURE__ */ s("span", { className: "font-medium text-gray-900", children: He(xe) }) }),
                    /* @__PURE__ */ p("div", { className: "flex items-center justify-between", children: [
                      /* @__PURE__ */ p("div", { className: "flex items-center space-x-2", children: [
                        /* @__PURE__ */ s("label", { className: "text-sm text-gray-600", children: "Qty:" }),
                        /* @__PURE__ */ s(
                          "select",
                          {
                            value: String(D.quantity || 1),
                            onChange: (bt) => {
                              const vt = parseInt(bt.target.value);
                              console.log(
                                "[CartSidebar] Select onChange fired:",
                                {
                                  variantId: Ie,
                                  newQty: vt,
                                  currentQty: D.quantity
                                }
                              ), Jt(Ie, vt);
                            },
                            className: "rounded border border-gray-300 px-2 py-1 text-sm",
                            children: [
                              ...Array(
                                Math.max(
                                  1,
                                  Math.floor(((Xe = D.variant) == null ? void 0 : Xe.inventory) || 10)
                                )
                              )
                            ].map((bt, vt) => /* @__PURE__ */ s("option", { value: String(vt + 1), children: vt + 1 }, vt + 1))
                          },
                          `qty-${Ie}`
                        )
                      ] }),
                      /* @__PURE__ */ p("div", { className: "flex items-center space-x-2", children: [
                        /* @__PURE__ */ s(
                          "button",
                          {
                            className: "rounded-full p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600",
                            "aria-label": "Add to favorites",
                            children: /* @__PURE__ */ s(Jn, { className: "h-4 w-4" })
                          }
                        ),
                        /* @__PURE__ */ s(
                          "button",
                          {
                            onClick: () => Qt(Ie, le),
                            className: "rounded-full p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-red-600",
                            "aria-label": "Remove item",
                            children: /* @__PURE__ */ s(Zn, { className: "h-4 w-4" })
                          }
                        )
                      ] })
                    ] })
                  ] })
                ] }, Ie);
              }) }) }),
              /* @__PURE__ */ p("div", { className: "border-t border-gray-200 p-6", children: [
                qe && q.subtotal < De && /* @__PURE__ */ s("div", { className: "mb-4 rounded-lg bg-gray-50 p-3", children: /* @__PURE__ */ p("p", { className: "text-sm text-gray-600", children: [
                  "Add",
                  " ",
                  He(De - q.subtotal),
                  " ",
                  "more for free delivery"
                ] }) }),
                /* @__PURE__ */ p("div", { className: "mb-2 flex items-center justify-between", children: [
                  /* @__PURE__ */ s("span", { className: "text-sm text-gray-600", children: "Subtotal" }),
                  /* @__PURE__ */ s("span", { className: "text-sm text-gray-900", children: He(q.subtotal) })
                ] }),
                /* @__PURE__ */ p("div", { className: "mb-2 flex items-center justify-between", children: [
                  /* @__PURE__ */ s("span", { className: "text-sm text-gray-600", children: "Shipping" }),
                  /* @__PURE__ */ s("span", { className: "text-sm text-gray-900", children: q.shipping === 0 ? "Free" : He(q.shipping) })
                ] }),
                /* @__PURE__ */ p("div", { className: "mb-4 flex items-center justify-between border-t pt-2", children: [
                  /* @__PURE__ */ s("span", { className: "text-lg font-medium text-gray-900", children: "Total" }),
                  /* @__PURE__ */ s("span", { className: "text-lg font-medium text-gray-900", children: He(q.total) })
                ] }),
                /* @__PURE__ */ p("div", { className: "space-y-3", children: [
                  /* @__PURE__ */ s(
                    "button",
                    {
                      onClick: Xt,
                      className: "w-full rounded-full transition-colors hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed",
                      style: {
                        backgroundColor: dt,
                        color: Mt,
                        borderRadius: `${Dt}px`,
                        fontSize: `${Wt}px`,
                        fontWeight: Ht,
                        padding: jt
                      },
                      disabled: Nt,
                      children: Nt ? /* @__PURE__ */ p("span", { className: "inline-flex items-center justify-center", children: [
                        /* @__PURE__ */ s("span", { className: "animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" }),
                        /* @__PURE__ */ s("span", { children: "Processing..." })
                      ] }) : Ne
                    }
                  ),
                  /* @__PURE__ */ s(
                    "button",
                    {
                      onClick: Gt,
                      className: "w-full rounded-full border border-gray-300 px-6 py-3 font-medium text-black transition-colors hover:border-gray-400",
                      children: "View Bag"
                    }
                  )
                ] }),
                qe && /* @__PURE__ */ p("div", { className: "mt-4 text-center", children: [
                  /* @__PURE__ */ p("p", { className: "text-sm text-gray-600", children: [
                    "Free delivery on orders over",
                    " ",
                    He(De)
                  ] }),
                  /* @__PURE__ */ s("p", { className: "mt-1 text-xs text-gray-500", children: "Members get free delivery on any order" })
                ] })
              ] })
            ] })
          ) })
        ]
      }
    )
  ] }) : null;
}, uc = ue(dc, {
  identifier: "nike.nikenavigation.cartsidebar",
  title: "Cart Sidebar",
  featuredImage: "/public/placeholder.png",
  description: "Nike cart sidebar with full cart functionality, configurable styling, and responsive design",
  category: "navigation",
  className: "nike-cart-sidebar",
  components: Gi,
  defaultData: Cr(Gi),
  renderMode: "client"
}), Kr = [
  // Background Configuration
  F(
    "text-block",
    "topnav-config",
    {
      desktop: [
        { inputKey: "backgroundColor", type: "color", value: "#F5F5F5" },
        { inputKey: "textColor", type: "color", value: "#6B7280" },
        { inputKey: "linkHoverColor", type: "color", value: "#000000" },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "fontSize", type: "number", value: 12 }
      ],
      tablet: [{ inputKey: "paddingX", type: "number", value: 16 }],
      mobile: [{ inputKey: "paddingX", type: "number", value: 16 }]
    },
    {
      name: "TopNavbar Configuration",
      description: "Overall styling and spacing for the top navigation bar"
    }
  ),
  // Jordan Logo Configuration
  F(
    "text-block",
    "jordan-logo",
    {
      desktop: [
        { inputKey: "logoSize", type: "number", value: 24 },
        { inputKey: "logoColor", type: "color", value: "#000000" },
        { inputKey: "showLogo", type: "checkbox", value: !0 },
        { inputKey: "logoLink", type: "text", value: "/" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Jordan Logo",
      description: "Jordan logo configuration and styling"
    }
  ),
  // Utility Links Configuration
  F(
    "text-block",
    "utility-links",
    {
      desktop: [
        { inputKey: "findStoreText", type: "text", value: "Find a Store" },
        { inputKey: "findStoreLink", type: "text", value: "#" },
        { inputKey: "helpText", type: "text", value: "Help" },
        { inputKey: "helpLink", type: "text", value: "#" },
        { inputKey: "showSeparators", type: "checkbox", value: !0 },
        { inputKey: "separatorColor", type: "color", value: "#9CA3AF" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Utility Links",
      description: "Find a Store and Help links configuration"
    }
  ),
  // Authentication Links Configuration
  F(
    "text-block",
    "auth-links",
    {
      desktop: [
        { inputKey: "joinUsText", type: "text", value: "Join Us" },
        { inputKey: "joinUsLink", type: "text", value: "/nike/signup" },
        { inputKey: "signInText", type: "text", value: "Sign In" },
        { inputKey: "signInLink", type: "text", value: "/nike/signin" },
        { inputKey: "accountLink", type: "text", value: "/nike/account" },
        { inputKey: "signOutText", type: "text", value: "Sign Out" },
        { inputKey: "showAuthLinks", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Authentication Links",
      description: "Sign in, sign up, and account links configuration"
    }
  )
], pc = ({ data: t, className: e, routeContext: i, routes: n, viewportMode: r }) => {
  const o = (H, X, re) => {
    const V = H == null ? void 0 : H[r || "desktop"], G = V == null ? void 0 : V.find((Y) => Y.inputKey === X);
    return (G == null ? void 0 : G.value) ?? re;
  }, l = R(t, "text-block", "topnav-config", r), a = R(t, "text-block", "jordan-logo", r), d = R(t, "text-block", "utility-links", r), c = R(t, "text-block", "auth-links", r), u = ze(i ?? void 0), h = o(l, "backgroundColor", "#F5F5F5"), m = o(l, "textColor", "#6B7280"), v = o(l, "linkHoverColor", "#000000"), y = o(l, "paddingY", 8), f = o(l, "paddingX", 24), x = o(l, "fontSize", 12), b = o(a, "logoSize", 24), g = o(a, "logoColor", "#000000"), k = o(a, "showLogo", !0) !== !1, C = o(a, "logoLink", "") || Se("home", i, n, u), T = o(d, "findStoreText", "Find a Store"), I = o(d, "findStoreLink", "#"), E = o(d, "helpText", "Help"), P = o(d, "helpLink", "#"), S = o(d, "showSeparators", !0) !== !1, K = o(d, "separatorColor", "#9CA3AF"), _ = o(c, "joinUsText", "Join Us"), L = o(c, "joinUsLink", ""), N = o(c, "signInText", "Sign In"), $ = o(c, "signInLink", ""), A = o(c, "showAuthLinks", !0) !== !1, M = L || Se("signIn", i, n, u), q = $ || Se("signIn", i, n, u);
  return /* @__PURE__ */ p(se, { children: [
    /* @__PURE__ */ s("style", { children: `
        .topnav-link {
          color: ${m};
          transition: color 0.2s;
        }
        .topnav-link:hover {
          color: ${v};
        }
      ` }),
    /* @__PURE__ */ s(
      "nav",
      {
        className: `nike-topnavbar-section ${e || ""}`,
        style: {
          backgroundColor: String(h),
          color: String(m),
          paddingTop: `${y}px`,
          paddingBottom: `${y}px`,
          fontSize: `${x}px`
        },
        children: /* @__PURE__ */ p(
          "div",
          {
            className: "flex items-center justify-between",
            style: {
              paddingLeft: `${f}px`,
              paddingRight: `${f}px`
            },
            children: [
              k && /* @__PURE__ */ s(
                "a",
                {
                  href: String(C),
                  className: "flex items-center transition-colors duration-200 hover:opacity-80",
                  children: /* @__PURE__ */ s(
                    "svg",
                    {
                      "aria-hidden": "true",
                      focusable: "false",
                      viewBox: "0 0 24 24",
                      role: "img",
                      style: {
                        height: `${b}px`,
                        width: `${b}px`,
                        fill: String(g)
                      },
                      children: /* @__PURE__ */ s(
                        "path",
                        {
                          fill: "currentColor",
                          fillRule: "evenodd",
                          d: "M13.182 3.733c-.012-.039-.012-.039-.012-.072a.966.966 0 01.922-1.007.97.97 0 011.007.922.964.964 0 01-.917 1.007c-.027.004-.062 0-.101 0-.016.004-.04.004-.056.022-.056.084.14.073-.005.44 0 0 0 .038-.012.077-.012.14-.08.562-.096.793.029.04.04.05.029.13a6.003 6.003 0 01-.09.534c-.04.14-.096.174-.147.202-.073.298-.095.545-.281.905-.022.276-.045.35-.106.484-.017.4.01.46-.281 1.101-.08.3-.017.507.05.821.068.321.276.461.298.793.05.771.017 1.305-.163 1.907l.135.348c.18.084.618.326.36.675.343.19.865.394 1.28.781.176.147.35.315.513.5.316.057.276.08.506.231.675.438 1.749 1.304 2.373 1.906.112.067.147.112.236.163.01.023.017.034.01.04-.026.072-.026.072-.06.14.039.04.095.073.134.107.04.005.04-.006.096-.017.079.073.18.135.214.135.106-.022.084-.005.185-.1.029-.035.084 0 .084 0 .04-.04.113-.119.214-.176.079-.045.23-.045.23-.045.052.006.04.051.029.073-.057.023-.18.057-.247.108-.152.14-.276.353-.276.353.299-.033.484.045.719.023.136-.005.237.006.377-.09 0 0 .14-.096.265-.14.118-.05.23-.017.33.062.069.084.119.084 0 .196-.044.045-.1.096-.18.17-.133.123-.313.291-.5.432a3.11 3.11 0 01-.527.315c-.338.23-.26.174-.523.394-.03.022-.124.078-.163.106-.107.062-.135.006-.197-.118 0 0-.028-.045-.08-.14-.05-.107-.09-.23-.072-.23-.062-.007-.331-.344-.331-.41-.063-.013-.304-.26-.31-.31l-.214-.18c-.253.044-.31-.113-.961-.608-.08-.006-.197-.05-.36-.174-.298-.253-1.007-.815-1.124-.883-.13-.067-.281-.134-.383-.214-.146-.022-.218-.05-.298-.067-.08-.022-.14-.057-.326-.079-.303-.045-.618-.18-.911-.337-.14-.073-.264-.107-.382-.169-.27-.124-.506-.236-.686-.28a2.148 2.148 0 01-.568-.226c-.061-.034-.095-.06-.134-.073-.09-.022-.153.006-.192.022-.23.108-.438.203-.636.31-.18.09-.348.186-.528.286a7.971 7.971 0 01-.534.254s-.534.253-.832.348c-.26.197-.787.546-1.107.715-.158.073-.467.252-.608.292-.08.061-.371.258-.596.421-.18.124-.31.231-.31.231-.106.084-.101.13-.28.045a1.491 1.491 0 00-.13.096c-.14.095-.146.073-.202.067-.101.08-.113.04-.197.13-.061.084 0 .061-.118.106-.028.006-.04.04-.057.056-.094.073-.1.293-.325.304-.135.09-.107.203-.197.191 0 .102-.18.23-.214.23-.292.096-.304-.118-.646.035-.045.016-.113.072-.197.084-.152.022-.332-.006-.444-.102a1.93 1.93 0 01-.326-.398c-.051-.13-.017-.208.163-.332.073-.045.084-.079.208-.084.06-.024.045.01.15-.024.064-.016.064-.005.193-.005.028-.017.067-.022.124-.045.1-.034.196-.062.196-.062s.028-.023.124-.01c.078-.035.169-.08.214-.097-.012-.124.005-.124.06-.174.08-.062.09-.05.148-.01.022-.007.039-.013.027-.035-.01-.073-.061-.107-.045-.247-.022-.057-.061-.129-.05-.174.01-.045.028-.069.056-.079.029-.012.045.006.057.022.028.034.05.135.05.135.006.118.04.26.152.18.067-.062.084-.242.214-.203l.096.085c.084-.073.084-.073.14-.107 0 0-.08-.073-.012-.135.045-.039.108-.067.208-.175.276-.292.422-.42.714-.657a6.811 6.811 0 011.699-.939c.146-.174.28-.286.585-.304.377-.606 1.085-1.136 1.248-1.22.134-.23.19-.208.365-.247.135-.107.175-.107.23-.214.063-.23-.112-.86.383-.877.112-.146.078-.112.196-.248a2.19 2.19 0 01-.118-.5c-.005-.016-.196-.157-.13-.332a2.33 2.33 0 01-.268-.432.202.202 0 01-.063-.012c-.022-.005-.055-.005-.09-.005-.078.196-.163.208-.303.253-.26.512-.35.731-1.046 1.142-.28.298-.382.64-.382.634a.46.46 0 00-.012.321c-.045.107-.027.124-.027.124.01.045.056.106.106.112.079.023.169.023.158.118-.011.113-.163.09-.237.073-.275-.05-.185-.23-.365-.174-.141.085-.196.348-.416.31-.028-.023-.017-.074.006-.119.028-.06.084-.118.056-.14-.146.04-.433.123-.433.123-.135.04-.281-.039-.147-.124.063-.022.153-.05.265-.118 0 0 .062-.072-.057-.039a1.144 1.144 0 01-.416.045s-.257-.039-.292-.056c-.028-.022-.061-.107.017-.1a2.71 2.71 0 00.563-.068c.095-.035.28-.14.382-.186 0 0 .113-.157.18-.19.107-.114.19-.18.28-.299.09-.18.192-.46.5-.906a4.16 4.16 0 01.535-.646s.062-.338.343-.573c.063-.14.157-.31.259-.462a1.7 1.7 0 00.106-.168c.09-.13.186-.377.518-.41 0 0 .147-.102.197-.175.084-.073.074-.186.14-.259-.106-.106-.365-.309-.382-.573a.85.85 0 01.265-.692c.196-.185.398-.275.646-.258.309.055.366.157.455.258.09.101.13.04.163.146.259.073.248.045.237.236.045.057.106.108.1.214.085-.175.108-.208.344-.399.062-.157.1-.315.15-.478.052-.146.114-.298.154-.41-.04-.326.06-.377.196-.664-.022-.039-.016-.05-.006-.112.057-.192.136-.433.186-.596 0 0 .017-.063.085-.063.06-.202.157-.579.179-.663.062-.208.029-.287-.01-.41-.012-.04-.006-.09-.03-.136a5.483 5.483 0 01-.19-.41c-.028-.073-.08-.354-.08-.354-.004-.062-.004-.09-.004-.09z",
                          clipRule: "evenodd"
                        }
                      )
                    }
                  )
                }
              ),
              /* @__PURE__ */ p("div", { className: "flex items-center gap-4", children: [
                /* @__PURE__ */ s("a", { href: String(I), className: "topnav-link", children: T }),
                S && /* @__PURE__ */ s("span", { style: { color: String(K) }, children: "|" }),
                /* @__PURE__ */ s("a", { href: String(P), className: "topnav-link", children: E }),
                S && /* @__PURE__ */ s("span", { style: { color: String(K) }, children: "|" }),
                A && /* @__PURE__ */ p(se, { children: [
                  /* @__PURE__ */ s("a", { href: String(M), className: "topnav-link", children: _ }),
                  S && /* @__PURE__ */ s("span", { style: { color: String(K) }, children: "|" }),
                  /* @__PURE__ */ s("a", { href: String(q), className: "topnav-link", children: N })
                ] })
              ] })
            ]
          }
        )
      }
    )
  ] });
}, mc = Kr.reduce(
  (t, e) => (t[e.componentIdentifier] = e.data, t),
  {}
), hc = ue(pc, {
  identifier: "nike.nikenavigation.topnavbar",
  title: "Top Bar",
  featuredImage: "/public/placeholder.png",
  description: "Nike utility navigation bar with Jordan logo, Find a Store, Help, and authentication links",
  category: "navigation",
  className: "nike-topnavbar",
  components: Kr,
  defaultData: mc,
  renderMode: "client"
}), gc = [
  // Section Configuration
  F(
    "text-block",
    "section-config",
    {
      desktop: [
        { inputKey: "showDelivery", type: "checkbox", value: !0 },
        { inputKey: "showSustainability", type: "checkbox", value: !0 },
        { inputKey: "showReviews", type: "checkbox", value: !0 },
        { inputKey: "showProductInfo", type: "checkbox", value: !0 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Section Configuration",
      description: "Configure which detail sections to show"
    }
  ),
  // Delivery & Returns Configuration
  F(
    "text-block",
    "delivery-config",
    {
      desktop: [
        { inputKey: "title", type: "text", value: "Delivery & Returns" },
        {
          inputKey: "content",
          type: "text",
          value: "Free standard delivery on orders over ₹14,000. Express delivery available. Free returns within 30 days."
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Delivery & Returns",
      description: "Delivery and returns information"
    }
  ),
  // Sustainability Configuration
  F(
    "text-block",
    "sustainability-config",
    {
      desktop: [
        { inputKey: "title", type: "text", value: "How This Was Made" },
        {
          inputKey: "content",
          type: "text",
          value: "We use recycled polyester made from plastic bottles to create the upper of this shoe, helping to reduce waste and our impact on the environment."
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Sustainability Info",
      description: "How the product was made sustainably"
    }
  ),
  // Reviews Configuration
  F(
    "text-block",
    "reviews-config",
    {
      desktop: [
        { inputKey: "title", type: "text", value: "Reviews" },
        { inputKey: "reviewCount", type: "number", value: 808 },
        { inputKey: "rating", type: "number", value: 4.8 },
        {
          inputKey: "summary",
          type: "text",
          value: "4.8 out of 5 stars based on 808 reviews. Customers love the comfort and classic style."
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Reviews Configuration",
      description: "Product reviews and ratings"
    }
  ),
  // Product Information Configuration
  F(
    "text-block",
    "product-info-config",
    {
      desktop: [
        { inputKey: "title", type: "text", value: "Product Information" },
        {
          inputKey: "content",
          type: "text",
          value: "Leather and synthetic upper. Rubber outsole. Foam midsole. Classic basketball-inspired design."
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product Information",
      description: "Detailed product specifications"
    }
  )
], fc = ({ data: t, viewportMode: e }) => {
  const [i, n] = O(
    /* @__PURE__ */ new Set()
  ), r = R(
    t,
    "text-block",
    "section-config",
    e
  ), o = R(t, "text-block", "delivery-config", e), l = R(
    t,
    "text-block",
    "sustainability-config",
    e
  ), a = R(t, "text-block", "reviews-config", e), d = R(
    t,
    "text-block",
    "product-info-config",
    e
  ), c = B(r, "showDelivery", !0), u = B(r, "showSustainability", !0), h = B(r, "showReviews", !0), m = B(r, "showProductInfo", !0), v = (x) => {
    const b = new Set(i);
    b.has(x) ? b.delete(x) : b.add(x), n(b);
  }, y = (x, b, g, k = !1, w, C) => {
    const T = i.has(x);
    return /* @__PURE__ */ p("div", { className: "border-b border-gray-200", children: [
      /* @__PURE__ */ p(
        "button",
        {
          onClick: () => v(x),
          className: "flex w-full items-center justify-between py-4 text-left focus:outline-none",
          children: [
            /* @__PURE__ */ p("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ s("h4", { className: "text-base font-medium text-black", children: b }),
              k && w && /* @__PURE__ */ p("div", { className: "flex items-center gap-1", children: [
                /* @__PURE__ */ p("span", { className: "text-sm text-gray-600", children: [
                  "(",
                  w,
                  ")"
                ] }),
                /* @__PURE__ */ s("div", { className: "flex items-center", children: [...Array(5)].map((I, E) => /* @__PURE__ */ s(
                  "svg",
                  {
                    className: `h-4 w-4 ${E < Math.floor(C || 0) ? "text-yellow-400" : "text-gray-300"}`,
                    fill: "currentColor",
                    viewBox: "0 0 20 20",
                    children: /* @__PURE__ */ s("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" })
                  },
                  E
                )) })
              ] })
            ] }),
            /* @__PURE__ */ s(
              "svg",
              {
                className: `h-5 w-5 text-gray-400 transition-transform ${T ? "rotate-180" : ""}`,
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M19 9l-7 7-7-7"
                  }
                )
              }
            )
          ]
        }
      ),
      T && /* @__PURE__ */ s("div", { className: "pb-4", children: /* @__PURE__ */ s("p", { className: "text-sm text-gray-600", children: g }) })
    ] }, x);
  }, f = [];
  if (c) {
    const x = B(o, "title", "Delivery & Returns"), b = B(o, "content", "");
    f.push({ id: "delivery", title: x, content: b });
  }
  if (u) {
    const x = B(l, "title", "How This Was Made"), b = B(l, "content", "");
    f.push({ id: "sustainability", title: x, content: b });
  }
  if (h) {
    const x = B(a, "title", "Reviews"), b = B(a, "summary", ""), g = B(a, "reviewCount", 0), k = B(a, "rating", 0);
    f.push({
      id: "reviews",
      title: x,
      content: b,
      isReviews: !0,
      reviewCount: g,
      rating: k
    });
  }
  if (m) {
    const x = B(d, "title", "Product Information"), b = B(d, "content", "");
    f.push({ id: "productInfo", title: x, content: b });
  }
  return f.length === 0 ? null : /* @__PURE__ */ s("section", { className: "mt-8", children: /* @__PURE__ */ s("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8", children: /* @__PURE__ */ s("div", { className: "space-y-0", children: f.map(
    (x) => y(
      x.id,
      x.title,
      x.content,
      x.isReviews,
      x.reviewCount,
      x.rating
    )
  ) }) }) });
}, yc = ue(fc, {
  identifier: "nike.nikeproduct.productdetails",
  title: "Product Details",
  featuredImage: z.previews.trending,
  description: "Expandable product detail sections for delivery, sustainability, reviews, and specifications",
  category: "nike",
  className: "nike-product-details",
  components: gc,
  renderMode: "client"
});
function Fi() {
  const t = new URLSearchParams(window.location.search);
  return console.log("Query param received", t.get("category")), t.get("category");
}
const bc = [
  // Section Title Component
  F(
    "heading-text",
    "product-grid-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Our Products" },
        { inputKey: "level", type: "select", value: "2" },
        { inputKey: "fontSize", type: "number", value: 48 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "marginBottom", type: "number", value: 48 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "marginBottom", type: "number", value: 32 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 24 },
        { inputKey: "marginBottom", type: "number", value: 24 }
      ]
    },
    {
      name: "Section Title",
      description: "Main heading for the Product Grid section"
    }
  ),
  // Grid Configuration Component
  F(
    "text-block",
    "grid-config",
    {
      desktop: [
        { inputKey: "columns", type: "number", value: 3 },
        { inputKey: "gap", type: "number", value: 16 },
        { inputKey: "showPrices", type: "checkbox", value: !0 },
        { inputKey: "showCategories", type: "checkbox", value: !0 },
        { inputKey: "showHoverEffects", type: "checkbox", value: !0 }
      ],
      tablet: [
        { inputKey: "columns", type: "number", value: 2 },
        { inputKey: "gap", type: "number", value: 16 }
      ],
      mobile: [
        { inputKey: "columns", type: "number", value: 1 },
        { inputKey: "gap", type: "number", value: 16 }
      ]
    },
    {
      name: "Grid Configuration",
      description: "Grid layout and display options"
    }
  ),
  // Product 1 Components
  F(
    "background-image",
    "product-1-image",
    {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: z.trending.trending1
        },
        { inputKey: "backgroundSize", type: "select", value: "cover" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "aspectRatio", type: "select", value: "square" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 1 Image",
      description: "Image for the first product"
    }
  ),
  F(
    "heading-text",
    "product-1-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Nike Air Max 270" },
        { inputKey: "level", type: "select", value: "4" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "semibold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "lineHeight", type: "number", value: 1.4 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 1 Title",
      description: "Title for the first product"
    }
  ),
  F(
    "text-block",
    "product-1-category",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Men's Shoes" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#6B7280" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 1 Category",
      description: "Category for the first product"
    }
  ),
  F(
    "heading-text",
    "product-1-price",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "MRP : ₹ 12,995.00" },
        { inputKey: "level", type: "select", value: "5" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "textColor", type: "color", value: "#000000" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 1 Price",
      description: "Price for the first product"
    }
  ),
  // Product 2 Components
  F(
    "background-image",
    "product-2-image",
    {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: z.trending.trending2
        },
        { inputKey: "backgroundSize", type: "select", value: "cover" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "aspectRatio", type: "select", value: "square" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 2 Image",
      description: "Image for the second product"
    }
  ),
  F(
    "heading-text",
    "product-2-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Nike React Infinity Run" },
        { inputKey: "level", type: "select", value: "4" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "semibold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "lineHeight", type: "number", value: 1.4 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 2 Title",
      description: "Title for the second product"
    }
  ),
  F(
    "text-block",
    "product-2-category",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Women's Running Shoes" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#6B7280" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 2 Category",
      description: "Category for the second product"
    }
  ),
  F(
    "heading-text",
    "product-2-price",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "MRP : ₹ 14,995.00" },
        { inputKey: "level", type: "select", value: "5" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "textColor", type: "color", value: "#000000" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 2 Price",
      description: "Price for the second product"
    }
  ),
  // Product 3 Components
  F(
    "background-image",
    "product-3-image",
    {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: z.trending.trending3
        },
        { inputKey: "backgroundSize", type: "select", value: "cover" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "aspectRatio", type: "select", value: "square" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 3 Image",
      description: "Image for the third product"
    }
  ),
  F(
    "heading-text",
    "product-3-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Nike Dri-FIT ADV" },
        { inputKey: "level", type: "select", value: "4" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "semibold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "lineHeight", type: "number", value: 1.4 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 3 Title",
      description: "Title for the third product"
    }
  ),
  F(
    "text-block",
    "product-3-category",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Women's Training Top" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#6B7280" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 3 Category",
      description: "Category for the third product"
    }
  ),
  F(
    "heading-text",
    "product-3-price",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "MRP : ₹ 4,995.00" },
        { inputKey: "level", type: "select", value: "5" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "textColor", type: "color", value: "#000000" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 3 Price",
      description: "Price for the third product"
    }
  ),
  // Load More Button
  F(
    "button-solid",
    "load-more-btn",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Load More Products" },
        { inputKey: "button-color", type: "color", value: "#000000" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 32 },
        { inputKey: "paddingY", type: "number", value: 12 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Load More Button",
      description: "Button to load additional products"
    }
  )
], vc = ({
  data: t,
  className: e,
  theme: i,
  storeId: n,
  viewportMode: r
}) => {
  const o = me(), l = tt(), a = Ue(hl), d = Ue(gl), c = Ue(fl), [u, h] = Z.useState(1), [m] = Z.useState(12), [v, y] = Z.useState(
    {}
  ), f = Z.useMemo(() => {
    const N = {
      page: u,
      limit: m
    };
    return Fi() && (N.categorySlug = Fi(), console.log("Query param received", Fi())), v.tag && Array.isArray(v.tag) && (N.tags = v.tag), v.status && (N.status = v.status), v.price && (v.price.min !== null && (N.min_price = v.price.min), v.price.max !== null && (N.max_price = v.price.max)), N;
  }, [u, m, v]);
  Z.useEffect(() => {
    o || l(Ko(f));
  }, [l, f, o]), Z.useEffect(() => {
    if (o)
      return;
    const N = (A) => {
      const { filters: M } = A.detail;
      y(M), h(1);
    };
    window.addEventListener(
      "productFiltersChanged",
      N
    );
    const $ = localStorage.getItem("productFilters");
    if ($)
      try {
        y(JSON.parse($));
      } catch (A) {
        console.warn("Failed to parse saved filters:", A);
      }
    return () => {
      window.removeEventListener(
        "productFiltersChanged",
        N
      );
    };
  }, [o]);
  const x = (N) => {
    h(N), window.scrollTo({ top: 0, behavior: "smooth" });
  }, b = d, g = R(
    t,
    "heading-text",
    "product-grid-title",
    r
  ), k = R(
    t,
    "text-block",
    "grid-config",
    r
  ), w = t, C = (w == null ? void 0 : w.columns) || B(k, "columns", 3), T = (w == null ? void 0 : w.gap) || B(k, "gap", 24), I = (w == null ? void 0 : w.showPrices) !== void 0 ? w.showPrices : B(k, "showPrices", !0), E = (w == null ? void 0 : w.showCategories) !== void 0 ? w.showCategories : B(k, "showCategories", !0), P = (w == null ? void 0 : w.showHoverEffects) !== void 0 ? w.showHoverEffects : B(k, "showHoverEffects", !0);
  let S = [];
  if (o)
    S = mr().map((N) => {
      var $, A, M, q, H;
      return {
        imageData: null,
        titleData: null,
        categoryData: null,
        priceData: null,
        defaultImage: ((M = (A = ($ = N.assets) == null ? void 0 : $[0]) == null ? void 0 : A.asset) == null ? void 0 : M.path) || z.trending.trending1,
        defaultTitle: N.title || "Product",
        defaultCategory: N.collectionName || "Category",
        defaultPrice: `MRP : ${He(((H = (q = N.variants) == null ? void 0 : q[0]) == null ? void 0 : H.price) || 0)}`,
        altText: N.title || "Product"
      };
    });
  else if (a && a.length > 0)
    S = a.map((N) => {
      var $, A, M, q;
      return {
        imageData: null,
        titleData: null,
        categoryData: null,
        priceData: null,
        defaultImage: (($ = N.images) == null ? void 0 : $[0]) || "public/placeholder.png",
        defaultTitle: N.title || "Product",
        defaultCategory: ((A = N.tags) == null ? void 0 : A[0]) || "Category",
        defaultPrice: `MRP : ${He(((q = (M = N.variants) == null ? void 0 : M[0]) == null ? void 0 : q.price) || 0)}`,
        altText: N.title || "Product"
      };
    });
  else {
    const N = w == null ? void 0 : w.products;
    S = N && Array.isArray(N) ? N.map(($, A) => ({
      imageData: null,
      titleData: null,
      categoryData: null,
      priceData: null,
      defaultImage: $.image || "public/placeholder.png",
      defaultTitle: $.title || `Product ${A + 1}`,
      defaultCategory: $.category || "Category",
      defaultPrice: $.price || "Price not available",
      altText: $.title || `Product ${A + 1}`
    })) : [
      {
        imageData: R(
          t,
          "background-image",
          "product-1-image",
          r
        ),
        titleData: R(
          t,
          "heading-text",
          "product-1-title",
          r
        ),
        categoryData: R(
          t,
          "text-block",
          "product-1-category",
          r
        ),
        priceData: R(
          t,
          "heading-text",
          "product-1-price",
          r
        ),
        defaultImage: z.trending.trending1,
        defaultTitle: "Nike Air Max 270",
        defaultCategory: "Men's Shoes",
        defaultPrice: "MRP : ₹ 12,995.00",
        altText: "Nike Air Max 270"
      },
      {
        imageData: R(
          t,
          "background-image",
          "product-2-image",
          r
        ),
        titleData: R(
          t,
          "heading-text",
          "product-2-title",
          r
        ),
        categoryData: R(
          t,
          "text-block",
          "product-2-category",
          r
        ),
        priceData: R(
          t,
          "heading-text",
          "product-2-price",
          r
        ),
        defaultImage: z.trending.trending2,
        defaultTitle: "Nike React Infinity Run",
        defaultCategory: "Women's Running Shoes",
        defaultPrice: "MRP : ₹ 14,995.00",
        altText: "Nike React Infinity Run"
      },
      {
        imageData: R(
          t,
          "background-image",
          "product-3-image",
          r
        ),
        titleData: R(
          t,
          "heading-text",
          "product-3-title",
          r
        ),
        categoryData: R(
          t,
          "text-block",
          "product-3-category",
          r
        ),
        priceData: R(
          t,
          "heading-text",
          "product-3-price",
          r
        ),
        defaultImage: z.trending.trending3,
        defaultTitle: "Nike Dri-FIT ADV",
        defaultCategory: "Women's Training Top",
        defaultPrice: "MRP : ₹ 4,995.00",
        altText: "Nike Dri-FIT ADV"
      }
    ];
  }
  const K = b, _ = S, L = () => {
    const N = "grid gap-4", A = {
      1: "lg:grid-cols-1",
      2: "lg:grid-cols-2",
      3: "lg:grid-cols-3",
      4: "lg:grid-cols-4",
      5: "lg:grid-cols-5",
      6: "lg:grid-cols-6"
    }[C] || "lg:grid-cols-3";
    return `${N} grid-cols-1 md:grid-cols-2 ${A}`;
  };
  return K ? /* @__PURE__ */ s(
    "section",
    {
      className: `nike-product-grid-section ${e || ""} bg-white py-12 lg:py-16`,
      children: /* @__PURE__ */ s("div", { className: "container mx-auto px-2 sm:px-3 lg:px-4", children: /* @__PURE__ */ p("div", { className: "text-center", children: [
        /* @__PURE__ */ s("div", { className: "animate-spin rounded-full h-12 w-12 border-b-2 border-black mx-auto" }),
        /* @__PURE__ */ s("p", { className: "mt-4 text-gray-600", children: "Loading products..." })
      ] }) })
    }
  ) : !K && _.length === 0 && Object.keys(v).length > 0 ? /* @__PURE__ */ s(
    "section",
    {
      className: `nike-product-grid-section ${e || ""} bg-white py-12 lg:py-16`,
      children: /* @__PURE__ */ s("div", { className: "container mx-auto px-2 sm:px-3 lg:px-4", children: /* @__PURE__ */ p("div", { className: "text-center", children: [
        /* @__PURE__ */ s("p", { className: "text-gray-600", children: "No products match your filters." }),
        /* @__PURE__ */ s(
          "button",
          {
            onClick: () => {
              y({}), localStorage.removeItem("productFilters"), window.dispatchEvent(
                new CustomEvent("productFiltersChanged", {
                  detail: { filters: {} }
                })
              );
            },
            className: "mt-4 text-black underline hover:no-underline",
            children: "Clear all filters"
          }
        )
      ] }) })
    }
  ) : /* @__PURE__ */ s(
    "section",
    {
      className: `nike-product-grid-section ${e || ""} bg-white py-12 lg:py-16`,
      children: /* @__PURE__ */ p("div", { className: "container mx-auto px-2 sm:px-3 lg:px-4", children: [
        /* @__PURE__ */ s("div", { className: "mb-8 sm:mb-12", children: /* @__PURE__ */ s(
          "h2",
          {
            className: "font-bold text-black",
            style: {
              fontSize: `${String(B(g, "fontSize", 48))}px`,
              color: String(B(g, "textColor", "#000000")),
              textAlign: B(g, "textAlign", "left"),
              marginBottom: `${String(B(g, "marginBottom", 48))}px`
            },
            children: B(g, "text", "Our Products")
          }
        ) }),
        /* @__PURE__ */ s("div", { className: L(), style: { gap: `${T}px` }, children: _.map((N, $) => /* @__PURE__ */ p(
          "div",
          {
            className: `group cursor-pointer p-1 ${P ? "transition-transform duration-300 hover:scale-105" : ""}`,
            children: [
              /* @__PURE__ */ s("div", { className: "relative mb-4 overflow-hidden rounded-lg bg-gray-100 sm:mb-6", children: /* @__PURE__ */ s(
                "img",
                {
                  src: B(N.imageData, "assetId", N.defaultImage),
                  alt: N.altText,
                  className: `aspect-square w-full object-cover ${P ? "transition-transform duration-500 group-hover:scale-110" : ""}`,
                  style: {
                    borderRadius: `${String(B(N.imageData, "borderRadius", 8))}px`
                  }
                }
              ) }),
              /* @__PURE__ */ p("div", { className: "space-y-2 sm:space-y-3 px-1", children: [
                /* @__PURE__ */ s(
                  "h4",
                  {
                    className: P ? "transition-colors group-hover:text-gray-600" : "",
                    style: {
                      fontSize: `${String(B(N.titleData, "fontSize", 16))}px`,
                      color: String(B(N.titleData, "textColor", "#000000")),
                      fontWeight: String(B(N.titleData, "fontWeight", "semibold")),
                      lineHeight: String(B(N.titleData, "lineHeight", 1.4))
                    },
                    children: B(N.titleData, "text", N.defaultTitle)
                  }
                ),
                E && /* @__PURE__ */ s(
                  "p",
                  {
                    style: {
                      fontSize: `${String(B(N.categoryData, "fontSize", 14))}px`,
                      color: String(B(N.categoryData, "textColor", "#6B7280")),
                      fontWeight: String(B(N.categoryData, "fontWeight", "normal"))
                    },
                    children: B(N.categoryData, "text", N.defaultCategory)
                  }
                ),
                I && /* @__PURE__ */ s(
                  "h5",
                  {
                    style: {
                      fontSize: `${String(B(N.priceData, "fontSize", 14))}px`,
                      color: String(B(N.priceData, "textColor", "#000000")),
                      fontWeight: String(B(N.priceData, "fontWeight", "medium"))
                    },
                    children: B(N.priceData, "text", N.defaultPrice)
                  }
                )
              ] })
            ]
          },
          $
        )) }),
        Ot() && /* @__PURE__ */ p("div", { className: "mt-4 p-2 bg-gray-100 text-xs", children: [
          "Debug: pagination = ",
          JSON.stringify(c),
          ", currentPage =",
          " ",
          u,
          ", products.length = ",
          (a == null ? void 0 : a.length) || 0
        ] }),
        (c && c.totalPages > 1 || a && a.length >= m) && /* @__PURE__ */ p("div", { className: "mt-8 flex justify-center items-center space-x-1 sm:mt-12", children: [
          /* @__PURE__ */ s(
            "button",
            {
              onClick: () => x(u - 1),
              disabled: u <= 1,
              className: `px-3 py-2 text-sm font-medium border rounded-md transition-colors ${u <= 1 ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`,
              children: "Previous"
            }
          ),
          (() => {
            const N = [], $ = (c == null ? void 0 : c.totalPages) || Math.max(
              5,
              Math.ceil(((a == null ? void 0 : a.length) || m) / m * 3)
            );
            for (let A = 1; A <= $; A++)
              N.push(
                /* @__PURE__ */ s(
                  "button",
                  {
                    onClick: () => x(A),
                    className: `px-3 py-2 text-sm font-medium border rounded-md transition-colors ${A === u ? "bg-black text-white border-black" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`,
                    children: A
                  },
                  A
                )
              );
            return N;
          })(),
          /* @__PURE__ */ s(
            "button",
            {
              onClick: () => x(u + 1),
              disabled: c ? u >= c.totalPages : u >= 10,
              className: `px-3 py-2 text-sm font-medium border rounded-md transition-colors ${(c ? u >= c.totalPages : u >= 10) ? "bg-gray-100 text-gray-400 border-gray-200 cursor-not-allowed" : "bg-white text-gray-700 border-gray-300 hover:bg-gray-50"}`,
              children: "Next"
            }
          )
        ] }),
        (c || (a == null ? void 0 : a.length) > 0) && /* @__PURE__ */ s("div", { className: "mt-4 text-center text-sm text-gray-600", children: c ? /* @__PURE__ */ p(se, { children: [
          "Showing ",
          (u - 1) * m + 1,
          " to",
          " ",
          Math.min(u * m, c.total),
          " of",
          " ",
          c.total,
          " products"
        ] }) : /* @__PURE__ */ p(se, { children: [
          "Showing ",
          (a == null ? void 0 : a.length) || 0,
          " products"
        ] }) })
      ] })
    }
  );
}, xc = ue(vc, {
  identifier: "nike.nikeproduct.productgrid",
  title: "Product Grid",
  featuredImage: z.previews.trending,
  description: "Configurable responsive grid for displaying Nike products with flexible layout options",
  category: "nike",
  className: "nike-product-grid",
  components: bc,
  renderMode: "client"
}), kc = (t, e) => typeof window > "u" || !t ? Promise.resolve(e) : new Promise((i) => {
  const n = new Image(), r = window.setTimeout(() => {
    n.onload = null, n.onerror = null, i(e);
  }, 2500);
  n.onload = () => {
    window.clearTimeout(r), i(t);
  }, n.onerror = () => {
    window.clearTimeout(r), i(e);
  }, n.src = t;
}), wc = ({
  images: t,
  productName: e,
  showHighlyRated: i,
  showImageCounter: n,
  showNavigationArrows: r,
  aspectRatio: o,
  borderRadius: l,
  backgroundColor: a,
  thumbnailSize: d,
  thumbnailGap: c,
  selectedBorderColor: u,
  defaultBorderColor: h,
  thumbnailPosition: m,
  badgeText: v,
  badgeBackgroundColor: y,
  badgeTextColor: f,
  starColor: x
}) => {
  var K, _;
  const b = Ke(() => Ta(), []), [g, k] = O(0), [w, C] = O(t), T = m === "bottom";
  U(() => {
    let L = !1;
    return (async () => {
      var q;
      const $ = t.length > 0 ? t : me() ? b : [], A = ((q = b[0]) == null ? void 0 : q.url) || "/placeholder.png", M = await Promise.all(
        $.map(async (H, X) => {
          var V;
          const re = me() ? await kc(
            H.url,
            ((V = b[X % b.length]) == null ? void 0 : V.url) || A
          ) : H.url;
          return {
            ...H,
            url: re || A
          };
        })
      );
      L || (C(M), k(
        (H) => M.length === 0 ? 0 : Math.min(H, M.length - 1)
      ));
    })(), () => {
      L = !0;
    };
  }, [b, t]);
  const I = w.length > 0 ? w : me() ? b : [], E = (L) => {
    k(L);
  }, P = () => {
    k((L) => L > 0 ? L - 1 : I.length - 1);
  }, S = () => {
    k((L) => L < I.length - 1 ? L + 1 : 0);
  };
  return I.length ? /* @__PURE__ */ p("div", { className: `flex gap-4 ${T ? "flex-col" : ""}`, children: [
    /* @__PURE__ */ s(
      "div",
      {
        className: `flex gap-2 ${T ? "order-2 flex-row overflow-x-auto pb-2" : "flex-col"}`,
        style: { gap: `${c}px` },
        children: I.map((L, N) => /* @__PURE__ */ s(
          "button",
          {
            onClick: () => E(N),
            className: `flex-shrink-0 rounded-lg overflow-hidden transition-all duration-200 ${g === N ? "ring-2" : "ring-1"}`,
            style: {
              width: `${d}px`,
              height: `${d}px`,
              borderColor: g === N ? u : h
            },
            children: /* @__PURE__ */ s(
              $e,
              {
                src: L.url,
                alt: L.alt,
                className: "w-full h-full object-cover",
                showPlaceholderIcon: !1
              }
            )
          },
          L.id
        ))
      }
    ),
    /* @__PURE__ */ s("div", { className: "flex-1 relative", children: /* @__PURE__ */ p(
      "div",
      {
        className: `relative overflow-hidden transition-all duration-300 ${o === "square" ? "aspect-square" : "aspect-[4/3]"}`,
        style: {
          borderRadius: `${l}px`,
          backgroundColor: a
        },
        children: [
          i && /* @__PURE__ */ p(
            "div",
            {
              className: "absolute top-4 left-4 z-10 px-3 py-2 rounded-full flex items-center gap-2 text-sm font-medium",
              style: {
                backgroundColor: y,
                color: f
              },
              children: [
                /* @__PURE__ */ s(
                  "svg",
                  {
                    className: "w-4 h-4",
                    fill: "currentColor",
                    viewBox: "0 0 20 20",
                    style: { color: x },
                    children: /* @__PURE__ */ s("path", { d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" })
                  }
                ),
                v
              ]
            }
          ),
          r && I.length > 1 && /* @__PURE__ */ p(se, { children: [
            /* @__PURE__ */ s(
              "button",
              {
                onClick: P,
                className: "absolute left-4 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-2 transition-colors shadow-lg",
                children: /* @__PURE__ */ s(
                  "svg",
                  {
                    className: "w-5 h-5",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: /* @__PURE__ */ s(
                      "path",
                      {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M15 19l-7-7 7-7"
                      }
                    )
                  }
                )
              }
            ),
            /* @__PURE__ */ s(
              "button",
              {
                onClick: S,
                className: "absolute right-4 top-1/2 -translate-y-1/2 z-10 bg-white/80 hover:bg-white rounded-full p-2 transition-colors shadow-lg",
                children: /* @__PURE__ */ s(
                  "svg",
                  {
                    className: "w-5 h-5",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: /* @__PURE__ */ s(
                      "path",
                      {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M9 5l7 7-7 7"
                      }
                    )
                  }
                )
              }
            )
          ] }),
          n && I.length > 1 && /* @__PURE__ */ p("div", { className: "absolute bottom-4 right-4 z-10 bg-black/50 text-white px-3 py-1 rounded-full text-sm", children: [
            g + 1,
            " / ",
            I.length
          ] }),
          /* @__PURE__ */ s(
            $e,
            {
              src: (K = I[g]) == null ? void 0 : K.url,
              alt: (_ = I[g]) == null ? void 0 : _.alt,
              className: "w-full h-full object-cover transition-opacity duration-300",
              showPlaceholderIcon: !0
            }
          )
        ]
      }
    ) })
  ] }) : /* @__PURE__ */ s("div", { className: "flex items-center justify-center h-96 bg-gray-100 rounded-lg", children: /* @__PURE__ */ s("p", { className: "text-gray-500", children: "No images available" }) });
}, Sc = (t, e) => {
  if (!(t != null && t.options) || !(t != null && t.variants)) return {};
  const i = {};
  return t.options.forEach((n) => {
    i[n.key] = /* @__PURE__ */ new Set();
  }), t.variants.forEach((n) => {
    n.track_inventory && n.inventory === 0 && !n.continue_selling_oos || t.options.forEach((r, o) => {
      const l = n[`option${o + 1}`];
      if (!l) return;
      let a = !0;
      t.options.forEach((d, c) => {
        if (d.key === r.key) return;
        const u = `option${c + 1}`, h = e[u];
        h && n[u] !== h && (a = !1);
      }), a && i[r.key].add(l);
    });
  }), i;
}, Cc = (t, e, i, n) => {
  var o;
  return ((o = Sc(t, e)[i]) == null ? void 0 : o.has(n)) ?? !1;
}, Nc = /* @__PURE__ */ new Date("2026-05-01T10:00:00.000Z");
function mt(t) {
  return new Date(Nc.getTime() - 24 * t * 60 * 60 * 1e3).toISOString();
}
function fe(t, e = 0) {
  const i = mt(e);
  return { id: t, created_at: i, updated_at: i };
}
function Tr(t, e) {
  return { ...fe(`asset-${t}-${e}`, e), path: `https://picsum.photos/seed/${t}-${e}/1200/1200`, original_name: `${t}-${e}.jpg`, content_type: "image/jpeg", size: 512e3 + 1e3 * e, usage: "general" };
}
function bi(t, e, i = {}) {
  const n = e % 2 == 0 ? "Bengaluru" : "Mumbai", r = e % 2 == 0 ? "Karnataka" : "Maharashtra", o = e % 2 == 0 ? "560001" : "400001";
  return { ...fe(`address-${t}-${e}`, e + 2), address_line_one: `${100 + e} ${r === "Karnataka" ? "MG Road" : "Linking Road"}`, address_line_two: e % 2 == 0 ? "Near Central Mall" : "Floor 2", city: n, state: r, postal_code: o, billing_address: e === 0, created_by: "fake-user-1", ...i };
}
function Pi(t, e, i) {
  const n = 7995 + 500 * e;
  return { ...fe(`variant-${t}-${e}`, e + 1), sku: `${t.toUpperCase()}-${i.replace(/\s+/g, "-")}`, product_slug: t, product_id: `product-${t}`, title: i, description: { ops: [{ insert: `${i} size variant for ${t}.` }] }, inventory: 24 - 3 * e, continue_selling_oos: !1, price: n, listing_price: n + 2e3, option1: i, track_inventory: !0, shipping_details: { weight: 400, weight_unit: "g", width: 20, height: 12, length: 32, shipping_class: "standard", free_shipping: !1, shipping_price: 0 }, assets: [{ ...fe(`variant-asset-${t}-${e}`, e + 1), position: 0, usage: "thumbnail", asset: Tr(`${t}-variant`, e) }] };
}
function Li(t, e = {}) {
  const i = t === 1 ? "nike-air-max-90" : t === 2 ? "nike-dunk-low" : `nike-product-${t}`, n = t === 1 ? "Nike Air Max 90" : t === 2 ? "Nike Dunk Low" : `Nike Running Shoe ${t}`, r = 8995 + 750 * t;
  return { ...fe(`product-${t}`, t + 5), slug: i, handle: i, title: n, tags: ["sneakers", "nike", "fake-data"], status: "ACTIVE", description: { ops: [{ insert: t === 1 ? "Deterministic fake product for screenshot generation." : "Sample product data for fake-data rendering." }] }, metafields: [{ key: "material", value: "mesh", type: "text" }, { key: "fit", value: "true-to-size", type: "text" }], options: [{ key: "size", title: "Size", position: 1, values: ["UK 7", "UK 8", "UK 9"] }], variants: [Pi(i, 0, "UK 7"), Pi(i, 1, "UK 8"), Pi(i, 2, "UK 9")], assets: [{ ...fe(`product-asset-${t}`, t + 5), position: 0, usage: "image", asset: Tr(i, t) }], collection_id: "collection-1", collection_name: "Featured", price: r, tax_ids: ["tax-1"], taxes: [{ ...fe("tax-1", 20), name: "GST", rate: 18, type: "percentage", applicable_on: "bill" }], ...e };
}
function Yi(t, e, i, n) {
  return { ...fe(`cart-item-${n}`, n + 1), id: `cart-item-${n}`, variant_id: e.id, product_id: t.id, quantity: i, product: t, variant: e };
}
function cn(t) {
  return { items: [], charges: [], discounts: [], total_taxes: [], total_quantity: 1, items_sub_total: t, charge_sub_total: 0, total_charges: 0, discount_sub_total: 0, total_discounts: 0, total_tax: Math.round(0.18 * t), grand_total: Math.round(1.18 * t), grand_total_int: Math.round(1.18 * t) };
}
function Ir(t) {
  const e = t[0], i = t[1], n = [Yi(e, e.variants[1], 1, 1), Yi(i, i.variants[0], 2, 2)], r = n.reduce((o, l) => o + l.variant.price * l.quantity, 0);
  return { ...fe("cart-1", 0), items: n, user_id: "fake-user-1", store_id: "fake-store", discount_codes: ["WELCOME10"], calculation: cn(r) };
}
function Er() {
  const t = [bi("profile", 0), bi("profile", 1)];
  return { ...fe("fake-user-1", 12), phone_number: "919876543210", first_name: "Screenshot", last_name: "User", email: "screenshots@example.com", default_address_id: t[0].id, default_address: t[0], customer_addresses: t, total_orders: 0, total_spent: 0, enabled: !0 };
}
function It(t, e, i = "CONFIRMED") {
  const n = e.variants[t % e.variants.length], r = Yi(e, n, t + 1, t), o = r.variant.price * r.quantity, l = bi("shipping", t, { billing_address: !1 }), a = bi("billing", t + 10, { billing_address: !0 }), d = i;
  return { ...fe(`order-${t}`, t + 3), user_id: "fake-user-1", customer: Er(), order_number: 1e3 + t, order_sets: [Kc(t, e, r)], billing_address_different_than_shipping: !0, items: [r], variants: [n], store_id: "fake-store", discount_codes: t % 2 == 0 ? ["WELCOME10"] : [], calculation: cn(o), shipping_address: l, billing_address: a, supported_payment_type: ["PREPAID", "POSTPAID"], used_payment_type: "PREPAID", payment_status: t === 0 ? "CAPTURED" : "AUTHORIZED", order_status: d, support_tickets: [hi(t, `order-${t}`)] };
}
function Kc(t, e, i) {
  return { ...fe(`order-set-${t}`, t + 3), order_id: `order-${t}`, shipping_status: t === 0 ? "DELIVERED" : "SHIPPED", shipping_type: "INTERNAL", store_id: "fake-store", store_type: "SELLER", needs_verification: !1, calculation: cn(i.variant.price * i.quantity), items: [{ ...fe(`order-item-${t}`, t + 3), sku: i.variant.sku, product_slug: e.slug, title: e.title, description: e.description, inventory: i.variant.inventory, continue_selling_oos: i.variant.continue_selling_oos, price: i.variant.price, listing_price: i.variant.listing_price, option1: i.variant.option1, quantity: i.quantity, purchased_at: mt(t + 3), order_set_id: `order-set-${t}` }], charges: [{ name: "Shipping", amount: 0 }], notes: [{ ...fe(`order-note-${t}`, t + 3), order_set_id: `order-set-${t}`, title: "Packed", description: "Order packed for dispatch", created_by: "Shiphouse Ops" }], stage_history: [{ ...fe(`order-stage-${t}`, t + 3), order_set_id: `order-set-${t}`, stage: "CONFIRMED", previous_stage: "CREATED", changed_by: "Shiphouse Ops", reason: "Order placed", notes: "Automatically generated fake order", timestamp: mt(t + 3) }], shipping_details: { ...fe(`shipping-${t}`, t + 3), order_set_id: `order-set-${t}`, shipping_provider: "Shiphouse Express", tracking_url: "https://example.com/tracking/fake", tracking_id: `TRK-${t}`, shipment_status: "IN_TRANSIT" }, address_id: `address-shipping-${t}`, address: { ...fe(`store-address-${t}`, t + 3), address_line_one: "Warehouse Road", address_line_two: "Dock 3", city: "Bengaluru", state: "Karnataka", postal_code: "560001", billing_address: !1 } };
}
function vi(t, e) {
  const i = [5, 4, 5], n = i[t % i.length];
  return { ...fe(`review-${t}`, t + 1), product_id: e.id, product_slug: e.slug, customer_id: "fake-user-1", customer_name: t === 0 ? "Aisha Khan" : t === 1 ? "Rohan Mehta" : "Priya Nair", customer_email: `reviewer${t + 1}@example.com`, rating: n, title: t === 0 ? "Great fit" : t === 1 ? "Comfortable daily wear" : "Looks premium", comment: t === 0 ? "Fits exactly as expected and the cushioning feels great." : t === 1 ? "Shipping was fast and the shoe is very comfortable." : "The fake screenshot data looks realistic enough for UI testing.", status: "APPROVED", verified_purchase: !0, helpful_count: 18 - 3 * t, not_helpful_count: t, images: [{ id: `review-image-${t}`, url: `https://picsum.photos/seed/review-${t}/800/800`, thumbnail_url: `https://picsum.photos/seed/review-${t}/320/320`, position: 0 }], reply: t === 0 ? { id: `reply-${t}`, reply_text: "Thanks for the feedback.", replied_by: "Shiphouse Support", replied_at: mt(t), created_at: mt(t), updated_at: mt(t) } : void 0 };
}
function _r(t) {
  var r;
  const e = t.length, i = e === 0 ? 0 : t.reduce((o, l) => o + l.rating, 0) / e, n = { 1: t.filter((o) => o.rating === 1).length, 2: t.filter((o) => o.rating === 2).length, 3: t.filter((o) => o.rating === 3).length, 4: t.filter((o) => o.rating === 4).length, 5: t.filter((o) => o.rating === 5).length };
  return { product_id: ((r = t[0]) == null ? void 0 : r.product_id) || "fake-product-1", total_reviews: e, average_rating: Number(i.toFixed(1)), rating_distribution: n, verified_purchase_count: t.filter((o) => o.verified_purchase).length, with_images_count: t.filter((o) => {
    var l;
    return !!((l = o.images) != null && l.length);
  }).length };
}
function hi(t, e) {
  const i = ["open", "pending", "resolved"], n = ["normal", "high", "urgent"];
  return { ...fe(`ticket-${t}`, t + 1), subject: t === 0 ? "Where is my order?" : t === 1 ? "Need size exchange" : "Payment failed", title: t === 0 ? "Where is my order?" : t === 1 ? "Need size exchange" : "Payment failed", description: t === 0 ? "The customer wants an update on delivery status." : t === 1 ? "Customer requested a different size after delivery." : "Checkout payment failed on the final step.", status: i[t % i.length], priority: n[t % n.length], order_id: e, tags: ["screenshot", "fake-data"] };
}
const Pe = [Li(1), Li(2), Li(3)], Xi = Pe.reduce((t, e, i) => (t[e.slug] = [vi(i, e), vi(i + 1, e)], t), {}), je = Object.values(Xi).flat(), Tc = _r(je), _e = [It(0, Pe[0], "CONFIRMED"), It(1, Pe[1], "SHIPPING"), It(2, Pe[2], "COMPLETED")], li = [hi(0, _e[0].id), hi(1, _e[1].id), hi(2, _e[2].id)], ut = (function(t) {
  const e = [It(0, t[0], "CONFIRMED"), It(1, t[1], "SHIPPING")], i = Ir(t);
  return { ...Er(), orders: e, total_orders: e.length, total_spent: e.reduce((n, r) => n + r.calculation.grand_total, 0), carts: i };
})(Pe), Ic = Ir(Pe);
function ne(t, e = "Using fake screenshot data") {
  return { valid: !0, message: e, data: t };
}
function kt(t, e = "Using fake screenshot data") {
  return { valid: !0, message: e, data: t, page: 1, page_size: t.length, total: t.length, total_pages: 1 };
}
function Ai(t) {
  const e = t.toLowerCase();
  return Pe.find((i) => i.id === t || i.slug === e || i.handle === e) || Pe[0];
}
function In(t) {
  return _e.find((e) => e.id === t) || _e[0];
}
function En(t) {
  return je.find((e) => e.id === t) || je[0];
}
function Ec(t, e) {
  var n, r, o, l, a;
  if (e.includes("/auth/customer/login")) return { valid: !0, message: "OTP sent successfully (fake mode)", authenticationId: "fake-auth-id-1", data: { authenticationId: "fake-auth-id-1" } };
  if (e.includes("/auth/customer/verify-otp")) return ne({ sessionToken: "fake-session-token", refreshToken: "fake-refresh-token", user: { id: ut.id, name: `${ut.first_name} ${ut.last_name}`, email: ut.email } });
  if (e.includes("/auth/customer/session")) return ne({ sessionToken: "fake-session-token" });
  if (e.includes("/reviews/upload/complete")) return { valid: !0, message: "Review image upload completed" };
  if (e.includes("/reviews/upload/")) {
    const d = e.split("/reviews/upload/").pop() || "upload.jpg";
    return ne({ upload_url: `https://example.com/upload/${d}`, asset_id: `fake-review-asset-${d}`, expires_at: mt(-1) });
  }
  const i = e.match(/\/products\/([^/]+)\/reviews(\/stats)?$/);
  if (i) {
    const d = Ai(decodeURIComponent(i[1])), c = Xi[d.slug] || [vi(0, d)], u = _r(c);
    return i[2] === "/stats" ? ne(u) : ne({ reviews: c, stats: u, pagination: { page: 1, limit: c.length, total: c.length, total_pages: 1 } });
  }
  if (e.includes("/reviews/check")) {
    const d = Ai(((n = e.split("/products/").pop()) == null ? void 0 : n.split("/reviews/")[0]) || Pe[0].id);
    return ne({ has_reviewed: !0, review: ((r = Xi[d.slug]) == null ? void 0 : r[0]) || vi(0, d) });
  }
  if (e.includes("/reviews/") && e.includes("/helpful")) {
    const d = En(((o = e.split("/reviews/").pop()) == null ? void 0 : o.split("/helpful")[0]) || je[0].id);
    return ne({ helpful_count: d.helpful_count + 1, not_helpful_count: d.not_helpful_count });
  }
  if (e.includes("/reviews/") && e.includes("/report")) return ne(void 0);
  if (e.includes("/reviews/") && !e.endsWith("/reviews"))
    return ne(En(e.split("/reviews/").pop() || je[0].id));
  if (e.endsWith("/reviews")) return e.includes("/authorized/") ? ne({ reviews: je.slice(0, 3), pagination: { page: 1, limit: 3, total: je.length, total_pages: 1 } }) : ne({ reviews: je.slice(0, 4), stats: Tc, pagination: { page: 1, limit: 4, total: je.length, total_pages: 1 } });
  if (e.includes("/tickets/") && !e.endsWith("/tickets"))
    return ne((function(d) {
      return li.find((c) => c.id === d) || li[0];
    })(e.split("/tickets/").pop() || li[0].id));
  if (e.endsWith("/tickets"))
    return t === "POST" ? ne({ ...fe("ticket-new", 0), subject: "Fake support ticket", title: "Fake support ticket", description: "Fake ticket created while screenshot mode is enabled.", status: "open", priority: "normal" }) : kt(li);
  if (e.includes("/order/checkout")) return ne({ order: _e[0], payment_url: "https://example.com/fake-payment", redirect_url: "https://example.com/fake-checkout" });
  if (e.includes("/order/process-payment")) return ne({ order: _e[0], payment_url: "https://example.com/fake-payment", status: "pending" });
  if (e.includes("/order/pay/success")) return ne({ order: _e[0], status: "success" });
  if (e.includes("/order/pay/failure")) return ne({ order: _e[0], status: "failed" });
  if (e.includes("/order/pay")) return ne({ payment_url: "https://example.com/fake-payment", status: "pending" });
  if (e.includes("/order/verify")) return ne({ valid: !0, message: "Order verified in fake mode" });
  if (e.match(/\/order\/[^/]+\/set\/[^/]+$/)) {
    const d = ((l = e.split("/order/").pop()) == null ? void 0 : l.split("/set/")[0]) || _e[0].id, c = e.split("/set/").pop() || "order-set-0", u = In(d);
    return ne({ ...(a = u.order_sets) == null ? void 0 : a[0], id: c, order_id: d });
  }
  return e.match(/\/order\/[^/]+$/) ? ne(In(e.split("/order/").pop() || _e[0].id)) : e.endsWith("/order/search") ? kt(_e.map((d) => ({ ...d, status_label: d.order_status }))) : e.endsWith("/order") ? kt(_e) : e.includes("/cart/validate-promo") ? ne({ valid: !0, message: "Promo applied in fake mode", promo_code: { code: "WELCOME10" } }) : e.endsWith("/cart") ? ne(Ic) : e.includes("/customer/address") ? ne(ut.customer_addresses || []) : e.includes("/customer/profile") || e.endsWith("/customer") ? ne(ut) : e.includes("/wishlist") ? ne([]) : e.includes("/products/filters") ? ne({ filters: [{ fieldName: "category", displayName: "Category", filterType: "select", options: [{ name: "Running", filterValue: "Running", count: 12 }, { name: "Lifestyle", filterValue: "Lifestyle", count: 9 }], minValue: null, maxValue: null, multiSelect: !0, isPublic: !0 }] }) : e.includes("/products/search") ? kt(Pe.slice(0, 2)) : e.match(/\/products\/[^/]+$/) ? ne(Ai(decodeURIComponent(e.split("/products/").pop() || ""))) : e.endsWith("/products") ? kt(Pe) : e.endsWith("/collections") ? kt([{ ...fe("collection-1", 30), name: "Featured", slug: "featured", products: Pe.slice(0, 2) }]) : e.match(/\/collections\/[^/]+$/) ? ne({ ...fe("collection-1", 30), name: "Featured", slug: "featured", products: Pe.slice(0, 2) }) : e.includes("/payment-methods") ? ne([{ id: "razorpay", type: "razorpay", name: "Razorpay", description: "Pay securely using Razorpay" }, { id: "postpaid", type: "postpaid", name: "Pay on delivery", description: "Cash on delivery" }]) : e.includes("/delivery-options") ? ne([{ id: "standard", title: "Standard Delivery", price: 0, eta: "3-5 business days" }, { id: "express", title: "Express Delivery", price: 199, eta: "1-2 business days" }]) : t === "GET" ? ne({}) : null;
}
class _c {
  constructor(e) {
    this.baseUrlInitialized = !1, this.isRefreshing = !1, this.refreshPromise = null, this.requestDebounceMap = /* @__PURE__ */ new Map(), this.DEBOUNCE_DURATION = 1e3, this.config = e, this.baseURL = qi, this.storeId = (e == null ? void 0 : e.storeId) || "", this.timeout = (e == null ? void 0 : e.timeout) || 3e4, this.enableLogging = (e == null ? void 0 : e.enableDevtools) || !1, this.fakeDataMode = !!Va, this.sessionToken = fi(e != null && e.testMode ? "test" : void 0), this.fakeDataMode && (this.refreshToken = vr()), this.enableLogging && (console.log("🔧 [SDK] Logging enabled - All requests and responses will be logged"), console.log(`🌐 [SDK] Using base URL: ${this.baseURL}`));
  }
  ensureCorrectBaseUrl() {
    if (this.baseUrlInitialized) return;
    const e = (function() {
      if (typeof window < "u") {
        const i = window.location.hostname;
        if (i === "localhost" || i === "127.0.0.1") return "http://localhost:8000";
      }
      return qi;
    })();
    e !== this.baseURL && (console.log(`🔧 [SDK ApiClient] Updating baseURL from ${this.baseURL} to ${e} (localhost detected)`), this.baseURL = e), this.baseUrlInitialized = !0;
  }
  setSessionToken(e) {
    this.sessionToken = e || void 0;
  }
  getSessionToken() {
    return this.sessionToken;
  }
  setRefreshToken(e) {
    this.refreshToken = e || void 0, j.log("[ApiClient] Refresh token set:", !!e);
  }
  getRefreshToken() {
    return this.refreshToken;
  }
  getBaseUrl() {
    return this.baseURL;
  }
  getStoreId() {
    return this.storeId;
  }
  getCSRFTokenFromCookie() {
    if (typeof document > "u") return null;
    const e = document.cookie.match(/shiphouse-csrf=([^;]+)/);
    return e ? e[1] : null;
  }
  hydratePersistedAuth() {
    if (typeof window < "u") try {
      if (!this.sessionToken && window.localStorage) {
        const e = localStorage.getItem("shiphouse-session");
        e && (this.sessionToken = e, j.log("[ApiClient] Hydrated session token from localStorage"));
      }
      if (!this.refreshToken && window.localStorage) {
        const e = localStorage.getItem("shiphouse-refresh-token");
        e && (this.refreshToken = e, j.log("[ApiClient] Hydrated refresh token from localStorage"));
      }
    } catch (e) {
      j.log("[ApiClient] Failed to hydrate persisted auth tokens", e);
    }
  }
  getDefaultHeaders() {
    this.hydratePersistedAuth();
    const e = { "Content-Type": "application/json" }, i = ja, n = !!this.config.testMode, r = this.sessionToken === "test", o = Re.INTEGRATION_TESTS, l = i || n || r || o;
    if (j.log("[ApiClient] Test mode check:", { isTestModeEnv: i, isTestModeConfig: n, isTestToken: r, isIntegrationTest: o, finalIsTestMode: l, sessionToken: this.sessionToken }), this.sessionToken ? (e.Authorization = `Bearer ${this.sessionToken}`, Re.isProduction || j.log("[ApiClient] Using session token authorization")) : ln() ? e.Authorization = `Bearer ${fi()}` : j.log("[ApiClient] No session token - making unauthenticated request"), typeof document < "u") {
      const a = this.getCSRFTokenFromCookie();
      a && (e["X-CSRF-Token"] = a);
    }
    return e;
  }
  async attemptTokenRefresh() {
    if (this.hydratePersistedAuth(), this.isRefreshing && this.refreshPromise) return j.log("[ApiClient] Token refresh already in progress, waiting..."), this.refreshPromise;
    if (!this.refreshToken) return j.log("[ApiClient] No refresh token available, cannot refresh session"), !1;
    this.isRefreshing = !0, this.refreshPromise = this.performTokenRefresh();
    try {
      return await this.refreshPromise;
    } finally {
      this.isRefreshing = !1, this.refreshPromise = null;
    }
  }
  async performTokenRefresh() {
    var e;
    try {
      j.log("[ApiClient] Attempting to refresh session token...");
      const i = this.buildURL("/api/v1/auth/customer/session"), n = await fetch(i, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ refreshToken: this.refreshToken }) });
      if (!n.ok) return j.error("[ApiClient] Token refresh failed with status:", n.status), this.sessionToken = void 0, this.refreshToken = void 0, !1;
      const r = await n.json();
      return r.valid && ((e = r.data) != null && e.sessionToken) ? (j.log("[ApiClient] Token refresh successful, updating session token"), this.sessionToken = r.data.sessionToken, !0) : (j.error("[ApiClient] Token refresh response invalid:", r.message), this.sessionToken = void 0, this.refreshToken = void 0, !1);
    } catch (i) {
      return j.error("[ApiClient] Token refresh exception:", i), this.sessionToken = void 0, this.refreshToken = void 0, !1;
    }
  }
  generateDebounceKey(e, i, n, r) {
    return `${e}:${i}:${r ? JSON.stringify(r) : ""}:${n ? JSON.stringify(n) : ""}`;
  }
  cleanupDebounceMap() {
    const e = Date.now();
    for (const [i, n] of this.requestDebounceMap.entries()) e - n.timestamp > this.DEBOUNCE_DURATION && this.requestDebounceMap.delete(i);
  }
  buildURL(e, i) {
    const n = !!(this.sessionToken && this.sessionToken !== "test"), r = this.storeId || "test";
    j.log("[ApiClient] buildURL - isAuthenticated:", n, "effectiveStoreId:", r, "endpoint:", e);
    const o = e.replace("{storeId}", r);
    if (!this.storeId && this.enableLogging && console.log("⚠️ [ApiClient] No storeId configured, using 'test':", { original: e, effectiveStoreId: r, finalUrl: o }), !this.baseURL) return j.error("baseURL is undefined! Cannot build URL. Config issue detected."), `INVALID_URL${o}`;
    let l;
    try {
      l = new URL(o, this.baseURL).toString();
    } catch {
      l = this.baseURL.endsWith("/") && o.startsWith("/") ? this.baseURL + o.substring(1) : this.baseURL.endsWith("/") || o.startsWith("/") ? this.baseURL + o : this.baseURL + "/" + o;
    }
    if (i) {
      const a = new URLSearchParams();
      Object.entries(i).forEach(([c, u]) => {
        u != null && (Array.isArray(u) ? u.forEach((h) => a.append(c, String(h))) : a.append(c, String(u)));
      });
      const d = a.toString();
      return d ? `${l}?${d}` : l;
    }
    return l;
  }
  async makeRequest(e, i, n, r) {
    this.ensureCorrectBaseUrl();
    const o = this.generateDebounceKey(e, i, n, r == null ? void 0 : r.params), l = Date.now();
    this.cleanupDebounceMap();
    const a = this.requestDebounceMap.get(o);
    if (a && l - a.timestamp < this.DEBOUNCE_DURATION) return j.log(`[ApiClient] 🔄 Debouncing duplicate request: ${e} ${i}`), a.promise;
    const d = this.executeRequest(e, i, n, r);
    return this.requestDebounceMap.set(o, { promise: d, timestamp: l }), d.finally(() => {
      setTimeout(() => {
        this.requestDebounceMap.delete(o);
      }, this.DEBOUNCE_DURATION);
    }), d;
  }
  async executeRequest(e, i, n, r) {
    if (this.fakeDataMode) {
      const m = Ec(e, i);
      if (m) return j.log(`[ApiClient] Returning fake data for ${e} ${i}`), m;
    }
    const o = this.buildURL(i, r == null ? void 0 : r.params), l = { ...this.getDefaultHeaders(), ...r == null ? void 0 : r.headers }, a = (r == null ? void 0 : r.timeout) || this.timeout, d = new AbortController(), c = setTimeout(() => d.abort(), a), u = { method: e, headers: l, signal: d.signal };
    !n || e !== "POST" && e !== "PUT" && e !== "PATCH" || (u.body = JSON.stringify(n)), this.enableLogging && (console.group(`🌐 [SDK Request] ${e} ${o}`), console.log("📤 URL:", o), console.log("📋 Method:", e), console.log("🔑 Headers:", l), n && console.log("📦 Request Body:", n), r != null && r.params && console.log("🔍 Query Params:", r.params), console.log("⏱️ Timeout:", `${a}ms`), console.groupEnd()), j.log(`[ApiClient] ${e} ${o}`), n && j.log("[ApiClient] Request data:", n), j.log("[ApiClient] Request headers:", l);
    const h = Date.now();
    try {
      const m = await fetch(o, u);
      clearTimeout(c);
      const v = Date.now() - h;
      if (j.log("[ApiClient] Response status:", m == null ? void 0 : m.status, m == null ? void 0 : m.statusText), (m == null ? void 0 : m.status) === 401) {
        if (j.log("[ApiClient] Received 401 Unauthorized - attempting token refresh"), await this.attemptTokenRefresh()) {
          j.log("[ApiClient] Token refreshed successfully - retrying original request");
          const f = { ...this.getDefaultHeaders(), ...r == null ? void 0 : r.headers };
          try {
            this.sessionToken && (f.Authorization = `Bearer ${this.sessionToken}`);
          } catch {
          }
          const x = { method: e, headers: f, signal: d.signal };
          !n || e !== "POST" && e !== "PUT" && e !== "PATCH" || (x.body = JSON.stringify(n));
          const b = await fetch(o, x);
          if (j.log("[ApiClient] Retry response status:", b == null ? void 0 : b.status, b == null ? void 0 : b.statusText), (b == null ? void 0 : b.status) === 401) return j.error("[ApiClient] Retry failed with 401 - session cannot be recovered, logout required"), this.setSessionToken(null), this.setRefreshToken(null), { valid: !1, message: "Session expired - please login again", error: { status: 401, statusText: "Unauthorized", requiresLogout: !0 } };
          if (!b.ok)
            return await b.json().catch((k) => (j.error("[ApiClient] Failed to parse retry error response JSON:", k), { valid: !1, message: `HTTP ${b.status}: ${b.statusText}`, error: { status: b.status, statusText: b.statusText, parseError: k == null ? void 0 : k.message, url: o, method: e } }));
          const g = await b.json().catch((k) => (j.error("[ApiClient] Failed to parse retry JSON response:", k), { valid: !1, message: `Failed to parse response after retry: ${(k == null ? void 0 : k.message) || String(k)}`, error: k }));
          return j.log("[ApiClient] Retry response JSON:", g), g;
        }
        return j.error("[ApiClient] Token refresh failed - session expired, logout required"), this.setSessionToken(null), this.setRefreshToken(null), { valid: !1, message: "Session expired - please login again", error: { status: 401, statusText: "Unauthorized", requiresLogout: !0 } };
      }
      if (!m) return j.error("[ApiClient] No response received from server"), this.enableLogging && (console.group(`❌ [SDK Response] ${e} ${o}`), console.error("⚠️ No response received from server"), console.log("⏱️ Duration:", `${v}ms`), console.groupEnd()), { valid: !1, message: "No response received from server", error: { message: "No response received from server", name: "ApiError" } };
      if (!m.ok) {
        const f = await m.json().catch((x) => (j.error("[ApiClient] Failed to parse error response JSON:", x), j.error("[ApiClient] Failed request URL:", o), j.error("[ApiClient] Failed request method:", e), { valid: !1, message: `HTTP ${m.status}: ${m.statusText}`, error: { status: m.status, statusText: m.statusText, parseError: x.message, url: o, method: e } }));
        return Object.keys(f).length === 0 ? (j.error("[ApiClient] Empty error response for:", e, o), { valid: !1, message: `HTTP ${m.status}: ${m.statusText} - Empty response body`, error: { status: m.status, statusText: m.statusText, url: o, method: e } }) : (j.error("[ApiClient] Error response:", f), this.enableLogging && (console.group(`❌ [SDK Response] ${e} ${o}`), console.error("📥 Status:", m.status, m.statusText), console.error("📦 Error Data:", f), console.log("⏱️ Duration:", `${v}ms`), console.groupEnd()), clearTimeout(c), f);
      }
      const y = await m.json();
      return j.log("[ApiClient] Response JSON:", y), this.enableLogging && (console.group(`✅ [SDK Response] ${e} ${o}`), console.log("📥 Status:", m.status, m.statusText), console.log("📦 Response Data:", y), console.log("⏱️ Duration:", `${v}ms`), console.log("✨ Valid:", y.valid !== !1), console.groupEnd()), y;
    } catch (m) {
      clearTimeout(c);
      const v = Date.now() - h;
      return j.error("[ApiClient] Request error:", m), this.enableLogging && (console.group(`❌ [SDK Error] ${e} ${o}`), console.error("⚠️ Error:", m), console.log("⏱️ Duration:", `${v}ms`), m instanceof Error && (console.error("📝 Error Name:", m.name), console.error("📝 Error Message:", m.message)), console.groupEnd()), m instanceof Error ? m.name === "AbortError" || m.name === "TimeoutError" || m.message.includes("timeout") ? { valid: !1, message: "Request timeout - server may not be running on localhost:8000", error: m } : { valid: !1, message: m.message || "Network error - check if localhost:8000 is running", error: m } : { valid: !1, message: "Unknown error occurred - server may not be responding", error: m };
    }
  }
  async get(e, i) {
    return this.makeRequest("GET", e, void 0, i);
  }
  async post(e, i, n) {
    return this.makeRequest("POST", e, i, n);
  }
  async put(e, i, n) {
    return this.makeRequest("PUT", e, i, n);
  }
  async patch(e, i, n) {
    return this.makeRequest("PATCH", e, i, n);
  }
  async delete(e, i) {
    return this.makeRequest("DELETE", e, void 0, i);
  }
}
const Ri = new class {
  constructor(t = {}) {
    this.queues = /* @__PURE__ */ new Map(), this.activeRequests = /* @__PURE__ */ new Map(), this.config = { timeout: t.timeout || Sn.DEFAULT, maxConcurrentRequests: t.maxConcurrentRequests || 3, retryCount: t.retryCount || si.MAX_RETRIES, retryDelay: t.retryDelay || si.RETRY_DELAY };
  }
  async enqueue(t, e, i = "GET", n, r) {
    this.cancelSimilarRequests(t, e, i);
    const o = this.generateRequestId(t, e, i), l = new AbortController();
    let a, d;
    const c = new Promise((h, m) => {
      a = h, d = m;
    }), u = { id: o, endpoint: e, method: i, data: n, config: r, controller: l, timestamp: Date.now(), category: t, promise: c, resolve: a, reject: d };
    return this.queues.has(t) || this.queues.set(t, []), this.queues.get(t).push(u), this.processQueue(t), c;
  }
  cancelCategory(t) {
    (this.queues.get(t) || []).forEach((e) => {
      e.controller.abort(), e.reject(new Error("Request cancelled by category"));
    }), this.queues.set(t, []), (this.activeRequests.get(t) || []).forEach((e) => {
      e.controller.abort(), e.reject(new Error("Request cancelled by category"));
    }), this.activeRequests.set(t, []), j.log(`[RequestQueue] Cancelled all requests in category: ${t}`);
  }
  cancelRequest(t) {
    for (const [e, i] of this.queues.entries()) {
      const n = i.findIndex((r) => r.id === t);
      if (n >= 0) {
        const r = i[n];
        return r.controller.abort(), r.reject(new Error("Request cancelled")), i.splice(n, 1), void j.log(`[RequestQueue] Cancelled queued request: ${t}`);
      }
    }
    for (const [e, i] of this.activeRequests.entries()) {
      const n = i.findIndex((r) => r.id === t);
      if (n >= 0) {
        const r = i[n];
        return r.controller.abort(), r.reject(new Error("Request cancelled")), i.splice(n, 1), void j.log(`[RequestQueue] Cancelled active request: ${t}`);
      }
    }
  }
  async executeRequest(t, e) {
    var r, o;
    const i = ((r = t.config) == null ? void 0 : r.timeout) || this.config.timeout, n = setTimeout(() => {
      t.controller.abort();
    }, i);
    try {
      const l = { ...t.config, method: t.method, signal: t.controller.signal, body: t.data ? JSON.stringify(t.data) : void 0, headers: { "Content-Type": "application/json", ...(o = t.config) == null ? void 0 : o.headers } };
      j.log(`[RequestQueue] Executing ${t.method} ${t.endpoint}`);
      const a = await e(t.endpoint, l);
      return clearTimeout(n), t.resolve(a), a;
    } catch (l) {
      if (clearTimeout(n), l.name === "AbortError") {
        const a = new Error("Request timeout or cancelled");
        throw t.reject(a), a;
      }
      throw t.reject(l), l;
    }
  }
  async processQueue(t) {
    const e = this.queues.get(t) || [];
    if ((this.activeRequests.get(t) || []).length >= this.config.maxConcurrentRequests) return;
    const i = e.shift();
    i && (this.activeRequests.has(t) || this.activeRequests.set(t, []), this.activeRequests.get(t).push(i), setTimeout(() => this.processQueue(t), 10));
  }
  completeRequest(t, e) {
    const i = this.activeRequests.get(t) || [], n = i.findIndex((r) => r.id === e);
    n >= 0 && (i.splice(n, 1), this.processQueue(t));
  }
  cancelSimilarRequests(t, e, i) {
    const n = this.queues.get(t) || [], r = n.filter((c) => c.endpoint === e && c.method === i);
    r.forEach((c) => {
      c.controller.abort(), c.reject(new Error("Request superseded by newer request"));
    });
    const o = n.filter((c) => !(c.endpoint === e && c.method === i));
    this.queues.set(t, o);
    const l = this.activeRequests.get(t) || [], a = l.filter((c) => c.endpoint === e && c.method === i);
    a.forEach((c) => {
      c.controller.abort(), c.reject(new Error("Request superseded by newer request"));
    });
    const d = l.filter((c) => !(c.endpoint === e && c.method === i));
    this.activeRequests.set(t, d), (r.length > 0 || a.length > 0) && j.log(`[RequestQueue] Cancelled ${r.length + a.length} similar requests for ${i} ${e}`);
  }
  generateRequestId(t, e, i) {
    return `${t}-${i}-${e.replace(/[^a-zA-Z0-9]/g, "_")}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  }
  getStats() {
    const t = {};
    for (const [e, i] of this.queues.entries()) t[e] = { queued: i.length, active: 0 };
    for (const [e, i] of this.activeRequests.entries()) t[e] || (t[e] = { queued: 0, active: 0 }), t[e].active = i.length;
    return t;
  }
  clearAll() {
    for (const t of this.queues.keys()) this.cancelCategory(t);
    this.queues.clear(), this.activeRequests.clear(), j.log("[RequestQueue] Cleared all queues");
  }
}({ timeout: Sn.DEFAULT, maxConcurrentRequests: 3, retryCount: si.MAX_RETRIES, retryDelay: si.RETRY_DELAY });
class _n {
  constructor(e) {
    this.apiClient = e;
  }
  async login(e) {
    if (j.log("[AuthService] login() called with phoneNumber:", e), !e || typeof e != "string" || e.trim() === "") return j.error("[AuthService] login() precondition failed: phoneNumber is required"), { valid: !1, message: "phoneNumber is required for login", error: { message: "phoneNumber is required" } };
    const i = (function(n) {
      const r = n.replace(/\D/g, "");
      return r.length === 10 ? `91${r}` : (r.length === 12 && r.startsWith("91"), r);
    })(e);
    j.log("[AuthService] login() formatted phone:", i, "(original:", e + ")");
    try {
      const n = await this.apiClient.post("/api/v1/auth/customer/login", { phoneNumber: i });
      return j.log("[AuthService] login() response:", n), n;
    } catch (n) {
      return j.error("[AuthService] login() error:", n), { valid: !1, message: (n == null ? void 0 : n.message) || "Login request failed", error: n };
    }
  }
  async verifyOTP(e, i) {
    var n;
    if (j.log("[AuthService] verifyOTP() called with authenticationId:", e), !e || !i) return j.error("[AuthService] verifyOTP() precondition failed: authenticationId and otp are required"), { valid: !1, message: "authenticationId and otp are required", error: { message: "Missing authenticationId or otp" } };
    try {
      const r = await this.apiClient.post("/api/v1/auth/customer/verify-otp", { authenticationId: e, otp: i });
      return j.log("[AuthService] verifyOTP() response:", r), r.valid && ((n = r.data) != null && n.sessionToken) ? (j.log("[AuthService] verifyOTP() storing session token"), this.apiClient.setSessionToken(r.data.sessionToken)) : j.warn("[AuthService] verifyOTP() did not return sessionToken"), r;
    } catch (r) {
      return j.error("[AuthService] verifyOTP() error:", r), { valid: !1, message: (r == null ? void 0 : r.message) || "OTP verification failed", error: r };
    }
  }
  async refreshSession(e) {
    var i;
    if (j.log("[AuthService] refreshSession() called"), !e) return j.error("[AuthService] refreshSession() precondition failed: refreshToken is required"), { valid: !1, message: "refreshToken is required", error: { message: "Missing refreshToken" } };
    try {
      const n = await this.apiClient.post("/api/v1/auth/customer/session", { refreshToken: e });
      return j.log("[AuthService] refreshSession() response:", n), n.valid && ((i = n.data) != null && i.sessionToken) && (j.log("[AuthService] refreshSession() updating session token"), this.apiClient.setSessionToken(n.data.sessionToken)), n;
    } catch (n) {
      return j.error("[AuthService] refreshSession() error:", n), { valid: !1, message: (n == null ? void 0 : n.message) || "Session refresh failed", error: n };
    }
  }
  logout() {
    j.log("[AuthService] logout() called - clearing session token"), this.apiClient.setSessionToken(null);
  }
  isAuthenticated() {
    const e = this.apiClient.getSessionToken();
    return j.log("[AuthService] isAuthenticated() ->", !!e), !!e;
  }
}
class Fn {
  constructor(e) {
    this.apiClient = e;
  }
  async getProducts(e) {
    return this.apiClient.get("/api/v1/public/{storeId}/products", { params: { ...e } });
  }
  async getProduct(e) {
    const i = (function(n) {
      const r = n.trim();
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(r) ? r.toLowerCase() : r.length === 32 && /^[0-9a-fA-F]{32}$/.test(r) ? `${r.slice(0, 8)}-${r.slice(8, 12)}-${r.slice(12, 16)}-${r.slice(16, 20)}-${r.slice(20)}`.toLowerCase() : r;
    })(e);
    return this.apiClient.get(`/api/v1/public/{storeId}/products/${encodeURIComponent(i)}`);
  }
  async searchProducts(e, i) {
    return this.apiClient.get("/api/v1/public/{storeId}/products/search", { params: { q: e, page: i == null ? void 0 : i.page, page_size: i == null ? void 0 : i.limit } });
  }
  async getFilterFields() {
    return this.apiClient.get("/api/v1/public/{storeId}/products/filters");
  }
  async getAllProducts(e) {
    return this.getProducts(e);
  }
}
class Pn {
  constructor(e) {
    this.apiClient = e;
  }
  async getCollections(e) {
    return this.apiClient.get("/api/v1/public/{storeId}/collections", { params: { ...e } });
  }
  async getCollection(e) {
    return this.apiClient.get(`/api/v1/public/{storeId}/collections/${e}`);
  }
}
class Ln {
  constructor(e) {
    this.apiClient = e;
  }
  async getCart() {
    return this.apiClient.get("/api/v1/public/authorized/{storeId}/cart");
  }
  async addItem(e, i, n) {
    return this.apiClient.post("/api/v1/public/authorized/{storeId}/cart", { productId: e, variantId: i, quantity: n });
  }
  async addMultipleItems(e, i) {
    return this.apiClient.put("/api/v1/public/authorized/{storeId}/cart", { products: e, discountCode: i });
  }
  async removeItem(e, i) {
    return this.apiClient.delete("/api/v1/public/authorized/{storeId}/cart", { params: { variant_id: e, quantity: i } });
  }
  async setDiscountCodes(e) {
    return this.apiClient.patch("/api/v1/public/authorized/{storeId}/cart", { discountCode: e });
  }
  async clearCart() {
    var i;
    const e = await this.getCart();
    if (e.valid && ((i = e.data) != null && i.items)) {
      const n = e.data.items.map((r) => this.removeItem(r.variant_id, r.quantity));
      await Promise.all(n);
    }
    return { valid: !0, message: "Cart cleared", data: void 0 };
  }
  async addToCart(e, i, n = 1) {
    return this.addItem(e, i, n);
  }
  async applyDiscountCode(e) {
    const i = await this.getCart();
    if (i.valid && i.data) {
      const n = i.data.discount_codes || [];
      if (!n.includes(e)) return this.setDiscountCodes([...n, e]);
    }
    return i;
  }
  async removeDiscountCode(e) {
    const i = await this.getCart();
    if (i.valid && i.data) {
      const n = (i.data.discount_codes || []).filter((r) => r !== e);
      return this.setDiscountCodes(n);
    }
    return i;
  }
  async validatePromoCode(e) {
    try {
      return await this.apiClient.post("/api/v1/public/authorized/{storeId}/cart/validate-promo", { code: e.code, cart_total: e.cartTotal });
    } catch (i) {
      return { valid: !1, message: i.message || "Invalid promo code" };
    }
  }
}
class An {
  constructor(e) {
    this.apiClient = e;
  }
  async getOrders(e) {
    return this.apiClient.get("/api/v1/public/authorized/{storeId}/order", { params: { ...e } });
  }
  async getOrder(e) {
    return this.apiClient.get(`/api/v1/public/authorized/{storeId}/order/${e}`);
  }
  async searchOrders(e, i) {
    const n = new URLSearchParams();
    return n.append("q", e), i && (i.order_status && n.append("order_status", i.order_status), i.payment_status && n.append("payment_status", i.payment_status), i.status && n.append("status", i.status), i.date_from && n.append("date_from", i.date_from), i.date_to && n.append("date_to", i.date_to), i.page && n.append("page", i.page.toString()), i.limit && n.append("limit", i.limit.toString())), this.apiClient.get(`/api/v1/public/authorized/{storeId}/order/search?${n.toString()}`);
  }
  async getOrderSet(e, i) {
    return this.apiClient.get(`/api/v1/public/authorized/{storeId}/order/${e}/set/${i}`);
  }
  async createOrder(e, i, n) {
    let r = e;
    if (!r) try {
      const l = await this.apiClient.get("/api/v1/public/authorized/{storeId}/cart");
      if (!(l && l.valid && l.data && l.data.id)) return { valid: !1, message: "No cart found for checkout", error: { reason: "no_cart" } };
      r = l.data.id;
    } catch (l) {
      return { valid: !1, message: (l == null ? void 0 : l.message) || "Failed to retrieve cart for checkout", error: l };
    }
    const o = { cart_id: r };
    return i && (o.payment_method = i), n && (o.address_id = n), this.apiClient.post("/api/v1/public/authorized/{storeId}/order/checkout", o);
  }
  async processPayment(e) {
    return this.apiClient.post("/api/v1/public/authorized/{storeId}/order/process-payment", e);
  }
  async handlePaymentSuccess(e, i) {
    return this.apiClient.post(`/api/v1/public/authorized/{storeId}/order/${e}/payment-success`, i);
  }
  async handlePaymentFailure(e, i) {
    return this.apiClient.post(`/api/v1/public/authorized/{storeId}/order/${e}/payment-failure`, i);
  }
  async getPaymentMethods() {
    return this.apiClient.get("/api/v1/public/authorized/{storeId}/payment-methods");
  }
  async getDeliveryOptions(e) {
    return this.apiClient.get("/api/v1/public/authorized/{storeId}/delivery-options", { params: e });
  }
  async getPaymentTypes() {
    return this.apiClient.get("/api/v1/public/{storeId}/paymentTypes");
  }
  async verifyOrderAddress(e, i) {
    return this.apiClient.post("/api/v1/public/authorized/{storeId}/order/verify", { cart_id: e, address_id: i });
  }
}
class Rn {
  constructor(e) {
    this.apiClient = e;
  }
  async getProfile() {
    j.log("[CustomerService] Fetching customer profile from /api/v1/public/authorized/customer");
    const e = await this.apiClient.get("/api/v1/public/authorized/customer");
    return j.log("[CustomerService] Profile response:", e), e;
  }
  async updateProfile(e) {
    return j.log("[CustomerService] Updating customer profile:", e), this.apiClient.put("/api/v1/public/authorized/customer", e);
  }
  async getAddresses() {
    j.log("[CustomerService] Fetching addresses via profile");
    const e = await this.getProfile();
    if (!e.valid || !e.data) return j.error("[CustomerService] Failed to fetch profile for addresses:", e.message), { valid: !1, message: e.message || "Failed to fetch addresses", data: [] };
    const i = e.data.customer_addresses || [];
    return j.log(`[CustomerService] Found ${i.length} addresses`), { valid: !0, message: "Addresses fetched successfully", data: i };
  }
  async addAddress(e) {
    return this.apiClient.post("/api/v1/public/authorized/customer/address", e);
  }
  async updateAddress(e, i) {
    return this.apiClient.patch(`/api/v1/public/authorized/customer/address/${e}`, i);
  }
  async deleteAddress(e) {
    return this.apiClient.delete(`/api/v1/public/authorized/customer/address/${e}`);
  }
  async setDefaultAddress(e) {
    return this.apiClient.patch("/api/v1/public/authorized/customer/profile", { default_address_id: e });
  }
  async addToWishlist(e) {
    return Promise.resolve({ valid: !0, data: { productId: e }, message: "Added to wishlist locally" });
  }
  async removeFromWishlist(e) {
    return Promise.resolve({ valid: !0, data: { productId: e }, message: "Removed from wishlist locally" });
  }
  async clearWishlist() {
    return Promise.resolve({ valid: !0, data: {}, message: "Cleared wishlist locally" });
  }
  async getWishlist() {
    return Promise.resolve({ valid: !0, data: [], message: "Wishlist retrieved locally" });
  }
}
class zn {
  constructor(e) {
    this.apiClient = e;
  }
  async createTicket(e) {
    return this.apiClient.post("/api/v1/public/authorized/{storeId}/tickets", e);
  }
  async getTickets(e) {
    return this.apiClient.get("/api/v1/public/authorized/{storeId}/tickets", { params: { ...e } });
  }
  async getTicket(e) {
    return this.apiClient.get(`/api/v1/public/authorized/{storeId}/tickets/${e}`);
  }
}
class Bn {
  constructor(e) {
    this.apiClient = e;
  }
  async getAsset(e) {
    return this.apiClient.get(`/api/v1/public/{storeId}/assets/${e}`);
  }
}
class $n {
  constructor(e) {
    this.apiClient = e;
  }
  async searchProducts(e, i = {}) {
    var r, o;
    const n = new URLSearchParams();
    return n.append("q", e), (r = i.categories) != null && r.length && n.append("category", i.categories.join(",")), i.priceMin !== void 0 && n.append("price_min", i.priceMin.toString()), i.priceMax !== void 0 && n.append("price_max", i.priceMax.toString()), (o = i.brands) != null && o.length && n.append("brand", i.brands.join(",")), i.availability !== void 0 && n.append("available", i.availability.toString()), i.sortBy && n.append("sort", i.sortBy), i.page && n.append("page", i.page.toString()), i.limit && n.append("limit", i.limit.toString()), this.apiClient.get(`/api/v1/public/{storeId}/search/products?${n.toString()}`);
  }
  async getSearchSuggestions(e, i = 10) {
    const n = new URLSearchParams();
    return n.append("q", e), n.append("limit", i.toString()), this.apiClient.get(`/api/v1/public/{storeId}/search/suggestions?${n.toString()}`);
  }
  async getPopularSearches(e = 10) {
    const i = new URLSearchParams();
    return i.append("limit", e.toString()), this.apiClient.get(`/api/v1/public/{storeId}/search/popular?${i.toString()}`);
  }
  async getTrendingSearches(e = 10) {
    const i = new URLSearchParams();
    return i.append("limit", e.toString()), this.apiClient.get(`/api/v1/public/{storeId}/search/trending?${i.toString()}`);
  }
  getSearchHistory() {
    if (typeof window > "u") return [];
    try {
      const e = localStorage.getItem("shiphouse_search_history");
      return e ? JSON.parse(e) : [];
    } catch {
      return [];
    }
  }
  addToSearchHistory(e) {
    if (typeof window < "u") try {
      const i = this.getSearchHistory(), n = [e, ...i.filter((r) => r !== e)].slice(0, 20);
      localStorage.setItem("shiphouse_search_history", JSON.stringify(n));
    } catch {
    }
  }
  clearSearchHistory() {
    if (typeof window < "u") try {
      localStorage.removeItem("shiphouse_search_history");
    } catch {
    }
  }
  async instantSearch(e) {
    if (!e.trim()) return { valid: !0, data: { products: [], suggestions: [] }, message: "Empty query" };
    const i = new URLSearchParams();
    return i.append("q", e), i.append("limit", "5"), i.append("instant", "true"), this.apiClient.get(`/api/v1/public/{storeId}/search/instant?${i.toString()}`);
  }
}
class On {
  constructor(e) {
    this.apiClient = e;
  }
  async getWishlist() {
    try {
      return this.apiClient.getSessionToken() ? this.apiClient.get("/api/v1/public/authorized/customer/wishlist") : { valid: !0, data: this.getLocalWishlist(), message: "Wishlist loaded from local storage" };
    } catch {
      return { valid: !0, data: this.getLocalWishlist(), message: "Wishlist loaded from local storage (fallback)" };
    }
  }
  async addToWishlist(e, i) {
    try {
      if (this.apiClient.getSessionToken()) {
        const n = await this.apiClient.post("/api/v1/public/authorized/customer/wishlist", { productId: e, variantId: i });
        return n.valid && this.addToLocalWishlist(e, i), n;
      }
      return this.addToLocalWishlist(e, i), { valid: !0, data: this.getLocalWishlist(), message: "Added to wishlist locally" };
    } catch {
      return this.addToLocalWishlist(e, i), { valid: !0, data: this.getLocalWishlist(), message: "Added to wishlist locally (fallback)" };
    }
  }
  async removeFromWishlist(e, i) {
    try {
      if (this.apiClient.getSessionToken()) {
        const n = new URLSearchParams();
        n.append("productId", e), i && n.append("variantId", i);
        const r = await this.apiClient.delete(`/api/v1/public/authorized/customer/wishlist?${n.toString()}`);
        return r.valid && this.removeFromLocalWishlist(e, i), r;
      }
      return this.removeFromLocalWishlist(e, i), { valid: !0, data: this.getLocalWishlist(), message: "Removed from wishlist locally" };
    } catch {
      return this.removeFromLocalWishlist(e, i), { valid: !0, data: this.getLocalWishlist(), message: "Removed from wishlist locally (fallback)" };
    }
  }
  async clearWishlist() {
    try {
      if (this.apiClient.getSessionToken()) {
        const e = await this.apiClient.delete("/api/v1/public/authorized/customer/wishlist/all");
        return e.valid && this.clearLocalWishlist(), e;
      }
      return this.clearLocalWishlist(), { valid: !0, data: this.getLocalWishlist(), message: "Wishlist cleared locally" };
    } catch {
      return this.clearLocalWishlist(), { valid: !0, data: this.getLocalWishlist(), message: "Wishlist cleared locally (fallback)" };
    }
  }
  async isInWishlist(e, i) {
    const n = await this.getWishlist();
    return !(!n.valid || !n.data) && n.data.items.some((r) => r.productId === e && (!i || r.variantId === i));
  }
  async getWishlistCount() {
    const e = await this.getWishlist();
    return e.valid && e.data ? e.data.itemCount : 0;
  }
  getLocalWishlist() {
    if (typeof window > "u") return { id: "local", items: [], itemCount: 0, updatedAt: /* @__PURE__ */ (/* @__PURE__ */ new Date()).toISOString() };
    try {
      const e = localStorage.getItem("shiphouse_wishlist");
      if (e) {
        const i = JSON.parse(e);
        return { id: "local", items: i.items || [], itemCount: (i.items || []).length, updatedAt: i.updatedAt || /* @__PURE__ */ (/* @__PURE__ */ new Date()).toISOString() };
      }
    } catch {
    }
    return { id: "local", items: [], itemCount: 0, updatedAt: /* @__PURE__ */ (/* @__PURE__ */ new Date()).toISOString() };
  }
  addToLocalWishlist(e, i) {
    if (typeof window < "u") try {
      const n = this.getLocalWishlist();
      if (n.items.findIndex((r) => r.productId === e && r.variantId === i) === -1) {
        const r = { id: `${e}-${i || "default"}-${Date.now()}`, productId: e, variantId: i, addedAt: /* @__PURE__ */ (/* @__PURE__ */ new Date()).toISOString() };
        n.items.push(r), n.itemCount = n.items.length, n.updatedAt = /* @__PURE__ */ (/* @__PURE__ */ new Date()).toISOString(), localStorage.setItem("shiphouse_wishlist", JSON.stringify(n));
      }
    } catch {
    }
  }
  removeFromLocalWishlist(e, i) {
    if (typeof window < "u") try {
      const n = this.getLocalWishlist();
      n.items = n.items.filter((r) => !(r.productId === e && r.variantId === i)), n.itemCount = n.items.length, n.updatedAt = /* @__PURE__ */ (/* @__PURE__ */ new Date()).toISOString(), localStorage.setItem("shiphouse_wishlist", JSON.stringify(n));
    } catch {
    }
  }
  clearLocalWishlist() {
    if (typeof window < "u") try {
      const e = { id: "local", items: [], itemCount: 0, updatedAt: /* @__PURE__ */ (/* @__PURE__ */ new Date()).toISOString() };
      localStorage.setItem("shiphouse_wishlist", JSON.stringify(e));
    } catch {
    }
  }
  async syncWithBackend() {
    if (!this.apiClient.getSessionToken()) return { valid: !1, message: "User not authenticated", data: this.getLocalWishlist() };
    try {
      const e = this.getLocalWishlist();
      if (e.items.length > 0) {
        const n = e.items.map((r) => this.apiClient.post("/api/v1/public/authorized/customer/wishlist", { productId: r.productId, variantId: r.variantId }));
        await Promise.allSettled(n);
      }
      const i = await this.apiClient.get("/api/v1/public/authorized/customer/wishlist");
      return i.valid && localStorage.setItem("shiphouse_wishlist", JSON.stringify(i.data)), i;
    } catch (e) {
      return { valid: !1, message: e.message || "Failed to sync wishlist", data: this.getLocalWishlist() };
    }
  }
}
class Mn {
  constructor(e) {
    this.apiClient = e;
  }
  async calculateShippingOptions(e) {
    try {
      const i = [{ id: "standard", name: "Standard Shipping", description: "Regular delivery in 5-7 business days", price: e.items.reduce((n, r) => n + 5 * r.quantity, 0), estimatedDays: { min: 5, max: 7 }, carrier: "Standard Courier", serviceType: "standard" }, { id: "express", name: "Express Shipping", description: "Fast delivery in 2-3 business days", price: e.items.reduce((n, r) => n + 15 * r.quantity, 0), estimatedDays: { min: 2, max: 3 }, carrier: "Express Courier", serviceType: "express" }, { id: "overnight", name: "Overnight Shipping", description: "Next business day delivery", price: e.items.reduce((n, r) => n + 25 * r.quantity, 0), estimatedDays: { min: 1, max: 1 }, carrier: "Priority Courier", serviceType: "overnight" }];
      return { valid: !0, data: this.filterOptionsByLocation(i, e.shippingAddress), message: "Shipping options calculated successfully" };
    } catch (i) {
      return { valid: !1, message: i.message || "Failed to calculate shipping options", data: [] };
    }
  }
  async validateAddress(e) {
    var i, n, r, o;
    try {
      const l = [];
      (i = e.address_line_one) != null && i.trim() || l.push("Address line 1 is required"), (n = e.city) != null && n.trim() || l.push("City is required"), (r = e.state) != null && r.trim() || l.push("State is required"), (o = e.postal_code) != null && o.trim() || l.push("Postal code is required");
      const a = { isValid: l.length === 0, errors: l };
      return { valid: !0, data: a, message: a.isValid ? "Address is valid" : "Address validation failed" };
    } catch (l) {
      return { valid: !1, message: l.message || "Failed to validate address", data: { isValid: !1, errors: [l.message || "Unknown error"] } };
    }
  }
  async estimateDeliveryDate(e, i) {
    try {
      const n = /* @__PURE__ */ new Date(), r = this.getDeliveryDaysForOption(e), o = 1, l = r.min + o, a = r.max + o, d = this.addBusinessDays(n, l), c = this.addBusinessDays(n, a);
      return { valid: !0, data: { estimatedDate: this.addBusinessDays(n, Math.ceil((l + a) / 2)).toISOString().split("T")[0], minimumDate: d.toISOString().split("T")[0], maximumDate: c.toISOString().split("T")[0] }, message: "Delivery date estimated successfully" };
    } catch (n) {
      return { valid: !1, message: n.message || "Failed to estimate delivery date", data: { estimatedDate: "", minimumDate: "", maximumDate: "" } };
    }
  }
  async trackShipment(e) {
    try {
      return { valid: !0, data: { status: "In Transit", location: "Distribution Center - City Name", estimatedDelivery: new Date(Date.now() + 1728e5).toISOString().split("T")[0], events: [{ date: new Date(Date.now() - 1728e5).toISOString(), status: "Shipped", location: "Origin Facility", description: "Package shipped from origin facility" }, { date: new Date(Date.now() - 864e5).toISOString(), status: "In Transit", location: "Distribution Center", description: "Package arrived at distribution center" }] }, message: "Tracking information retrieved successfully" };
    } catch (i) {
      return { valid: !1, message: i.message || "Failed to track shipment", data: { status: "", location: "", estimatedDelivery: "", events: [] } };
    }
  }
  filterOptionsByLocation(e, i) {
    return e;
  }
  getDeliveryDaysForOption(e) {
    return { standard: { min: 5, max: 7 }, express: { min: 2, max: 3 }, overnight: { min: 1, max: 1 }, pickup: { min: 0, max: 0 } }[e] || { min: 5, max: 7 };
  }
  addBusinessDays(e, i) {
    const n = new Date(e);
    let r = i;
    for (; r > 0; ) n.setDate(n.getDate() + 1), n.getDay() !== 0 && n.getDay() !== 6 && r--;
    return n;
  }
}
class Dn {
  constructor(e) {
    this.apiClient = e;
  }
  async getProductReviews(e, i) {
    return this.apiClient.get(`/api/v1/public/{storeId}/products/${e}/reviews`, { params: { ...i } });
  }
  async getReviews(e) {
    return this.apiClient.get("/api/v1/public/{storeId}/reviews", { params: { ...e } });
  }
  async getReview(e) {
    return this.apiClient.get(`/api/v1/public/{storeId}/reviews/${e}`);
  }
  async submitReview(e) {
    const i = new FormData();
    return i.append("product_id", e.product_id), i.append("rating", e.rating.toString()), i.append("title", e.title), i.append("comment", e.comment), e.images && e.images.length > 0 && e.images.forEach((n, r) => {
      n instanceof File ? i.append(`images[${r}]`, n) : typeof n == "string" && i.append(`image_urls[${r}]`, n);
    }), this.apiClient.post("/api/v1/public/{storeId}/reviews", i, { headers: { "Content-Type": "multipart/form-data" } });
  }
  async updateReview(e) {
    const { review_id: i, ...n } = e;
    return this.apiClient.put(`/api/v1/public/{storeId}/reviews/${i}`, n);
  }
  async deleteReview(e) {
    return this.apiClient.delete(`/api/v1/public/{storeId}/reviews/${e}`);
  }
  async getProductReviewStats(e) {
    return this.apiClient.get(`/api/v1/public/{storeId}/products/${e}/reviews/stats`);
  }
  async markReviewHelpful(e) {
    return this.apiClient.post(`/api/v1/public/{storeId}/reviews/${e.review_id}/helpful`, { helpful: e.helpful });
  }
  async getCustomerReviews(e, i) {
    return this.apiClient.get(`/api/v1/public/{storeId}/customers/${e}/reviews`, { params: { ...i } });
  }
  async hasCustomerReviewedProduct(e, i) {
    return this.apiClient.get(`/api/v1/public/{storeId}/products/${e}/reviews/check`, { params: { customer_id: i } });
  }
  async reportReview(e, i) {
    return this.apiClient.post(`/api/v1/public/{storeId}/reviews/${e}/report`, { reason: i });
  }
  async submitProductReview(e, i) {
    const n = { product_slug: e, ...i };
    return this.apiClient.post("/api/v1/public/authorized/{storeId}/reviews", n);
  }
  async getMyReviews(e, i) {
    return this.apiClient.get("/api/v1/public/authorized/{storeId}/reviews", { params: { page: e, page_size: i } });
  }
  async createReview(e) {
    return this.apiClient.post("/api/v1/public/authorized/{storeId}/reviews", e);
  }
  async getReviewImageUploadUrl(e) {
    return this.apiClient.get(`/api/v1/public/authorized/{storeId}/reviews/upload/${encodeURIComponent(e)}`);
  }
  async completeReviewImageUpload(e) {
    const i = { asset_id: e, store_id: this.apiClient.getStoreId() };
    return this.apiClient.post("/api/v1/public/authorized/{storeId}/reviews/upload/complete", i);
  }
  async uploadReviewImage(e) {
    const i = await this.getReviewImageUploadUrl(e.name);
    if (!i.valid || !i.data) throw new Error(i.message || "Failed to get upload URL");
    const { upload_url: n, asset_id: r } = i.data, o = await fetch(n, { method: "PUT", body: e, headers: { "Content-Type": e.type } });
    if (!o.ok) throw new Error(`Upload failed: ${o.statusText}`);
    const l = await this.completeReviewImageUpload(r);
    if (!l.valid) throw new Error(l.message || "Failed to complete upload");
    return r;
  }
  async uploadReviewImages(e) {
    const i = [];
    for (const n of e) {
      const r = await this.uploadReviewImage(n);
      i.push(r);
    }
    return i;
  }
  async submitReviewWithImages(e, i) {
    const { images: n, ...r } = i;
    let o;
    return n && n.length > 0 && (o = await this.uploadReviewImages(n)), this.submitProductReview(e, { ...r, asset_ids: o });
  }
}
const Fc = class Ae {
  constructor(e) {
    this.config = e, yr(this.config) && (console.log("🧪 GlobalSDKManager initialized in TEST MODE"), Ga(this.config)), this.apiClient = new _c(this.config), ln() && (this.apiClient.setSessionToken(fi() || null), this.apiClient.setRefreshToken(vr())), this.auth = new _n(this.apiClient), this.products = new Fn(this.apiClient), this.collections = new Pn(this.apiClient), this.cart = new Ln(this.apiClient), this.orders = new An(this.apiClient), this.customer = new Rn(this.apiClient), this.assets = new Bn(this.apiClient), this.search = new $n(this.apiClient), this.wishlist = new On(this.apiClient), this.shipping = new Mn(this.apiClient), this.reviews = new Dn(this.apiClient), this.support = new zn(this.apiClient);
  }
  static initialize(e) {
    if (Ae.instance) return console.warn("GlobalSDKManager is already initialized. Using existing instance."), Ae.instance;
    Ae.instance = new Ae(e), typeof globalThis < "u" && (globalThis.__SHIPHOUSE_SDK__ = Ae.instance, globalThis.__SHIPHOUSE_CONFIG__ = e);
    const i = e.testMode ? "🧪 [TEST MODE]" : "🚀";
    return console.log(`${i} GlobalSDKManager initialized with config:`, e), Ae.instance;
  }
  static initializeTestMode(e) {
    const i = { storeId: e, testMode: !0 };
    return console.log("🧪 Initializing SDK in TEST MODE"), console.log("📊 Original Store ID:", e), console.log("🌐 Server URL: http://localhost:8000"), console.log("🔗 URLs will use: /test/ instead of /" + e + "/"), console.log('🔑 Auth Token: "test"'), Ae.initialize(i);
  }
  static getInstance() {
    if (!Ae.instance) throw new Error("GlobalSDKManager not initialized. Call GlobalSDKManager.initialize(config) first.");
    return Ae.instance;
  }
  static isInitialized() {
    return Ae.instance !== null;
  }
  getStoreId() {
    return this.config.storeId || "";
  }
  getApiUrl() {
    return this.apiClient.getBaseUrl();
  }
  getConfig() {
    return { ...this.config };
  }
  isTestMode() {
    return !!this.config.testMode;
  }
  getTestConfig() {
    return this.config.testMode ? { testMode: !0, storeId: this.config.storeId || "" } : null;
  }
  getEffectiveStoreId() {
    return this.isTestMode() ? "test" : this.config.storeId || "";
  }
  getEffectiveAuthToken() {
    var e, i;
    return this.isTestMode() ? "test" : fi((i = (e = this.apiClient).getSessionToken) == null ? void 0 : i.call(e)) || "";
  }
  setAuthToken(e) {
    j.log("[GlobalSDKManager] setAuthToken called. token present:", !!e), this.apiClient.setSessionToken(e);
  }
  getAuthToken() {
    const e = this.apiClient.getSessionToken();
    return j.log("[GlobalSDKManager] getAuthToken ->", !!e), e;
  }
  setRefreshToken(e) {
    j.log("[GlobalSDKManager] setRefreshToken called. token present:", !!e), this.apiClient.setRefreshToken(e);
  }
  getRefreshToken() {
    const e = this.apiClient.getRefreshToken();
    return j.log("[GlobalSDKManager] getRefreshToken ->", !!e), e;
  }
  updateConfig(e) {
    this.config = { ...this.config, ...e };
  }
  async request(e, i = {}) {
    const { method: n = "GET", body: r, headers: o, params: l } = i, a = { headers: o, params: l };
    switch (n.toUpperCase()) {
      case "GET":
        return this.apiClient.get(e, a);
      case "POST":
        return this.apiClient.post(e, r, a);
      case "PUT":
        return this.apiClient.put(e, r, a);
      case "PATCH":
        return this.apiClient.patch(e, r, a);
      case "DELETE":
        return this.apiClient.delete(e, a);
      default:
        throw new Error(`Unsupported HTTP method: ${n}`);
    }
  }
  async queuedRequest(e, i, n = {}) {
    const { method: r = "GET", body: o, headers: l, params: a, timeout: d } = n;
    return Ri.enqueue(e, i, r, o, { headers: l, params: a, timeout: d });
  }
  cancelRequests(e) {
    Ri.cancelCategory(e);
  }
  getRequestStats() {
    return Ri.getStats();
  }
  async healthCheck() {
    const e = /* @__PURE__ */ (/* @__PURE__ */ new Date()).toISOString();
    try {
      const i = { auth: this.auth instanceof _n, products: this.products instanceof Fn, collections: this.collections instanceof Pn, cart: this.cart instanceof Ln, orders: this.orders instanceof An, customer: this.customer instanceof Rn, assets: this.assets instanceof Bn, search: this.search instanceof $n, wishlist: this.wishlist instanceof On, shipping: this.shipping instanceof Mn, reviews: this.reviews instanceof Dn, support: this.support instanceof zn };
      return { status: Object.values(i).every((n) => n) ? "healthy" : "unhealthy", services: i, config: this.config, timestamp: e };
    } catch {
      return { status: "unhealthy", services: { auth: !1, products: !1, collections: !1, cart: !1, orders: !1, customer: !1, assets: !1, search: !1, wishlist: !1, shipping: !1, reviews: !1, support: !1 }, config: this.config, timestamp: e };
    }
  }
  static reset() {
    Ae.instance = null, typeof globalThis < "u" && (globalThis.__SHIPHOUSE_SDK__ = void 0, globalThis.__SHIPHOUSE_CONFIG__ = void 0);
  }
};
Fc.instance = null;
const Fr = ({
  productId: t,
  variantId: e,
  title: i,
  image: n,
  price: r,
  className: o = "",
  children: l = "Add to Cart",
  disabled: a = !1,
  style: d,
  autoOpenCart: c = !0
  // Default to true to open cart sidebar
}) => {
  const { addItem: u, openCart: h } = $t();
  return /* @__PURE__ */ s(
    "button",
    {
      onClick: () => {
        !e || a || (console.log("🛒 AddToCartButton: Adding item to cart", {
          productId: t,
          variantId: e,
          title: i,
          image: n,
          price: r,
          autoOpenCart: c
        }), u(
          t,
          e,
          1,
          { autoOpenCart: c }
        ), c && (console.log("🛒 AddToCartButton: Opening cart sidebar"), h()));
      },
      className: o,
      disabled: a || !e,
      style: d,
      children: l
    }
  );
}, Pc = ({
  productData: t,
  productName: e,
  categoryText: i,
  description: n,
  showTitle: r,
  showCategory: o,
  showDescription: l,
  titleFontSize: a,
  titleColor: d,
  categoryFontSize: c,
  categoryColor: u,
  descriptionFontSize: h,
  descriptionColor: m,
  showTaxInfo: v,
  taxInfoText: y,
  taxInfoColor: f,
  priceFontSize: x,
  priceColor: b,
  addToBagText: g,
  addToBagBgColor: k,
  addToBagTextColor: w,
  favoriteText: C,
  buttonHeight: T,
  buttonBorderRadius: I,
  showSustainabilityBadge: E,
  sustainabilityText: P,
  sustainabilityBgColor: S,
  sustainabilityTextColor: K
}) => {
  var re, V;
  const [_, L] = O({}), [N, $] = O(null), A = ce(() => {
    if (!(t != null && t.variants) || t.variants.length === 0)
      return null;
    const G = t.variants.find(
      (Y) => {
        var ie;
        return ((ie = Y.option1) == null ? void 0 : ie.toLowerCase()) === "default";
      }
    );
    return G || t.variants[0];
  }, [t]);
  U(() => {
    if (t) {
      const G = A();
      G && ($(G), L({
        option1: G.option1,
        option2: G.option2,
        option3: G.option3
      }));
    }
  }, [t, A]);
  const M = ce(
    (G, Y) => {
      if (!(t != null && t.options) || !(t != null && t.variants)) {
        console.warn("No product loaded or product has no options");
        return;
      }
      const ie = t.options.findIndex(
        (de) => de.key === G
      );
      if (ie === -1) {
        console.warn(`Option with key "${G}" not found`);
        return;
      }
      const ae = { ..._ }, ge = `option${ie + 1}`;
      ae[ge] = Y, L(ae);
      const ye = t.variants.find((de) => !(ae.option1 && de.option1 !== ae.option1 || ae.option2 && de.option2 !== ae.option2 || ae.option3 && de.option3 !== ae.option3));
      $(ye || null);
    },
    [t, _]
  ), q = (G, Y) => {
    M(G, Y);
  }, H = ce(
    (G, Y) => Cc(t, _, G, Y),
    [t, _]
  ), X = !!(N != null && N.track_inventory && (N.inventory ?? 0) <= 0);
  return /* @__PURE__ */ p("div", { className: "space-y-6", children: [
    Ot() && t && /* @__PURE__ */ p("div", { className: "mb-4 p-2 bg-green-50 border border-green-200 rounded text-xs text-green-800", children: [
      "🎯 ProductInfo: Using SSR product data - ",
      t.title,
      " (ID:",
      " ",
      t.id,
      ")"
    ] }),
    E && /* @__PURE__ */ s("div", { className: "inline-block", children: /* @__PURE__ */ s(
      "span",
      {
        className: "px-3 py-1 text-sm font-medium rounded-full",
        style: {
          backgroundColor: S,
          color: K
        },
        children: P
      }
    ) }),
    r && /* @__PURE__ */ s(
      "h1",
      {
        className: "font-medium leading-tight",
        style: {
          fontSize: `${a}px`,
          color: d
        },
        children: e
      }
    ),
    o && /* @__PURE__ */ s(
      "p",
      {
        style: {
          fontSize: `${c}px`,
          color: u
        },
        children: i
      }
    ),
    /* @__PURE__ */ p("div", { className: "space-y-1", children: [
      /* @__PURE__ */ s("div", { className: "flex items-center gap-3", children: /* @__PURE__ */ s(
        "div",
        {
          className: "font-medium",
          style: {
            fontSize: `${x}px`,
            color: b
          },
          children: Bt((N == null ? void 0 : N.price) || 0)
        }
      ) }),
      v && /* @__PURE__ */ s("div", { className: "text-sm", style: { color: f }, children: y }),
      N && N.track_inventory && /* @__PURE__ */ p(se, { children: [
        N.inventory <= 5 && N.inventory > 0 && /* @__PURE__ */ p("div", { className: "text-sm text-orange-600", children: [
          "Only ",
          N.inventory,
          " left in stock"
        ] }),
        N.inventory <= 0 && /* @__PURE__ */ s("div", { className: "text-sm text-red-600", children: "Out of stock" })
      ] })
    ] }),
    (re = t == null ? void 0 : t.options) == null ? void 0 : re.map((G) => /* @__PURE__ */ p("div", { className: "space-y-3", children: [
      /* @__PURE__ */ s("div", { className: "text-sm font-medium text-gray-900", children: G.title }),
      /* @__PURE__ */ s("div", { className: "flex flex-wrap gap-2", children: G.values.map((Y) => {
        const ie = `option${G.position}`, ae = _[ie] === Y || !_[ie] && (N == null ? void 0 : N[ie]) === Y, ge = H(G.key, Y);
        return /* @__PURE__ */ s(
          "button",
          {
            onClick: () => q(G.key, Y),
            disabled: !ge,
            className: `px-4 py-2 text-sm border rounded-lg transition-colors ${ae ? "border-gray-900 bg-gray-900 text-white" : ge ? "border-gray-200 bg-white text-gray-900 hover:border-gray-400" : "border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed opacity-50"}`,
            title: ge ? void 0 : "Not available with current selection",
            children: Y
          },
          Y
        );
      }) })
    ] }, G.key)),
    /* @__PURE__ */ p("div", { className: "space-y-3", children: [
      /* @__PURE__ */ s(
        Fr,
        {
          productId: (t == null ? void 0 : t.id) || "default",
          variantId: (N == null ? void 0 : N.id) || "",
          title: e,
          image: (V = N == null ? void 0 : N.assets) != null && V[0] ? ht(N.assets[0], 200, 200) : "/placeholder.png",
          price: (N == null ? void 0 : N.price) || 0,
          disabled: !N || X,
          className: "w-full rounded-full font-medium transition-colors duration-200 hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed",
          style: {
            height: `${T}px`,
            backgroundColor: k,
            color: w,
            borderRadius: `${I}px`
          },
          children: X ? "Out of Stock" : g
        }
      ),
      /* @__PURE__ */ s(
        "button",
        {
          className: "w-full rounded-full font-medium border border-gray-200 transition-colors duration-200 hover:bg-gray-50",
          style: {
            height: `${T}px`,
            borderRadius: `${I}px`
          },
          children: /* @__PURE__ */ p("div", { className: "flex items-center justify-center gap-2", children: [
            /* @__PURE__ */ s(
              "svg",
              {
                className: "w-5 h-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.5,
                    d: "M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                  }
                )
              }
            ),
            C
          ] })
        }
      )
    ] }),
    l && n && /* @__PURE__ */ s(
      "div",
      {
        className: "leading-relaxed",
        style: {
          fontSize: `${h}px`,
          color: m
        },
        dangerouslySetInnerHTML: { __html: n }
      }
    )
  ] });
};
function Wn(t) {
  return t.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, "&");
}
function Lc(t) {
  const e = t.trim();
  return e.startsWith("{") && e.endsWith("}") || e.startsWith("[") && e.endsWith("]");
}
function Qi(t) {
  if (!t)
    return "";
  if (typeof t == "string") {
    const e = t.trim();
    if (!e)
      return "";
    if (Lc(e))
      try {
        return Qi(JSON.parse(e));
      } catch {
      }
    return Wn(e);
  }
  if (t.ops && Array.isArray(t.ops)) {
    let e = "";
    for (const i of t.ops)
      if (typeof i.insert == "string") {
        let n = i.insert;
        if (n === `
`) {
          e += "<br />";
          continue;
        }
        i.attributes && (i.attributes.bold && (n = `<strong>${n}</strong>`), i.attributes.italic && (n = `<em>${n}</em>`), i.attributes.underline && (n = `<u>${n}</u>`), i.attributes.strike && (n = `<s>${n}</s>`), i.attributes.link && (n = `<a href="${i.attributes.link}" target="_blank" rel="noopener noreferrer">${n}</a>`), i.attributes.header && (n = `<h${i.attributes.header}>${n}</h${i.attributes.header}>`)), e += n;
      } else typeof i.insert == "object" && i.insert.image && (e += `<img src="${i.insert.image}" alt="Image" />`);
    return e.trim();
  }
  if (typeof t == "object") {
    if (typeof t.html == "string")
      return Wn(t.html.trim());
    if (typeof t.description == "string")
      return Qi(t.description);
  }
  return String(t);
}
const Ac = ({ slug: t }) => /* @__PURE__ */ s("section", { className: "nike-product-maincontent-section", children: /* @__PURE__ */ p("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center", children: [
  /* @__PURE__ */ s("p", { className: "text-[8rem] font-black leading-none text-[#f5f5f5] select-none", children: "404" }),
  /* @__PURE__ */ p("div", { className: "-mt-4", children: [
    /* @__PURE__ */ s("h2", { className: "text-2xl font-bold uppercase tracking-tight text-black", children: "Product Not Found" }),
    t ? /* @__PURE__ */ p("p", { className: "mt-2 text-sm text-[#757575]", children: [
      "No product found for",
      " ",
      /* @__PURE__ */ p("span", { className: "font-medium text-black", children: [
        "“",
        t,
        "”"
      ] }),
      ". It may have been removed or the URL may be incorrect."
    ] }) : /* @__PURE__ */ s("p", { className: "mt-2 text-sm text-[#757575]", children: "No product was specified. Try browsing our latest collection." }),
    /* @__PURE__ */ s(
      "a",
      {
        href: "/",
        className: "mt-6 inline-block bg-black text-white text-sm font-medium px-8 py-4 rounded-full hover:bg-[#333] transition-colors uppercase tracking-wide",
        children: "Shop All Products"
      }
    )
  ] })
] }) }), Rc = () => /* @__PURE__ */ s("section", { className: "nike-product-maincontent-section animate-pulse", children: /* @__PURE__ */ s("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8", children: /* @__PURE__ */ p("div", { className: "grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12", children: [
  /* @__PURE__ */ p("div", { className: "space-y-3", children: [
    /* @__PURE__ */ s("div", { className: "aspect-square rounded-lg bg-[#f5f5f5]" }),
    /* @__PURE__ */ s("div", { className: "flex gap-2", children: [1, 2, 3, 4].map((t) => /* @__PURE__ */ s("div", { className: "w-16 h-16 rounded bg-[#f5f5f5]" }, t)) })
  ] }),
  /* @__PURE__ */ p("div", { className: "space-y-4 pt-2", children: [
    /* @__PURE__ */ s("div", { className: "h-8 w-3/4 rounded bg-[#f5f5f5]" }),
    /* @__PURE__ */ s("div", { className: "h-6 w-1/3 rounded bg-[#f5f5f5]" }),
    /* @__PURE__ */ s("div", { className: "h-4 w-full rounded bg-[#f5f5f5]" }),
    /* @__PURE__ */ s("div", { className: "h-4 w-5/6 rounded bg-[#f5f5f5]" }),
    /* @__PURE__ */ s("div", { className: "h-4 w-4/6 rounded bg-[#f5f5f5]" }),
    /* @__PURE__ */ p("div", { className: "mt-6 flex gap-3", children: [
      /* @__PURE__ */ s("div", { className: "h-14 flex-1 rounded-full bg-[#f5f5f5]" }),
      /* @__PURE__ */ s("div", { className: "h-14 flex-1 rounded-full bg-[#f5f5f5]" })
    ] })
  ] })
] }) }) }), zc = ({
  productData: t,
  className: e,
  routeContext: i,
  viewportMode: n
}) => {
  var v, y;
  const r = t || (v = i == null ? void 0 : i.additionalPath) == null ? void 0 : v.slice(-1)[0], o = me(), { product: l, loading: a, fetchProduct: d } = To();
  U(() => {
    o || r && d(r);
  }, [o, r]);
  const c = t ?? (o ? Ia() : l);
  if (a && !c)
    return /* @__PURE__ */ s(Rc, {});
  if (!c)
    return /* @__PURE__ */ s(
      Ac,
      {
        slug: (y = i == null ? void 0 : i.additionalPath) == null ? void 0 : y.slice(-1)[0]
      }
    );
  const u = c.title || "Nike Product", h = c.assets && c.assets.length > 0 ? c.assets.map((f, x) => ({
    url: ht(f, 600, 600),
    alt: `${u} - View ${x + 1}`,
    id: f.id
  })) : [
    {
      url: "/placeholder.png",
      alt: `${u} - Main View`,
      id: "placeholder"
    }
  ], m = Qi(c.description || "");
  return /* @__PURE__ */ s("section", { className: `nike-product-maincontent-section ${e || ""}`, children: /* @__PURE__ */ s("div", { className: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8", children: /* @__PURE__ */ p("div", { className: "grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12", children: [
    /* @__PURE__ */ s("div", { className: "lg:sticky lg:top-8 lg:self-start", children: /* @__PURE__ */ s(
      wc,
      {
        images: h,
        productName: u,
        showHighlyRated: !0,
        showImageCounter: !0,
        showNavigationArrows: !0,
        aspectRatio: "square",
        borderRadius: 8,
        backgroundColor: "#F9FAFB",
        thumbnailSize: 64,
        thumbnailGap: 8,
        selectedBorderColor: "#000000",
        defaultBorderColor: "#E5E7EB",
        thumbnailPosition: "left",
        badgeText: "Highly Rated",
        badgeBackgroundColor: "#FFFFFF",
        badgeTextColor: "#111827",
        starColor: "#FBBF24"
      }
    ) }),
    /* @__PURE__ */ s("div", { className: "space-y-8", children: /* @__PURE__ */ s(
      Pc,
      {
        productData: c,
        productName: u,
        categoryText: "",
        description: m,
        showTitle: !0,
        showCategory: !1,
        showDescription: !!m,
        titleFontSize: 32,
        titleColor: "#111827",
        categoryFontSize: 16,
        categoryColor: "#6B7280",
        descriptionFontSize: 16,
        descriptionColor: "#374151",
        showTaxInfo: !0,
        taxInfoText: "MRP incl. of all taxes",
        taxInfoColor: "#6B7280",
        priceFontSize: 18,
        priceColor: "#111827",
        addToBagText: "Add to Bag",
        addToBagBgColor: "#000000",
        addToBagTextColor: "#FFFFFF",
        favoriteText: "Favourite",
        buttonHeight: 60,
        buttonBorderRadius: 30,
        showSustainabilityBadge: !1,
        sustainabilityText: "",
        sustainabilityBgColor: "#059669",
        sustainabilityTextColor: "#FFFFFF"
      }
    ) })
  ] }) }) });
}, Bc = ue(zc, {
  identifier: "nike.nikeproduct.productmaincontentsection",
  title: "Main Content",
  featuredImage: "/public/placeholder.png",
  description: "Full product page layout with gallery and info in responsive grid",
  category: "nike",
  className: "nike-product-maincontent",
  components: [],
  renderMode: "client"
}), Ji = ({ rating: t, onRatingChange: e, readonly: i = !1, size: n = "md" }) => {
  const [r, o] = O(0), l = {
    sm: "h-4 w-4",
    md: "h-6 w-6",
    lg: "h-8 w-8"
  };
  return /* @__PURE__ */ s("div", { className: "flex gap-1", children: [1, 2, 3, 4, 5].map((a) => /* @__PURE__ */ s(
    "button",
    {
      type: "button",
      disabled: i,
      onClick: () => e == null ? void 0 : e(a),
      onMouseEnter: () => !i && o(a),
      onMouseLeave: () => !i && o(0),
      className: `${i ? "cursor-default" : "cursor-pointer"} transition-colors`,
      children: /* @__PURE__ */ s(
        "svg",
        {
          className: `${l[n]} ${a <= (r || t) ? "fill-yellow-400 text-yellow-400" : "fill-none text-gray-300"}`,
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          strokeWidth: 1.5,
          children: /* @__PURE__ */ s(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
            }
          )
        }
      )
    },
    a
  )) });
}, $c = ({ isOpen: t, onClose: e, productSlug: i, productName: n }) => {
  const [r, o] = O(0), [l, a] = O(""), [d, c] = O([]), [u, h] = O([]), m = oe(null), { submitReview: v, submitting: y, submitError: f, successMessage: x, clearErrors: b, clearSuccess: g } = Eo(), k = ce(
    (I) => {
      const E = Array.from(I.target.files || []);
      if (E.length + d.length > 5) {
        alert("Maximum 5 images allowed");
        return;
      }
      const P = [...d, ...E].slice(0, 5);
      c(P);
      const S = P.map((K) => URL.createObjectURL(K));
      u.forEach((K) => URL.revokeObjectURL(K)), h(S);
    },
    [d, u]
  ), w = ce(
    (I) => {
      const E = d.filter((S, K) => K !== I);
      c(E), URL.revokeObjectURL(u[I]);
      const P = u.filter((S, K) => K !== I);
      h(P);
    },
    [d, u]
  ), C = ce(
    async (I) => {
      if (I.preventDefault(), r === 0) {
        alert("Please select a rating");
        return;
      }
      if (!l.trim()) {
        alert("Please enter a review");
        return;
      }
      if (!i) {
        alert("Product information is missing");
        return;
      }
      v({
        productSlug: i,
        rating: r,
        description: l.trim(),
        images: d.length > 0 ? d : void 0
      });
    },
    [r, l, d, i, v]
  ), T = ce(() => {
    o(0), a(""), c([]), u.forEach((I) => URL.revokeObjectURL(I)), h([]), b(), g(), e();
  }, [u, e, b, g]);
  return Z.useEffect(() => {
    if (x) {
      const I = setTimeout(() => {
        T();
      }, 2e3);
      return () => clearTimeout(I);
    }
  }, [x, T]), t ? /* @__PURE__ */ s("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4", children: /* @__PURE__ */ p("div", { className: "w-full max-w-lg rounded-lg bg-white p-6 shadow-xl", children: [
    /* @__PURE__ */ p("div", { className: "mb-6 flex items-center justify-between", children: [
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s("h3", { className: "text-xl font-semibold text-gray-900", children: "Write a Review" }),
        n && /* @__PURE__ */ s("p", { className: "text-sm text-gray-500 mt-1", children: n })
      ] }),
      /* @__PURE__ */ s(
        "button",
        {
          onClick: T,
          className: "rounded-full p-1 text-gray-400 hover:bg-gray-100 hover:text-gray-600",
          children: /* @__PURE__ */ s("svg", { className: "h-6 w-6", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ s(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M6 18L18 6M6 6l12 12"
            }
          ) })
        }
      )
    ] }),
    i ? x ? /* @__PURE__ */ p("div", { className: "rounded-lg bg-green-50 p-4 text-center", children: [
      /* @__PURE__ */ s(
        "svg",
        {
          className: "mx-auto mb-2 h-12 w-12 text-green-500",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          children: /* @__PURE__ */ s(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M5 13l4 4L19 7"
            }
          )
        }
      ),
      /* @__PURE__ */ s("p", { className: "text-green-800", children: x })
    ] }) : /* @__PURE__ */ p("form", { onSubmit: C, children: [
      /* @__PURE__ */ p("div", { className: "mb-6", children: [
        /* @__PURE__ */ s("label", { className: "mb-2 block text-sm font-medium text-gray-700", children: "Your Rating" }),
        /* @__PURE__ */ s(Ji, { rating: r, onRatingChange: o, size: "lg" })
      ] }),
      /* @__PURE__ */ p("div", { className: "mb-6", children: [
        /* @__PURE__ */ s(
          "label",
          {
            htmlFor: "review-text",
            className: "mb-2 block text-sm font-medium text-gray-700",
            children: "Your Review"
          }
        ),
        /* @__PURE__ */ s(
          "textarea",
          {
            id: "review-text",
            rows: 4,
            value: l,
            onChange: (I) => a(I.target.value),
            placeholder: "Share your experience with this product...",
            className: "w-full rounded-lg border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-400 focus:border-black focus:outline-none focus:ring-1 focus:ring-black"
          }
        )
      ] }),
      /* @__PURE__ */ p("div", { className: "mb-6", children: [
        /* @__PURE__ */ s("label", { className: "mb-2 block text-sm font-medium text-gray-700", children: "Add Photos (Optional)" }),
        /* @__PURE__ */ s(
          "input",
          {
            ref: m,
            type: "file",
            accept: "image/*",
            multiple: !0,
            onChange: k,
            className: "hidden"
          }
        ),
        /* @__PURE__ */ p("div", { className: "flex flex-wrap gap-2", children: [
          u.map((I, E) => /* @__PURE__ */ p("div", { className: "relative", children: [
            /* @__PURE__ */ s(
              "img",
              {
                src: I,
                alt: `Preview ${E + 1}`,
                className: "h-20 w-20 rounded-lg object-cover"
              }
            ),
            /* @__PURE__ */ s(
              "button",
              {
                type: "button",
                onClick: () => w(E),
                className: "absolute -right-2 -top-2 rounded-full bg-red-500 p-1 text-white hover:bg-red-600",
                children: /* @__PURE__ */ s("svg", { className: "h-3 w-3", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M6 18L18 6M6 6l12 12"
                  }
                ) })
              }
            )
          ] }, E)),
          d.length < 5 && /* @__PURE__ */ s(
            "button",
            {
              type: "button",
              onClick: () => {
                var I;
                return (I = m.current) == null ? void 0 : I.click();
              },
              className: "flex h-20 w-20 items-center justify-center rounded-lg border-2 border-dashed border-gray-300 text-gray-400 hover:border-gray-400 hover:text-gray-500",
              children: /* @__PURE__ */ s("svg", { className: "h-8 w-8", fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", children: /* @__PURE__ */ s(
                "path",
                {
                  strokeLinecap: "round",
                  strokeLinejoin: "round",
                  strokeWidth: 2,
                  d: "M12 4v16m8-8H4"
                }
              ) })
            }
          )
        ] }),
        /* @__PURE__ */ p("p", { className: "mt-1 text-xs text-gray-500", children: [
          d.length,
          "/5 photos added"
        ] })
      ] }),
      f && /* @__PURE__ */ s("div", { className: "mb-4 rounded-lg bg-red-50 p-3 text-sm text-red-700", children: f }),
      /* @__PURE__ */ s(
        "button",
        {
          type: "submit",
          disabled: y || r === 0 || !l.trim(),
          className: "w-full rounded-full bg-black px-6 py-3 text-white transition-colors hover:bg-gray-800 disabled:cursor-not-allowed disabled:bg-gray-300",
          children: y ? /* @__PURE__ */ p("span", { className: "flex items-center justify-center gap-2", children: [
            /* @__PURE__ */ p("svg", { className: "h-5 w-5 animate-spin", viewBox: "0 0 24 24", children: [
              /* @__PURE__ */ s(
                "circle",
                {
                  className: "opacity-25",
                  cx: "12",
                  cy: "12",
                  r: "10",
                  stroke: "currentColor",
                  strokeWidth: "4",
                  fill: "none"
                }
              ),
              /* @__PURE__ */ s(
                "path",
                {
                  className: "opacity-75",
                  fill: "currentColor",
                  d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                }
              )
            ] }),
            "Submitting..."
          ] }) : "Submit Review"
        }
      )
    ] }) : /* @__PURE__ */ p("div", { className: "rounded-lg bg-yellow-50 p-4 text-center", children: [
      /* @__PURE__ */ s(
        "svg",
        {
          className: "mx-auto mb-2 h-12 w-12 text-yellow-500",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          children: /* @__PURE__ */ s(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 2,
              d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            }
          )
        }
      ),
      /* @__PURE__ */ s("p", { className: "text-yellow-800", children: "Unable to submit review. Product information is not available." }),
      /* @__PURE__ */ s(
        "button",
        {
          onClick: T,
          className: "mt-4 rounded-full bg-yellow-600 px-4 py-2 text-sm text-white hover:bg-yellow-700",
          children: "Close"
        }
      )
    ] })
  ] }) }) : null;
}, Oc = [
  // Section Configuration
  F(
    "text-block",
    "section-config",
    {
      desktop: [
        {
          inputKey: "sectionTitle",
          type: "text",
          value: "How Others Are Wearing It"
        },
        {
          inputKey: "subtitle",
          type: "text",
          value: "Upload your photo or mention @Nike on Instagram for a chance to be featured."
        },
        { inputKey: "showSection", type: "checkbox", value: !0 },
        { inputKey: "showUploadButton", type: "checkbox", value: !0 },
        {
          inputKey: "uploadButtonText",
          type: "text",
          value: "Upload Your Photo"
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Section Configuration",
      description: "Social proof section settings"
    }
  ),
  // Photo 1 Configuration
  F(
    "background-image",
    "photo-1-image",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: "public/placeholder.png" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Photo 1 Image",
      description: "First social proof photo"
    }
  ),
  F(
    "text-block",
    "photo-1-content",
    {
      desktop: [
        { inputKey: "username", type: "text", value: "@sneakerhead_raj" },
        {
          inputKey: "altText",
          type: "text",
          value: "Photo by @sneakerhead_raj"
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Photo 1 Content",
      description: "First photo username and details"
    }
  ),
  // Photo 2 Configuration
  F(
    "background-image",
    "photo-2-image",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: "public/placeholder.png" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Photo 2 Image",
      description: "Second social proof photo"
    }
  ),
  F(
    "text-block",
    "photo-2-content",
    {
      desktop: [
        { inputKey: "username", type: "text", value: "@style_guru_mumbai" },
        {
          inputKey: "altText",
          type: "text",
          value: "Photo by @style_guru_mumbai"
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Photo 2 Content",
      description: "Second photo username and details"
    }
  ),
  // Photo 3 Configuration
  F(
    "background-image",
    "photo-3-image",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: "public/placeholder.png" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Photo 3 Image",
      description: "Third social proof photo"
    }
  ),
  F(
    "text-block",
    "photo-3-content",
    {
      desktop: [
        { inputKey: "username", type: "text", value: "@kicks_collector" },
        {
          inputKey: "altText",
          type: "text",
          value: "Photo by @kicks_collector"
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Photo 3 Content",
      description: "Third photo username and details"
    }
  ),
  // Photo 4 Configuration
  F(
    "background-image",
    "photo-4-image",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: "public/placeholder.png" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Photo 4 Image",
      description: "Fourth social proof photo"
    }
  ),
  F(
    "text-block",
    "photo-4-content",
    {
      desktop: [
        { inputKey: "username", type: "text", value: "@street_style_delhi" },
        {
          inputKey: "altText",
          type: "text",
          value: "Photo by @street_style_delhi"
        }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Photo 4 Content",
      description: "Fourth photo username and details"
    }
  )
], ci = [
  {
    image: z.featured.featured1,
    username: "@nike_india",
    altText: "Nike social proof photo 1"
  },
  {
    image: z.featured.featured2,
    username: "@sneakerhead_raj",
    altText: "Nike social proof photo 2"
  },
  {
    image: z.featured.featured3,
    username: "@style_guru_mumbai",
    altText: "Nike social proof photo 3"
  },
  {
    image: z.trending.trending1,
    username: "@kicks_collector",
    altText: "Nike social proof photo 4"
  }
], Pr = [
  {
    id: "fake-social-proof-1",
    rating: 5,
    verified_purchase: !0,
    title: "Easy all-day wear",
    comment: "Comfortable straight out of the box with a clean look that works with everything.",
    customer_name: "Aarav",
    created_at: "2026-04-28T10:30:00.000Z",
    images: [
      {
        url: z.featured.featured1,
        thumbnail_url: z.featured.featured1
      }
    ]
  },
  {
    id: "fake-social-proof-2",
    rating: 4,
    verified_purchase: !0,
    title: "Looks sharp in person",
    comment: "The materials and proportions feel premium. Great pickup for daily wear.",
    customer_name: "Meera",
    created_at: "2026-04-25T15:45:00.000Z",
    images: [
      {
        url: z.featured.featured2,
        thumbnail_url: z.featured.featured2
      }
    ]
  },
  {
    id: "fake-social-proof-3",
    rating: 5,
    verified_purchase: !1,
    title: "Worth the hype",
    comment: "Strong fit, polished finish, and the colorway stands out without being loud.",
    customer_name: "Karan",
    created_at: "2026-04-20T08:15:00.000Z",
    images: [
      {
        url: z.featured.featured3,
        thumbnail_url: z.featured.featured3
      }
    ]
  }
], Mc = {
  average_rating: 4.8,
  total_reviews: Pr.length
}, Dc = ({
  data: t,
  theme: e,
  config: i,
  productData: n,
  storeId: r
}) => {
  var ae, ge, ye, de, qe, De, it, nt, rt, ot, st, at, lt, ct;
  const [o, l] = O(0), [a, d] = O(!1), c = me(), u = (Q, te) => {
    var dt;
    const Ne = R(t, "background-image", Q);
    return Array.isArray(Ne == null ? void 0 : Ne.desktop) && ((dt = Ne.desktop[0]) == null ? void 0 : dt.value) || te;
  }, h = c ? ci[0].image : u("photo-1-image", "public/placeholder.png"), m = c ? ci[1].image : u("photo-2-image", "public/placeholder.png"), v = c ? ci[2].image : u("photo-3-image", "public/placeholder.png"), y = c ? ci[3].image : u("photo-4-image", "public/placeholder.png"), [f, x] = O(
    typeof h == "string" && !h.startsWith("http") ? z.featured.featured1 : h
  ), [b, g] = O(
    typeof m == "string" && !m.startsWith("http") ? z.featured.featured2 : m
  ), [k, w] = O(
    typeof v == "string" && !v.startsWith("http") ? z.featured.featured3 : v
  ), [C, T] = O(
    typeof y == "string" && !y.startsWith("http") ? z.trending.trending1 : y
  );
  U(() => {
    if (c) {
      x(z.featured.featured1);
      return;
    }
    (async () => {
      try {
        if (typeof h == "string" && h && r) {
          const te = await we(
            h,
            r,
            { width: 500, height: 500, fit: "cover" }
          );
          x(te);
        }
      } catch (te) {
        console.error("[SocialProofClient] Failed to fetch photo1 asset:", te), x("public/placeholder.png");
      }
    })();
  }, [c, h, r]), U(() => {
    if (c) {
      g(z.featured.featured2);
      return;
    }
    (async () => {
      try {
        if (typeof m == "string" && m && r) {
          const te = await we(
            m,
            r,
            { width: 500, height: 500, fit: "cover" }
          );
          g(te);
        }
      } catch (te) {
        console.error("[SocialProofClient] Failed to fetch photo2 asset:", te), g("public/placeholder.png");
      }
    })();
  }, [c, m, r]), U(() => {
    if (c) {
      w(z.featured.featured3);
      return;
    }
    (async () => {
      try {
        if (typeof v == "string" && v && r) {
          const te = await we(
            v,
            r,
            { width: 500, height: 500, fit: "cover" }
          );
          w(te);
        }
      } catch (te) {
        console.error("[SocialProofClient] Failed to fetch photo3 asset:", te), w("public/placeholder.png");
      }
    })();
  }, [c, v, r]), U(() => {
    if (c) {
      T(z.trending.trending1);
      return;
    }
    (async () => {
      try {
        if (typeof y == "string" && y && r) {
          const te = await we(
            y,
            r,
            { width: 500, height: 500, fit: "cover" }
          );
          T(te);
        }
      } catch (te) {
        console.error("[SocialProofClient] Failed to fetch photo4 asset:", te), T("public/placeholder.png");
      }
    })();
  }, [c, y, r]);
  const I = n == null ? void 0 : n.slug, { reviews: E, stats: P, loading: S } = Io(
    c ? void 0 : I
  ), K = c ? Pr : E, _ = c ? Mc : P, L = c ? !1 : S, N = R(
    t,
    "text-block",
    "section-config"
  ), $ = ((ge = (ae = N == null ? void 0 : N.desktop) == null ? void 0 : ae.find(
    (Q) => Q.inputKey === "sectionTitle"
  )) == null ? void 0 : ge.value) || "How Others Are Wearing It", A = ((de = (ye = N == null ? void 0 : N.desktop) == null ? void 0 : ye.find(
    (Q) => Q.inputKey === "subtitle"
  )) == null ? void 0 : de.value) || "Upload your photo or mention @Nike on Instagram for a chance to be featured.", M = ((De = (qe = N == null ? void 0 : N.desktop) == null ? void 0 : qe.find(
    (Q) => Q.inputKey === "showSection"
  )) == null ? void 0 : De.value) !== !1, q = ((nt = (it = N == null ? void 0 : N.desktop) == null ? void 0 : it.find(
    (Q) => Q.inputKey === "showUploadButton"
  )) == null ? void 0 : nt.value) !== !1, H = ((ot = (rt = N == null ? void 0 : N.desktop) == null ? void 0 : rt.find(
    (Q) => Q.inputKey === "uploadButtonText"
  )) == null ? void 0 : ot.value) || "Upload Your Photo", X = [], re = [f, b, k, C];
  for (let Q = 1; Q <= 4; Q++) {
    const te = R(
      t,
      "text-block",
      `photo-${Q}-content`
    );
    te && X.push({
      id: Q,
      image: re[Q - 1],
      username: ((at = (st = te == null ? void 0 : te.desktop) == null ? void 0 : st.find(
        (Ne) => Ne.inputKey === "username"
      )) == null ? void 0 : at.value) || `@user${Q}`,
      altText: ((ct = (lt = te == null ? void 0 : te.desktop) == null ? void 0 : lt.find(
        (Ne) => Ne.inputKey === "altText"
      )) == null ? void 0 : ct.value) || `Photo by user ${Q}`
    });
  }
  const V = o > 0, G = o < X.length - 4, Y = () => {
    V && l(o - 1);
  }, ie = () => {
    G && l(o + 1);
  };
  return M ? /* @__PURE__ */ p("section", { className: "py-16", children: [
    /* @__PURE__ */ p("div", { className: "mx-auto max-w-7xl px-4 sm:px-6 lg:px-8", children: [
      /* @__PURE__ */ p("div", { className: "mb-8 text-center", children: [
        /* @__PURE__ */ s("h2", { className: "mb-4 text-2xl font-medium text-black md:text-3xl", children: $ }),
        /* @__PURE__ */ s("p", { className: "text-gray-600", children: A }),
        q && /* @__PURE__ */ p(
          "button",
          {
            onClick: () => d(!0),
            className: "mt-4 inline-flex items-center gap-2 rounded-full border border-gray-300 bg-white px-6 py-3 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-black focus:ring-offset-2",
            children: [
              /* @__PURE__ */ s(
                "svg",
                {
                  className: "h-5 w-5",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  children: /* @__PURE__ */ s(
                    "path",
                    {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M12 4v16m8-8H4"
                    }
                  )
                }
              ),
              H
            ]
          }
        ),
        _ && /* @__PURE__ */ p("div", { className: "mt-4 flex items-center justify-center gap-4", children: [
          /* @__PURE__ */ p("div", { className: "flex items-center gap-1", children: [
            /* @__PURE__ */ s(Ji, { rating: Math.round(_.average_rating), readonly: !0, size: "sm" }),
            /* @__PURE__ */ s("span", { className: "text-sm font-medium text-gray-700", children: _.average_rating.toFixed(1) })
          ] }),
          /* @__PURE__ */ p("span", { className: "text-sm text-gray-500", children: [
            "(",
            _.total_reviews,
            " ",
            _.total_reviews === 1 ? "review" : "reviews",
            ")"
          ] })
        ] })
      ] }),
      /* @__PURE__ */ p("div", { className: "mb-6 flex justify-center gap-2", children: [
        /* @__PURE__ */ s(
          "button",
          {
            onClick: Y,
            disabled: !V,
            className: "flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
            children: /* @__PURE__ */ s(
              "svg",
              {
                className: "h-5 w-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M15 19l-7-7 7-7"
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ s(
          "button",
          {
            onClick: ie,
            disabled: !G,
            className: "flex h-10 w-10 items-center justify-center rounded-full border border-gray-300 bg-white text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50",
            children: /* @__PURE__ */ s(
              "svg",
              {
                className: "h-5 w-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M9 5l7 7-7 7"
                  }
                )
              }
            )
          }
        )
      ] }),
      /* @__PURE__ */ s("div", { className: "overflow-hidden", children: /* @__PURE__ */ s(
        "div",
        {
          className: "flex gap-6 transition-transform duration-300",
          style: { transform: `translateX(-${o * 25}%)` },
          children: X.map((Q) => /* @__PURE__ */ p(
            "button",
            {
              className: "group min-w-0 flex-shrink-0 basis-1/4 cursor-pointer focus:outline-none",
              children: [
                /* @__PURE__ */ s("div", { className: "overflow-hidden rounded-lg bg-gray-100", children: /* @__PURE__ */ s(
                  $e,
                  {
                    src: Q.image,
                    alt: Q.altText,
                    className: "aspect-square w-full object-cover transition-transform duration-300 group-hover:scale-105",
                    showPlaceholderIcon: !1
                  }
                ) }),
                /* @__PURE__ */ s("p", { className: "mt-2 text-center text-sm font-medium text-gray-700 group-hover:text-black", children: Q.username })
              ]
            },
            Q.id
          ))
        }
      ) }),
      K && K.length > 0 && /* @__PURE__ */ p("div", { className: "mt-12 border-t border-gray-200 pt-12", children: [
        /* @__PURE__ */ s("h3", { className: "mb-6 text-xl font-medium text-gray-900", children: "Customer Reviews" }),
        /* @__PURE__ */ s("div", { className: "space-y-6", children: K.slice(0, 5).map((Q) => /* @__PURE__ */ p("div", { className: "border-b border-gray-100 pb-6 last:border-0", children: [
          /* @__PURE__ */ p("div", { className: "mb-2 flex items-center gap-3", children: [
            /* @__PURE__ */ s(Ji, { rating: Q.rating, readonly: !0, size: "sm" }),
            Q.verified_purchase && /* @__PURE__ */ s("span", { className: "rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700", children: "Verified Purchase" })
          ] }),
          Q.title && /* @__PURE__ */ s("h4", { className: "mb-1 font-medium text-gray-900", children: Q.title }),
          /* @__PURE__ */ s("p", { className: "mb-2 text-gray-600", children: Q.comment }),
          /* @__PURE__ */ p("div", { className: "flex items-center gap-4 text-sm text-gray-500", children: [
            /* @__PURE__ */ s("span", { children: Q.customer_name || "Anonymous" }),
            Q.created_at && /* @__PURE__ */ s("span", { children: new Date(Q.created_at).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric"
            }) })
          ] }),
          Q.images && Q.images.length > 0 && /* @__PURE__ */ s("div", { className: "mt-3 flex gap-2", children: Q.images.map((te, Ne) => /* @__PURE__ */ s(
            "img",
            {
              src: te.url || te.thumbnail_url,
              alt: `Review image ${Ne + 1}`,
              className: "h-16 w-16 rounded-lg object-cover"
            },
            Ne
          )) })
        ] }, Q.id)) })
      ] }),
      L && /* @__PURE__ */ s("div", { className: "mt-12 flex justify-center", children: /* @__PURE__ */ p("svg", { className: "h-8 w-8 animate-spin text-gray-400", viewBox: "0 0 24 24", children: [
        /* @__PURE__ */ s(
          "circle",
          {
            className: "opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "4",
            fill: "none"
          }
        ),
        /* @__PURE__ */ s(
          "path",
          {
            className: "opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ s(
      $c,
      {
        isOpen: a,
        onClose: () => d(!1),
        productSlug: I,
        productName: (n == null ? void 0 : n.name) || (n == null ? void 0 : n.title)
      }
    )
  ] }) : null;
}, Wc = ue(Dc, {
  identifier: "nike.nikeproduct.socialproof",
  title: "Social Proof",
  featuredImage: z.previews.trending,
  description: "Social proof section with user-generated content photos and Instagram integration",
  category: "product",
  className: "nike-social-proof",
  components: Oc,
  renderMode: "client"
});
function Hn(t) {
  return t !== null && typeof t == "object" && "constructor" in t && t.constructor === Object;
}
function dn(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = {});
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => i.indexOf(n) < 0).forEach((n) => {
    typeof t[n] > "u" ? t[n] = e[n] : Hn(e[n]) && Hn(t[n]) && Object.keys(e[n]).length > 0 && dn(t[n], e[n]);
  });
}
const Lr = {
  body: {},
  addEventListener() {
  },
  removeEventListener() {
  },
  activeElement: {
    blur() {
    },
    nodeName: ""
  },
  querySelector() {
    return null;
  },
  querySelectorAll() {
    return [];
  },
  getElementById() {
    return null;
  },
  createEvent() {
    return {
      initEvent() {
      }
    };
  },
  createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute() {
      },
      getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS() {
    return {};
  },
  importNode() {
    return null;
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  }
};
function yt() {
  const t = typeof document < "u" ? document : {};
  return dn(t, Lr), t;
}
const Hc = {
  document: Lr,
  navigator: {
    userAgent: ""
  },
  location: {
    hash: "",
    host: "",
    hostname: "",
    href: "",
    origin: "",
    pathname: "",
    protocol: "",
    search: ""
  },
  history: {
    replaceState() {
    },
    pushState() {
    },
    go() {
    },
    back() {
    }
  },
  CustomEvent: function() {
    return this;
  },
  addEventListener() {
  },
  removeEventListener() {
  },
  getComputedStyle() {
    return {
      getPropertyValue() {
        return "";
      }
    };
  },
  Image() {
  },
  Date() {
  },
  screen: {},
  setTimeout() {
  },
  clearTimeout() {
  },
  matchMedia() {
    return {};
  },
  requestAnimationFrame(t) {
    return typeof setTimeout > "u" ? (t(), null) : setTimeout(t, 0);
  },
  cancelAnimationFrame(t) {
    typeof setTimeout > "u" || clearTimeout(t);
  }
};
function Te() {
  const t = typeof window < "u" ? window : {};
  return dn(t, Hc), t;
}
function jc(t) {
  return t === void 0 && (t = ""), t.trim().split(" ").filter((e) => !!e.trim());
}
function Vc(t) {
  const e = t;
  Object.keys(e).forEach((i) => {
    try {
      e[i] = null;
    } catch {
    }
    try {
      delete e[i];
    } catch {
    }
  });
}
function Ar(t, e) {
  return e === void 0 && (e = 0), setTimeout(t, e);
}
function xi() {
  return Date.now();
}
function Uc(t) {
  const e = Te();
  let i;
  return e.getComputedStyle && (i = e.getComputedStyle(t, null)), !i && t.currentStyle && (i = t.currentStyle), i || (i = t.style), i;
}
function qc(t, e) {
  e === void 0 && (e = "x");
  const i = Te();
  let n, r, o;
  const l = Uc(t);
  return i.WebKitCSSMatrix ? (r = l.transform || l.webkitTransform, r.split(",").length > 6 && (r = r.split(", ").map((a) => a.replace(",", ".")).join(", ")), o = new i.WebKitCSSMatrix(r === "none" ? "" : r)) : (o = l.MozTransform || l.OTransform || l.MsTransform || l.msTransform || l.transform || l.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = o.toString().split(",")), e === "x" && (i.WebKitCSSMatrix ? r = o.m41 : n.length === 16 ? r = parseFloat(n[12]) : r = parseFloat(n[4])), e === "y" && (i.WebKitCSSMatrix ? r = o.m42 : n.length === 16 ? r = parseFloat(n[13]) : r = parseFloat(n[5])), r || 0;
}
function di(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object";
}
function Gc(t) {
  return typeof window < "u" && typeof window.HTMLElement < "u" ? t instanceof HTMLElement : t && (t.nodeType === 1 || t.nodeType === 11);
}
function Fe() {
  const t = Object(arguments.length <= 0 ? void 0 : arguments[0]), e = ["__proto__", "constructor", "prototype"];
  for (let i = 1; i < arguments.length; i += 1) {
    const n = i < 0 || arguments.length <= i ? void 0 : arguments[i];
    if (n != null && !Gc(n)) {
      const r = Object.keys(Object(n)).filter((o) => e.indexOf(o) < 0);
      for (let o = 0, l = r.length; o < l; o += 1) {
        const a = r[o], d = Object.getOwnPropertyDescriptor(n, a);
        d !== void 0 && d.enumerable && (di(t[a]) && di(n[a]) ? n[a].__swiper__ ? t[a] = n[a] : Fe(t[a], n[a]) : !di(t[a]) && di(n[a]) ? (t[a] = {}, n[a].__swiper__ ? t[a] = n[a] : Fe(t[a], n[a])) : t[a] = n[a]);
      }
    }
  }
  return t;
}
function ui(t, e, i) {
  t.style.setProperty(e, i);
}
function Rr(t) {
  let {
    swiper: e,
    targetPosition: i,
    side: n
  } = t;
  const r = Te(), o = -e.translate;
  let l = null, a;
  const d = e.params.speed;
  e.wrapperEl.style.scrollSnapType = "none", r.cancelAnimationFrame(e.cssModeFrameID);
  const c = i > o ? "next" : "prev", u = (m, v) => c === "next" && m >= v || c === "prev" && m <= v, h = () => {
    a = (/* @__PURE__ */ new Date()).getTime(), l === null && (l = a);
    const m = Math.max(Math.min((a - l) / d, 1), 0), v = 0.5 - Math.cos(m * Math.PI) / 2;
    let y = o + v * (i - o);
    if (u(y, i) && (y = i), e.wrapperEl.scrollTo({
      [n]: y
    }), u(y, i)) {
      e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout(() => {
        e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
          [n]: y
        });
      }), r.cancelAnimationFrame(e.cssModeFrameID);
      return;
    }
    e.cssModeFrameID = r.requestAnimationFrame(h);
  };
  h();
}
function Me(t, e) {
  e === void 0 && (e = "");
  const i = Te(), n = [...t.children];
  return i.HTMLSlotElement && t instanceof HTMLSlotElement && n.push(...t.assignedElements()), e ? n.filter((r) => r.matches(e)) : n;
}
function Yc(t, e) {
  const i = [e];
  for (; i.length > 0; ) {
    const n = i.shift();
    if (t === n)
      return !0;
    i.push(...n.children, ...n.shadowRoot ? n.shadowRoot.children : [], ...n.assignedElements ? n.assignedElements() : []);
  }
}
function Xc(t, e) {
  const i = Te();
  let n = e.contains(t);
  return !n && i.HTMLSlotElement && e instanceof HTMLSlotElement && (n = [...e.assignedElements()].includes(t), n || (n = Yc(t, e))), n;
}
function ki(t) {
  try {
    console.warn(t);
    return;
  } catch {
  }
}
function wi(t, e) {
  e === void 0 && (e = []);
  const i = document.createElement(t);
  return i.classList.add(...Array.isArray(e) ? e : jc(e)), i;
}
function Qc(t, e) {
  const i = [];
  for (; t.previousElementSibling; ) {
    const n = t.previousElementSibling;
    e ? n.matches(e) && i.push(n) : i.push(n), t = n;
  }
  return i;
}
function Jc(t, e) {
  const i = [];
  for (; t.nextElementSibling; ) {
    const n = t.nextElementSibling;
    e ? n.matches(e) && i.push(n) : i.push(n), t = n;
  }
  return i;
}
function Ze(t, e) {
  return Te().getComputedStyle(t, null).getPropertyValue(e);
}
function Si(t) {
  let e = t, i;
  if (e) {
    for (i = 0; (e = e.previousSibling) !== null; )
      e.nodeType === 1 && (i += 1);
    return i;
  }
}
function zr(t, e) {
  const i = [];
  let n = t.parentElement;
  for (; n; )
    e ? n.matches(e) && i.push(n) : i.push(n), n = n.parentElement;
  return i;
}
function Zi(t, e, i) {
  const n = Te();
  return t[e === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(t, null).getPropertyValue(e === "width" ? "margin-left" : "margin-bottom"));
}
function ke(t) {
  return (Array.isArray(t) ? t : [t]).filter((e) => !!e);
}
function Ci(t, e) {
  e === void 0 && (e = ""), typeof trustedTypes < "u" ? t.innerHTML = trustedTypes.createPolicy("html", {
    createHTML: (i) => i
  }).createHTML(e) : t.innerHTML = e;
}
let zi;
function Zc() {
  const t = Te(), e = yt();
  return {
    smoothScroll: e.documentElement && e.documentElement.style && "scrollBehavior" in e.documentElement.style,
    touch: !!("ontouchstart" in t || t.DocumentTouch && e instanceof t.DocumentTouch)
  };
}
function Br() {
  return zi || (zi = Zc()), zi;
}
let Bi;
function ed(t) {
  let {
    userAgent: e
  } = t === void 0 ? {} : t;
  const i = Br(), n = Te(), r = n.navigator.platform, o = e || n.navigator.userAgent, l = {
    ios: !1,
    android: !1
  }, a = n.screen.width, d = n.screen.height, c = o.match(/(Android);?[\s\/]+([\d.]+)?/);
  let u = o.match(/(iPad).*OS\s([\d_]+)/);
  const h = o.match(/(iPod)(.*OS\s([\d_]+))?/), m = !u && o.match(/(iPhone\sOS|iOS)\s([\d_]+)/), v = r === "Win32";
  let y = r === "MacIntel";
  const f = ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"];
  return !u && y && i.touch && f.indexOf(`${a}x${d}`) >= 0 && (u = o.match(/(Version)\/([\d.]+)/), u || (u = [0, 1, "13_0_0"]), y = !1), c && !v && (l.os = "android", l.android = !0), (u || m || h) && (l.os = "ios", l.ios = !0), l;
}
function $r(t) {
  return t === void 0 && (t = {}), Bi || (Bi = ed(t)), Bi;
}
let $i;
function td() {
  const t = Te(), e = $r();
  let i = !1;
  function n() {
    const a = t.navigator.userAgent.toLowerCase();
    return a.indexOf("safari") >= 0 && a.indexOf("chrome") < 0 && a.indexOf("android") < 0;
  }
  if (n()) {
    const a = String(t.navigator.userAgent);
    if (a.includes("Version/")) {
      const [d, c] = a.split("Version/")[1].split(" ")[0].split(".").map((u) => Number(u));
      i = d < 16 || d === 16 && c < 2;
    }
  }
  const r = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(t.navigator.userAgent), o = n(), l = o || r && e.ios;
  return {
    isSafari: i || o,
    needPerspectiveFix: i,
    need3dFix: l,
    isWebView: r
  };
}
function Or() {
  return $i || ($i = td()), $i;
}
function id(t) {
  let {
    swiper: e,
    on: i,
    emit: n
  } = t;
  const r = Te();
  let o = null, l = null;
  const a = () => {
    !e || e.destroyed || !e.initialized || (n("beforeResize"), n("resize"));
  }, d = () => {
    !e || e.destroyed || !e.initialized || (o = new ResizeObserver((h) => {
      l = r.requestAnimationFrame(() => {
        const {
          width: m,
          height: v
        } = e;
        let y = m, f = v;
        h.forEach((x) => {
          let {
            contentBoxSize: b,
            contentRect: g,
            target: k
          } = x;
          k && k !== e.el || (y = g ? g.width : (b[0] || b).inlineSize, f = g ? g.height : (b[0] || b).blockSize);
        }), (y !== m || f !== v) && a();
      });
    }), o.observe(e.el));
  }, c = () => {
    l && r.cancelAnimationFrame(l), o && o.unobserve && e.el && (o.unobserve(e.el), o = null);
  }, u = () => {
    !e || e.destroyed || !e.initialized || n("orientationchange");
  };
  i("init", () => {
    if (e.params.resizeObserver && typeof r.ResizeObserver < "u") {
      d();
      return;
    }
    r.addEventListener("resize", a), r.addEventListener("orientationchange", u);
  }), i("destroy", () => {
    c(), r.removeEventListener("resize", a), r.removeEventListener("orientationchange", u);
  });
}
function nd(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: r
  } = t;
  const o = [], l = Te(), a = function(u, h) {
    h === void 0 && (h = {});
    const m = l.MutationObserver || l.WebkitMutationObserver, v = new m((y) => {
      if (e.__preventObserver__) return;
      if (y.length === 1) {
        r("observerUpdate", y[0]);
        return;
      }
      const f = function() {
        r("observerUpdate", y[0]);
      };
      l.requestAnimationFrame ? l.requestAnimationFrame(f) : l.setTimeout(f, 0);
    });
    v.observe(u, {
      attributes: typeof h.attributes > "u" ? !0 : h.attributes,
      childList: e.isElement || (typeof h.childList > "u" ? !0 : h).childList,
      characterData: typeof h.characterData > "u" ? !0 : h.characterData
    }), o.push(v);
  }, d = () => {
    if (e.params.observer) {
      if (e.params.observeParents) {
        const u = zr(e.hostEl);
        for (let h = 0; h < u.length; h += 1)
          a(u[h]);
      }
      a(e.hostEl, {
        childList: e.params.observeSlideChildren
      }), a(e.wrapperEl, {
        attributes: !1
      });
    }
  }, c = () => {
    o.forEach((u) => {
      u.disconnect();
    }), o.splice(0, o.length);
  };
  i({
    observer: !1,
    observeParents: !1,
    observeSlideChildren: !1
  }), n("init", d), n("destroy", c);
}
var rd = {
  on(t, e, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    const r = i ? "unshift" : "push";
    return t.split(" ").forEach((o) => {
      n.eventsListeners[o] || (n.eventsListeners[o] = []), n.eventsListeners[o][r](e);
    }), n;
  },
  once(t, e, i) {
    const n = this;
    if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
    function r() {
      n.off(t, r), r.__emitterProxy && delete r.__emitterProxy;
      for (var o = arguments.length, l = new Array(o), a = 0; a < o; a++)
        l[a] = arguments[a];
      e.apply(n, l);
    }
    return r.__emitterProxy = e, n.on(t, r, i);
  },
  onAny(t, e) {
    const i = this;
    if (!i.eventsListeners || i.destroyed || typeof t != "function") return i;
    const n = e ? "unshift" : "push";
    return i.eventsAnyListeners.indexOf(t) < 0 && i.eventsAnyListeners[n](t), i;
  },
  offAny(t) {
    const e = this;
    if (!e.eventsListeners || e.destroyed || !e.eventsAnyListeners) return e;
    const i = e.eventsAnyListeners.indexOf(t);
    return i >= 0 && e.eventsAnyListeners.splice(i, 1), e;
  },
  off(t, e) {
    const i = this;
    return !i.eventsListeners || i.destroyed || !i.eventsListeners || t.split(" ").forEach((n) => {
      typeof e > "u" ? i.eventsListeners[n] = [] : i.eventsListeners[n] && i.eventsListeners[n].forEach((r, o) => {
        (r === e || r.__emitterProxy && r.__emitterProxy === e) && i.eventsListeners[n].splice(o, 1);
      });
    }), i;
  },
  emit() {
    const t = this;
    if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
    let e, i, n;
    for (var r = arguments.length, o = new Array(r), l = 0; l < r; l++)
      o[l] = arguments[l];
    return typeof o[0] == "string" || Array.isArray(o[0]) ? (e = o[0], i = o.slice(1, o.length), n = t) : (e = o[0].events, i = o[0].data, n = o[0].context || t), i.unshift(n), (Array.isArray(e) ? e : e.split(" ")).forEach((d) => {
      t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((c) => {
        c.apply(n, [d, ...i]);
      }), t.eventsListeners && t.eventsListeners[d] && t.eventsListeners[d].forEach((c) => {
        c.apply(n, i);
      });
    }), t;
  }
};
function od() {
  const t = this;
  let e, i;
  const n = t.el;
  typeof t.params.width < "u" && t.params.width !== null ? e = t.params.width : e = n.clientWidth, typeof t.params.height < "u" && t.params.height !== null ? i = t.params.height : i = n.clientHeight, !(e === 0 && t.isHorizontal() || i === 0 && t.isVertical()) && (e = e - parseInt(Ze(n, "padding-left") || 0, 10) - parseInt(Ze(n, "padding-right") || 0, 10), i = i - parseInt(Ze(n, "padding-top") || 0, 10) - parseInt(Ze(n, "padding-bottom") || 0, 10), Number.isNaN(e) && (e = 0), Number.isNaN(i) && (i = 0), Object.assign(t, {
    width: e,
    height: i,
    size: t.isHorizontal() ? e : i
  }));
}
function sd() {
  const t = this;
  function e(S, K) {
    return parseFloat(S.getPropertyValue(t.getDirectionLabel(K)) || 0);
  }
  const i = t.params, {
    wrapperEl: n,
    slidesEl: r,
    size: o,
    rtlTranslate: l,
    wrongRTL: a
  } = t, d = t.virtual && i.virtual.enabled, c = d ? t.virtual.slides.length : t.slides.length, u = Me(r, `.${t.params.slideClass}, swiper-slide`), h = d ? t.virtual.slides.length : u.length;
  let m = [];
  const v = [], y = [];
  let f = i.slidesOffsetBefore;
  typeof f == "function" && (f = i.slidesOffsetBefore.call(t));
  let x = i.slidesOffsetAfter;
  typeof x == "function" && (x = i.slidesOffsetAfter.call(t));
  const b = t.snapGrid.length, g = t.slidesGrid.length;
  let k = i.spaceBetween, w = -f, C = 0, T = 0;
  if (typeof o > "u")
    return;
  typeof k == "string" && k.indexOf("%") >= 0 ? k = parseFloat(k.replace("%", "")) / 100 * o : typeof k == "string" && (k = parseFloat(k)), t.virtualSize = -k, u.forEach((S) => {
    l ? S.style.marginLeft = "" : S.style.marginRight = "", S.style.marginBottom = "", S.style.marginTop = "";
  }), i.centeredSlides && i.cssMode && (ui(n, "--swiper-centered-offset-before", ""), ui(n, "--swiper-centered-offset-after", ""));
  const I = i.grid && i.grid.rows > 1 && t.grid;
  I ? t.grid.initSlides(u) : t.grid && t.grid.unsetSlides();
  let E;
  const P = i.slidesPerView === "auto" && i.breakpoints && Object.keys(i.breakpoints).filter((S) => typeof i.breakpoints[S].slidesPerView < "u").length > 0;
  for (let S = 0; S < h; S += 1) {
    E = 0;
    let K;
    if (u[S] && (K = u[S]), I && t.grid.updateSlide(S, K, u), !(u[S] && Ze(K, "display") === "none")) {
      if (i.slidesPerView === "auto") {
        P && (u[S].style[t.getDirectionLabel("width")] = "");
        const _ = getComputedStyle(K), L = K.style.transform, N = K.style.webkitTransform;
        if (L && (K.style.transform = "none"), N && (K.style.webkitTransform = "none"), i.roundLengths)
          E = t.isHorizontal() ? Zi(K, "width") : Zi(K, "height");
        else {
          const $ = e(_, "width"), A = e(_, "padding-left"), M = e(_, "padding-right"), q = e(_, "margin-left"), H = e(_, "margin-right"), X = _.getPropertyValue("box-sizing");
          if (X && X === "border-box")
            E = $ + q + H;
          else {
            const {
              clientWidth: re,
              offsetWidth: V
            } = K;
            E = $ + A + M + q + H + (V - re);
          }
        }
        L && (K.style.transform = L), N && (K.style.webkitTransform = N), i.roundLengths && (E = Math.floor(E));
      } else
        E = (o - (i.slidesPerView - 1) * k) / i.slidesPerView, i.roundLengths && (E = Math.floor(E)), u[S] && (u[S].style[t.getDirectionLabel("width")] = `${E}px`);
      u[S] && (u[S].swiperSlideSize = E), y.push(E), i.centeredSlides ? (w = w + E / 2 + C / 2 + k, C === 0 && S !== 0 && (w = w - o / 2 - k), S === 0 && (w = w - o / 2 - k), Math.abs(w) < 1 / 1e3 && (w = 0), i.roundLengths && (w = Math.floor(w)), T % i.slidesPerGroup === 0 && m.push(w), v.push(w)) : (i.roundLengths && (w = Math.floor(w)), (T - Math.min(t.params.slidesPerGroupSkip, T)) % t.params.slidesPerGroup === 0 && m.push(w), v.push(w), w = w + E + k), t.virtualSize += E + k, C = E, T += 1;
    }
  }
  if (t.virtualSize = Math.max(t.virtualSize, o) + x, l && a && (i.effect === "slide" || i.effect === "coverflow") && (n.style.width = `${t.virtualSize + k}px`), i.setWrapperSize && (n.style[t.getDirectionLabel("width")] = `${t.virtualSize + k}px`), I && t.grid.updateWrapperSize(E, m), !i.centeredSlides) {
    const S = [];
    for (let K = 0; K < m.length; K += 1) {
      let _ = m[K];
      i.roundLengths && (_ = Math.floor(_)), m[K] <= t.virtualSize - o && S.push(_);
    }
    m = S, Math.floor(t.virtualSize - o) - Math.floor(m[m.length - 1]) > 1 && m.push(t.virtualSize - o);
  }
  if (d && i.loop) {
    const S = y[0] + k;
    if (i.slidesPerGroup > 1) {
      const K = Math.ceil((t.virtual.slidesBefore + t.virtual.slidesAfter) / i.slidesPerGroup), _ = S * i.slidesPerGroup;
      for (let L = 0; L < K; L += 1)
        m.push(m[m.length - 1] + _);
    }
    for (let K = 0; K < t.virtual.slidesBefore + t.virtual.slidesAfter; K += 1)
      i.slidesPerGroup === 1 && m.push(m[m.length - 1] + S), v.push(v[v.length - 1] + S), t.virtualSize += S;
  }
  if (m.length === 0 && (m = [0]), k !== 0) {
    const S = t.isHorizontal() && l ? "marginLeft" : t.getDirectionLabel("marginRight");
    u.filter((K, _) => !i.cssMode || i.loop ? !0 : _ !== u.length - 1).forEach((K) => {
      K.style[S] = `${k}px`;
    });
  }
  if (i.centeredSlides && i.centeredSlidesBounds) {
    let S = 0;
    y.forEach((_) => {
      S += _ + (k || 0);
    }), S -= k;
    const K = S > o ? S - o : 0;
    m = m.map((_) => _ <= 0 ? -f : _ > K ? K + x : _);
  }
  if (i.centerInsufficientSlides) {
    let S = 0;
    y.forEach((_) => {
      S += _ + (k || 0);
    }), S -= k;
    const K = (i.slidesOffsetBefore || 0) + (i.slidesOffsetAfter || 0);
    if (S + K < o) {
      const _ = (o - S - K) / 2;
      m.forEach((L, N) => {
        m[N] = L - _;
      }), v.forEach((L, N) => {
        v[N] = L + _;
      });
    }
  }
  if (Object.assign(t, {
    slides: u,
    snapGrid: m,
    slidesGrid: v,
    slidesSizesGrid: y
  }), i.centeredSlides && i.cssMode && !i.centeredSlidesBounds) {
    ui(n, "--swiper-centered-offset-before", `${-m[0]}px`), ui(n, "--swiper-centered-offset-after", `${t.size / 2 - y[y.length - 1] / 2}px`);
    const S = -t.snapGrid[0], K = -t.slidesGrid[0];
    t.snapGrid = t.snapGrid.map((_) => _ + S), t.slidesGrid = t.slidesGrid.map((_) => _ + K);
  }
  if (h !== c && t.emit("slidesLengthChange"), m.length !== b && (t.params.watchOverflow && t.checkOverflow(), t.emit("snapGridLengthChange")), v.length !== g && t.emit("slidesGridLengthChange"), i.watchSlidesProgress && t.updateSlidesOffset(), t.emit("slidesUpdated"), !d && !i.cssMode && (i.effect === "slide" || i.effect === "fade")) {
    const S = `${i.containerModifierClass}backface-hidden`, K = t.el.classList.contains(S);
    h <= i.maxBackfaceHiddenSlides ? K || t.el.classList.add(S) : K && t.el.classList.remove(S);
  }
}
function ad(t) {
  const e = this, i = [], n = e.virtual && e.params.virtual.enabled;
  let r = 0, o;
  typeof t == "number" ? e.setTransition(t) : t === !0 && e.setTransition(e.params.speed);
  const l = (a) => n ? e.slides[e.getSlideIndexByData(a)] : e.slides[a];
  if (e.params.slidesPerView !== "auto" && e.params.slidesPerView > 1)
    if (e.params.centeredSlides)
      (e.visibleSlides || []).forEach((a) => {
        i.push(a);
      });
    else
      for (o = 0; o < Math.ceil(e.params.slidesPerView); o += 1) {
        const a = e.activeIndex + o;
        if (a > e.slides.length && !n) break;
        i.push(l(a));
      }
  else
    i.push(l(e.activeIndex));
  for (o = 0; o < i.length; o += 1)
    if (typeof i[o] < "u") {
      const a = i[o].offsetHeight;
      r = a > r ? a : r;
    }
  (r || r === 0) && (e.wrapperEl.style.height = `${r}px`);
}
function ld() {
  const t = this, e = t.slides, i = t.isElement ? t.isHorizontal() ? t.wrapperEl.offsetLeft : t.wrapperEl.offsetTop : 0;
  for (let n = 0; n < e.length; n += 1)
    e[n].swiperSlideOffset = (t.isHorizontal() ? e[n].offsetLeft : e[n].offsetTop) - i - t.cssOverflowAdjustment();
}
const jn = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function cd(t) {
  t === void 0 && (t = this && this.translate || 0);
  const e = this, i = e.params, {
    slides: n,
    rtlTranslate: r,
    snapGrid: o
  } = e;
  if (n.length === 0) return;
  typeof n[0].swiperSlideOffset > "u" && e.updateSlidesOffset();
  let l = -t;
  r && (l = t), e.visibleSlidesIndexes = [], e.visibleSlides = [];
  let a = i.spaceBetween;
  typeof a == "string" && a.indexOf("%") >= 0 ? a = parseFloat(a.replace("%", "")) / 100 * e.size : typeof a == "string" && (a = parseFloat(a));
  for (let d = 0; d < n.length; d += 1) {
    const c = n[d];
    let u = c.swiperSlideOffset;
    i.cssMode && i.centeredSlides && (u -= n[0].swiperSlideOffset);
    const h = (l + (i.centeredSlides ? e.minTranslate() : 0) - u) / (c.swiperSlideSize + a), m = (l - o[0] + (i.centeredSlides ? e.minTranslate() : 0) - u) / (c.swiperSlideSize + a), v = -(l - u), y = v + e.slidesSizesGrid[d], f = v >= 0 && v <= e.size - e.slidesSizesGrid[d], x = v >= 0 && v < e.size - 1 || y > 1 && y <= e.size || v <= 0 && y >= e.size;
    x && (e.visibleSlides.push(c), e.visibleSlidesIndexes.push(d)), jn(c, x, i.slideVisibleClass), jn(c, f, i.slideFullyVisibleClass), c.progress = r ? -h : h, c.originalProgress = r ? -m : m;
  }
}
function dd(t) {
  const e = this;
  if (typeof t > "u") {
    const u = e.rtlTranslate ? -1 : 1;
    t = e && e.translate && e.translate * u || 0;
  }
  const i = e.params, n = e.maxTranslate() - e.minTranslate();
  let {
    progress: r,
    isBeginning: o,
    isEnd: l,
    progressLoop: a
  } = e;
  const d = o, c = l;
  if (n === 0)
    r = 0, o = !0, l = !0;
  else {
    r = (t - e.minTranslate()) / n;
    const u = Math.abs(t - e.minTranslate()) < 1, h = Math.abs(t - e.maxTranslate()) < 1;
    o = u || r <= 0, l = h || r >= 1, u && (r = 0), h && (r = 1);
  }
  if (i.loop) {
    const u = e.getSlideIndexByData(0), h = e.getSlideIndexByData(e.slides.length - 1), m = e.slidesGrid[u], v = e.slidesGrid[h], y = e.slidesGrid[e.slidesGrid.length - 1], f = Math.abs(t);
    f >= m ? a = (f - m) / y : a = (f + y - v) / y, a > 1 && (a -= 1);
  }
  Object.assign(e, {
    progress: r,
    progressLoop: a,
    isBeginning: o,
    isEnd: l
  }), (i.watchSlidesProgress || i.centeredSlides && i.autoHeight) && e.updateSlidesProgress(t), o && !d && e.emit("reachBeginning toEdge"), l && !c && e.emit("reachEnd toEdge"), (d && !o || c && !l) && e.emit("fromEdge"), e.emit("progress", r);
}
const Oi = (t, e, i) => {
  e && !t.classList.contains(i) ? t.classList.add(i) : !e && t.classList.contains(i) && t.classList.remove(i);
};
function ud() {
  const t = this, {
    slides: e,
    params: i,
    slidesEl: n,
    activeIndex: r
  } = t, o = t.virtual && i.virtual.enabled, l = t.grid && i.grid && i.grid.rows > 1, a = (h) => Me(n, `.${i.slideClass}${h}, swiper-slide${h}`)[0];
  let d, c, u;
  if (o)
    if (i.loop) {
      let h = r - t.virtual.slidesBefore;
      h < 0 && (h = t.virtual.slides.length + h), h >= t.virtual.slides.length && (h -= t.virtual.slides.length), d = a(`[data-swiper-slide-index="${h}"]`);
    } else
      d = a(`[data-swiper-slide-index="${r}"]`);
  else
    l ? (d = e.find((h) => h.column === r), u = e.find((h) => h.column === r + 1), c = e.find((h) => h.column === r - 1)) : d = e[r];
  d && (l || (u = Jc(d, `.${i.slideClass}, swiper-slide`)[0], i.loop && !u && (u = e[0]), c = Qc(d, `.${i.slideClass}, swiper-slide`)[0], i.loop && !c === 0 && (c = e[e.length - 1]))), e.forEach((h) => {
    Oi(h, h === d, i.slideActiveClass), Oi(h, h === u, i.slideNextClass), Oi(h, h === c, i.slidePrevClass);
  }), t.emitSlidesClasses();
}
const gi = (t, e) => {
  if (!t || t.destroyed || !t.params) return;
  const i = () => t.isElement ? "swiper-slide" : `.${t.params.slideClass}`, n = e.closest(i());
  if (n) {
    let r = n.querySelector(`.${t.params.lazyPreloaderClass}`);
    !r && t.isElement && (n.shadowRoot ? r = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`) : requestAnimationFrame(() => {
      n.shadowRoot && (r = n.shadowRoot.querySelector(`.${t.params.lazyPreloaderClass}`), r && r.remove());
    })), r && r.remove();
  }
}, Mi = (t, e) => {
  if (!t.slides[e]) return;
  const i = t.slides[e].querySelector('[loading="lazy"]');
  i && i.removeAttribute("loading");
}, en = (t) => {
  if (!t || t.destroyed || !t.params) return;
  let e = t.params.lazyPreloadPrevNext;
  const i = t.slides.length;
  if (!i || !e || e < 0) return;
  e = Math.min(e, i);
  const n = t.params.slidesPerView === "auto" ? t.slidesPerViewDynamic() : Math.ceil(t.params.slidesPerView), r = t.activeIndex;
  if (t.params.grid && t.params.grid.rows > 1) {
    const l = r, a = [l - e];
    a.push(...Array.from({
      length: e
    }).map((d, c) => l + n + c)), t.slides.forEach((d, c) => {
      a.includes(d.column) && Mi(t, c);
    });
    return;
  }
  const o = r + n - 1;
  if (t.params.rewind || t.params.loop)
    for (let l = r - e; l <= o + e; l += 1) {
      const a = (l % i + i) % i;
      (a < r || a > o) && Mi(t, a);
    }
  else
    for (let l = Math.max(r - e, 0); l <= Math.min(o + e, i - 1); l += 1)
      l !== r && (l > o || l < r) && Mi(t, l);
};
function pd(t) {
  const {
    slidesGrid: e,
    params: i
  } = t, n = t.rtlTranslate ? t.translate : -t.translate;
  let r;
  for (let o = 0; o < e.length; o += 1)
    typeof e[o + 1] < "u" ? n >= e[o] && n < e[o + 1] - (e[o + 1] - e[o]) / 2 ? r = o : n >= e[o] && n < e[o + 1] && (r = o + 1) : n >= e[o] && (r = o);
  return i.normalizeSlideIndex && (r < 0 || typeof r > "u") && (r = 0), r;
}
function md(t) {
  const e = this, i = e.rtlTranslate ? e.translate : -e.translate, {
    snapGrid: n,
    params: r,
    activeIndex: o,
    realIndex: l,
    snapIndex: a
  } = e;
  let d = t, c;
  const u = (v) => {
    let y = v - e.virtual.slidesBefore;
    return y < 0 && (y = e.virtual.slides.length + y), y >= e.virtual.slides.length && (y -= e.virtual.slides.length), y;
  };
  if (typeof d > "u" && (d = pd(e)), n.indexOf(i) >= 0)
    c = n.indexOf(i);
  else {
    const v = Math.min(r.slidesPerGroupSkip, d);
    c = v + Math.floor((d - v) / r.slidesPerGroup);
  }
  if (c >= n.length && (c = n.length - 1), d === o && !e.params.loop) {
    c !== a && (e.snapIndex = c, e.emit("snapIndexChange"));
    return;
  }
  if (d === o && e.params.loop && e.virtual && e.params.virtual.enabled) {
    e.realIndex = u(d);
    return;
  }
  const h = e.grid && r.grid && r.grid.rows > 1;
  let m;
  if (e.virtual && r.virtual.enabled && r.loop)
    m = u(d);
  else if (h) {
    const v = e.slides.find((f) => f.column === d);
    let y = parseInt(v.getAttribute("data-swiper-slide-index"), 10);
    Number.isNaN(y) && (y = Math.max(e.slides.indexOf(v), 0)), m = Math.floor(y / r.grid.rows);
  } else if (e.slides[d]) {
    const v = e.slides[d].getAttribute("data-swiper-slide-index");
    v ? m = parseInt(v, 10) : m = d;
  } else
    m = d;
  Object.assign(e, {
    previousSnapIndex: a,
    snapIndex: c,
    previousRealIndex: l,
    realIndex: m,
    previousIndex: o,
    activeIndex: d
  }), e.initialized && en(e), e.emit("activeIndexChange"), e.emit("snapIndexChange"), (e.initialized || e.params.runCallbacksOnInit) && (l !== m && e.emit("realIndexChange"), e.emit("slideChange"));
}
function hd(t, e) {
  const i = this, n = i.params;
  let r = t.closest(`.${n.slideClass}, swiper-slide`);
  !r && i.isElement && e && e.length > 1 && e.includes(t) && [...e.slice(e.indexOf(t) + 1, e.length)].forEach((a) => {
    !r && a.matches && a.matches(`.${n.slideClass}, swiper-slide`) && (r = a);
  });
  let o = !1, l;
  if (r) {
    for (let a = 0; a < i.slides.length; a += 1)
      if (i.slides[a] === r) {
        o = !0, l = a;
        break;
      }
  }
  if (r && o)
    i.clickedSlide = r, i.virtual && i.params.virtual.enabled ? i.clickedIndex = parseInt(r.getAttribute("data-swiper-slide-index"), 10) : i.clickedIndex = l;
  else {
    i.clickedSlide = void 0, i.clickedIndex = void 0;
    return;
  }
  n.slideToClickedSlide && i.clickedIndex !== void 0 && i.clickedIndex !== i.activeIndex && i.slideToClickedSlide();
}
var gd = {
  updateSize: od,
  updateSlides: sd,
  updateAutoHeight: ad,
  updateSlidesOffset: ld,
  updateSlidesProgress: cd,
  updateProgress: dd,
  updateSlidesClasses: ud,
  updateActiveIndex: md,
  updateClickedSlide: hd
};
function fd(t) {
  t === void 0 && (t = this.isHorizontal() ? "x" : "y");
  const e = this, {
    params: i,
    rtlTranslate: n,
    translate: r,
    wrapperEl: o
  } = e;
  if (i.virtualTranslate)
    return n ? -r : r;
  if (i.cssMode)
    return r;
  let l = qc(o, t);
  return l += e.cssOverflowAdjustment(), n && (l = -l), l || 0;
}
function yd(t, e) {
  const i = this, {
    rtlTranslate: n,
    params: r,
    wrapperEl: o,
    progress: l
  } = i;
  let a = 0, d = 0;
  const c = 0;
  i.isHorizontal() ? a = n ? -t : t : d = t, r.roundLengths && (a = Math.floor(a), d = Math.floor(d)), i.previousTranslate = i.translate, i.translate = i.isHorizontal() ? a : d, r.cssMode ? o[i.isHorizontal() ? "scrollLeft" : "scrollTop"] = i.isHorizontal() ? -a : -d : r.virtualTranslate || (i.isHorizontal() ? a -= i.cssOverflowAdjustment() : d -= i.cssOverflowAdjustment(), o.style.transform = `translate3d(${a}px, ${d}px, ${c}px)`);
  let u;
  const h = i.maxTranslate() - i.minTranslate();
  h === 0 ? u = 0 : u = (t - i.minTranslate()) / h, u !== l && i.updateProgress(t), i.emit("setTranslate", i.translate, e);
}
function bd() {
  return -this.snapGrid[0];
}
function vd() {
  return -this.snapGrid[this.snapGrid.length - 1];
}
function xd(t, e, i, n, r) {
  t === void 0 && (t = 0), e === void 0 && (e = this.params.speed), i === void 0 && (i = !0), n === void 0 && (n = !0);
  const o = this, {
    params: l,
    wrapperEl: a
  } = o;
  if (o.animating && l.preventInteractionOnTransition)
    return !1;
  const d = o.minTranslate(), c = o.maxTranslate();
  let u;
  if (n && t > d ? u = d : n && t < c ? u = c : u = t, o.updateProgress(u), l.cssMode) {
    const h = o.isHorizontal();
    if (e === 0)
      a[h ? "scrollLeft" : "scrollTop"] = -u;
    else {
      if (!o.support.smoothScroll)
        return Rr({
          swiper: o,
          targetPosition: -u,
          side: h ? "left" : "top"
        }), !0;
      a.scrollTo({
        [h ? "left" : "top"]: -u,
        behavior: "smooth"
      });
    }
    return !0;
  }
  return e === 0 ? (o.setTransition(0), o.setTranslate(u), i && (o.emit("beforeTransitionStart", e, r), o.emit("transitionEnd"))) : (o.setTransition(e), o.setTranslate(u), i && (o.emit("beforeTransitionStart", e, r), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd || (o.onTranslateToWrapperTransitionEnd = function(m) {
    !o || o.destroyed || m.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, o.animating = !1, i && o.emit("transitionEnd"));
  }), o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), !0;
}
var kd = {
  getTranslate: fd,
  setTranslate: yd,
  minTranslate: bd,
  maxTranslate: vd,
  translateTo: xd
};
function wd(t, e) {
  const i = this;
  i.params.cssMode || (i.wrapperEl.style.transitionDuration = `${t}ms`, i.wrapperEl.style.transitionDelay = t === 0 ? "0ms" : ""), i.emit("setTransition", t, e);
}
function Mr(t) {
  let {
    swiper: e,
    runCallbacks: i,
    direction: n,
    step: r
  } = t;
  const {
    activeIndex: o,
    previousIndex: l
  } = e;
  let a = n;
  a || (o > l ? a = "next" : o < l ? a = "prev" : a = "reset"), e.emit(`transition${r}`), i && a === "reset" ? e.emit(`slideResetTransition${r}`) : i && o !== l && (e.emit(`slideChangeTransition${r}`), a === "next" ? e.emit(`slideNextTransition${r}`) : e.emit(`slidePrevTransition${r}`));
}
function Sd(t, e) {
  t === void 0 && (t = !0);
  const i = this, {
    params: n
  } = i;
  n.cssMode || (n.autoHeight && i.updateAutoHeight(), Mr({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "Start"
  }));
}
function Cd(t, e) {
  t === void 0 && (t = !0);
  const i = this, {
    params: n
  } = i;
  i.animating = !1, !n.cssMode && (i.setTransition(0), Mr({
    swiper: i,
    runCallbacks: t,
    direction: e,
    step: "End"
  }));
}
var Nd = {
  setTransition: wd,
  transitionStart: Sd,
  transitionEnd: Cd
};
function Kd(t, e, i, n, r) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const o = this;
  let l = t;
  l < 0 && (l = 0);
  const {
    params: a,
    snapGrid: d,
    slidesGrid: c,
    previousIndex: u,
    activeIndex: h,
    rtlTranslate: m,
    wrapperEl: v,
    enabled: y
  } = o;
  if (!y && !n && !r || o.destroyed || o.animating && a.preventInteractionOnTransition)
    return !1;
  typeof e > "u" && (e = o.params.speed);
  const f = Math.min(o.params.slidesPerGroupSkip, l);
  let x = f + Math.floor((l - f) / o.params.slidesPerGroup);
  x >= d.length && (x = d.length - 1);
  const b = -d[x];
  if (a.normalizeSlideIndex)
    for (let I = 0; I < c.length; I += 1) {
      const E = -Math.floor(b * 100), P = Math.floor(c[I] * 100), S = Math.floor(c[I + 1] * 100);
      typeof c[I + 1] < "u" ? E >= P && E < S - (S - P) / 2 ? l = I : E >= P && E < S && (l = I + 1) : E >= P && (l = I);
    }
  if (o.initialized && l !== h && (!o.allowSlideNext && (m ? b > o.translate && b > o.minTranslate() : b < o.translate && b < o.minTranslate()) || !o.allowSlidePrev && b > o.translate && b > o.maxTranslate() && (h || 0) !== l))
    return !1;
  l !== (u || 0) && i && o.emit("beforeSlideChangeStart"), o.updateProgress(b);
  let g;
  l > h ? g = "next" : l < h ? g = "prev" : g = "reset";
  const k = o.virtual && o.params.virtual.enabled;
  if (!(k && r) && (m && -b === o.translate || !m && b === o.translate))
    return o.updateActiveIndex(l), a.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), a.effect !== "slide" && o.setTranslate(b), g !== "reset" && (o.transitionStart(i, g), o.transitionEnd(i, g)), !1;
  if (a.cssMode) {
    const I = o.isHorizontal(), E = m ? b : -b;
    if (e === 0)
      k && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = !0), k && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = !0, requestAnimationFrame(() => {
        v[I ? "scrollLeft" : "scrollTop"] = E;
      })) : v[I ? "scrollLeft" : "scrollTop"] = E, k && requestAnimationFrame(() => {
        o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = !1;
      });
    else {
      if (!o.support.smoothScroll)
        return Rr({
          swiper: o,
          targetPosition: E,
          side: I ? "left" : "top"
        }), !0;
      v.scrollTo({
        [I ? "left" : "top"]: E,
        behavior: "smooth"
      });
    }
    return !0;
  }
  const T = Or().isSafari;
  return k && !r && T && o.isElement && o.virtual.update(!1, !1, l), o.setTransition(e), o.setTranslate(b), o.updateActiveIndex(l), o.updateSlidesClasses(), o.emit("beforeTransitionStart", e, n), o.transitionStart(i, g), e === 0 ? o.transitionEnd(i, g) : o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd || (o.onSlideToWrapperTransitionEnd = function(E) {
    !o || o.destroyed || E.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(i, g));
  }), o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), !0;
}
function Td(t, e, i, n) {
  t === void 0 && (t = 0), i === void 0 && (i = !0), typeof t == "string" && (t = parseInt(t, 10));
  const r = this;
  if (r.destroyed) return;
  typeof e > "u" && (e = r.params.speed);
  const o = r.grid && r.params.grid && r.params.grid.rows > 1;
  let l = t;
  if (r.params.loop)
    if (r.virtual && r.params.virtual.enabled)
      l = l + r.virtual.slidesBefore;
    else {
      let a;
      if (o) {
        const m = l * r.params.grid.rows;
        a = r.slides.find((v) => v.getAttribute("data-swiper-slide-index") * 1 === m).column;
      } else
        a = r.getSlideIndexByData(l);
      const d = o ? Math.ceil(r.slides.length / r.params.grid.rows) : r.slides.length, {
        centeredSlides: c
      } = r.params;
      let u = r.params.slidesPerView;
      u === "auto" ? u = r.slidesPerViewDynamic() : (u = Math.ceil(parseFloat(r.params.slidesPerView, 10)), c && u % 2 === 0 && (u = u + 1));
      let h = d - a < u;
      if (c && (h = h || a < Math.ceil(u / 2)), n && c && r.params.slidesPerView !== "auto" && !o && (h = !1), h) {
        const m = c ? a < r.activeIndex ? "prev" : "next" : a - r.activeIndex - 1 < r.params.slidesPerView ? "next" : "prev";
        r.loopFix({
          direction: m,
          slideTo: !0,
          activeSlideIndex: m === "next" ? a + 1 : a - d + 1,
          slideRealIndex: m === "next" ? r.realIndex : void 0
        });
      }
      if (o) {
        const m = l * r.params.grid.rows;
        l = r.slides.find((v) => v.getAttribute("data-swiper-slide-index") * 1 === m).column;
      } else
        l = r.getSlideIndexByData(l);
    }
  return requestAnimationFrame(() => {
    r.slideTo(l, e, i, n);
  }), r;
}
function Id(t, e, i) {
  e === void 0 && (e = !0);
  const n = this, {
    enabled: r,
    params: o,
    animating: l
  } = n;
  if (!r || n.destroyed) return n;
  typeof t > "u" && (t = n.params.speed);
  let a = o.slidesPerGroup;
  o.slidesPerView === "auto" && o.slidesPerGroup === 1 && o.slidesPerGroupAuto && (a = Math.max(n.slidesPerViewDynamic("current", !0), 1));
  const d = n.activeIndex < o.slidesPerGroupSkip ? 1 : a, c = n.virtual && o.virtual.enabled;
  if (o.loop) {
    if (l && !c && o.loopPreventsSliding) return !1;
    if (n.loopFix({
      direction: "next"
    }), n._clientLeft = n.wrapperEl.clientLeft, n.activeIndex === n.slides.length - 1 && o.cssMode)
      return requestAnimationFrame(() => {
        n.slideTo(n.activeIndex + d, t, e, i);
      }), !0;
  }
  return o.rewind && n.isEnd ? n.slideTo(0, t, e, i) : n.slideTo(n.activeIndex + d, t, e, i);
}
function Ed(t, e, i) {
  e === void 0 && (e = !0);
  const n = this, {
    params: r,
    snapGrid: o,
    slidesGrid: l,
    rtlTranslate: a,
    enabled: d,
    animating: c
  } = n;
  if (!d || n.destroyed) return n;
  typeof t > "u" && (t = n.params.speed);
  const u = n.virtual && r.virtual.enabled;
  if (r.loop) {
    if (c && !u && r.loopPreventsSliding) return !1;
    n.loopFix({
      direction: "prev"
    }), n._clientLeft = n.wrapperEl.clientLeft;
  }
  const h = a ? n.translate : -n.translate;
  function m(g) {
    return g < 0 ? -Math.floor(Math.abs(g)) : Math.floor(g);
  }
  const v = m(h), y = o.map((g) => m(g)), f = r.freeMode && r.freeMode.enabled;
  let x = o[y.indexOf(v) - 1];
  if (typeof x > "u" && (r.cssMode || f)) {
    let g;
    o.forEach((k, w) => {
      v >= k && (g = w);
    }), typeof g < "u" && (x = f ? o[g] : o[g > 0 ? g - 1 : g]);
  }
  let b = 0;
  if (typeof x < "u" && (b = l.indexOf(x), b < 0 && (b = n.activeIndex - 1), r.slidesPerView === "auto" && r.slidesPerGroup === 1 && r.slidesPerGroupAuto && (b = b - n.slidesPerViewDynamic("previous", !0) + 1, b = Math.max(b, 0))), r.rewind && n.isBeginning) {
    const g = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
    return n.slideTo(g, t, e, i);
  } else if (r.loop && n.activeIndex === 0 && r.cssMode)
    return requestAnimationFrame(() => {
      n.slideTo(b, t, e, i);
    }), !0;
  return n.slideTo(b, t, e, i);
}
function _d(t, e, i) {
  e === void 0 && (e = !0);
  const n = this;
  if (!n.destroyed)
    return typeof t > "u" && (t = n.params.speed), n.slideTo(n.activeIndex, t, e, i);
}
function Fd(t, e, i, n) {
  e === void 0 && (e = !0), n === void 0 && (n = 0.5);
  const r = this;
  if (r.destroyed) return;
  typeof t > "u" && (t = r.params.speed);
  let o = r.activeIndex;
  const l = Math.min(r.params.slidesPerGroupSkip, o), a = l + Math.floor((o - l) / r.params.slidesPerGroup), d = r.rtlTranslate ? r.translate : -r.translate;
  if (d >= r.snapGrid[a]) {
    const c = r.snapGrid[a], u = r.snapGrid[a + 1];
    d - c > (u - c) * n && (o += r.params.slidesPerGroup);
  } else {
    const c = r.snapGrid[a - 1], u = r.snapGrid[a];
    d - c <= (u - c) * n && (o -= r.params.slidesPerGroup);
  }
  return o = Math.max(o, 0), o = Math.min(o, r.slidesGrid.length - 1), r.slideTo(o, t, e, i);
}
function Pd() {
  const t = this;
  if (t.destroyed) return;
  const {
    params: e,
    slidesEl: i
  } = t, n = e.slidesPerView === "auto" ? t.slidesPerViewDynamic() : e.slidesPerView;
  let r = t.getSlideIndexWhenGrid(t.clickedIndex), o;
  const l = t.isElement ? "swiper-slide" : `.${e.slideClass}`, a = t.grid && t.params.grid && t.params.grid.rows > 1;
  if (e.loop) {
    if (t.animating) return;
    o = parseInt(t.clickedSlide.getAttribute("data-swiper-slide-index"), 10), e.centeredSlides ? t.slideToLoop(o) : r > (a ? (t.slides.length - n) / 2 - (t.params.grid.rows - 1) : t.slides.length - n) ? (t.loopFix(), r = t.getSlideIndex(Me(i, `${l}[data-swiper-slide-index="${o}"]`)[0]), Ar(() => {
      t.slideTo(r);
    })) : t.slideTo(r);
  } else
    t.slideTo(r);
}
var Ld = {
  slideTo: Kd,
  slideToLoop: Td,
  slideNext: Id,
  slidePrev: Ed,
  slideReset: _d,
  slideToClosest: Fd,
  slideToClickedSlide: Pd
};
function Ad(t, e) {
  const i = this, {
    params: n,
    slidesEl: r
  } = i;
  if (!n.loop || i.virtual && i.params.virtual.enabled) return;
  const o = () => {
    Me(r, `.${n.slideClass}, swiper-slide`).forEach((v, y) => {
      v.setAttribute("data-swiper-slide-index", y);
    });
  }, l = () => {
    const m = Me(r, `.${n.slideBlankClass}`);
    m.forEach((v) => {
      v.remove();
    }), m.length > 0 && (i.recalcSlides(), i.updateSlides());
  }, a = i.grid && n.grid && n.grid.rows > 1;
  n.loopAddBlankSlides && (n.slidesPerGroup > 1 || a) && l();
  const d = n.slidesPerGroup * (a ? n.grid.rows : 1), c = i.slides.length % d !== 0, u = a && i.slides.length % n.grid.rows !== 0, h = (m) => {
    for (let v = 0; v < m; v += 1) {
      const y = i.isElement ? wi("swiper-slide", [n.slideBlankClass]) : wi("div", [n.slideClass, n.slideBlankClass]);
      i.slidesEl.append(y);
    }
  };
  if (c) {
    if (n.loopAddBlankSlides) {
      const m = d - i.slides.length % d;
      h(m), i.recalcSlides(), i.updateSlides();
    } else
      ki("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    o();
  } else if (u) {
    if (n.loopAddBlankSlides) {
      const m = n.grid.rows - i.slides.length % n.grid.rows;
      h(m), i.recalcSlides(), i.updateSlides();
    } else
      ki("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)");
    o();
  } else
    o();
  i.loopFix({
    slideRealIndex: t,
    direction: n.centeredSlides ? void 0 : "next",
    initial: e
  });
}
function Rd(t) {
  let {
    slideRealIndex: e,
    slideTo: i = !0,
    direction: n,
    setTranslate: r,
    activeSlideIndex: o,
    initial: l,
    byController: a,
    byMousewheel: d
  } = t === void 0 ? {} : t;
  const c = this;
  if (!c.params.loop) return;
  c.emit("beforeLoopFix");
  const {
    slides: u,
    allowSlidePrev: h,
    allowSlideNext: m,
    slidesEl: v,
    params: y
  } = c, {
    centeredSlides: f,
    initialSlide: x
  } = y;
  if (c.allowSlidePrev = !0, c.allowSlideNext = !0, c.virtual && y.virtual.enabled) {
    i && (!y.centeredSlides && c.snapIndex === 0 ? c.slideTo(c.virtual.slides.length, 0, !1, !0) : y.centeredSlides && c.snapIndex < y.slidesPerView ? c.slideTo(c.virtual.slides.length + c.snapIndex, 0, !1, !0) : c.snapIndex === c.snapGrid.length - 1 && c.slideTo(c.virtual.slidesBefore, 0, !1, !0)), c.allowSlidePrev = h, c.allowSlideNext = m, c.emit("loopFix");
    return;
  }
  let b = y.slidesPerView;
  b === "auto" ? b = c.slidesPerViewDynamic() : (b = Math.ceil(parseFloat(y.slidesPerView, 10)), f && b % 2 === 0 && (b = b + 1));
  const g = y.slidesPerGroupAuto ? b : y.slidesPerGroup;
  let k = f ? Math.max(g, Math.ceil(b / 2)) : g;
  k % g !== 0 && (k += g - k % g), k += y.loopAdditionalSlides, c.loopedSlides = k;
  const w = c.grid && y.grid && y.grid.rows > 1;
  u.length < b + k || c.params.effect === "cards" && u.length < b + k * 2 ? ki("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : w && y.grid.fill === "row" && ki("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
  const C = [], T = [], I = w ? Math.ceil(u.length / y.grid.rows) : u.length, E = l && I - x < b && !f;
  let P = E ? x : c.activeIndex;
  typeof o > "u" ? o = c.getSlideIndex(u.find((A) => A.classList.contains(y.slideActiveClass))) : P = o;
  const S = n === "next" || !n, K = n === "prev" || !n;
  let _ = 0, L = 0;
  const $ = (w ? u[o].column : o) + (f && typeof r > "u" ? -b / 2 + 0.5 : 0);
  if ($ < k) {
    _ = Math.max(k - $, g);
    for (let A = 0; A < k - $; A += 1) {
      const M = A - Math.floor(A / I) * I;
      if (w) {
        const q = I - M - 1;
        for (let H = u.length - 1; H >= 0; H -= 1)
          u[H].column === q && C.push(H);
      } else
        C.push(I - M - 1);
    }
  } else if ($ + b > I - k) {
    L = Math.max($ - (I - k * 2), g), E && (L = Math.max(L, b - I + x + 1));
    for (let A = 0; A < L; A += 1) {
      const M = A - Math.floor(A / I) * I;
      w ? u.forEach((q, H) => {
        q.column === M && T.push(H);
      }) : T.push(M);
    }
  }
  if (c.__preventObserver__ = !0, requestAnimationFrame(() => {
    c.__preventObserver__ = !1;
  }), c.params.effect === "cards" && u.length < b + k * 2 && (T.includes(o) && T.splice(T.indexOf(o), 1), C.includes(o) && C.splice(C.indexOf(o), 1)), K && C.forEach((A) => {
    u[A].swiperLoopMoveDOM = !0, v.prepend(u[A]), u[A].swiperLoopMoveDOM = !1;
  }), S && T.forEach((A) => {
    u[A].swiperLoopMoveDOM = !0, v.append(u[A]), u[A].swiperLoopMoveDOM = !1;
  }), c.recalcSlides(), y.slidesPerView === "auto" ? c.updateSlides() : w && (C.length > 0 && K || T.length > 0 && S) && c.slides.forEach((A, M) => {
    c.grid.updateSlide(M, A, c.slides);
  }), y.watchSlidesProgress && c.updateSlidesOffset(), i) {
    if (C.length > 0 && K) {
      if (typeof e > "u") {
        const A = c.slidesGrid[P], q = c.slidesGrid[P + _] - A;
        d ? c.setTranslate(c.translate - q) : (c.slideTo(P + Math.ceil(_), 0, !1, !0), r && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - q, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - q));
      } else if (r) {
        const A = w ? C.length / y.grid.rows : C.length;
        c.slideTo(c.activeIndex + A, 0, !1, !0), c.touchEventsData.currentTranslate = c.translate;
      }
    } else if (T.length > 0 && S)
      if (typeof e > "u") {
        const A = c.slidesGrid[P], q = c.slidesGrid[P - L] - A;
        d ? c.setTranslate(c.translate - q) : (c.slideTo(P - L, 0, !1, !0), r && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - q, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - q));
      } else {
        const A = w ? T.length / y.grid.rows : T.length;
        c.slideTo(c.activeIndex - A, 0, !1, !0);
      }
  }
  if (c.allowSlidePrev = h, c.allowSlideNext = m, c.controller && c.controller.control && !a) {
    const A = {
      slideRealIndex: e,
      direction: n,
      setTranslate: r,
      activeSlideIndex: o,
      byController: !0
    };
    Array.isArray(c.controller.control) ? c.controller.control.forEach((M) => {
      !M.destroyed && M.params.loop && M.loopFix({
        ...A,
        slideTo: M.params.slidesPerView === y.slidesPerView ? i : !1
      });
    }) : c.controller.control instanceof c.constructor && c.controller.control.params.loop && c.controller.control.loopFix({
      ...A,
      slideTo: c.controller.control.params.slidesPerView === y.slidesPerView ? i : !1
    });
  }
  c.emit("loopFix");
}
function zd() {
  const t = this, {
    params: e,
    slidesEl: i
  } = t;
  if (!e.loop || !i || t.virtual && t.params.virtual.enabled) return;
  t.recalcSlides();
  const n = [];
  t.slides.forEach((r) => {
    const o = typeof r.swiperSlideIndex > "u" ? r.getAttribute("data-swiper-slide-index") * 1 : r.swiperSlideIndex;
    n[o] = r;
  }), t.slides.forEach((r) => {
    r.removeAttribute("data-swiper-slide-index");
  }), n.forEach((r) => {
    i.append(r);
  }), t.recalcSlides(), t.slideTo(t.realIndex, 0);
}
var Bd = {
  loopCreate: Ad,
  loopFix: Rd,
  loopDestroy: zd
};
function $d(t) {
  const e = this;
  if (!e.params.simulateTouch || e.params.watchOverflow && e.isLocked || e.params.cssMode) return;
  const i = e.params.touchEventsTarget === "container" ? e.el : e.wrapperEl;
  e.isElement && (e.__preventObserver__ = !0), i.style.cursor = "move", i.style.cursor = t ? "grabbing" : "grab", e.isElement && requestAnimationFrame(() => {
    e.__preventObserver__ = !1;
  });
}
function Od() {
  const t = this;
  t.params.watchOverflow && t.isLocked || t.params.cssMode || (t.isElement && (t.__preventObserver__ = !0), t[t.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", t.isElement && requestAnimationFrame(() => {
    t.__preventObserver__ = !1;
  }));
}
var Md = {
  setGrabCursor: $d,
  unsetGrabCursor: Od
};
function Dd(t, e) {
  e === void 0 && (e = this);
  function i(n) {
    if (!n || n === yt() || n === Te()) return null;
    n.assignedSlot && (n = n.assignedSlot);
    const r = n.closest(t);
    return !r && !n.getRootNode ? null : r || i(n.getRootNode().host);
  }
  return i(e);
}
function Vn(t, e, i) {
  const n = Te(), {
    params: r
  } = t, o = r.edgeSwipeDetection, l = r.edgeSwipeThreshold;
  return o && (i <= l || i >= n.innerWidth - l) ? o === "prevent" ? (e.preventDefault(), !0) : !1 : !0;
}
function Wd(t) {
  const e = this, i = yt();
  let n = t;
  n.originalEvent && (n = n.originalEvent);
  const r = e.touchEventsData;
  if (n.type === "pointerdown") {
    if (r.pointerId !== null && r.pointerId !== n.pointerId)
      return;
    r.pointerId = n.pointerId;
  } else n.type === "touchstart" && n.targetTouches.length === 1 && (r.touchId = n.targetTouches[0].identifier);
  if (n.type === "touchstart") {
    Vn(e, n, n.targetTouches[0].pageX);
    return;
  }
  const {
    params: o,
    touches: l,
    enabled: a
  } = e;
  if (!a || !o.simulateTouch && n.pointerType === "mouse" || e.animating && o.preventInteractionOnTransition)
    return;
  !e.animating && o.cssMode && o.loop && e.loopFix();
  let d = n.target;
  if (o.touchEventsTarget === "wrapper" && !Xc(d, e.wrapperEl) || "which" in n && n.which === 3 || "button" in n && n.button > 0 || r.isTouched && r.isMoved) return;
  const c = !!o.noSwipingClass && o.noSwipingClass !== "", u = n.composedPath ? n.composedPath() : n.path;
  c && n.target && n.target.shadowRoot && u && (d = u[0]);
  const h = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, m = !!(n.target && n.target.shadowRoot);
  if (o.noSwiping && (m ? Dd(h, d) : d.closest(h))) {
    e.allowClick = !0;
    return;
  }
  if (o.swipeHandler && !d.closest(o.swipeHandler))
    return;
  l.currentX = n.pageX, l.currentY = n.pageY;
  const v = l.currentX, y = l.currentY;
  if (!Vn(e, n, v))
    return;
  Object.assign(r, {
    isTouched: !0,
    isMoved: !1,
    allowTouchCallbacks: !0,
    isScrolling: void 0,
    startMoving: void 0
  }), l.startX = v, l.startY = y, r.touchStartTime = xi(), e.allowClick = !0, e.updateSize(), e.swipeDirection = void 0, o.threshold > 0 && (r.allowThresholdMove = !1);
  let f = !0;
  d.matches(r.focusableElements) && (f = !1, d.nodeName === "SELECT" && (r.isTouched = !1)), i.activeElement && i.activeElement.matches(r.focusableElements) && i.activeElement !== d && (n.pointerType === "mouse" || n.pointerType !== "mouse" && !d.matches(r.focusableElements)) && i.activeElement.blur();
  const x = f && e.allowTouchMove && o.touchStartPreventDefault;
  (o.touchStartForcePreventDefault || x) && !d.isContentEditable && n.preventDefault(), o.freeMode && o.freeMode.enabled && e.freeMode && e.animating && !o.cssMode && e.freeMode.onTouchStart(), e.emit("touchStart", n);
}
function Hd(t) {
  const e = yt(), i = this, n = i.touchEventsData, {
    params: r,
    touches: o,
    rtlTranslate: l,
    enabled: a
  } = i;
  if (!a || !r.simulateTouch && t.pointerType === "mouse") return;
  let d = t;
  if (d.originalEvent && (d = d.originalEvent), d.type === "pointermove" && (n.touchId !== null || d.pointerId !== n.pointerId))
    return;
  let c;
  if (d.type === "touchmove") {
    if (c = [...d.changedTouches].find((C) => C.identifier === n.touchId), !c || c.identifier !== n.touchId) return;
  } else
    c = d;
  if (!n.isTouched) {
    n.startMoving && n.isScrolling && i.emit("touchMoveOpposite", d);
    return;
  }
  const u = c.pageX, h = c.pageY;
  if (d.preventedByNestedSwiper) {
    o.startX = u, o.startY = h;
    return;
  }
  if (!i.allowTouchMove) {
    d.target.matches(n.focusableElements) || (i.allowClick = !1), n.isTouched && (Object.assign(o, {
      startX: u,
      startY: h,
      currentX: u,
      currentY: h
    }), n.touchStartTime = xi());
    return;
  }
  if (r.touchReleaseOnEdges && !r.loop)
    if (i.isVertical()) {
      if (h < o.startY && i.translate <= i.maxTranslate() || h > o.startY && i.translate >= i.minTranslate()) {
        n.isTouched = !1, n.isMoved = !1;
        return;
      }
    } else {
      if (l && (u > o.startX && -i.translate <= i.maxTranslate() || u < o.startX && -i.translate >= i.minTranslate()))
        return;
      if (!l && (u < o.startX && i.translate <= i.maxTranslate() || u > o.startX && i.translate >= i.minTranslate()))
        return;
    }
  if (e.activeElement && e.activeElement.matches(n.focusableElements) && e.activeElement !== d.target && d.pointerType !== "mouse" && e.activeElement.blur(), e.activeElement && d.target === e.activeElement && d.target.matches(n.focusableElements)) {
    n.isMoved = !0, i.allowClick = !1;
    return;
  }
  n.allowTouchCallbacks && i.emit("touchMove", d), o.previousX = o.currentX, o.previousY = o.currentY, o.currentX = u, o.currentY = h;
  const m = o.currentX - o.startX, v = o.currentY - o.startY;
  if (i.params.threshold && Math.sqrt(m ** 2 + v ** 2) < i.params.threshold) return;
  if (typeof n.isScrolling > "u") {
    let C;
    i.isHorizontal() && o.currentY === o.startY || i.isVertical() && o.currentX === o.startX ? n.isScrolling = !1 : m * m + v * v >= 25 && (C = Math.atan2(Math.abs(v), Math.abs(m)) * 180 / Math.PI, n.isScrolling = i.isHorizontal() ? C > r.touchAngle : 90 - C > r.touchAngle);
  }
  if (n.isScrolling && i.emit("touchMoveOpposite", d), typeof n.startMoving > "u" && (o.currentX !== o.startX || o.currentY !== o.startY) && (n.startMoving = !0), n.isScrolling || d.type === "touchmove" && n.preventTouchMoveFromPointerMove) {
    n.isTouched = !1;
    return;
  }
  if (!n.startMoving)
    return;
  i.allowClick = !1, !r.cssMode && d.cancelable && d.preventDefault(), r.touchMoveStopPropagation && !r.nested && d.stopPropagation();
  let y = i.isHorizontal() ? m : v, f = i.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
  r.oneWayMovement && (y = Math.abs(y) * (l ? 1 : -1), f = Math.abs(f) * (l ? 1 : -1)), o.diff = y, y *= r.touchRatio, l && (y = -y, f = -f);
  const x = i.touchesDirection;
  i.swipeDirection = y > 0 ? "prev" : "next", i.touchesDirection = f > 0 ? "prev" : "next";
  const b = i.params.loop && !r.cssMode, g = i.touchesDirection === "next" && i.allowSlideNext || i.touchesDirection === "prev" && i.allowSlidePrev;
  if (!n.isMoved) {
    if (b && g && i.loopFix({
      direction: i.swipeDirection
    }), n.startTranslate = i.getTranslate(), i.setTransition(0), i.animating) {
      const C = new window.CustomEvent("transitionend", {
        bubbles: !0,
        cancelable: !0,
        detail: {
          bySwiperTouchMove: !0
        }
      });
      i.wrapperEl.dispatchEvent(C);
    }
    n.allowMomentumBounce = !1, r.grabCursor && (i.allowSlideNext === !0 || i.allowSlidePrev === !0) && i.setGrabCursor(!0), i.emit("sliderFirstMove", d);
  }
  if ((/* @__PURE__ */ new Date()).getTime(), r._loopSwapReset !== !1 && n.isMoved && n.allowThresholdMove && x !== i.touchesDirection && b && g && Math.abs(y) >= 1) {
    Object.assign(o, {
      startX: u,
      startY: h,
      currentX: u,
      currentY: h,
      startTranslate: n.currentTranslate
    }), n.loopSwapReset = !0, n.startTranslate = n.currentTranslate;
    return;
  }
  i.emit("sliderMove", d), n.isMoved = !0, n.currentTranslate = y + n.startTranslate;
  let k = !0, w = r.resistanceRatio;
  if (r.touchReleaseOnEdges && (w = 0), y > 0 ? (b && g && n.allowThresholdMove && n.currentTranslate > (r.centeredSlides ? i.minTranslate() - i.slidesSizesGrid[i.activeIndex + 1] - (r.slidesPerView !== "auto" && i.slides.length - r.slidesPerView >= 2 ? i.slidesSizesGrid[i.activeIndex + 1] + i.params.spaceBetween : 0) - i.params.spaceBetween : i.minTranslate()) && i.loopFix({
    direction: "prev",
    setTranslate: !0,
    activeSlideIndex: 0
  }), n.currentTranslate > i.minTranslate() && (k = !1, r.resistance && (n.currentTranslate = i.minTranslate() - 1 + (-i.minTranslate() + n.startTranslate + y) ** w))) : y < 0 && (b && g && n.allowThresholdMove && n.currentTranslate < (r.centeredSlides ? i.maxTranslate() + i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween + (r.slidesPerView !== "auto" && i.slides.length - r.slidesPerView >= 2 ? i.slidesSizesGrid[i.slidesSizesGrid.length - 1] + i.params.spaceBetween : 0) : i.maxTranslate()) && i.loopFix({
    direction: "next",
    setTranslate: !0,
    activeSlideIndex: i.slides.length - (r.slidesPerView === "auto" ? i.slidesPerViewDynamic() : Math.ceil(parseFloat(r.slidesPerView, 10)))
  }), n.currentTranslate < i.maxTranslate() && (k = !1, r.resistance && (n.currentTranslate = i.maxTranslate() + 1 - (i.maxTranslate() - n.startTranslate - y) ** w))), k && (d.preventedByNestedSwiper = !0), !i.allowSlideNext && i.swipeDirection === "next" && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && i.swipeDirection === "prev" && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), !i.allowSlidePrev && !i.allowSlideNext && (n.currentTranslate = n.startTranslate), r.threshold > 0)
    if (Math.abs(y) > r.threshold || n.allowThresholdMove) {
      if (!n.allowThresholdMove) {
        n.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, n.currentTranslate = n.startTranslate, o.diff = i.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
        return;
      }
    } else {
      n.currentTranslate = n.startTranslate;
      return;
    }
  !r.followFinger || r.cssMode || ((r.freeMode && r.freeMode.enabled && i.freeMode || r.watchSlidesProgress) && (i.updateActiveIndex(), i.updateSlidesClasses()), r.freeMode && r.freeMode.enabled && i.freeMode && i.freeMode.onTouchMove(), i.updateProgress(n.currentTranslate), i.setTranslate(n.currentTranslate));
}
function jd(t) {
  const e = this, i = e.touchEventsData;
  let n = t;
  n.originalEvent && (n = n.originalEvent);
  let r;
  if (n.type === "touchend" || n.type === "touchcancel") {
    if (r = [...n.changedTouches].find((C) => C.identifier === i.touchId), !r || r.identifier !== i.touchId) return;
  } else {
    if (i.touchId !== null || n.pointerId !== i.pointerId) return;
    r = n;
  }
  if (["pointercancel", "pointerout", "pointerleave", "contextmenu"].includes(n.type) && !(["pointercancel", "contextmenu"].includes(n.type) && (e.browser.isSafari || e.browser.isWebView)))
    return;
  i.pointerId = null, i.touchId = null;
  const {
    params: l,
    touches: a,
    rtlTranslate: d,
    slidesGrid: c,
    enabled: u
  } = e;
  if (!u || !l.simulateTouch && n.pointerType === "mouse") return;
  if (i.allowTouchCallbacks && e.emit("touchEnd", n), i.allowTouchCallbacks = !1, !i.isTouched) {
    i.isMoved && l.grabCursor && e.setGrabCursor(!1), i.isMoved = !1, i.startMoving = !1;
    return;
  }
  l.grabCursor && i.isMoved && i.isTouched && (e.allowSlideNext === !0 || e.allowSlidePrev === !0) && e.setGrabCursor(!1);
  const h = xi(), m = h - i.touchStartTime;
  if (e.allowClick) {
    const C = n.path || n.composedPath && n.composedPath();
    e.updateClickedSlide(C && C[0] || n.target, C), e.emit("tap click", n), m < 300 && h - i.lastClickTime < 300 && e.emit("doubleTap doubleClick", n);
  }
  if (i.lastClickTime = xi(), Ar(() => {
    e.destroyed || (e.allowClick = !0);
  }), !i.isTouched || !i.isMoved || !e.swipeDirection || a.diff === 0 && !i.loopSwapReset || i.currentTranslate === i.startTranslate && !i.loopSwapReset) {
    i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
    return;
  }
  i.isTouched = !1, i.isMoved = !1, i.startMoving = !1;
  let v;
  if (l.followFinger ? v = d ? e.translate : -e.translate : v = -i.currentTranslate, l.cssMode)
    return;
  if (l.freeMode && l.freeMode.enabled) {
    e.freeMode.onTouchEnd({
      currentPos: v
    });
    return;
  }
  const y = v >= -e.maxTranslate() && !e.params.loop;
  let f = 0, x = e.slidesSizesGrid[0];
  for (let C = 0; C < c.length; C += C < l.slidesPerGroupSkip ? 1 : l.slidesPerGroup) {
    const T = C < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
    typeof c[C + T] < "u" ? (y || v >= c[C] && v < c[C + T]) && (f = C, x = c[C + T] - c[C]) : (y || v >= c[C]) && (f = C, x = c[c.length - 1] - c[c.length - 2]);
  }
  let b = null, g = null;
  l.rewind && (e.isBeginning ? g = l.virtual && l.virtual.enabled && e.virtual ? e.virtual.slides.length - 1 : e.slides.length - 1 : e.isEnd && (b = 0));
  const k = (v - c[f]) / x, w = f < l.slidesPerGroupSkip - 1 ? 1 : l.slidesPerGroup;
  if (m > l.longSwipesMs) {
    if (!l.longSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.swipeDirection === "next" && (k >= l.longSwipesRatio ? e.slideTo(l.rewind && e.isEnd ? b : f + w) : e.slideTo(f)), e.swipeDirection === "prev" && (k > 1 - l.longSwipesRatio ? e.slideTo(f + w) : g !== null && k < 0 && Math.abs(k) > l.longSwipesRatio ? e.slideTo(g) : e.slideTo(f));
  } else {
    if (!l.shortSwipes) {
      e.slideTo(e.activeIndex);
      return;
    }
    e.navigation && (n.target === e.navigation.nextEl || n.target === e.navigation.prevEl) ? n.target === e.navigation.nextEl ? e.slideTo(f + w) : e.slideTo(f) : (e.swipeDirection === "next" && e.slideTo(b !== null ? b : f + w), e.swipeDirection === "prev" && e.slideTo(g !== null ? g : f));
  }
}
function Un() {
  const t = this, {
    params: e,
    el: i
  } = t;
  if (i && i.offsetWidth === 0) return;
  e.breakpoints && t.setBreakpoint();
  const {
    allowSlideNext: n,
    allowSlidePrev: r,
    snapGrid: o
  } = t, l = t.virtual && t.params.virtual.enabled;
  t.allowSlideNext = !0, t.allowSlidePrev = !0, t.updateSize(), t.updateSlides(), t.updateSlidesClasses();
  const a = l && e.loop;
  (e.slidesPerView === "auto" || e.slidesPerView > 1) && t.isEnd && !t.isBeginning && !t.params.centeredSlides && !a ? t.slideTo(t.slides.length - 1, 0, !1, !0) : t.params.loop && !l ? t.slideToLoop(t.realIndex, 0, !1, !0) : t.slideTo(t.activeIndex, 0, !1, !0), t.autoplay && t.autoplay.running && t.autoplay.paused && (clearTimeout(t.autoplay.resizeTimeout), t.autoplay.resizeTimeout = setTimeout(() => {
    t.autoplay && t.autoplay.running && t.autoplay.paused && t.autoplay.resume();
  }, 500)), t.allowSlidePrev = r, t.allowSlideNext = n, t.params.watchOverflow && o !== t.snapGrid && t.checkOverflow();
}
function Vd(t) {
  const e = this;
  e.enabled && (e.allowClick || (e.params.preventClicks && t.preventDefault(), e.params.preventClicksPropagation && e.animating && (t.stopPropagation(), t.stopImmediatePropagation())));
}
function Ud() {
  const t = this, {
    wrapperEl: e,
    rtlTranslate: i,
    enabled: n
  } = t;
  if (!n) return;
  t.previousTranslate = t.translate, t.isHorizontal() ? t.translate = -e.scrollLeft : t.translate = -e.scrollTop, t.translate === 0 && (t.translate = 0), t.updateActiveIndex(), t.updateSlidesClasses();
  let r;
  const o = t.maxTranslate() - t.minTranslate();
  o === 0 ? r = 0 : r = (t.translate - t.minTranslate()) / o, r !== t.progress && t.updateProgress(i ? -t.translate : t.translate), t.emit("setTranslate", t.translate, !1);
}
function qd(t) {
  const e = this;
  gi(e, t.target), !(e.params.cssMode || e.params.slidesPerView !== "auto" && !e.params.autoHeight) && e.update();
}
function Gd() {
  const t = this;
  t.documentTouchHandlerProceeded || (t.documentTouchHandlerProceeded = !0, t.params.touchReleaseOnEdges && (t.el.style.touchAction = "auto"));
}
const Dr = (t, e) => {
  const i = yt(), {
    params: n,
    el: r,
    wrapperEl: o,
    device: l
  } = t, a = !!n.nested, d = e === "on" ? "addEventListener" : "removeEventListener", c = e;
  !r || typeof r == "string" || (i[d]("touchstart", t.onDocumentTouchStart, {
    passive: !1,
    capture: a
  }), r[d]("touchstart", t.onTouchStart, {
    passive: !1
  }), r[d]("pointerdown", t.onTouchStart, {
    passive: !1
  }), i[d]("touchmove", t.onTouchMove, {
    passive: !1,
    capture: a
  }), i[d]("pointermove", t.onTouchMove, {
    passive: !1,
    capture: a
  }), i[d]("touchend", t.onTouchEnd, {
    passive: !0
  }), i[d]("pointerup", t.onTouchEnd, {
    passive: !0
  }), i[d]("pointercancel", t.onTouchEnd, {
    passive: !0
  }), i[d]("touchcancel", t.onTouchEnd, {
    passive: !0
  }), i[d]("pointerout", t.onTouchEnd, {
    passive: !0
  }), i[d]("pointerleave", t.onTouchEnd, {
    passive: !0
  }), i[d]("contextmenu", t.onTouchEnd, {
    passive: !0
  }), (n.preventClicks || n.preventClicksPropagation) && r[d]("click", t.onClick, !0), n.cssMode && o[d]("scroll", t.onScroll), n.updateOnWindowResize ? t[c](l.ios || l.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", Un, !0) : t[c]("observerUpdate", Un, !0), r[d]("load", t.onLoad, {
    capture: !0
  }));
};
function Yd() {
  const t = this, {
    params: e
  } = t;
  t.onTouchStart = Wd.bind(t), t.onTouchMove = Hd.bind(t), t.onTouchEnd = jd.bind(t), t.onDocumentTouchStart = Gd.bind(t), e.cssMode && (t.onScroll = Ud.bind(t)), t.onClick = Vd.bind(t), t.onLoad = qd.bind(t), Dr(t, "on");
}
function Xd() {
  Dr(this, "off");
}
var Qd = {
  attachEvents: Yd,
  detachEvents: Xd
};
const qn = (t, e) => t.grid && e.grid && e.grid.rows > 1;
function Jd() {
  const t = this, {
    realIndex: e,
    initialized: i,
    params: n,
    el: r
  } = t, o = n.breakpoints;
  if (!o || o && Object.keys(o).length === 0) return;
  const l = yt(), a = n.breakpointsBase === "window" || !n.breakpointsBase ? n.breakpointsBase : "container", d = ["window", "container"].includes(n.breakpointsBase) || !n.breakpointsBase ? t.el : l.querySelector(n.breakpointsBase), c = t.getBreakpoint(o, a, d);
  if (!c || t.currentBreakpoint === c) return;
  const h = (c in o ? o[c] : void 0) || t.originalParams, m = qn(t, n), v = qn(t, h), y = t.params.grabCursor, f = h.grabCursor, x = n.enabled;
  m && !v ? (r.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), t.emitContainerClasses()) : !m && v && (r.classList.add(`${n.containerModifierClass}grid`), (h.grid.fill && h.grid.fill === "column" || !h.grid.fill && n.grid.fill === "column") && r.classList.add(`${n.containerModifierClass}grid-column`), t.emitContainerClasses()), y && !f ? t.unsetGrabCursor() : !y && f && t.setGrabCursor(), ["navigation", "pagination", "scrollbar"].forEach((T) => {
    if (typeof h[T] > "u") return;
    const I = n[T] && n[T].enabled, E = h[T] && h[T].enabled;
    I && !E && t[T].disable(), !I && E && t[T].enable();
  });
  const b = h.direction && h.direction !== n.direction, g = n.loop && (h.slidesPerView !== n.slidesPerView || b), k = n.loop;
  b && i && t.changeDirection(), Fe(t.params, h);
  const w = t.params.enabled, C = t.params.loop;
  Object.assign(t, {
    allowTouchMove: t.params.allowTouchMove,
    allowSlideNext: t.params.allowSlideNext,
    allowSlidePrev: t.params.allowSlidePrev
  }), x && !w ? t.disable() : !x && w && t.enable(), t.currentBreakpoint = c, t.emit("_beforeBreakpoint", h), i && (g ? (t.loopDestroy(), t.loopCreate(e), t.updateSlides()) : !k && C ? (t.loopCreate(e), t.updateSlides()) : k && !C && t.loopDestroy()), t.emit("breakpoint", h);
}
function Zd(t, e, i) {
  if (e === void 0 && (e = "window"), !t || e === "container" && !i) return;
  let n = !1;
  const r = Te(), o = e === "window" ? r.innerHeight : i.clientHeight, l = Object.keys(t).map((a) => {
    if (typeof a == "string" && a.indexOf("@") === 0) {
      const d = parseFloat(a.substr(1));
      return {
        value: o * d,
        point: a
      };
    }
    return {
      value: a,
      point: a
    };
  });
  l.sort((a, d) => parseInt(a.value, 10) - parseInt(d.value, 10));
  for (let a = 0; a < l.length; a += 1) {
    const {
      point: d,
      value: c
    } = l[a];
    e === "window" ? r.matchMedia(`(min-width: ${c}px)`).matches && (n = d) : c <= i.clientWidth && (n = d);
  }
  return n || "max";
}
var eu = {
  setBreakpoint: Jd,
  getBreakpoint: Zd
};
function tu(t, e) {
  const i = [];
  return t.forEach((n) => {
    typeof n == "object" ? Object.keys(n).forEach((r) => {
      n[r] && i.push(e + r);
    }) : typeof n == "string" && i.push(e + n);
  }), i;
}
function iu() {
  const t = this, {
    classNames: e,
    params: i,
    rtl: n,
    el: r,
    device: o
  } = t, l = tu(["initialized", i.direction, {
    "free-mode": t.params.freeMode && i.freeMode.enabled
  }, {
    autoheight: i.autoHeight
  }, {
    rtl: n
  }, {
    grid: i.grid && i.grid.rows > 1
  }, {
    "grid-column": i.grid && i.grid.rows > 1 && i.grid.fill === "column"
  }, {
    android: o.android
  }, {
    ios: o.ios
  }, {
    "css-mode": i.cssMode
  }, {
    centered: i.cssMode && i.centeredSlides
  }, {
    "watch-progress": i.watchSlidesProgress
  }], i.containerModifierClass);
  e.push(...l), r.classList.add(...e), t.emitContainerClasses();
}
function nu() {
  const t = this, {
    el: e,
    classNames: i
  } = t;
  !e || typeof e == "string" || (e.classList.remove(...i), t.emitContainerClasses());
}
var ru = {
  addClasses: iu,
  removeClasses: nu
};
function ou() {
  const t = this, {
    isLocked: e,
    params: i
  } = t, {
    slidesOffsetBefore: n
  } = i;
  if (n) {
    const r = t.slides.length - 1, o = t.slidesGrid[r] + t.slidesSizesGrid[r] + n * 2;
    t.isLocked = t.size > o;
  } else
    t.isLocked = t.snapGrid.length === 1;
  i.allowSlideNext === !0 && (t.allowSlideNext = !t.isLocked), i.allowSlidePrev === !0 && (t.allowSlidePrev = !t.isLocked), e && e !== t.isLocked && (t.isEnd = !1), e !== t.isLocked && t.emit(t.isLocked ? "lock" : "unlock");
}
var su = {
  checkOverflow: ou
}, tn = {
  init: !0,
  direction: "horizontal",
  oneWayMovement: !1,
  swiperElementNodeName: "SWIPER-CONTAINER",
  touchEventsTarget: "wrapper",
  initialSlide: 0,
  speed: 300,
  cssMode: !1,
  updateOnWindowResize: !0,
  resizeObserver: !0,
  nested: !1,
  createElements: !1,
  eventsPrefix: "swiper",
  enabled: !0,
  focusableElements: "input, select, option, textarea, button, video, label",
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: !1,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: !1,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: !1,
  // Set wrapper width
  setWrapperSize: !1,
  // Virtual Translate
  virtualTranslate: !1,
  // Effects
  effect: "slide",
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: void 0,
  breakpointsBase: "window",
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: !1,
  centeredSlides: !1,
  centeredSlidesBounds: !1,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: !0,
  centerInsufficientSlides: !1,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: !0,
  // Round length
  roundLengths: !1,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: !0,
  shortSwipes: !0,
  longSwipes: !0,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: !0,
  allowTouchMove: !0,
  threshold: 5,
  touchMoveStopPropagation: !1,
  touchStartPreventDefault: !0,
  touchStartForcePreventDefault: !1,
  touchReleaseOnEdges: !1,
  // Unique Navigation Elements
  uniqueNavElements: !0,
  // Resistance
  resistance: !0,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: !1,
  // Cursor
  grabCursor: !1,
  // Clicks
  preventClicks: !0,
  preventClicksPropagation: !0,
  slideToClickedSlide: !1,
  // loop
  loop: !1,
  loopAddBlankSlides: !0,
  loopAdditionalSlides: 0,
  loopPreventsSliding: !0,
  // rewind
  rewind: !1,
  // Swiping/no swiping
  allowSlidePrev: !0,
  allowSlideNext: !0,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: !0,
  noSwipingClass: "swiper-no-swiping",
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: !0,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: "swiper-",
  // NEW
  slideClass: "swiper-slide",
  slideBlankClass: "swiper-slide-blank",
  slideActiveClass: "swiper-slide-active",
  slideVisibleClass: "swiper-slide-visible",
  slideFullyVisibleClass: "swiper-slide-fully-visible",
  slideNextClass: "swiper-slide-next",
  slidePrevClass: "swiper-slide-prev",
  wrapperClass: "swiper-wrapper",
  lazyPreloaderClass: "swiper-lazy-preloader",
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: !0,
  // Internals
  _emitClasses: !1
};
function au(t, e) {
  return function(n) {
    n === void 0 && (n = {});
    const r = Object.keys(n)[0], o = n[r];
    if (typeof o != "object" || o === null) {
      Fe(e, n);
      return;
    }
    if (t[r] === !0 && (t[r] = {
      enabled: !0
    }), r === "navigation" && t[r] && t[r].enabled && !t[r].prevEl && !t[r].nextEl && (t[r].auto = !0), ["pagination", "scrollbar"].indexOf(r) >= 0 && t[r] && t[r].enabled && !t[r].el && (t[r].auto = !0), !(r in t && "enabled" in o)) {
      Fe(e, n);
      return;
    }
    typeof t[r] == "object" && !("enabled" in t[r]) && (t[r].enabled = !0), t[r] || (t[r] = {
      enabled: !1
    }), Fe(e, n);
  };
}
const Di = {
  eventsEmitter: rd,
  update: gd,
  translate: kd,
  transition: Nd,
  slide: Ld,
  loop: Bd,
  grabCursor: Md,
  events: Qd,
  breakpoints: eu,
  checkOverflow: su,
  classes: ru
}, Wi = {};
let un = class We {
  constructor() {
    let e, i;
    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++)
      r[o] = arguments[o];
    r.length === 1 && r[0].constructor && Object.prototype.toString.call(r[0]).slice(8, -1) === "Object" ? i = r[0] : [e, i] = r, i || (i = {}), i = Fe({}, i), e && !i.el && (i.el = e);
    const l = yt();
    if (i.el && typeof i.el == "string" && l.querySelectorAll(i.el).length > 1) {
      const u = [];
      return l.querySelectorAll(i.el).forEach((h) => {
        const m = Fe({}, i, {
          el: h
        });
        u.push(new We(m));
      }), u;
    }
    const a = this;
    a.__swiper__ = !0, a.support = Br(), a.device = $r({
      userAgent: i.userAgent
    }), a.browser = Or(), a.eventsListeners = {}, a.eventsAnyListeners = [], a.modules = [...a.__modules__], i.modules && Array.isArray(i.modules) && a.modules.push(...i.modules);
    const d = {};
    a.modules.forEach((u) => {
      u({
        params: i,
        swiper: a,
        extendParams: au(i, d),
        on: a.on.bind(a),
        once: a.once.bind(a),
        off: a.off.bind(a),
        emit: a.emit.bind(a)
      });
    });
    const c = Fe({}, tn, d);
    return a.params = Fe({}, c, Wi, i), a.originalParams = Fe({}, a.params), a.passedParams = Fe({}, i), a.params && a.params.on && Object.keys(a.params.on).forEach((u) => {
      a.on(u, a.params.on[u]);
    }), a.params && a.params.onAny && a.onAny(a.params.onAny), Object.assign(a, {
      enabled: a.params.enabled,
      el: e,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal() {
        return a.params.direction === "horizontal";
      },
      isVertical() {
        return a.params.direction === "vertical";
      },
      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: !0,
      isEnd: !1,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: !1,
      cssOverflowAdjustment() {
        return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
      },
      // Locks
      allowSlideNext: a.params.allowSlideNext,
      allowSlidePrev: a.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: void 0,
        isMoved: void 0,
        allowTouchCallbacks: void 0,
        touchStartTime: void 0,
        isScrolling: void 0,
        currentTranslate: void 0,
        startTranslate: void 0,
        allowThresholdMove: void 0,
        // Form elements to match
        focusableElements: a.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: void 0,
        // Velocities
        velocities: [],
        allowMomentumBounce: void 0,
        startMoving: void 0,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: !0,
      // Touches
      allowTouchMove: a.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    }), a.emit("_swiper"), a.params.init && a.init(), a;
  }
  getDirectionLabel(e) {
    return this.isHorizontal() ? e : {
      width: "height",
      "margin-top": "margin-left",
      "margin-bottom ": "margin-right",
      "margin-left": "margin-top",
      "margin-right": "margin-bottom",
      "padding-left": "padding-top",
      "padding-right": "padding-bottom",
      marginRight: "marginBottom"
    }[e];
  }
  getSlideIndex(e) {
    const {
      slidesEl: i,
      params: n
    } = this, r = Me(i, `.${n.slideClass}, swiper-slide`), o = Si(r[0]);
    return Si(e) - o;
  }
  getSlideIndexByData(e) {
    return this.getSlideIndex(this.slides.find((i) => i.getAttribute("data-swiper-slide-index") * 1 === e));
  }
  getSlideIndexWhenGrid(e) {
    return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? e = Math.floor(e / this.params.grid.rows) : this.params.grid.fill === "row" && (e = e % Math.ceil(this.slides.length / this.params.grid.rows))), e;
  }
  recalcSlides() {
    const e = this, {
      slidesEl: i,
      params: n
    } = e;
    e.slides = Me(i, `.${n.slideClass}, swiper-slide`);
  }
  enable() {
    const e = this;
    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
  }
  disable() {
    const e = this;
    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
  }
  setProgress(e, i) {
    const n = this;
    e = Math.min(Math.max(e, 0), 1);
    const r = n.minTranslate(), l = (n.maxTranslate() - r) * e + r;
    n.translateTo(l, typeof i > "u" ? 0 : i), n.updateActiveIndex(), n.updateSlidesClasses();
  }
  emitContainerClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = e.el.className.split(" ").filter((n) => n.indexOf("swiper") === 0 || n.indexOf(e.params.containerModifierClass) === 0);
    e.emit("_containerClasses", i.join(" "));
  }
  getSlideClasses(e) {
    const i = this;
    return i.destroyed ? "" : e.className.split(" ").filter((n) => n.indexOf("swiper-slide") === 0 || n.indexOf(i.params.slideClass) === 0).join(" ");
  }
  emitSlidesClasses() {
    const e = this;
    if (!e.params._emitClasses || !e.el) return;
    const i = [];
    e.slides.forEach((n) => {
      const r = e.getSlideClasses(n);
      i.push({
        slideEl: n,
        classNames: r
      }), e.emit("_slideClass", n, r);
    }), e.emit("_slideClasses", i);
  }
  slidesPerViewDynamic(e, i) {
    e === void 0 && (e = "current"), i === void 0 && (i = !1);
    const n = this, {
      params: r,
      slides: o,
      slidesGrid: l,
      slidesSizesGrid: a,
      size: d,
      activeIndex: c
    } = n;
    let u = 1;
    if (typeof r.slidesPerView == "number") return r.slidesPerView;
    if (r.centeredSlides) {
      let h = o[c] ? Math.ceil(o[c].swiperSlideSize) : 0, m;
      for (let v = c + 1; v < o.length; v += 1)
        o[v] && !m && (h += Math.ceil(o[v].swiperSlideSize), u += 1, h > d && (m = !0));
      for (let v = c - 1; v >= 0; v -= 1)
        o[v] && !m && (h += o[v].swiperSlideSize, u += 1, h > d && (m = !0));
    } else if (e === "current")
      for (let h = c + 1; h < o.length; h += 1)
        (i ? l[h] + a[h] - l[c] < d : l[h] - l[c] < d) && (u += 1);
    else
      for (let h = c - 1; h >= 0; h -= 1)
        l[c] - l[h] < d && (u += 1);
    return u;
  }
  update() {
    const e = this;
    if (!e || e.destroyed) return;
    const {
      snapGrid: i,
      params: n
    } = e;
    n.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((l) => {
      l.complete && gi(e, l);
    }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
    function r() {
      const l = e.rtlTranslate ? e.translate * -1 : e.translate, a = Math.min(Math.max(l, e.maxTranslate()), e.minTranslate());
      e.setTranslate(a), e.updateActiveIndex(), e.updateSlidesClasses();
    }
    let o;
    if (n.freeMode && n.freeMode.enabled && !n.cssMode)
      r(), n.autoHeight && e.updateAutoHeight();
    else {
      if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
        const l = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
        o = e.slideTo(l.length - 1, 0, !1, !0);
      } else
        o = e.slideTo(e.activeIndex, 0, !1, !0);
      o || r();
    }
    n.watchOverflow && i !== e.snapGrid && e.checkOverflow(), e.emit("update");
  }
  changeDirection(e, i) {
    i === void 0 && (i = !0);
    const n = this, r = n.params.direction;
    return e || (e = r === "horizontal" ? "vertical" : "horizontal"), e === r || e !== "horizontal" && e !== "vertical" || (n.el.classList.remove(`${n.params.containerModifierClass}${r}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((o) => {
      e === "vertical" ? o.style.width = "" : o.style.height = "";
    }), n.emit("changeDirection"), i && n.update()), n;
  }
  changeLanguageDirection(e) {
    const i = this;
    i.rtl && e === "rtl" || !i.rtl && e === "ltr" || (i.rtl = e === "rtl", i.rtlTranslate = i.params.direction === "horizontal" && i.rtl, i.rtl ? (i.el.classList.add(`${i.params.containerModifierClass}rtl`), i.el.dir = "rtl") : (i.el.classList.remove(`${i.params.containerModifierClass}rtl`), i.el.dir = "ltr"), i.update());
  }
  mount(e) {
    const i = this;
    if (i.mounted) return !0;
    let n = e || i.params.el;
    if (typeof n == "string" && (n = document.querySelector(n)), !n)
      return !1;
    n.swiper = i, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === i.params.swiperElementNodeName.toUpperCase() && (i.isElement = !0);
    const r = () => `.${(i.params.wrapperClass || "").trim().split(" ").join(".")}`;
    let l = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(r()) : Me(n, r())[0];
    return !l && i.params.createElements && (l = wi("div", i.params.wrapperClass), n.append(l), Me(n, `.${i.params.slideClass}`).forEach((a) => {
      l.append(a);
    })), Object.assign(i, {
      el: n,
      wrapperEl: l,
      slidesEl: i.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : l,
      hostEl: i.isElement ? n.parentNode.host : n,
      mounted: !0,
      // RTL
      rtl: n.dir.toLowerCase() === "rtl" || Ze(n, "direction") === "rtl",
      rtlTranslate: i.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || Ze(n, "direction") === "rtl"),
      wrongRTL: Ze(l, "display") === "-webkit-box"
    }), !0;
  }
  init(e) {
    const i = this;
    if (i.initialized || i.mount(e) === !1) return i;
    i.emit("beforeInit"), i.params.breakpoints && i.setBreakpoint(), i.addClasses(), i.updateSize(), i.updateSlides(), i.params.watchOverflow && i.checkOverflow(), i.params.grabCursor && i.enabled && i.setGrabCursor(), i.params.loop && i.virtual && i.params.virtual.enabled ? i.slideTo(i.params.initialSlide + i.virtual.slidesBefore, 0, i.params.runCallbacksOnInit, !1, !0) : i.slideTo(i.params.initialSlide, 0, i.params.runCallbacksOnInit, !1, !0), i.params.loop && i.loopCreate(void 0, !0), i.attachEvents();
    const r = [...i.el.querySelectorAll('[loading="lazy"]')];
    return i.isElement && r.push(...i.hostEl.querySelectorAll('[loading="lazy"]')), r.forEach((o) => {
      o.complete ? gi(i, o) : o.addEventListener("load", (l) => {
        gi(i, l.target);
      });
    }), en(i), i.initialized = !0, en(i), i.emit("init"), i.emit("afterInit"), i;
  }
  destroy(e, i) {
    e === void 0 && (e = !0), i === void 0 && (i = !0);
    const n = this, {
      params: r,
      el: o,
      wrapperEl: l,
      slides: a
    } = n;
    return typeof n.params > "u" || n.destroyed || (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), r.loop && n.loopDestroy(), i && (n.removeClasses(), o && typeof o != "string" && o.removeAttribute("style"), l && l.removeAttribute("style"), a && a.length && a.forEach((d) => {
      d.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), d.removeAttribute("style"), d.removeAttribute("data-swiper-slide-index");
    })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((d) => {
      n.off(d);
    }), e !== !1 && (n.el && typeof n.el != "string" && (n.el.swiper = null), Vc(n)), n.destroyed = !0), null;
  }
  static extendDefaults(e) {
    Fe(Wi, e);
  }
  static get extendedDefaults() {
    return Wi;
  }
  static get defaults() {
    return tn;
  }
  static installModule(e) {
    We.prototype.__modules__ || (We.prototype.__modules__ = []);
    const i = We.prototype.__modules__;
    typeof e == "function" && i.indexOf(e) < 0 && i.push(e);
  }
  static use(e) {
    return Array.isArray(e) ? (e.forEach((i) => We.installModule(i)), We) : (We.installModule(e), We);
  }
};
Object.keys(Di).forEach((t) => {
  Object.keys(Di[t]).forEach((e) => {
    un.prototype[e] = Di[t][e];
  });
});
un.use([id, nd]);
const Wr = [
  "eventsPrefix",
  "injectStyles",
  "injectStylesUrls",
  "modules",
  "init",
  "_direction",
  "oneWayMovement",
  "swiperElementNodeName",
  "touchEventsTarget",
  "initialSlide",
  "_speed",
  "cssMode",
  "updateOnWindowResize",
  "resizeObserver",
  "nested",
  "focusableElements",
  "_enabled",
  "_width",
  "_height",
  "preventInteractionOnTransition",
  "userAgent",
  "url",
  "_edgeSwipeDetection",
  "_edgeSwipeThreshold",
  "_freeMode",
  "_autoHeight",
  "setWrapperSize",
  "virtualTranslate",
  "_effect",
  "breakpoints",
  "breakpointsBase",
  "_spaceBetween",
  "_slidesPerView",
  "maxBackfaceHiddenSlides",
  "_grid",
  "_slidesPerGroup",
  "_slidesPerGroupSkip",
  "_slidesPerGroupAuto",
  "_centeredSlides",
  "_centeredSlidesBounds",
  "_slidesOffsetBefore",
  "_slidesOffsetAfter",
  "normalizeSlideIndex",
  "_centerInsufficientSlides",
  "_watchOverflow",
  "roundLengths",
  "touchRatio",
  "touchAngle",
  "simulateTouch",
  "_shortSwipes",
  "_longSwipes",
  "longSwipesRatio",
  "longSwipesMs",
  "_followFinger",
  "allowTouchMove",
  "_threshold",
  "touchMoveStopPropagation",
  "touchStartPreventDefault",
  "touchStartForcePreventDefault",
  "touchReleaseOnEdges",
  "uniqueNavElements",
  "_resistance",
  "_resistanceRatio",
  "_watchSlidesProgress",
  "_grabCursor",
  "preventClicks",
  "preventClicksPropagation",
  "_slideToClickedSlide",
  "_loop",
  "loopAdditionalSlides",
  "loopAddBlankSlides",
  "loopPreventsSliding",
  "_rewind",
  "_allowSlidePrev",
  "_allowSlideNext",
  "_swipeHandler",
  "_noSwiping",
  "noSwipingClass",
  "noSwipingSelector",
  "passiveListeners",
  "containerModifierClass",
  "slideClass",
  "slideActiveClass",
  "slideVisibleClass",
  "slideFullyVisibleClass",
  "slideNextClass",
  "slidePrevClass",
  "slideBlankClass",
  "wrapperClass",
  "lazyPreloaderClass",
  "lazyPreloadPrevNext",
  "runCallbacksOnInit",
  "observer",
  "observeParents",
  "observeSlideChildren",
  // modules
  "a11y",
  "_autoplay",
  "_controller",
  "coverflowEffect",
  "cubeEffect",
  "fadeEffect",
  "flipEffect",
  "creativeEffect",
  "cardsEffect",
  "hashNavigation",
  "history",
  "keyboard",
  "mousewheel",
  "_navigation",
  "_pagination",
  "parallax",
  "_scrollbar",
  "_thumbs",
  "virtual",
  "zoom",
  "control"
];
function gt(t) {
  return typeof t == "object" && t !== null && t.constructor && Object.prototype.toString.call(t).slice(8, -1) === "Object" && !t.__swiper__;
}
function St(t, e) {
  const i = ["__proto__", "constructor", "prototype"];
  Object.keys(e).filter((n) => i.indexOf(n) < 0).forEach((n) => {
    typeof t[n] > "u" ? t[n] = e[n] : gt(e[n]) && gt(t[n]) && Object.keys(e[n]).length > 0 ? e[n].__swiper__ ? t[n] = e[n] : St(t[n], e[n]) : t[n] = e[n];
  });
}
function Hr(t) {
  return t === void 0 && (t = {}), t.navigation && typeof t.navigation.nextEl > "u" && typeof t.navigation.prevEl > "u";
}
function jr(t) {
  return t === void 0 && (t = {}), t.pagination && typeof t.pagination.el > "u";
}
function Vr(t) {
  return t === void 0 && (t = {}), t.scrollbar && typeof t.scrollbar.el > "u";
}
function Ur(t) {
  t === void 0 && (t = "");
  const e = t.split(" ").map((n) => n.trim()).filter((n) => !!n), i = [];
  return e.forEach((n) => {
    i.indexOf(n) < 0 && i.push(n);
  }), i.join(" ");
}
function lu(t) {
  return t === void 0 && (t = ""), t ? t.includes("swiper-wrapper") ? t : `swiper-wrapper ${t}` : "swiper-wrapper";
}
function cu(t) {
  let {
    swiper: e,
    slides: i,
    passedParams: n,
    changedParams: r,
    nextEl: o,
    prevEl: l,
    scrollbarEl: a,
    paginationEl: d
  } = t;
  const c = r.filter((P) => P !== "children" && P !== "direction" && P !== "wrapperClass"), {
    params: u,
    pagination: h,
    navigation: m,
    scrollbar: v,
    virtual: y,
    thumbs: f
  } = e;
  let x, b, g, k, w, C, T, I;
  r.includes("thumbs") && n.thumbs && n.thumbs.swiper && !n.thumbs.swiper.destroyed && u.thumbs && (!u.thumbs.swiper || u.thumbs.swiper.destroyed) && (x = !0), r.includes("controller") && n.controller && n.controller.control && u.controller && !u.controller.control && (b = !0), r.includes("pagination") && n.pagination && (n.pagination.el || d) && (u.pagination || u.pagination === !1) && h && !h.el && (g = !0), r.includes("scrollbar") && n.scrollbar && (n.scrollbar.el || a) && (u.scrollbar || u.scrollbar === !1) && v && !v.el && (k = !0), r.includes("navigation") && n.navigation && (n.navigation.prevEl || l) && (n.navigation.nextEl || o) && (u.navigation || u.navigation === !1) && m && !m.prevEl && !m.nextEl && (w = !0);
  const E = (P) => {
    e[P] && (e[P].destroy(), P === "navigation" ? (e.isElement && (e[P].prevEl.remove(), e[P].nextEl.remove()), u[P].prevEl = void 0, u[P].nextEl = void 0, e[P].prevEl = void 0, e[P].nextEl = void 0) : (e.isElement && e[P].el.remove(), u[P].el = void 0, e[P].el = void 0));
  };
  r.includes("loop") && e.isElement && (u.loop && !n.loop ? C = !0 : !u.loop && n.loop ? T = !0 : I = !0), c.forEach((P) => {
    if (gt(u[P]) && gt(n[P]))
      Object.assign(u[P], n[P]), (P === "navigation" || P === "pagination" || P === "scrollbar") && "enabled" in n[P] && !n[P].enabled && E(P);
    else {
      const S = n[P];
      (S === !0 || S === !1) && (P === "navigation" || P === "pagination" || P === "scrollbar") ? S === !1 && E(P) : u[P] = n[P];
    }
  }), c.includes("controller") && !b && e.controller && e.controller.control && u.controller && u.controller.control && (e.controller.control = u.controller.control), r.includes("children") && i && y && u.virtual.enabled ? (y.slides = i, y.update(!0)) : r.includes("virtual") && y && u.virtual.enabled && (i && (y.slides = i), y.update(!0)), r.includes("children") && i && u.loop && (I = !0), x && f.init() && f.update(!0), b && (e.controller.control = u.controller.control), g && (e.isElement && (!d || typeof d == "string") && (d = document.createElement("div"), d.classList.add("swiper-pagination"), d.part.add("pagination"), e.el.appendChild(d)), d && (u.pagination.el = d), h.init(), h.render(), h.update()), k && (e.isElement && (!a || typeof a == "string") && (a = document.createElement("div"), a.classList.add("swiper-scrollbar"), a.part.add("scrollbar"), e.el.appendChild(a)), a && (u.scrollbar.el = a), v.init(), v.updateSize(), v.setTranslate()), w && (e.isElement && ((!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-button-next"), Ci(o, e.hostEl.constructor.nextButtonSvg), o.part.add("button-next"), e.el.appendChild(o)), (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-button-prev"), Ci(l, e.hostEl.constructor.prevButtonSvg), l.part.add("button-prev"), e.el.appendChild(l))), o && (u.navigation.nextEl = o), l && (u.navigation.prevEl = l), m.init(), m.update()), r.includes("allowSlideNext") && (e.allowSlideNext = n.allowSlideNext), r.includes("allowSlidePrev") && (e.allowSlidePrev = n.allowSlidePrev), r.includes("direction") && e.changeDirection(n.direction, !1), (C || I) && e.loopDestroy(), (T || I) && e.loopCreate(), e.update();
}
function du(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = !0);
  const i = {
    on: {}
  }, n = {}, r = {};
  St(i, tn), i._emitClasses = !0, i.init = !1;
  const o = {}, l = Wr.map((d) => d.replace(/_/, "")), a = Object.assign({}, t);
  return Object.keys(a).forEach((d) => {
    typeof t[d] > "u" || (l.indexOf(d) >= 0 ? gt(t[d]) ? (i[d] = {}, r[d] = {}, St(i[d], t[d]), St(r[d], t[d])) : (i[d] = t[d], r[d] = t[d]) : d.search(/on[A-Z]/) === 0 && typeof t[d] == "function" ? e ? n[`${d[2].toLowerCase()}${d.substr(3)}`] = t[d] : i.on[`${d[2].toLowerCase()}${d.substr(3)}`] = t[d] : o[d] = t[d]);
  }), ["navigation", "pagination", "scrollbar"].forEach((d) => {
    i[d] === !0 && (i[d] = {}), i[d] === !1 && delete i[d];
  }), {
    params: i,
    passedParams: r,
    rest: o,
    events: n
  };
}
function uu(t, e) {
  let {
    el: i,
    nextEl: n,
    prevEl: r,
    paginationEl: o,
    scrollbarEl: l,
    swiper: a
  } = t;
  Hr(e) && n && r && (a.params.navigation.nextEl = n, a.originalParams.navigation.nextEl = n, a.params.navigation.prevEl = r, a.originalParams.navigation.prevEl = r), jr(e) && o && (a.params.pagination.el = o, a.originalParams.pagination.el = o), Vr(e) && l && (a.params.scrollbar.el = l, a.originalParams.scrollbar.el = l), a.init(i);
}
function pu(t, e, i, n, r) {
  const o = [];
  if (!e) return o;
  const l = (d) => {
    o.indexOf(d) < 0 && o.push(d);
  };
  if (i && n) {
    const d = n.map(r), c = i.map(r);
    d.join("") !== c.join("") && l("children"), n.length !== i.length && l("children");
  }
  return Wr.filter((d) => d[0] === "_").map((d) => d.replace(/_/, "")).forEach((d) => {
    if (d in t && d in e)
      if (gt(t[d]) && gt(e[d])) {
        const c = Object.keys(t[d]), u = Object.keys(e[d]);
        c.length !== u.length ? l(d) : (c.forEach((h) => {
          t[d][h] !== e[d][h] && l(d);
        }), u.forEach((h) => {
          t[d][h] !== e[d][h] && l(d);
        }));
      } else t[d] !== e[d] && l(d);
  }), o;
}
const mu = (t) => {
  !t || t.destroyed || !t.params.virtual || t.params.virtual && !t.params.virtual.enabled || (t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.emit("_virtualUpdated"), t.parallax && t.params.parallax && t.params.parallax.enabled && t.parallax.setTranslate());
};
function Ni() {
  return Ni = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var i = arguments[e];
      for (var n in i)
        Object.prototype.hasOwnProperty.call(i, n) && (t[n] = i[n]);
    }
    return t;
  }, Ni.apply(this, arguments);
}
function qr(t) {
  return t.type && t.type.displayName && t.type.displayName.includes("SwiperSlide");
}
function Gr(t) {
  const e = [];
  return Z.Children.toArray(t).forEach((i) => {
    qr(i) ? e.push(i) : i.props && i.props.children && Gr(i.props.children).forEach((n) => e.push(n));
  }), e;
}
function hu(t) {
  const e = [], i = {
    "container-start": [],
    "container-end": [],
    "wrapper-start": [],
    "wrapper-end": []
  };
  return Z.Children.toArray(t).forEach((n) => {
    if (qr(n))
      e.push(n);
    else if (n.props && n.props.slot && i[n.props.slot])
      i[n.props.slot].push(n);
    else if (n.props && n.props.children) {
      const r = Gr(n.props.children);
      r.length > 0 ? r.forEach((o) => e.push(o)) : i["container-end"].push(n);
    } else
      i["container-end"].push(n);
  }), {
    slides: e,
    slots: i
  };
}
function gu(t, e, i) {
  if (!i) return null;
  const n = (u) => {
    let h = u;
    return u < 0 ? h = e.length + u : h >= e.length && (h = h - e.length), h;
  }, r = t.isHorizontal() ? {
    [t.rtlTranslate ? "right" : "left"]: `${i.offset}px`
  } : {
    top: `${i.offset}px`
  }, {
    from: o,
    to: l
  } = i, a = t.params.loop ? -e.length : 0, d = t.params.loop ? e.length * 2 : e.length, c = [];
  for (let u = a; u < d; u += 1)
    u >= o && u <= l && c.push(e[n(u)]);
  return c.map((u, h) => /* @__PURE__ */ Z.cloneElement(u, {
    swiper: t,
    style: r,
    key: u.props.virtualIndex || u.key || `slide-${h}`
  }));
}
function Et(t, e) {
  return typeof window > "u" ? U(t, e) : io(t, e);
}
const Gn = /* @__PURE__ */ zt(null), fu = /* @__PURE__ */ zt(null), Yr = /* @__PURE__ */ Xn(function(t, e) {
  let {
    className: i,
    tag: n = "div",
    wrapperTag: r = "div",
    children: o,
    onSwiper: l,
    ...a
  } = t === void 0 ? {} : t, d = !1;
  const [c, u] = O("swiper"), [h, m] = O(null), [v, y] = O(!1), f = oe(!1), x = oe(null), b = oe(null), g = oe(null), k = oe(null), w = oe(null), C = oe(null), T = oe(null), I = oe(null), {
    params: E,
    passedParams: P,
    rest: S,
    events: K
  } = du(a), {
    slides: _,
    slots: L
  } = hu(o), N = () => {
    y(!v);
  };
  Object.assign(E.on, {
    _containerClasses(H, X) {
      u(X);
    }
  });
  const $ = () => {
    Object.assign(E.on, K), d = !0;
    const H = {
      ...E
    };
    if (delete H.wrapperClass, b.current = new un(H), b.current.virtual && b.current.params.virtual.enabled) {
      b.current.virtual.slides = _;
      const X = {
        cache: !1,
        slides: _,
        renderExternal: m,
        renderExternalUpdate: !1
      };
      St(b.current.params.virtual, X), St(b.current.originalParams.virtual, X);
    }
  };
  x.current || $(), b.current && b.current.on("_beforeBreakpoint", N);
  const A = () => {
    d || !K || !b.current || Object.keys(K).forEach((H) => {
      b.current.on(H, K[H]);
    });
  }, M = () => {
    !K || !b.current || Object.keys(K).forEach((H) => {
      b.current.off(H, K[H]);
    });
  };
  U(() => () => {
    b.current && b.current.off("_beforeBreakpoint", N);
  }), U(() => {
    !f.current && b.current && (b.current.emitSlidesClasses(), f.current = !0);
  }), Et(() => {
    if (e && (e.current = x.current), !!x.current)
      return b.current.destroyed && $(), uu({
        el: x.current,
        nextEl: w.current,
        prevEl: C.current,
        paginationEl: T.current,
        scrollbarEl: I.current,
        swiper: b.current
      }, E), l && !b.current.destroyed && l(b.current), () => {
        b.current && !b.current.destroyed && b.current.destroy(!0, !1);
      };
  }, []), Et(() => {
    A();
    const H = pu(P, g.current, _, k.current, (X) => X.key);
    return g.current = P, k.current = _, H.length && b.current && !b.current.destroyed && cu({
      swiper: b.current,
      slides: _,
      passedParams: P,
      changedParams: H,
      nextEl: w.current,
      prevEl: C.current,
      scrollbarEl: I.current,
      paginationEl: T.current
    }), () => {
      M();
    };
  }), Et(() => {
    mu(b.current);
  }, [h]);
  function q() {
    return E.virtual ? gu(b.current, _, h) : _.map((H, X) => /* @__PURE__ */ Z.cloneElement(H, {
      swiper: b.current,
      swiperSlideIndex: X
    }));
  }
  return /* @__PURE__ */ Z.createElement(n, Ni({
    ref: x,
    className: Ur(`${c}${i ? ` ${i}` : ""}`)
  }, S), /* @__PURE__ */ Z.createElement(fu.Provider, {
    value: b.current
  }, L["container-start"], /* @__PURE__ */ Z.createElement(r, {
    className: lu(E.wrapperClass)
  }, L["wrapper-start"], q(), L["wrapper-end"]), Hr(E) && /* @__PURE__ */ Z.createElement(Z.Fragment, null, /* @__PURE__ */ Z.createElement("div", {
    ref: C,
    className: "swiper-button-prev"
  }), /* @__PURE__ */ Z.createElement("div", {
    ref: w,
    className: "swiper-button-next"
  })), Vr(E) && /* @__PURE__ */ Z.createElement("div", {
    ref: I,
    className: "swiper-scrollbar"
  }), jr(E) && /* @__PURE__ */ Z.createElement("div", {
    ref: T,
    className: "swiper-pagination"
  }), L["container-end"]));
});
Yr.displayName = "Swiper";
const Xr = /* @__PURE__ */ Xn(function(t, e) {
  let {
    tag: i = "div",
    children: n,
    className: r = "",
    swiper: o,
    zoom: l,
    lazy: a,
    virtualIndex: d,
    swiperSlideIndex: c,
    ...u
  } = t === void 0 ? {} : t;
  const h = oe(null), [m, v] = O("swiper-slide"), [y, f] = O(!1);
  function x(w, C, T) {
    C === h.current && v(T);
  }
  Et(() => {
    if (typeof c < "u" && (h.current.swiperSlideIndex = c), e && (e.current = h.current), !(!h.current || !o)) {
      if (o.destroyed) {
        m !== "swiper-slide" && v("swiper-slide");
        return;
      }
      return o.on("_slideClass", x), () => {
        o && o.off("_slideClass", x);
      };
    }
  }), Et(() => {
    o && h.current && !o.destroyed && v(o.getSlideClasses(h.current));
  }, [o]);
  const b = {
    isActive: m.indexOf("swiper-slide-active") >= 0,
    isVisible: m.indexOf("swiper-slide-visible") >= 0,
    isPrev: m.indexOf("swiper-slide-prev") >= 0,
    isNext: m.indexOf("swiper-slide-next") >= 0
  }, g = () => typeof n == "function" ? n(b) : n, k = () => {
    f(!0);
  };
  return /* @__PURE__ */ Z.createElement(i, Ni({
    ref: h,
    className: Ur(`${m}${r ? ` ${r}` : ""}`),
    "data-swiper-slide-index": d,
    onLoad: k
  }, u), l && /* @__PURE__ */ Z.createElement(Gn.Provider, {
    value: b
  }, /* @__PURE__ */ Z.createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof l == "number" ? l : void 0
  }, g(), a && !y && /* @__PURE__ */ Z.createElement("div", {
    className: "swiper-lazy-preloader"
  }))), !l && /* @__PURE__ */ Z.createElement(Gn.Provider, {
    value: b
  }, g(), a && !y && /* @__PURE__ */ Z.createElement("div", {
    className: "swiper-lazy-preloader"
  })));
});
Xr.displayName = "SwiperSlide";
function Qr(t, e, i, n) {
  return t.params.createElements && Object.keys(n).forEach((r) => {
    if (!i[r] && i.auto === !0) {
      let o = Me(t.el, `.${n[r]}`)[0];
      o || (o = wi("div", n[r]), o.className = n[r], t.el.append(o)), i[r] = o, e[r] = o;
    }
  }), i;
}
function yu(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: r
  } = t;
  i({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: !1,
      disabledClass: "swiper-button-disabled",
      hiddenClass: "swiper-button-hidden",
      lockClass: "swiper-button-lock",
      navigationDisabledClass: "swiper-navigation-disabled"
    }
  }), e.navigation = {
    nextEl: null,
    prevEl: null
  };
  function o(y) {
    let f;
    return y && typeof y == "string" && e.isElement && (f = e.el.querySelector(y) || e.hostEl.querySelector(y), f) ? f : (y && (typeof y == "string" && (f = [...document.querySelectorAll(y)]), e.params.uniqueNavElements && typeof y == "string" && f && f.length > 1 && e.el.querySelectorAll(y).length === 1 ? f = e.el.querySelector(y) : f && f.length === 1 && (f = f[0])), y && !f ? y : f);
  }
  function l(y, f) {
    const x = e.params.navigation;
    y = ke(y), y.forEach((b) => {
      b && (b.classList[f ? "add" : "remove"](...x.disabledClass.split(" ")), b.tagName === "BUTTON" && (b.disabled = f), e.params.watchOverflow && e.enabled && b.classList[e.isLocked ? "add" : "remove"](x.lockClass));
    });
  }
  function a() {
    const {
      nextEl: y,
      prevEl: f
    } = e.navigation;
    if (e.params.loop) {
      l(f, !1), l(y, !1);
      return;
    }
    l(f, e.isBeginning && !e.params.rewind), l(y, e.isEnd && !e.params.rewind);
  }
  function d(y) {
    y.preventDefault(), !(e.isBeginning && !e.params.loop && !e.params.rewind) && (e.slidePrev(), r("navigationPrev"));
  }
  function c(y) {
    y.preventDefault(), !(e.isEnd && !e.params.loop && !e.params.rewind) && (e.slideNext(), r("navigationNext"));
  }
  function u() {
    const y = e.params.navigation;
    if (e.params.navigation = Qr(e, e.originalParams.navigation, e.params.navigation, {
      nextEl: "swiper-button-next",
      prevEl: "swiper-button-prev"
    }), !(y.nextEl || y.prevEl)) return;
    let f = o(y.nextEl), x = o(y.prevEl);
    Object.assign(e.navigation, {
      nextEl: f,
      prevEl: x
    }), f = ke(f), x = ke(x);
    const b = (g, k) => {
      g && g.addEventListener("click", k === "next" ? c : d), !e.enabled && g && g.classList.add(...y.lockClass.split(" "));
    };
    f.forEach((g) => b(g, "next")), x.forEach((g) => b(g, "prev"));
  }
  function h() {
    let {
      nextEl: y,
      prevEl: f
    } = e.navigation;
    y = ke(y), f = ke(f);
    const x = (b, g) => {
      b.removeEventListener("click", g === "next" ? c : d), b.classList.remove(...e.params.navigation.disabledClass.split(" "));
    };
    y.forEach((b) => x(b, "next")), f.forEach((b) => x(b, "prev"));
  }
  n("init", () => {
    e.params.navigation.enabled === !1 ? v() : (u(), a());
  }), n("toEdge fromEdge lock unlock", () => {
    a();
  }), n("destroy", () => {
    h();
  }), n("enable disable", () => {
    let {
      nextEl: y,
      prevEl: f
    } = e.navigation;
    if (y = ke(y), f = ke(f), e.enabled) {
      a();
      return;
    }
    [...y, ...f].filter((x) => !!x).forEach((x) => x.classList.add(e.params.navigation.lockClass));
  }), n("click", (y, f) => {
    let {
      nextEl: x,
      prevEl: b
    } = e.navigation;
    x = ke(x), b = ke(b);
    const g = f.target;
    let k = b.includes(g) || x.includes(g);
    if (e.isElement && !k) {
      const w = f.path || f.composedPath && f.composedPath();
      w && (k = w.find((C) => x.includes(C) || b.includes(C)));
    }
    if (e.params.navigation.hideOnClick && !k) {
      if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === g || e.pagination.el.contains(g))) return;
      let w;
      x.length ? w = x[0].classList.contains(e.params.navigation.hiddenClass) : b.length && (w = b[0].classList.contains(e.params.navigation.hiddenClass)), r(w === !0 ? "navigationShow" : "navigationHide"), [...x, ...b].filter((C) => !!C).forEach((C) => C.classList.toggle(e.params.navigation.hiddenClass));
    }
  });
  const m = () => {
    e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), u(), a();
  }, v = () => {
    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), h();
  };
  Object.assign(e.navigation, {
    enable: m,
    disable: v,
    update: a,
    init: u,
    destroy: h
  });
}
function Tt(t) {
  return t === void 0 && (t = ""), `.${t.trim().replace(/([\.:!+\/()[\]])/g, "\\$1").replace(/ /g, ".")}`;
}
function bu(t) {
  let {
    swiper: e,
    extendParams: i,
    on: n,
    emit: r
  } = t;
  const o = "swiper-pagination";
  i({
    pagination: {
      el: null,
      bulletElement: "span",
      clickable: !1,
      hideOnClick: !1,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: !1,
      type: "bullets",
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: !1,
      dynamicMainBullets: 1,
      formatFractionCurrent: (g) => g,
      formatFractionTotal: (g) => g,
      bulletClass: `${o}-bullet`,
      bulletActiveClass: `${o}-bullet-active`,
      modifierClass: `${o}-`,
      currentClass: `${o}-current`,
      totalClass: `${o}-total`,
      hiddenClass: `${o}-hidden`,
      progressbarFillClass: `${o}-progressbar-fill`,
      progressbarOppositeClass: `${o}-progressbar-opposite`,
      clickableClass: `${o}-clickable`,
      lockClass: `${o}-lock`,
      horizontalClass: `${o}-horizontal`,
      verticalClass: `${o}-vertical`,
      paginationDisabledClass: `${o}-disabled`
    }
  }), e.pagination = {
    el: null,
    bullets: []
  };
  let l, a = 0;
  function d() {
    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && e.pagination.el.length === 0;
  }
  function c(g, k) {
    const {
      bulletActiveClass: w
    } = e.params.pagination;
    g && (g = g[`${k === "prev" ? "previous" : "next"}ElementSibling`], g && (g.classList.add(`${w}-${k}`), g = g[`${k === "prev" ? "previous" : "next"}ElementSibling`], g && g.classList.add(`${w}-${k}-${k}`)));
  }
  function u(g, k, w) {
    if (g = g % w, k = k % w, k === g + 1)
      return "next";
    if (k === g - 1)
      return "previous";
  }
  function h(g) {
    const k = g.target.closest(Tt(e.params.pagination.bulletClass));
    if (!k)
      return;
    g.preventDefault();
    const w = Si(k) * e.params.slidesPerGroup;
    if (e.params.loop) {
      if (e.realIndex === w) return;
      const C = u(e.realIndex, w, e.slides.length);
      C === "next" ? e.slideNext() : C === "previous" ? e.slidePrev() : e.slideToLoop(w);
    } else
      e.slideTo(w);
  }
  function m() {
    const g = e.rtl, k = e.params.pagination;
    if (d()) return;
    let w = e.pagination.el;
    w = ke(w);
    let C, T;
    const I = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length, E = e.params.loop ? Math.ceil(I / e.params.slidesPerGroup) : e.snapGrid.length;
    if (e.params.loop ? (T = e.previousRealIndex || 0, C = e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex) : typeof e.snapIndex < "u" ? (C = e.snapIndex, T = e.previousSnapIndex) : (T = e.previousIndex || 0, C = e.activeIndex || 0), k.type === "bullets" && e.pagination.bullets && e.pagination.bullets.length > 0) {
      const P = e.pagination.bullets;
      let S, K, _;
      if (k.dynamicBullets && (l = Zi(P[0], e.isHorizontal() ? "width" : "height"), w.forEach((L) => {
        L.style[e.isHorizontal() ? "width" : "height"] = `${l * (k.dynamicMainBullets + 4)}px`;
      }), k.dynamicMainBullets > 1 && T !== void 0 && (a += C - (T || 0), a > k.dynamicMainBullets - 1 ? a = k.dynamicMainBullets - 1 : a < 0 && (a = 0)), S = Math.max(C - a, 0), K = S + (Math.min(P.length, k.dynamicMainBullets) - 1), _ = (K + S) / 2), P.forEach((L) => {
        const N = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map(($) => `${k.bulletActiveClass}${$}`)].map(($) => typeof $ == "string" && $.includes(" ") ? $.split(" ") : $).flat();
        L.classList.remove(...N);
      }), w.length > 1)
        P.forEach((L) => {
          const N = Si(L);
          N === C ? L.classList.add(...k.bulletActiveClass.split(" ")) : e.isElement && L.setAttribute("part", "bullet"), k.dynamicBullets && (N >= S && N <= K && L.classList.add(...`${k.bulletActiveClass}-main`.split(" ")), N === S && c(L, "prev"), N === K && c(L, "next"));
        });
      else {
        const L = P[C];
        if (L && L.classList.add(...k.bulletActiveClass.split(" ")), e.isElement && P.forEach((N, $) => {
          N.setAttribute("part", $ === C ? "bullet-active" : "bullet");
        }), k.dynamicBullets) {
          const N = P[S], $ = P[K];
          for (let A = S; A <= K; A += 1)
            P[A] && P[A].classList.add(...`${k.bulletActiveClass}-main`.split(" "));
          c(N, "prev"), c($, "next");
        }
      }
      if (k.dynamicBullets) {
        const L = Math.min(P.length, k.dynamicMainBullets + 4), N = (l * L - l) / 2 - _ * l, $ = g ? "right" : "left";
        P.forEach((A) => {
          A.style[e.isHorizontal() ? $ : "top"] = `${N}px`;
        });
      }
    }
    w.forEach((P, S) => {
      if (k.type === "fraction" && (P.querySelectorAll(Tt(k.currentClass)).forEach((K) => {
        K.textContent = k.formatFractionCurrent(C + 1);
      }), P.querySelectorAll(Tt(k.totalClass)).forEach((K) => {
        K.textContent = k.formatFractionTotal(E);
      })), k.type === "progressbar") {
        let K;
        k.progressbarOpposite ? K = e.isHorizontal() ? "vertical" : "horizontal" : K = e.isHorizontal() ? "horizontal" : "vertical";
        const _ = (C + 1) / E;
        let L = 1, N = 1;
        K === "horizontal" ? L = _ : N = _, P.querySelectorAll(Tt(k.progressbarFillClass)).forEach(($) => {
          $.style.transform = `translate3d(0,0,0) scaleX(${L}) scaleY(${N})`, $.style.transitionDuration = `${e.params.speed}ms`;
        });
      }
      k.type === "custom" && k.renderCustom ? (Ci(P, k.renderCustom(e, C + 1, E)), S === 0 && r("paginationRender", P)) : (S === 0 && r("paginationRender", P), r("paginationUpdate", P)), e.params.watchOverflow && e.enabled && P.classList[e.isLocked ? "add" : "remove"](k.lockClass);
    });
  }
  function v() {
    const g = e.params.pagination;
    if (d()) return;
    const k = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.grid && e.params.grid.rows > 1 ? e.slides.length / Math.ceil(e.params.grid.rows) : e.slides.length;
    let w = e.pagination.el;
    w = ke(w);
    let C = "";
    if (g.type === "bullets") {
      let T = e.params.loop ? Math.ceil(k / e.params.slidesPerGroup) : e.snapGrid.length;
      e.params.freeMode && e.params.freeMode.enabled && T > k && (T = k);
      for (let I = 0; I < T; I += 1)
        g.renderBullet ? C += g.renderBullet.call(e, I, g.bulletClass) : C += `<${g.bulletElement} ${e.isElement ? 'part="bullet"' : ""} class="${g.bulletClass}"></${g.bulletElement}>`;
    }
    g.type === "fraction" && (g.renderFraction ? C = g.renderFraction.call(e, g.currentClass, g.totalClass) : C = `<span class="${g.currentClass}"></span> / <span class="${g.totalClass}"></span>`), g.type === "progressbar" && (g.renderProgressbar ? C = g.renderProgressbar.call(e, g.progressbarFillClass) : C = `<span class="${g.progressbarFillClass}"></span>`), e.pagination.bullets = [], w.forEach((T) => {
      g.type !== "custom" && Ci(T, C || ""), g.type === "bullets" && e.pagination.bullets.push(...T.querySelectorAll(Tt(g.bulletClass)));
    }), g.type !== "custom" && r("paginationRender", w[0]);
  }
  function y() {
    e.params.pagination = Qr(e, e.originalParams.pagination, e.params.pagination, {
      el: "swiper-pagination"
    });
    const g = e.params.pagination;
    if (!g.el) return;
    let k;
    typeof g.el == "string" && e.isElement && (k = e.el.querySelector(g.el)), !k && typeof g.el == "string" && (k = [...document.querySelectorAll(g.el)]), k || (k = g.el), !(!k || k.length === 0) && (e.params.uniqueNavElements && typeof g.el == "string" && Array.isArray(k) && k.length > 1 && (k = [...e.el.querySelectorAll(g.el)], k.length > 1 && (k = k.find((w) => zr(w, ".swiper")[0] === e.el))), Array.isArray(k) && k.length === 1 && (k = k[0]), Object.assign(e.pagination, {
      el: k
    }), k = ke(k), k.forEach((w) => {
      g.type === "bullets" && g.clickable && w.classList.add(...(g.clickableClass || "").split(" ")), w.classList.add(g.modifierClass + g.type), w.classList.add(e.isHorizontal() ? g.horizontalClass : g.verticalClass), g.type === "bullets" && g.dynamicBullets && (w.classList.add(`${g.modifierClass}${g.type}-dynamic`), a = 0, g.dynamicMainBullets < 1 && (g.dynamicMainBullets = 1)), g.type === "progressbar" && g.progressbarOpposite && w.classList.add(g.progressbarOppositeClass), g.clickable && w.addEventListener("click", h), e.enabled || w.classList.add(g.lockClass);
    }));
  }
  function f() {
    const g = e.params.pagination;
    if (d()) return;
    let k = e.pagination.el;
    k && (k = ke(k), k.forEach((w) => {
      w.classList.remove(g.hiddenClass), w.classList.remove(g.modifierClass + g.type), w.classList.remove(e.isHorizontal() ? g.horizontalClass : g.verticalClass), g.clickable && (w.classList.remove(...(g.clickableClass || "").split(" ")), w.removeEventListener("click", h));
    })), e.pagination.bullets && e.pagination.bullets.forEach((w) => w.classList.remove(...g.bulletActiveClass.split(" ")));
  }
  n("changeDirection", () => {
    if (!e.pagination || !e.pagination.el) return;
    const g = e.params.pagination;
    let {
      el: k
    } = e.pagination;
    k = ke(k), k.forEach((w) => {
      w.classList.remove(g.horizontalClass, g.verticalClass), w.classList.add(e.isHorizontal() ? g.horizontalClass : g.verticalClass);
    });
  }), n("init", () => {
    e.params.pagination.enabled === !1 ? b() : (y(), v(), m());
  }), n("activeIndexChange", () => {
    typeof e.snapIndex > "u" && m();
  }), n("snapIndexChange", () => {
    m();
  }), n("snapGridLengthChange", () => {
    v(), m();
  }), n("destroy", () => {
    f();
  }), n("enable disable", () => {
    let {
      el: g
    } = e.pagination;
    g && (g = ke(g), g.forEach((k) => k.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass)));
  }), n("lock unlock", () => {
    m();
  }), n("click", (g, k) => {
    const w = k.target, C = ke(e.pagination.el);
    if (e.params.pagination.el && e.params.pagination.hideOnClick && C && C.length > 0 && !w.classList.contains(e.params.pagination.bulletClass)) {
      if (e.navigation && (e.navigation.nextEl && w === e.navigation.nextEl || e.navigation.prevEl && w === e.navigation.prevEl)) return;
      const T = C[0].classList.contains(e.params.pagination.hiddenClass);
      r(T === !0 ? "paginationShow" : "paginationHide"), C.forEach((I) => I.classList.toggle(e.params.pagination.hiddenClass));
    }
  });
  const x = () => {
    e.el.classList.remove(e.params.pagination.paginationDisabledClass);
    let {
      el: g
    } = e.pagination;
    g && (g = ke(g), g.forEach((k) => k.classList.remove(e.params.pagination.paginationDisabledClass))), y(), v(), m();
  }, b = () => {
    e.el.classList.add(e.params.pagination.paginationDisabledClass);
    let {
      el: g
    } = e.pagination;
    g && (g = ke(g), g.forEach((k) => k.classList.add(e.params.pagination.paginationDisabledClass))), f();
  };
  Object.assign(e.pagination, {
    enable: x,
    disable: b,
    render: v,
    update: m,
    init: y,
    destroy: f
  });
}
const Yn = ({
  product: t,
  routeContext: e
}) => {
  var h;
  const i = (h = t.variants) == null ? void 0 : h[0], n = !!(i != null && i.id && (!i.track_inventory || i.inventory > 0)), r = Nr(), o = e ?? r, l = ze(o ?? void 0), a = ba(t), d = va(
    a,
    o ?? void 0,
    void 0,
    l
  ), c = t.assets && t.assets.length > 0 ? t.assets[0].asset.path : "", u = t.assets && t.assets.length > 0 ? ht(t.assets[0]) : "";
  return /* @__PURE__ */ p("div", { className: "group cursor-pointer", children: [
    /* @__PURE__ */ p("div", { className: "relative mb-3 overflow-hidden rounded-lg shadow-lg sm:mb-4", children: [
      /* @__PURE__ */ s(
        $e,
        {
          src: c,
          alt: t.title || "Product",
          className: "aspect-square w-full object-cover transition-transform duration-500 group-hover:scale-110",
          showPlaceholderIcon: !0
        }
      ),
      /* @__PURE__ */ s("div", { className: "absolute inset-0 transition-all duration-300", children: /* @__PURE__ */ s("div", { className: "absolute inset-x-0 bottom-4 opacity-0 transition-all duration-300 group-hover:opacity-100", children: /* @__PURE__ */ s(
        Fr,
        {
          productId: t.id,
          variantId: i == null ? void 0 : i.id,
          title: t.title,
          image: u,
          price: (i == null ? void 0 : i.price) || 0,
          disabled: !n,
          className: "mx-auto block rounded-full bg-white px-6 py-2 text-sm font-semibold text-black shadow-lg transition-all duration-200 hover:bg-gray-100",
          children: n ? "Add to Cart" : "Out of Stock"
        }
      ) }) })
    ] }),
    /* @__PURE__ */ p("div", { className: "space-y-1 sm:space-y-2", children: [
      /* @__PURE__ */ s(Lt, { href: d, className: "block", children: /* @__PURE__ */ s("h4", { className: "font-semibold text-black transition-colors hover:text-blue-600 group-hover:text-gray-600", children: t.title }) }),
      Ot() && /* @__PURE__ */ p("div", { className: "text-xs text-gray-400 font-mono bg-gray-50 px-2 py-1 rounded", children: [
        "→ ",
        a
      ] }),
      /* @__PURE__ */ s("p", { className: "text-sm text-gray-600", children: a }),
      /* @__PURE__ */ s("h5", { className: "font-medium text-black", children: t.variants && t.variants.length > 0 ? `MRP : ${Bt(t.variants[0].price)}` : "Price not available" })
    ] })
  ] });
}, vu = ({
  displayProducts: t,
  titleFontSize: e,
  titleColor: i,
  titleText: n,
  mobileCtaData: r,
  routeContext: o
}) => {
  var d, c, u, h, m, v, y, f, x, b, g, k, w, C, T, I;
  const l = oe(null), a = oe(null);
  return /* @__PURE__ */ s("section", { className: "nike-trending-section bg-white py-12 lg:py-16", children: /* @__PURE__ */ p("div", { className: "container mx-auto px-4 sm:px-6 lg:px-8", children: [
    /* @__PURE__ */ p("div", { className: "mb-8 flex items-center justify-between sm:mb-12", children: [
      /* @__PURE__ */ p("div", { children: [
        /* @__PURE__ */ s(
          "h2",
          {
            className: "font-bold text-black",
            style: {
              fontSize: `${e}px`,
              color: i
            },
            children: n
          }
        ),
        Ot() && o && /* @__PURE__ */ p("div", { className: "mt-2 text-xs text-gray-500 font-mono", children: [
          "Route: ",
          o.fullRoute,
          " | Additional: [",
          o.additionalPath.join(", "),
          "]"
        ] })
      ] }),
      /* @__PURE__ */ p("div", { className: "hidden items-center gap-4 sm:flex", children: [
        /* @__PURE__ */ s("button", { className: "text-sm font-medium text-black hover:text-gray-600 lg:text-base", children: "Shop" }),
        /* @__PURE__ */ p("div", { className: "flex gap-2", children: [
          /* @__PURE__ */ s(
            "button",
            {
              ref: l,
              className: "flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 transition-colors hover:bg-gray-300 disabled:opacity-50 lg:h-10 lg:w-10",
              children: /* @__PURE__ */ s(
                "svg",
                {
                  className: "h-4 w-4 lg:h-5 lg:w-5",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  children: /* @__PURE__ */ s(
                    "path",
                    {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M15 19l-7-7 7-7"
                    }
                  )
                }
              )
            }
          ),
          /* @__PURE__ */ s(
            "button",
            {
              ref: a,
              className: "flex h-8 w-8 items-center justify-center rounded-full bg-gray-200 transition-colors hover:bg-gray-300 lg:h-10 lg:w-10",
              children: /* @__PURE__ */ s(
                "svg",
                {
                  className: "h-4 w-4 lg:h-5 lg:w-5",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24",
                  children: /* @__PURE__ */ s(
                    "path",
                    {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      strokeWidth: 2,
                      d: "M9 5l7 7-7 7"
                    }
                  )
                }
              )
            }
          )
        ] })
      ] })
    ] }),
    t.length === 0 ? /* @__PURE__ */ p("div", { className: "flex flex-col items-center justify-center py-16 text-center", children: [
      /* @__PURE__ */ s("div", { className: "mb-4", children: /* @__PURE__ */ s(
        "svg",
        {
          className: "mx-auto h-16 w-16 text-gray-300",
          fill: "none",
          stroke: "currentColor",
          viewBox: "0 0 24 24",
          children: /* @__PURE__ */ s(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              strokeWidth: 1.5,
              d: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4"
            }
          )
        }
      ) }),
      /* @__PURE__ */ s("h3", { className: "text-xl font-semibold text-gray-900 mb-2", children: "No Trending Products Available" }),
      /* @__PURE__ */ s("p", { className: "text-gray-500 max-w-md", children: "Check back soon for the latest trending products." })
    ] }) : /* @__PURE__ */ p(se, { children: [
      /* @__PURE__ */ s("div", { className: "hidden md:block", children: /* @__PURE__ */ s(
        Yr,
        {
          modules: [yu, bu],
          spaceBetween: 24,
          slidesPerView: 2,
          navigation: {
            prevEl: l.current,
            nextEl: a.current
          },
          onBeforeInit: (E) => {
            E.params.navigation.prevEl = l.current, E.params.navigation.nextEl = a.current;
          },
          breakpoints: {
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 24
            }
          },
          className: "trending-swiper",
          children: t.map((E) => /* @__PURE__ */ s(Xr, { children: /* @__PURE__ */ s(Yn, { product: E, routeContext: o }) }, E.id))
        }
      ) }),
      /* @__PURE__ */ s("div", { className: "grid grid-cols-1 gap-6 md:hidden", children: t.map((E) => /* @__PURE__ */ s(
        Yn,
        {
          product: E,
          routeContext: o
        },
        E.id
      )) })
    ] }),
    /* @__PURE__ */ s("div", { className: "mt-6 text-center sm:hidden", children: /* @__PURE__ */ s(
      "button",
      {
        className: "font-medium transition-colors",
        style: {
          backgroundColor: ((c = (d = r == null ? void 0 : r.desktop) == null ? void 0 : d.find(
            (E) => E.inputKey === "button-color"
          )) == null ? void 0 : c.value) || "#000000",
          color: ((h = (u = r == null ? void 0 : r.desktop) == null ? void 0 : u.find(
            (E) => E.inputKey === "textColor"
          )) == null ? void 0 : h.value) || "#FFFFFF",
          borderRadius: `${((v = (m = r == null ? void 0 : r.desktop) == null ? void 0 : m.find(
            (E) => E.inputKey === "borderRadius"
          )) == null ? void 0 : v.value) || 50}px`,
          paddingLeft: `${((f = (y = r == null ? void 0 : r.desktop) == null ? void 0 : y.find(
            (E) => E.inputKey === "paddingX"
          )) == null ? void 0 : f.value) || 24}px`,
          paddingRight: `${((b = (x = r == null ? void 0 : r.desktop) == null ? void 0 : x.find(
            (E) => E.inputKey === "paddingX"
          )) == null ? void 0 : b.value) || 24}px`,
          paddingTop: `${((k = (g = r == null ? void 0 : r.desktop) == null ? void 0 : g.find(
            (E) => E.inputKey === "paddingY"
          )) == null ? void 0 : k.value) || 8}px`,
          paddingBottom: `${((C = (w = r == null ? void 0 : r.desktop) == null ? void 0 : w.find(
            (E) => E.inputKey === "paddingY"
          )) == null ? void 0 : C.value) || 8}px`,
          border: "none",
          cursor: "pointer"
        },
        children: ((I = (T = r == null ? void 0 : r.desktop) == null ? void 0 : T.find(
          (E) => E.inputKey === "button-text"
        )) == null ? void 0 : I.value) || "Shop All"
      }
    ) })
  ] }) });
}, xu = [
  // Section Title Component
  F(
    "heading-text",
    "trending-section-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Trending Now" },
        { inputKey: "level", type: "select", value: "2" },
        { inputKey: "fontSize", type: "number", value: 48 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "marginBottom", type: "number", value: 48 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "marginBottom", type: "number", value: 32 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 24 },
        { inputKey: "marginBottom", type: "number", value: 24 }
      ]
    },
    {
      name: "Section Title",
      description: "Main heading for the Trending section"
    }
  ),
  // Product 1 - Background Image
  F(
    "background-image",
    "trending-product-1-bg",
    {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: z.trending.trending1
        },
        { inputKey: "backgroundSize", type: "select", value: "cover" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "aspectRatio", type: "select", value: "square" },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Product 1 Image",
      description: "Product image for the first trending item"
    }
  ),
  // Product 1 - Title
  F(
    "heading-text",
    "trending-product-1-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Nike Zoom Vomero 5" },
        { inputKey: "level", type: "select", value: "4" },
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "fontWeight", type: "select", value: "semibold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "lineHeight", type: "number", value: 1.4 },
        { inputKey: "marginBottom", type: "number", value: 4 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 14 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 14 }]
    },
    {
      name: "Product 1 Title",
      description: "Title for the first trending product"
    }
  ),
  // Product 1 - Category
  F(
    "text-block",
    "trending-product-1-category",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Men's Shoes" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#6B7280" },
        { inputKey: "marginBottom", type: "number", value: 4 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 12 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 12 }]
    },
    {
      name: "Product 1 Category",
      description: "Category for the first trending product"
    }
  ),
  // Product 1 - Price
  F(
    "text-block",
    "trending-product-1-price",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "MRP : ₹ 14 995.00" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "semibold" },
        { inputKey: "textColor", type: "color", value: "#000000" }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 12 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 12 }]
    },
    {
      name: "Product 1 Price",
      description: "Price for the first trending product"
    }
  ),
  // Repeat similar pattern for Products 2-12 (abbreviated here for brevity)
  // In production, you'd have all 12 products configured
  // Mobile View Options CTA
  F(
    "button-solid",
    "trending-mobile-cta",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "View Options" },
        { inputKey: "width", type: "select", value: "full" },
        { inputKey: "backgroundColor", type: "color", value: "#000000" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "borderRadius", type: "number", value: 30 },
        { inputKey: "padding", type: "text", value: "12px 24px" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Mobile CTA Button",
      description: "Call-to-action button shown on mobile view"
    }
  )
], ku = ({ data: t, className: e, routeContext: i, storeId: n, viewportMode: r }) => {
  const o = R(
    t,
    "heading-text",
    "trending-section-title",
    r
  ), l = R(
    t,
    "button-solid",
    "trending-mobile-cta",
    r
  ), a = B(o, "fontSize", 48), d = B(o, "textColor", "#000000"), c = B(o, "text", "Trending Now"), [u, h] = O([]);
  return U(() => {
    let m = !1;
    return (async () => {
      var y;
      try {
        if (me()) {
          m || h(
            mr()
          );
          return;
        }
        const f = n || ur.STORE_ID || "test";
        no.isInitialized() || ro({
          storeId: f,
          testMode: Ot()
        });
        const b = await pt().products.getProducts({
          page: 1,
          page_size: 12,
          status: "ACTIVE"
        }), g = Array.isArray(b == null ? void 0 : b.data) ? b.data : Array.isArray((y = b == null ? void 0 : b.data) == null ? void 0 : y.data) ? b.data.data : [];
        m || h(g);
      } catch (f) {
        console.error("[TrendingClient] Failed to fetch trending products via SDK:", f), m || h([]);
      }
    })(), () => {
      m = !0;
    };
  }, [n]), /* @__PURE__ */ s(
    vu,
    {
      displayProducts: u,
      titleFontSize: a,
      titleColor: d,
      titleText: c,
      mobileCtaData: l,
      routeContext: i
    }
  );
}, wu = ue(ku, {
  identifier: "nike.nikeproduct.trendingsection",
  title: "Trending",
  featuredImage: z.previews.trending,
  description: "Client-side version of trending Nike products section. Uses client-side data fetching or state.",
  category: "nike",
  className: "nike-trending",
  components: xu,
  renderMode: "client"
}), Su = [
  // Section Title Component
  F(
    "heading-text",
    "dont-miss-section-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Don't Miss" },
        { inputKey: "level", type: "select", value: "2" },
        { inputKey: "fontSize", type: "number", value: 48 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "marginBottom", type: "number", value: 48 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 40 },
        { inputKey: "marginBottom", type: "number", value: 40 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "marginBottom", type: "number", value: 32 }
      ]
    },
    {
      name: "Section Title",
      description: "Main heading for the Don't Miss section"
    }
  ),
  // Background Image Component
  F(
    "background-image",
    "dont-miss-bg",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: z.dontMiss.main },
        { inputKey: "backgroundSize", type: "select", value: "contain" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 600 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 500 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 400 }]
    },
    {
      name: "Background Image",
      description: "Main background image for the promotional banner"
    }
  ),
  // Subtitle Component
  F(
    "text-block",
    "dont-miss-subtitle",
    {
      desktop: [
        {
          inputKey: "text",
          type: "text",
          value: "Men's Air Jordan Collection"
        },
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#D1D5DB" },
        { inputKey: "marginBottom", type: "number", value: 8 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Subtitle",
      description: "Subtitle text for the promotional banner"
    }
  ),
  // Main Title Component
  F(
    "heading-text",
    "dont-miss-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Show 'Em Up" },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 48 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 40 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 32 }]
    },
    {
      name: "Main Title",
      description: "Main title for the promotional banner"
    }
  ),
  // Description Component
  F(
    "text-block",
    "dont-miss-description",
    {
      desktop: [
        {
          inputKey: "text",
          type: "text",
          value: "Crafted for your flyest self, the new Air Jordan Collection brings iconic prints and elevated cuts."
        },
        { inputKey: "fontSize", type: "number", value: 18 },
        { inputKey: "fontWeight", type: "select", value: "normal" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.6 },
        { inputKey: "marginBottom", type: "number", value: 32 },
        { inputKey: "maxWidth", type: "number", value: 600 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 16 },
        { inputKey: "marginBottom", type: "number", value: 24 },
        { inputKey: "maxWidth", type: "number", value: 500 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 14 },
        { inputKey: "marginBottom", type: "number", value: 20 },
        { inputKey: "maxWidth", type: "number", value: 400 }
      ]
    },
    {
      name: "Description",
      description: "Description text for the promotional banner"
    }
  ),
  // CTA Button Component
  F(
    "button-solid",
    "dont-miss-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "CTA Button",
      description: "Call-to-action button for the promotional banner"
    }
  )
], Cu = ({ data: t, className: e, storeId: i, viewportMode: n = "desktop" }) => {
  var u, h, m, v, y, f, x, b, g, k, w, C, T, I, E, P;
  const r = me(), o = (S, K) => {
    var L;
    const _ = (t == null ? void 0 : t[n || "desktop"]) ?? (t == null ? void 0 : t.desktop);
    return _ && Array.isArray(_) ? ((L = _ == null ? void 0 : _.find((N) => N.inputKey === S)) == null ? void 0 : L.value) ?? K : K;
  };
  R(
    t,
    "heading-text",
    "dont-miss-section-title",
    n
  ), R(
    t,
    "background-image",
    "dont-miss-bg",
    n
  ), R(
    t,
    "text-block",
    "dont-miss-subtitle",
    n
  ), R(
    t,
    "heading-text",
    "dont-miss-title",
    n
  ), R(
    t,
    "text-block",
    "dont-miss-description",
    n
  );
  const l = R(t, "button-solid", "dont-miss-cta", n), a = o("assetId") || z.dontMiss.main, [d, c] = O(
    r || typeof a == "string" && !a.startsWith("http") ? z.dontMiss.main : a
  );
  return U(() => {
    if (r)
      return;
    (async () => {
      try {
        if (typeof a == "string" && a && i) {
          const K = await we(
            a,
            i,
            { width: 1920, height: 1080, fit: "cover" }
          );
          c(K);
        }
      } catch (K) {
        console.error("[DontMiss] Failed to fetch background asset:", K), c(z.dontMiss.main);
      }
    })();
  }, [a, i, r]), /* @__PURE__ */ s(
    "section",
    {
      className: `nike-dont-miss-section ${e || ""} bg-white py-16 lg:py-24`,
      children: /* @__PURE__ */ p("div", { className: "container mx-auto px-4 sm:px-6 lg:px-8", children: [
        /* @__PURE__ */ s(
          "h2",
          {
            className: "mb-12 font-bold text-black",
            style: {
              fontSize: `${o("fontSize", 48)}px`,
              color: o("textColor", "#000000"),
              marginBottom: `${o("marginBottom", 48)}px`
            },
            children: o("text", "Don't Miss")
          }
        ),
        /* @__PURE__ */ s("div", { className: "group relative cursor-pointer", children: /* @__PURE__ */ p("div", { className: "relative overflow-hidden rounded-lg shadow-lg", children: [
          /* @__PURE__ */ s(
            "img",
            {
              src: d,
              alt: "Men's Air Jordan Collection",
              className: "w-full object-contain transition-transform duration-500 group-hover:scale-110",
              style: {
                minHeight: `${o("minHeight", 600)}px`
              }
            }
          ),
          /* @__PURE__ */ s("div", { className: "absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-8 md:p-12", children: /* @__PURE__ */ p("div", { className: "max-w-2xl text-white", children: [
            /* @__PURE__ */ s(
              "p",
              {
                className: "mb-2",
                style: {
                  fontSize: `${o("fontSize", 14)}px`,
                  color: o("textColor", "#D1D5DB"),
                  marginBottom: `${o("marginBottom", 8)}px`
                },
                children: o("text", "Men's Air Jordan Collection")
              }
            ),
            /* @__PURE__ */ s(
              "h3",
              {
                className: "mb-4 font-bold",
                style: {
                  fontSize: `${o("fontSize", 48)}px`,
                  color: o("textColor", "#FFFFFF"),
                  lineHeight: o("lineHeight", 1.2),
                  marginBottom: `${o("marginBottom", 16)}px`
                },
                children: o("text", "Show 'Em Up")
              }
            ),
            /* @__PURE__ */ s(
              "p",
              {
                className: "mb-8 leading-relaxed",
                style: {
                  fontSize: `${o("fontSize", 18)}px`,
                  color: o("textColor", "#FFFFFF"),
                  lineHeight: o("lineHeight", 1.6),
                  marginBottom: `${o("marginBottom", 32)}px`,
                  maxWidth: `${o("maxWidth", 600)}px`
                },
                children: o("text", "") || "Crafted for your flyest self, the new Air Jordan Collection brings iconic prints and elevated cuts."
              }
            ),
            /* @__PURE__ */ s(
              "button",
              {
                className: "font-medium transition-all duration-300",
                style: {
                  backgroundColor: ((h = (u = l == null ? void 0 : l.desktop) == null ? void 0 : u.find(
                    (S) => S.inputKey === "button-color"
                  )) == null ? void 0 : h.value) || "#FFFFFF",
                  color: ((v = (m = l == null ? void 0 : l.desktop) == null ? void 0 : m.find(
                    (S) => S.inputKey === "textColor"
                  )) == null ? void 0 : v.value) || "#000000",
                  borderRadius: `${((f = (y = l == null ? void 0 : l.desktop) == null ? void 0 : y.find((S) => S.inputKey === "borderRadius")) == null ? void 0 : f.value) || 50}px`,
                  paddingLeft: `${((b = (x = l == null ? void 0 : l.desktop) == null ? void 0 : x.find((S) => S.inputKey === "paddingX")) == null ? void 0 : b.value) || 24}px`,
                  paddingRight: `${((k = (g = l == null ? void 0 : l.desktop) == null ? void 0 : g.find((S) => S.inputKey === "paddingX")) == null ? void 0 : k.value) || 24}px`,
                  paddingTop: `${((C = (w = l == null ? void 0 : l.desktop) == null ? void 0 : w.find((S) => S.inputKey === "paddingY")) == null ? void 0 : C.value) || 8}px`,
                  paddingBottom: `${((I = (T = l == null ? void 0 : l.desktop) == null ? void 0 : T.find((S) => S.inputKey === "paddingY")) == null ? void 0 : I.value) || 8}px`,
                  border: "none",
                  cursor: "pointer"
                },
                children: ((P = (E = l == null ? void 0 : l.desktop) == null ? void 0 : E.find(
                  (S) => S.inputKey === "button-text"
                )) == null ? void 0 : P.value) || "Shop"
              }
            )
          ] }) })
        ] }) })
      ] })
    }
  );
}, Nu = ue(Cu, {
  identifier: "nike.nikepromotional.dontmisssection",
  title: "Don't Miss",
  featuredImage: z.previews.dontMiss,
  description: "Large promotional banner with configurable background image, content overlay, and call-to-action",
  category: "nike",
  className: "nike-dont-miss",
  components: Su,
  renderMode: "client"
}), Ku = [
  // Section Title Component
  F(
    "heading-text",
    "featured-section-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Featured" },
        { inputKey: "level", type: "select", value: "2" },
        { inputKey: "fontSize", type: "number", value: 48 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "marginBottom", type: "number", value: 48 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 40 },
        { inputKey: "marginBottom", type: "number", value: 40 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "marginBottom", type: "number", value: 32 }
      ]
    },
    {
      name: "Section Title",
      description: "Main heading for the Featured section"
    }
  ),
  // Featured Item 1 - Background Image
  F(
    "background-image",
    "featured-item-1-bg",
    {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: z.featured.featured1
        },
        { inputKey: "backgroundSize", type: "select", value: "contain" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 400 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 350 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 300 }]
    },
    {
      name: "Featured Item 1 Background",
      description: "Background image for the first featured item"
    }
  ),
  // Featured Item 1 - Title
  F(
    "heading-text",
    "featured-item-1-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Cool For The Summer" },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 24 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 20 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 18 }]
    },
    {
      name: "Featured Item 1 Title",
      description: "Title for the first featured item"
    }
  ),
  // Featured Item 1 - CTA Button
  F(
    "button-solid",
    "featured-item-1-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Featured Item 1 CTA",
      description: "Call-to-action button for the first featured item"
    }
  ),
  // Featured Item 2 - Background Image
  F(
    "background-image",
    "featured-item-2-bg",
    {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: z.featured.featured2
        },
        { inputKey: "backgroundSize", type: "select", value: "contain" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 400 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 350 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 300 }]
    },
    {
      name: "Featured Item 2 Background",
      description: "Background image for the second featured item"
    }
  ),
  // Featured Item 2 - Title
  F(
    "heading-text",
    "featured-item-2-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Gear for Every Rep" },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 24 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 20 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 18 }]
    },
    {
      name: "Featured Item 2 Title",
      description: "Title for the second featured item"
    }
  ),
  // Featured Item 2 - CTA Button
  F(
    "button-solid",
    "featured-item-2-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Featured Item 2 CTA",
      description: "Call-to-action button for the second featured item"
    }
  ),
  // Featured Item 3 - Background Image
  F(
    "background-image",
    "featured-item-3-bg",
    {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: z.featured.featured3
        },
        { inputKey: "backgroundSize", type: "select", value: "contain" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 400 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 350 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 300 }]
    },
    {
      name: "Featured Item 3 Background",
      description: "Background image for the third featured item"
    }
  ),
  // Featured Item 3 - Title
  F(
    "heading-text",
    "featured-item-3-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Kids' Pegasus 41" },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 24 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 20 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 18 }]
    },
    {
      name: "Featured Item 3 Title",
      description: "Title for the third featured item"
    }
  ),
  // Featured Item 3 - CTA Button
  F(
    "button-solid",
    "featured-item-3-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Featured Item 3 CTA",
      description: "Call-to-action button for the third featured item"
    }
  )
], Tu = ({ data: t, className: e, theme: i, storeId: n, viewportMode: r }) => {
  const o = (S, K, _) => {
    var N;
    const L = (S == null ? void 0 : S[r || "desktop"]) ?? (S == null ? void 0 : S.desktop);
    return Array.isArray(L) ? ((N = L.find(($) => $.inputKey === K)) == null ? void 0 : N.value) ?? _ : L && typeof L == "object" ? L[K] ?? _ : _;
  }, l = R(
    t,
    "heading-text",
    "featured-section-title",
    r
  ), a = R(
    t,
    "background-image",
    "featured-item-1-bg",
    r
  ), d = R(
    t,
    "heading-text",
    "featured-item-1-title",
    r
  ), c = R(
    t,
    "button-solid",
    "featured-item-1-cta",
    r
  ), u = R(
    t,
    "background-image",
    "featured-item-2-bg",
    r
  ), h = R(
    t,
    "heading-text",
    "featured-item-2-title",
    r
  ), m = R(
    t,
    "button-solid",
    "featured-item-2-cta",
    r
  ), v = R(
    t,
    "background-image",
    "featured-item-3-bg",
    r
  ), y = R(
    t,
    "heading-text",
    "featured-item-3-title",
    r
  ), f = R(
    t,
    "button-solid",
    "featured-item-3-cta",
    r
  ), x = o(a, "assetId", z.featured.featured1) || z.featured.featured1, b = o(u, "assetId", z.featured.featured2) || z.featured.featured2, g = o(v, "assetId", z.featured.featured3) || z.featured.featured3, [k, w] = O(
    typeof x == "string" && !x.startsWith("http") ? z.featured.featured1 : x
  ), [C, T] = O(
    typeof b == "string" && !b.startsWith("http") ? z.featured.featured2 : b
  ), [I, E] = O(
    typeof g == "string" && !g.startsWith("http") ? z.featured.featured3 : g
  );
  U(() => {
    (async () => {
      try {
        if (typeof x == "string" && x && n) {
          const K = await we(
            x,
            n,
            { width: 500, height: 400, fit: "cover" }
          );
          w(K);
        }
      } catch (K) {
        console.error("[Featured] Failed to fetch item1 asset:", K), w(z.featured.featured1);
      }
    })();
  }, [x, n]), U(() => {
    (async () => {
      try {
        if (typeof b == "string" && b && n) {
          const K = await we(
            b,
            n,
            { width: 500, height: 400, fit: "cover" }
          );
          T(K);
        }
      } catch (K) {
        console.error("[Featured] Failed to fetch item2 asset:", K), T(z.featured.featured2);
      }
    })();
  }, [b, n]), U(() => {
    (async () => {
      try {
        if (typeof g == "string" && g && n) {
          const K = await we(
            g,
            n,
            { width: 500, height: 400, fit: "cover" }
          );
          E(K);
        }
      } catch (K) {
        console.error("[Featured] Failed to fetch item3 asset:", K), E(z.featured.featured3);
      }
    })();
  }, [g, n]);
  const P = (S, K, _, L, N, $) => /* @__PURE__ */ s("div", { className: "group relative cursor-pointer", children: /* @__PURE__ */ p("div", { className: "relative overflow-hidden rounded-lg shadow-lg", children: [
    /* @__PURE__ */ s(
      "img",
      {
        src: L,
        alt: $,
        className: "w-full object-contain transition-transform duration-500 group-hover:scale-110",
        style: {
          minHeight: `${o(S, "minHeight", 400)}px`
        }
      }
    ),
    /* @__PURE__ */ s("div", { className: "absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-8", children: /* @__PURE__ */ p("div", { className: "text-white", children: [
      /* @__PURE__ */ s(
        "h3",
        {
          className: "mb-4 font-bold leading-tight",
          style: {
            fontSize: `${o(K, "fontSize", 24)}px`,
            color: o(K, "textColor", "#FFFFFF"),
            lineHeight: o(K, "lineHeight", 1.2),
            marginBottom: `${o(K, "marginBottom", 16)}px`
          },
          children: o(K, "text", N)
        }
      ),
      /* @__PURE__ */ s(
        "button",
        {
          className: "font-medium transition-all duration-300",
          style: {
            backgroundColor: o(_, "button-color", "#FFFFFF"),
            color: o(_, "textColor", "#000000"),
            borderRadius: `${o(_, "borderRadius", 50)}px`,
            paddingLeft: `${o(_, "paddingX", 24)}px`,
            paddingRight: `${o(_, "paddingX", 24)}px`,
            paddingTop: `${o(_, "paddingY", 8)}px`,
            paddingBottom: `${o(_, "paddingY", 8)}px`,
            border: "none",
            cursor: "pointer"
          },
          children: o(_, "button-text", "Shop")
        }
      )
    ] }) })
  ] }) });
  return /* @__PURE__ */ s(
    "section",
    {
      className: `nike-featured-section ${e || ""} bg-white py-16 lg:py-24`,
      children: /* @__PURE__ */ p("div", { className: "container mx-auto px-4 sm:px-6 lg:px-8", children: [
        /* @__PURE__ */ s(
          "h2",
          {
            className: "mb-12 font-bold text-black",
            style: {
              fontSize: `${o(l, "fontSize", 48)}px`,
              color: o(l, "textColor", "#000000"),
              marginBottom: `${o(l, "marginBottom", 48)}px`
            },
            children: o(l, "text", "Featured")
          }
        ),
        /* @__PURE__ */ p("div", { className: "grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 lg:gap-8", children: [
          P(
            a,
            d,
            c,
            k,
            "Cool For The Summer",
            "Cool For The Summer"
          ),
          P(
            u,
            h,
            m,
            C,
            "Gear for Every Rep",
            "Gear for Every Rep"
          ),
          P(
            v,
            y,
            f,
            I,
            "Kids' Pegasus 41",
            "Kids' Pegasus 41"
          )
        ] })
      ] })
    }
  );
}, Iu = ue(Tu, {
  identifier: "nike.nikepromotional.featuredsection",
  title: "Featured",
  featuredImage: z.previews.featured,
  description: "Three-column grid showcasing featured Nike products with customizable images, titles, and CTAs",
  category: "nike",
  className: "nike-featured",
  components: Ku,
  renderMode: "client"
}), Eu = [
  // Section Title Component
  F(
    "heading-text",
    "latest-section-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "The Latest" },
        { inputKey: "level", type: "select", value: "2" },
        { inputKey: "fontSize", type: "number", value: 48 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "marginBottom", type: "number", value: 48 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 40 },
        { inputKey: "marginBottom", type: "number", value: 40 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "marginBottom", type: "number", value: 32 }
      ]
    },
    {
      name: "Section Title",
      description: "Main heading for the Latest section"
    }
  ),
  // Left Card Background Image
  F(
    "background-image",
    "latest-card-1-bg",
    {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: z.promotions.promotion1
        },
        { inputKey: "backgroundSize", type: "select", value: "cover" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 500 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 450 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 400 }]
    },
    {
      name: "Left Card Background",
      description: "Background image for the first promotional card"
    }
  ),
  // Left Card Subtitle
  F(
    "text-block",
    "latest-card-1-subtitle",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Feed the Phantom" },
        { inputKey: "fontSize", type: "number", value: 12 },
        { inputKey: "fontWeight", type: "select", value: "medium" },
        { inputKey: "textColor", type: "color", value: "#D1D5DB" },
        { inputKey: "textTransform", type: "select", value: "uppercase" },
        { inputKey: "letterSpacing", type: "number", value: 1 },
        { inputKey: "marginBottom", type: "number", value: 12 }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Left Card Subtitle",
      description: "Subtitle text for the first promotional card"
    }
  ),
  // Left Card Title
  F(
    "heading-text",
    "latest-card-1-title",
    {
      desktop: [
        {
          inputKey: "text",
          type: "text",
          value: "The new Phantom 6—so precise, it's scary."
        },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 24 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 28 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 24 }]
    },
    {
      name: "Left Card Title",
      description: "Main title for the first promotional card"
    }
  ),
  // Left Card CTA Button
  F(
    "button-solid",
    "latest-card-1-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Left Card CTA",
      description: "Call-to-action button for the first promotional card"
    }
  ),
  // Right Card Background Image
  F(
    "background-image",
    "latest-card-2-bg",
    {
      desktop: [
        {
          inputKey: "assetId",
          type: "text",
          value: z.promotions.promotion2
        },
        { inputKey: "backgroundSize", type: "select", value: "cover" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 500 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 450 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 400 }]
    },
    {
      name: "Right Card Background",
      description: "Background image for the second promotional card"
    }
  ),
  // Right Card Title
  F(
    "heading-text",
    "latest-card-2-title",
    {
      desktop: [
        {
          inputKey: "text",
          type: "text",
          value: "The Faith Kipyegon Collection"
        },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 24 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 28 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 24 }]
    },
    {
      name: "Right Card Title",
      description: "Main title for the second promotional card"
    }
  ),
  // Right Card CTA Button
  F(
    "button-solid",
    "latest-card-2-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Right Card CTA",
      description: "Call-to-action button for the second promotional card"
    }
  )
], ee = (t, e, i, n) => {
  const r = t == null ? void 0 : t[e];
  if (Array.isArray(r)) {
    const o = r.find((l) => l.inputKey === i);
    if (o !== void 0) return o.value;
  }
  return n;
}, _u = ({
  data: t,
  className: e,
  theme: i,
  storeId: n,
  viewportMode: r = "desktop"
}) => {
  const o = R(
    t,
    "heading-text",
    "latest-section-title",
    r
  ), l = R(
    t,
    "background-image",
    "latest-card-1-bg",
    r
  ), a = R(
    t,
    "text-block",
    "latest-card-1-subtitle",
    r
  ), d = R(
    t,
    "heading-text",
    "latest-card-1-title",
    r
  ), c = R(
    t,
    "button-solid",
    "latest-card-1-cta",
    r
  ), u = R(
    t,
    "background-image",
    "latest-card-2-bg",
    r
  ), h = R(
    t,
    "heading-text",
    "latest-card-2-title",
    r
  ), m = R(
    t,
    "button-solid",
    "latest-card-2-cta",
    r
  ), v = ee(
    l,
    r,
    "assetId",
    z.promotions.promotion1
  ), y = ee(
    u,
    r,
    "assetId",
    z.promotions.promotion2
  ), [f, x] = O(
    typeof v == "string" && !v.startsWith("http") ? z.promotions.promotion1 : v
  ), [b, g] = O(
    typeof y == "string" && !y.startsWith("http") ? z.promotions.promotion2 : y
  );
  return U(() => {
    (async () => {
      try {
        if (typeof v == "string" && v && n) {
          const w = await we(
            v,
            n,
            { width: 800, height: 500, fit: "cover" }
          );
          x(w);
        }
      } catch (w) {
        console.error("[Latest] Failed to fetch card1 asset:", w), x(z.promotions.promotion1);
      }
    })();
  }, [v, n]), U(() => {
    (async () => {
      try {
        if (typeof y == "string" && y && n) {
          const w = await we(
            y,
            n,
            { width: 800, height: 500, fit: "cover" }
          );
          g(w);
        }
      } catch (w) {
        console.error("[Latest] Failed to fetch card2 asset:", w), g(z.promotions.promotion2);
      }
    })();
  }, [y, n]), /* @__PURE__ */ s(
    "section",
    {
      className: `nike-latest-section ${e || ""} bg-white py-16 lg:py-24`,
      children: /* @__PURE__ */ p("div", { className: "container mx-auto px-4 sm:px-6 lg:px-8", children: [
        /* @__PURE__ */ s(
          "h2",
          {
            className: "mb-12 font-bold text-black",
            style: {
              fontSize: `${ee(o, r, "fontSize", 48)}px`,
              color: ee(o, r, "textColor", "#000000"),
              marginBottom: `${ee(o, r, "marginBottom", 48)}px`
            },
            children: ee(o, r, "text", "The Latest")
          }
        ),
        /* @__PURE__ */ p("div", { className: "grid grid-cols-1 gap-6 md:grid-cols-2 lg:gap-8", children: [
          /* @__PURE__ */ s("div", { className: "group relative cursor-pointer", children: /* @__PURE__ */ p("div", { className: "relative overflow-hidden rounded-lg shadow-lg", children: [
            /* @__PURE__ */ s(
              "img",
              {
                src: f,
                alt: "Feed the Phantom",
                className: "h-[500px] w-full object-cover transition-transform duration-500 group-hover:scale-110"
              }
            ),
            /* @__PURE__ */ s("div", { className: "absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-10", children: /* @__PURE__ */ p("div", { className: "text-white", children: [
              /* @__PURE__ */ s(
                "p",
                {
                  className: "mb-3 uppercase tracking-wide",
                  style: {
                    fontSize: `${ee(a, r, "fontSize", 12)}px`,
                    color: ee(a, r, "textColor", "#D1D5DB"),
                    letterSpacing: `${ee(a, r, "letterSpacing", 1)}px`,
                    marginBottom: `${ee(a, r, "marginBottom", 12)}px`
                  },
                  children: ee(a, r, "text", "Feed the Phantom")
                }
              ),
              /* @__PURE__ */ s(
                "h3",
                {
                  className: "mb-6 font-bold leading-tight",
                  style: {
                    fontSize: `${ee(d, r, "fontSize", 32)}px`,
                    color: ee(d, r, "textColor", "#FFFFFF"),
                    lineHeight: ee(d, r, "lineHeight", 1.2),
                    marginBottom: `${ee(d, r, "marginBottom", 24)}px`
                  },
                  children: ee(d, r, "text", "The new Phantom 6—so precise, it's scary.")
                }
              ),
              /* @__PURE__ */ s(
                "button",
                {
                  className: "font-medium transition-all duration-300",
                  style: {
                    backgroundColor: ee(c, r, "button-color", "#FFFFFF"),
                    color: ee(c, r, "textColor", "#000000"),
                    borderRadius: `${ee(c, r, "borderRadius", 50)}px`,
                    paddingLeft: `${ee(c, r, "paddingX", 24)}px`,
                    paddingRight: `${ee(c, r, "paddingX", 24)}px`,
                    paddingTop: `${ee(c, r, "paddingY", 8)}px`,
                    paddingBottom: `${ee(c, r, "paddingY", 8)}px`,
                    border: "none",
                    cursor: "pointer"
                  },
                  children: ee(c, r, "button-text", "Shop")
                }
              )
            ] }) })
          ] }) }),
          /* @__PURE__ */ s("div", { className: "group relative cursor-pointer", children: /* @__PURE__ */ p("div", { className: "relative overflow-hidden rounded-lg shadow-lg", children: [
            /* @__PURE__ */ s(
              "img",
              {
                src: b,
                alt: "The Faith Kipyegon Collection",
                className: "h-[500px] w-full object-cover transition-transform duration-500 group-hover:scale-110"
              }
            ),
            /* @__PURE__ */ s("div", { className: "absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-10", children: /* @__PURE__ */ p("div", { className: "text-white", children: [
              /* @__PURE__ */ s(
                "h3",
                {
                  className: "mb-6 font-bold leading-tight",
                  style: {
                    fontSize: `${ee(h, r, "fontSize", 32)}px`,
                    color: ee(h, r, "textColor", "#FFFFFF"),
                    lineHeight: ee(h, r, "lineHeight", 1.2),
                    marginBottom: `${ee(h, r, "marginBottom", 24)}px`
                  },
                  children: ee(h, r, "text", "The Faith Kipyegon Collection")
                }
              ),
              /* @__PURE__ */ s(
                "button",
                {
                  className: "font-medium transition-all duration-300",
                  style: {
                    backgroundColor: ee(m, r, "button-color", "#FFFFFF"),
                    color: ee(m, r, "textColor", "#000000"),
                    borderRadius: `${ee(m, r, "borderRadius", 50)}px`,
                    paddingLeft: `${ee(m, r, "paddingX", 24)}px`,
                    paddingRight: `${ee(m, r, "paddingX", 24)}px`,
                    paddingTop: `${ee(m, r, "paddingY", 8)}px`,
                    paddingBottom: `${ee(m, r, "paddingY", 8)}px`,
                    border: "none",
                    cursor: "pointer"
                  },
                  children: ee(m, r, "button-text", "Shop")
                }
              )
            ] }) })
          ] }) })
        ] })
      ] })
    }
  );
}, Fu = ue(_u, {
  identifier: "nike.nikepromotional.latestsection",
  title: "Latest",
  featuredImage: z.previews.latest,
  description: "Two-card promotional section showcasing the latest Nike products and collections",
  category: "nike",
  className: "nike-latest",
  components: Eu,
  renderMode: "client"
}), Pu = [
  // Section Title Component
  F(
    "heading-text",
    "shop-by-icons-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Shop by Icons" },
        { inputKey: "level", type: "select", value: "2" },
        { inputKey: "fontSize", type: "number", value: 48 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "textAlign", type: "select", value: "left" },
        { inputKey: "marginBottom", type: "number", value: 48 }
      ],
      tablet: [
        { inputKey: "fontSize", type: "number", value: 40 },
        { inputKey: "marginBottom", type: "number", value: 40 }
      ],
      mobile: [
        { inputKey: "fontSize", type: "number", value: 32 },
        { inputKey: "marginBottom", type: "number", value: 32 }
      ]
    },
    {
      name: "Section Title",
      description: "Main heading for the Shop by Icons section"
    }
  ),
  // Icon Item 1 - Background Image
  F(
    "background-image",
    "shop-icon-1-bg",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: z.shopBy.image1 },
        { inputKey: "backgroundSize", type: "select", value: "contain" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 300 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 250 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 200 }]
    },
    {
      name: "Icon Item 1 Background",
      description: "Background image for the first icon item"
    }
  ),
  // Icon Item 1 - Title
  F(
    "heading-text",
    "shop-icon-1-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Vomero 18" },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 20 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 18 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 16 }]
    },
    {
      name: "Icon Item 1 Title",
      description: "Title for the first icon item"
    }
  ),
  // Icon Item 1 - CTA Button
  F(
    "button-solid",
    "shop-icon-1-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Icon Item 1 CTA",
      description: "Call-to-action button for the first icon item"
    }
  ),
  // Icon Item 2 - Background Image
  F(
    "background-image",
    "shop-icon-2-bg",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: z.shopBy.image2 },
        { inputKey: "backgroundSize", type: "select", value: "contain" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 300 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 250 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 200 }]
    },
    {
      name: "Icon Item 2 Background",
      description: "Background image for the second icon item"
    }
  ),
  // Icon Item 2 - Title
  F(
    "heading-text",
    "shop-icon-2-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "V2K" },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 20 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 18 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 16 }]
    },
    {
      name: "Icon Item 2 Title",
      description: "Title for the second icon item"
    }
  ),
  // Icon Item 2 - CTA Button
  F(
    "button-solid",
    "shop-icon-2-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Icon Item 2 CTA",
      description: "Call-to-action button for the second icon item"
    }
  ),
  // Icon Item 3 - Background Image
  F(
    "background-image",
    "shop-icon-3-bg",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: z.shopBy.image3 },
        { inputKey: "backgroundSize", type: "select", value: "contain" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 300 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 250 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 200 }]
    },
    {
      name: "Icon Item 3 Background",
      description: "Background image for the third icon item"
    }
  ),
  // Icon Item 3 - Title
  F(
    "heading-text",
    "shop-icon-3-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Pegasus 41" },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 20 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 18 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 16 }]
    },
    {
      name: "Icon Item 3 Title",
      description: "Title for the third icon item"
    }
  ),
  // Icon Item 3 - CTA Button
  F(
    "button-solid",
    "shop-icon-3-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Icon Item 3 CTA",
      description: "Call-to-action button for the third icon item"
    }
  ),
  // Icon Item 4 - Background Image
  F(
    "background-image",
    "shop-icon-4-bg",
    {
      desktop: [
        { inputKey: "assetId", type: "image", value: z.shopBy.image4 },
        { inputKey: "backgroundSize", type: "select", value: "contain" },
        { inputKey: "backgroundPosition", type: "select", value: "center" },
        { inputKey: "minHeight", type: "number", value: 300 },
        { inputKey: "borderRadius", type: "number", value: 8 }
      ],
      tablet: [{ inputKey: "minHeight", type: "number", value: 250 }],
      mobile: [{ inputKey: "minHeight", type: "number", value: 200 }]
    },
    {
      name: "Icon Item 4 Background",
      description: "Background image for the fourth icon item"
    }
  ),
  // Icon Item 4 - Title
  F(
    "heading-text",
    "shop-icon-4-title",
    {
      desktop: [
        { inputKey: "text", type: "text", value: "Vomero 5" },
        { inputKey: "level", type: "select", value: "3" },
        { inputKey: "fontSize", type: "number", value: 20 },
        { inputKey: "fontWeight", type: "select", value: "bold" },
        { inputKey: "textColor", type: "color", value: "#FFFFFF" },
        { inputKey: "lineHeight", type: "number", value: 1.2 },
        { inputKey: "marginBottom", type: "number", value: 16 }
      ],
      tablet: [{ inputKey: "fontSize", type: "number", value: 18 }],
      mobile: [{ inputKey: "fontSize", type: "number", value: 16 }]
    },
    {
      name: "Icon Item 4 Title",
      description: "Title for the fourth icon item"
    }
  ),
  // Icon Item 4 - CTA Button
  F(
    "button-solid",
    "shop-icon-4-cta",
    {
      desktop: [
        { inputKey: "button-text", type: "text", value: "Shop" },
        { inputKey: "button-color", type: "color", value: "#FFFFFF" },
        { inputKey: "textColor", type: "color", value: "#000000" },
        { inputKey: "button-size", type: "select", value: "medium" },
        { inputKey: "borderRadius", type: "number", value: 50 },
        { inputKey: "paddingX", type: "number", value: 24 },
        { inputKey: "paddingY", type: "number", value: 8 },
        { inputKey: "fontWeight", type: "select", value: "medium" }
      ],
      tablet: [],
      mobile: []
    },
    {
      name: "Icon Item 4 CTA",
      description: "Call-to-action button for the fourth icon item"
    }
  )
], Lu = ({ data: t, className: e, storeId: i, viewportMode: n = "desktop" }) => {
  const r = R(
    t,
    "heading-text",
    "shop-by-icons-title",
    n
  ), o = R(
    t,
    "background-image",
    "shop-icon-1-bg",
    n
  ), l = R(
    t,
    "heading-text",
    "shop-icon-1-title",
    n
  ), a = R(
    t,
    "button-solid",
    "shop-icon-1-cta",
    n
  ), d = R(
    t,
    "background-image",
    "shop-icon-2-bg",
    n
  ), c = R(
    t,
    "heading-text",
    "shop-icon-2-title",
    n
  ), u = R(
    t,
    "button-solid",
    "shop-icon-2-cta",
    n
  ), h = R(
    t,
    "background-image",
    "shop-icon-3-bg",
    n
  ), m = R(
    t,
    "heading-text",
    "shop-icon-3-title",
    n
  ), v = R(
    t,
    "button-solid",
    "shop-icon-3-cta",
    n
  ), y = R(
    t,
    "background-image",
    "shop-icon-4-bg",
    n
  ), f = R(
    t,
    "heading-text",
    "shop-icon-4-title",
    n
  ), x = R(
    t,
    "button-solid",
    "shop-icon-4-cta",
    n
  ), b = B(o, "assetId", z.shopBy.image1) || z.shopBy.image1, g = B(d, "assetId", z.shopBy.image2) || z.shopBy.image2, k = B(h, "assetId", z.shopBy.image3) || z.shopBy.image3, w = B(y, "assetId", z.shopBy.image4) || z.shopBy.image4, [C, T] = O(
    typeof b == "string" && !b.startsWith("http") ? z.shopBy.image1 : b
  ), [I, E] = O(
    typeof g == "string" && !g.startsWith("http") ? z.shopBy.image2 : g
  ), [P, S] = O(
    typeof k == "string" && !k.startsWith("http") ? z.shopBy.image3 : k
  ), [K, _] = O(
    typeof w == "string" && !w.startsWith("http") ? z.shopBy.image4 : w
  );
  U(() => {
    (async () => {
      try {
        if (typeof b == "string" && b && i) {
          const M = await we(
            b,
            i,
            { width: 600, height: 600, fit: "cover" }
          );
          T(M);
        }
      } catch (M) {
        console.error("[ShopByIcons] Failed to fetch icon1 asset:", M), T(z.shopBy.image1);
      }
    })();
  }, [b, i]), U(() => {
    (async () => {
      try {
        if (typeof g == "string" && g && i) {
          const M = await we(
            g,
            i,
            { width: 600, height: 600, fit: "cover" }
          );
          E(M);
        }
      } catch (M) {
        console.error("[ShopByIcons] Failed to fetch icon2 asset:", M), E(z.shopBy.image2);
      }
    })();
  }, [g, i]), U(() => {
    (async () => {
      try {
        if (typeof k == "string" && k && i) {
          const M = await we(
            k,
            i,
            { width: 600, height: 600, fit: "cover" }
          );
          S(M);
        }
      } catch (M) {
        console.error("[ShopByIcons] Failed to fetch icon3 asset:", M), S(z.shopBy.image3);
      }
    })();
  }, [k, i]), U(() => {
    (async () => {
      try {
        if (typeof w == "string" && w && i) {
          const M = await we(
            w,
            i,
            { width: 600, height: 600, fit: "cover" }
          );
          _(M);
        }
      } catch (M) {
        console.error("[ShopByIcons] Failed to fetch icon4 asset:", M), _(z.shopBy.image4);
      }
    })();
  }, [w, i]);
  const L = (A, M, q, H, X, re, V) => /* @__PURE__ */ s(
    "div",
    {
      className: "group w-64 flex-shrink-0 cursor-pointer",
      children: /* @__PURE__ */ p("div", { className: "relative overflow-hidden rounded-lg shadow-lg", children: [
        /* @__PURE__ */ s(
          "img",
          {
            src: H,
            alt: re,
            className: "w-full object-contain transition-transform duration-500 group-hover:scale-110",
            style: {
              minHeight: `${B(A, "minHeight", 300)}px`
            }
          }
        ),
        /* @__PURE__ */ s("div", { className: "absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent p-6", children: /* @__PURE__ */ p("div", { className: "text-white", children: [
          /* @__PURE__ */ s(
            "h3",
            {
              className: "mb-4 font-bold leading-tight",
              style: {
                fontSize: `${B(M, "fontSize", 20)}px`,
                color: B(M, "textColor", "#FFFFFF"),
                lineHeight: B(M, "lineHeight", 1.2),
                marginBottom: `${B(M, "marginBottom", 16)}px`
              },
              children: B(M, "text", X)
            }
          ),
          /* @__PURE__ */ s(
            "button",
            {
              className: "font-medium transition-all duration-300",
              style: {
                backgroundColor: B(q, "button-color", "#FFFFFF"),
                color: B(q, "textColor", "#000000"),
                borderRadius: `${B(q, "borderRadius", 50)}px`,
                paddingLeft: `${B(q, "paddingX", 24)}px`,
                paddingRight: `${B(q, "paddingX", 24)}px`,
                paddingTop: `${B(q, "paddingY", 8)}px`,
                paddingBottom: `${B(q, "paddingY", 8)}px`,
                border: "none",
                cursor: "pointer"
              },
              children: B(q, "button-text", "Shop")
            }
          )
        ] }) })
      ] })
    },
    `icon-item-${V}`
  ), N = [
    {
      bgData: o,
      titleData: l,
      ctaData: a,
      imageSrc: C,
      defaultTitle: "Vomero 18",
      altText: "Vomero 18"
    },
    {
      bgData: d,
      titleData: c,
      ctaData: u,
      imageSrc: I,
      defaultTitle: "V2K",
      altText: "V2K"
    },
    {
      bgData: h,
      titleData: m,
      ctaData: v,
      imageSrc: P,
      defaultTitle: "Pegasus 41",
      altText: "Pegasus 41"
    },
    {
      bgData: y,
      titleData: f,
      ctaData: x,
      imageSrc: K,
      defaultTitle: "Vomero 5",
      altText: "Vomero 5"
    }
  ], $ = [...N, ...N];
  return /* @__PURE__ */ s(
    "section",
    {
      className: `nike-shop-by-icons-section ${e || ""} bg-white py-16 lg:py-24`,
      children: /* @__PURE__ */ p("div", { className: "container mx-auto px-4 sm:px-6 lg:px-8", children: [
        /* @__PURE__ */ p("div", { className: "mb-12 flex items-center justify-between", children: [
          /* @__PURE__ */ s(
            "h2",
            {
              className: "font-bold text-black",
              style: {
                fontSize: `${B(r, "fontSize", 48)}px`,
                color: B(r, "textColor", "#000000")
              },
              children: B(r, "text", "Shop by Icons")
            }
          ),
          /* @__PURE__ */ p("div", { className: "flex gap-2", children: [
            /* @__PURE__ */ s(
              "button",
              {
                className: "flex h-10 w-10 items-center justify-center rounded-full bg-gray-200 transition-colors hover:bg-gray-300 disabled:opacity-50",
                disabled: !0,
                children: /* @__PURE__ */ s(
                  "svg",
                  {
                    className: "h-5 w-5",
                    fill: "none",
                    stroke: "currentColor",
                    viewBox: "0 0 24 24",
                    children: /* @__PURE__ */ s(
                      "path",
                      {
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M15 19l-7-7 7-7"
                      }
                    )
                  }
                )
              }
            ),
            /* @__PURE__ */ s("button", { className: "flex h-10 w-10 items-center justify-center rounded-full bg-gray-200 transition-colors hover:bg-gray-300", children: /* @__PURE__ */ s(
              "svg",
              {
                className: "h-5 w-5",
                fill: "none",
                stroke: "currentColor",
                viewBox: "0 0 24 24",
                children: /* @__PURE__ */ s(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M9 5l7 7-7 7"
                  }
                )
              }
            ) })
          ] })
        ] }),
        /* @__PURE__ */ s("div", { className: "scrollbar-hide overflow-x-auto", children: /* @__PURE__ */ s("div", { className: "flex gap-6 pb-4", style: { width: "max-content" }, children: $.map(
          (A, M) => L(
            A.bgData,
            A.titleData,
            A.ctaData,
            A.imageSrc,
            A.defaultTitle,
            A.altText,
            M
          )
        ) }) })
      ] })
    }
  );
}, Au = ue(Lu, {
  identifier: "nike.nikepromotional.shopbyiconssection",
  title: "Shop By Icons",
  featuredImage: z.previews.shopBy,
  description: "Horizontal scrolling carousel of category icons with configurable images, titles, and CTAs",
  category: "nike",
  className: "nike-shop-by-icons",
  components: Pu,
  renderMode: "client"
}), Ru = {
  "nike.nikeaccount.accountdashboard": $a,
  "nike.nikeaccount.ordertracking": il,
  "nike.nikeauthentication.otpverification": ol,
  "nike.nikeauthentication.phoneauthform": ll,
  "nike.nikecheckout.checkout": Pl,
  "nike.nikeecommerce.categoryfiltertabs": Rl,
  "nike.nikeecommerce.productlistingheader": $l,
  "nike.nikeecommerce.relatedcategories": Dl,
  "nike.nikeecommerce.relatedstories": jl,
  "nike.nikefooter.nikefooter": ql,
  "nike.nikeheader.nikeheadersection": nc,
  "nike.nikehero.nikehero": sc,
  "nike.nikenavigation.cartsidebar": uc,
  "nike.nikenavigation.topnavbar": hc,
  "nike.nikeproduct.cartsummary": yi,
  "nike.nikeproduct.productdetails": yc,
  "nike.nikeproduct.productgrid": xc,
  "nike.nikeproduct.productmaincontentsection": Bc,
  "nike.nikeproduct.socialproof": Wc,
  "nike.nikeproduct.trendingsection": wu,
  "nike.nikepromotional.dontmisssection": Nu,
  "nike.nikepromotional.featuredsection": Iu,
  "nike.nikepromotional.latestsection": Fu,
  "nike.nikepromotional.shopbyiconssection": Au
};
function Jr() {
  const t = {}, e = [
    ha || {},
    Ru || {}
  ];
  for (const i of e)
    for (const [n, r] of Object.entries(i)) {
      const o = {
        name: r && r.title || n,
        key: n,
        component: r,
        inputs: r && r.defaultData || {},
        type: "client"
      };
      t[n] = o;
    }
  return t;
}
function qu() {
  return Object.keys(Jr());
}
function Gu(t) {
  return t in Jr();
}
export {
  da as DEFAULT_ROUTE_CONFIG,
  va as buildProductRoute,
  At as buildRoute,
  Ki as buildRouteWithParams,
  lr as createDefaultDataMap,
  ma as extractSectionDefaultData,
  qu as getAllAvailableClientSections,
  Jr as getComponentClientMap,
  Uu as getComponentField,
  Se as getNamedRoute,
  ze as getRouteOptions,
  cr as getRoutes,
  ju as getSectionDefaultData,
  Gu as isValidClientSectionIdentifier,
  Vu as setComponentField,
  Hu as useComponentField
};
//# sourceMappingURL=client.js.map
